/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: { input: unknown; output: unknown; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: unknown; output: unknown; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: unknown; output: unknown; }
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  Long: { input: unknown; output: unknown; }
  ProgrammeTypeProgrammeQuestionsDynamicZoneInput: { input: unknown; output: unknown; }
  SectionQuestionsDynamicZoneInput: { input: unknown; output: unknown; }
};

export type AccountChange = {
  __typename?: 'AccountChange';
  accept?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  new_division?: Maybe<Division>;
  new_region?: Maybe<Region>;
  old_division?: Maybe<Division>;
  old_region?: Maybe<Region>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<UsersPermissionsUser>;
  user_updated?: Maybe<Scalars['Boolean']['output']>;
};

export type AccountChangeEntityResponseCollection = {
  __typename?: 'AccountChangeEntityResponseCollection';
  nodes: Array<AccountChange>;
  pageInfo: Pagination;
};

export type AccountChangeFiltersInput = {
  accept?: InputMaybe<BooleanFilterInput>;
  and?: InputMaybe<Array<InputMaybe<AccountChangeFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  new_division?: InputMaybe<DivisionFiltersInput>;
  new_region?: InputMaybe<RegionFiltersInput>;
  not?: InputMaybe<AccountChangeFiltersInput>;
  old_division?: InputMaybe<DivisionFiltersInput>;
  old_region?: InputMaybe<RegionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<AccountChangeFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  user?: InputMaybe<UsersPermissionsUserFiltersInput>;
  user_updated?: InputMaybe<BooleanFilterInput>;
};

export type AccountChangeInput = {
  accept?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  newDivision?: InputMaybe<Scalars['ID']['input']>;
  newRegion?: InputMaybe<Scalars['ID']['input']>;
  new_division?: InputMaybe<Scalars['ID']['input']>;
  new_region?: InputMaybe<Scalars['ID']['input']>;
  oldDivision?: InputMaybe<Scalars['ID']['input']>;
  oldRegion?: InputMaybe<Scalars['ID']['input']>;
  old_division?: InputMaybe<Scalars['ID']['input']>;
  old_region?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
  user?: InputMaybe<Scalars['ID']['input']>;
  userUpdated?: InputMaybe<Scalars['Boolean']['input']>;
  user_updated?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccountChangeRelationResponseCollection = {
  __typename?: 'AccountChangeRelationResponseCollection';
  nodes: Array<AccountChange>;
};

export type AdminUser = {
  __typename?: 'AdminUser';
  id: Scalars['ID']['output'];
  username?: Maybe<Scalars['String']['output']>;
};

export type Appointment = {
  __typename?: 'Appointment';
  appointment_end_date?: Maybe<Scalars['DateTime']['output']>;
  appointment_schedule_id?: Maybe<Scalars['Long']['output']>;
  appointment_start_date?: Maybe<Scalars['DateTime']['output']>;
  appointment_title?: Maybe<Scalars['String']['output']>;
  appointment_url?: Maybe<Scalars['String']['output']>;
  business_id?: Maybe<Scalars['Long']['output']>;
  calendar_id?: Maybe<Scalars['Long']['output']>;
  client_email?: Maybe<Scalars['String']['output']>;
  client_name?: Maybe<Scalars['String']['output']>;
  coach_session?: Maybe<CoachSession>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AppointmentEntityResponseCollection = {
  __typename?: 'AppointmentEntityResponseCollection';
  nodes: Array<Appointment>;
  pageInfo: Pagination;
};

export type AppointmentFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<AppointmentFiltersInput>>>;
  appointment_end_date?: InputMaybe<DateTimeFilterInput>;
  appointment_schedule_id?: InputMaybe<LongFilterInput>;
  appointment_start_date?: InputMaybe<DateTimeFilterInput>;
  appointment_title?: InputMaybe<StringFilterInput>;
  appointment_url?: InputMaybe<StringFilterInput>;
  business_id?: InputMaybe<LongFilterInput>;
  calendar_id?: InputMaybe<LongFilterInput>;
  client_email?: InputMaybe<StringFilterInput>;
  client_name?: InputMaybe<StringFilterInput>;
  coach_session?: InputMaybe<CoachSessionFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<AppointmentFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<AppointmentFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  status?: InputMaybe<BooleanFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type AppointmentInput = {
  appointment_end_date?: InputMaybe<Scalars['DateTime']['input']>;
  appointment_schedule_id?: InputMaybe<Scalars['Long']['input']>;
  appointment_start_date?: InputMaybe<Scalars['DateTime']['input']>;
  appointment_title?: InputMaybe<Scalars['String']['input']>;
  appointment_url?: InputMaybe<Scalars['String']['input']>;
  business_id?: InputMaybe<Scalars['Long']['input']>;
  calendar_id?: InputMaybe<Scalars['Long']['input']>;
  client_email?: InputMaybe<Scalars['String']['input']>;
  client_name?: InputMaybe<Scalars['String']['input']>;
  coach_session?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Appointments = {
  __typename?: 'Appointments';
  appointmentEndDate?: Maybe<Scalars['DateTime']['output']>;
  appointmentScheduleId?: Maybe<Scalars['Long']['output']>;
  appointmentStartDate?: Maybe<Scalars['DateTime']['output']>;
  appointmentTitle?: Maybe<Scalars['String']['output']>;
  appointmentUrl?: Maybe<Scalars['String']['output']>;
  businessId?: Maybe<Scalars['Long']['output']>;
  calendarId?: Maybe<Scalars['Long']['output']>;
  clientEmail?: Maybe<Scalars['String']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  coachSession?: Maybe<CoachSession>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<AdminUser>;
  id: Scalars['ID']['output'];
  status?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<AdminUser>;
};

export type Article = {
  __typename?: 'Article';
  companies: Array<Maybe<Company>>;
  companies_connection?: Maybe<CompanyRelationResponseCollection>;
  content_english?: Maybe<Scalars['String']['output']>;
  content_french?: Maybe<Scalars['String']['output']>;
  content_german?: Maybe<Scalars['String']['output']>;
  content_mandarin?: Maybe<Scalars['String']['output']>;
  content_spanish?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  date_published?: Maybe<Scalars['Date']['output']>;
  documentId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<UploadFile>;
  link?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Long']['output']>;
  programme_types: Array<Maybe<ProgrammeType>>;
  programme_types_connection?: Maybe<ProgrammeTypeRelationResponseCollection>;
  programmes: Array<Maybe<Programme>>;
  programmes_connection?: Maybe<ProgrammeRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  read_time?: Maybe<Scalars['Int']['output']>;
  title_english?: Maybe<Scalars['String']['output']>;
  title_french?: Maybe<Scalars['String']['output']>;
  title_german?: Maybe<Scalars['String']['output']>;
  title_mandarin?: Maybe<Scalars['String']['output']>;
  title_spanish?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ArticleCompaniesArgs = {
  filters?: InputMaybe<CompanyFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ArticleCompanies_ConnectionArgs = {
  filters?: InputMaybe<CompanyFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ArticleProgramme_TypesArgs = {
  filters?: InputMaybe<ProgrammeTypeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ArticleProgramme_Types_ConnectionArgs = {
  filters?: InputMaybe<ProgrammeTypeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ArticleProgrammesArgs = {
  filters?: InputMaybe<ProgrammeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ArticleProgrammes_ConnectionArgs = {
  filters?: InputMaybe<ProgrammeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ArticleEntityResponseCollection = {
  __typename?: 'ArticleEntityResponseCollection';
  nodes: Array<Article>;
  pageInfo: Pagination;
};

export type ArticleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ArticleFiltersInput>>>;
  companies?: InputMaybe<CompanyFiltersInput>;
  content_english?: InputMaybe<StringFilterInput>;
  content_french?: InputMaybe<StringFilterInput>;
  content_german?: InputMaybe<StringFilterInput>;
  content_mandarin?: InputMaybe<StringFilterInput>;
  content_spanish?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  date_published?: InputMaybe<DateFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  link?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ArticleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ArticleFiltersInput>>>;
  position?: InputMaybe<LongFilterInput>;
  programme_types?: InputMaybe<ProgrammeTypeFiltersInput>;
  programmes?: InputMaybe<ProgrammeFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  read_time?: InputMaybe<IntFilterInput>;
  title_english?: InputMaybe<StringFilterInput>;
  title_french?: InputMaybe<StringFilterInput>;
  title_german?: InputMaybe<StringFilterInput>;
  title_mandarin?: InputMaybe<StringFilterInput>;
  title_spanish?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ArticleInput = {
  companies?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  content_english?: InputMaybe<Scalars['String']['input']>;
  content_french?: InputMaybe<Scalars['String']['input']>;
  content_german?: InputMaybe<Scalars['String']['input']>;
  content_mandarin?: InputMaybe<Scalars['String']['input']>;
  content_spanish?: InputMaybe<Scalars['String']['input']>;
  date_published?: InputMaybe<Scalars['Date']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Long']['input']>;
  programme_types?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  programmes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  read_time?: InputMaybe<Scalars['Int']['input']>;
  title_english?: InputMaybe<Scalars['String']['input']>;
  title_french?: InputMaybe<Scalars['String']['input']>;
  title_german?: InputMaybe<Scalars['String']['input']>;
  title_mandarin?: InputMaybe<Scalars['String']['input']>;
  title_spanish?: InputMaybe<Scalars['String']['input']>;
};

export type ArticleRelationResponseCollection = {
  __typename?: 'ArticleRelationResponseCollection';
  nodes: Array<Article>;
};

export type AuditTrail = {
  __typename?: 'AuditTrail';
  action?: Maybe<Scalars['String']['output']>;
  by?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  details?: Maybe<Scalars['JSON']['output']>;
  documentId: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  section?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AuditTrailEntityResponseCollection = {
  __typename?: 'AuditTrailEntityResponseCollection';
  nodes: Array<AuditTrail>;
  pageInfo: Pagination;
};

export type AuditTrailFiltersInput = {
  action?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<AuditTrailFiltersInput>>>;
  by?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  details?: InputMaybe<JsonFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<AuditTrailFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<AuditTrailFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  section?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type AuditTrailInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  by?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['JSON']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  section?: InputMaybe<Scalars['String']['input']>;
};

export type Booking = {
  __typename?: 'Booking';
  cancelled?: Maybe<Scalars['Boolean']['output']>;
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['ID']['output'];
  duration?: Maybe<Scalars['Int']['output']>;
  end?: Maybe<Scalars['DateTime']['output']>;
  event_id?: Maybe<Scalars['Int']['output']>;
  is_updated?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  organiser?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<UsersPermissionsUser>;
};

export type BookingEntityResponseCollection = {
  __typename?: 'BookingEntityResponseCollection';
  nodes: Array<Booking>;
  pageInfo: Pagination;
};

export type BookingFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<BookingFiltersInput>>>;
  cancelled?: InputMaybe<BooleanFilterInput>;
  confirmed?: InputMaybe<BooleanFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  date?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  duration?: InputMaybe<IntFilterInput>;
  end?: InputMaybe<DateTimeFilterInput>;
  event_id?: InputMaybe<IntFilterInput>;
  is_updated?: InputMaybe<BooleanFilterInput>;
  location?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<BookingFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<BookingFiltersInput>>>;
  organiser?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  user?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type BookingInput = {
  cancelled?: InputMaybe<Scalars['Boolean']['input']>;
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  event_id?: InputMaybe<Scalars['Int']['input']>;
  is_updated?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  organiser?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['ID']['input']>;
};

export type BookingRelationResponseCollection = {
  __typename?: 'BookingRelationResponseCollection';
  nodes: Array<Booking>;
};

export type BooleanFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  contains?: InputMaybe<Scalars['Boolean']['input']>;
  containsi?: InputMaybe<Scalars['Boolean']['input']>;
  endsWith?: InputMaybe<Scalars['Boolean']['input']>;
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  eqi?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nei?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<BooleanFilterInput>;
  notContains?: InputMaybe<Scalars['Boolean']['input']>;
  notContainsi?: InputMaybe<Scalars['Boolean']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  startsWith?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CheckConfirmed = {
  __typename?: 'CheckConfirmed';
  success?: Maybe<Scalars['String']['output']>;
};

export type Coach = {
  __typename?: 'Coach';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  email: Scalars['String']['output'];
  first_name: Scalars['String']['output'];
  is_coach_added_by_user?: Maybe<Scalars['Boolean']['output']>;
  last_name: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CoachEntityResponseCollection = {
  __typename?: 'CoachEntityResponseCollection';
  nodes: Array<Coach>;
  pageInfo: Pagination;
};

export type CoachFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<CoachFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  first_name?: InputMaybe<StringFilterInput>;
  is_coach_added_by_user?: InputMaybe<BooleanFilterInput>;
  last_name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CoachFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CoachFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type CoachInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  is_coach_added_by_user?: InputMaybe<Scalars['Boolean']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CoachSession = {
  __typename?: 'CoachSession';
  appointment?: Maybe<Appointment>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  programme_submission?: Maybe<ProgrammeSubmission>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  sub_module_submission?: Maybe<SubModuleSubmission>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<UsersPermissionsUser>;
};

export type CoachSessionEntityResponseCollection = {
  __typename?: 'CoachSessionEntityResponseCollection';
  nodes: Array<CoachSession>;
  pageInfo: Pagination;
};

export type CoachSessionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<CoachSessionFiltersInput>>>;
  appointment?: InputMaybe<AppointmentFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<CoachSessionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CoachSessionFiltersInput>>>;
  programme_submission?: InputMaybe<ProgrammeSubmissionFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  status?: InputMaybe<BooleanFilterInput>;
  sub_module_submission?: InputMaybe<SubModuleSubmissionFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  user?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type CoachSessionInput = {
  appointment?: InputMaybe<Scalars['ID']['input']>;
  programme_submission?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  sub_module_submission?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['ID']['input']>;
};

export type CoachSessionRelationResponseCollection = {
  __typename?: 'CoachSessionRelationResponseCollection';
  nodes: Array<CoachSession>;
};

export type CoachSubmittedReport = {
  __typename?: 'CoachSubmittedReport';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  notes_id?: Maybe<Array<Maybe<ComponentSubmissionsSaboteurComponent>>>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<UsersPermissionsUser>;
};


export type CoachSubmittedReportNotes_IdArgs = {
  filters?: InputMaybe<ComponentSubmissionsSaboteurComponentFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CoachSubmittedReportEntityResponseCollection = {
  __typename?: 'CoachSubmittedReportEntityResponseCollection';
  nodes: Array<CoachSubmittedReport>;
  pageInfo: Pagination;
};

export type CoachSubmittedReportFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<CoachSubmittedReportFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CoachSubmittedReportFiltersInput>;
  notes_id?: InputMaybe<ComponentSubmissionsSaboteurComponentFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CoachSubmittedReportFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  user?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type CoachSubmittedReportInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  notes_id?: InputMaybe<Array<InputMaybe<ComponentSubmissionsSaboteurComponentInput>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<Scalars['ID']['input']>;
};

export type CoachSubmittedReportRelationResponseCollection = {
  __typename?: 'CoachSubmittedReportRelationResponseCollection';
  nodes: Array<CoachSubmittedReport>;
};

export type Company = {
  __typename?: 'Company';
  about_us?: Maybe<ComponentTranslationsAboutUs>;
  articles: Array<Maybe<Article>>;
  articles_connection?: Maybe<ArticleRelationResponseCollection>;
  certificate_template?: Maybe<UploadFile>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  divisions: Array<Maybe<Division>>;
  divisions_connection?: Maybe<DivisionRelationResponseCollection>;
  documentId: Scalars['ID']['output'];
  email_logs: Array<Maybe<EmailLog>>;
  email_logs_connection?: Maybe<EmailLogRelationResponseCollection>;
  is_template?: Maybe<Scalars['Boolean']['output']>;
  language_selection?: Maybe<ComponentTranslationsLanguageSelection>;
  languages: Array<Maybe<Language>>;
  languages_connection?: Maybe<LanguageRelationResponseCollection>;
  lets_get_started_screen?: Maybe<ComponentTranslationsLetsGetStartedScreen>;
  logo?: Maybe<UploadFile>;
  modules: Array<Maybe<Module>>;
  modules_connection?: Maybe<ModuleRelationResponseCollection>;
  name?: Maybe<Scalars['String']['output']>;
  programmes: Array<Maybe<Programme>>;
  programmes_connection?: Maybe<ProgrammeRelationResponseCollection>;
  programmes_subTitle?: Maybe<Scalars['String']['output']>;
  programmes_title?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  regions: Array<Maybe<Region>>;
  regions_connection?: Maybe<RegionRelationResponseCollection>;
  roles: Array<Maybe<UsersPermissionsRole>>;
  roles_connection?: Maybe<UsersPermissionsRoleRelationResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  users: Array<Maybe<UsersPermissionsUser>>;
  users_confirm_details?: Maybe<Scalars['Boolean']['output']>;
  users_connection?: Maybe<UsersPermissionsUserRelationResponseCollection>;
  welcome_screen?: Maybe<ComponentTranslationsWelcomeScreen>;
  what_to_expect?: Maybe<ComponentTranslationsWhatToExpect>;
};


export type CompanyArticlesArgs = {
  filters?: InputMaybe<ArticleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CompanyArticles_ConnectionArgs = {
  filters?: InputMaybe<ArticleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CompanyDivisionsArgs = {
  filters?: InputMaybe<DivisionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CompanyDivisions_ConnectionArgs = {
  filters?: InputMaybe<DivisionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CompanyEmail_LogsArgs = {
  filters?: InputMaybe<EmailLogFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CompanyEmail_Logs_ConnectionArgs = {
  filters?: InputMaybe<EmailLogFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CompanyLanguagesArgs = {
  filters?: InputMaybe<LanguageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CompanyLanguages_ConnectionArgs = {
  filters?: InputMaybe<LanguageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CompanyModulesArgs = {
  filters?: InputMaybe<ModuleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CompanyModules_ConnectionArgs = {
  filters?: InputMaybe<ModuleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CompanyProgrammesArgs = {
  filters?: InputMaybe<ProgrammeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CompanyProgrammes_ConnectionArgs = {
  filters?: InputMaybe<ProgrammeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CompanyRegionsArgs = {
  filters?: InputMaybe<RegionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CompanyRegions_ConnectionArgs = {
  filters?: InputMaybe<RegionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CompanyRolesArgs = {
  filters?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CompanyRoles_ConnectionArgs = {
  filters?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CompanyUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CompanyUsers_ConnectionArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CompanyEntityResponseCollection = {
  __typename?: 'CompanyEntityResponseCollection';
  nodes: Array<Company>;
  pageInfo: Pagination;
};

export type CompanyFiltersInput = {
  about_us?: InputMaybe<ComponentTranslationsAboutUsFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<CompanyFiltersInput>>>;
  articles?: InputMaybe<ArticleFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  divisions?: InputMaybe<DivisionFiltersInput>;
  documentId?: InputMaybe<IdFilterInput>;
  email_logs?: InputMaybe<EmailLogFiltersInput>;
  is_template?: InputMaybe<BooleanFilterInput>;
  language_selection?: InputMaybe<ComponentTranslationsLanguageSelectionFiltersInput>;
  languages?: InputMaybe<LanguageFiltersInput>;
  lets_get_started_screen?: InputMaybe<ComponentTranslationsLetsGetStartedScreenFiltersInput>;
  modules?: InputMaybe<ModuleFiltersInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CompanyFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CompanyFiltersInput>>>;
  programmes?: InputMaybe<ProgrammeFiltersInput>;
  programmes_subTitle?: InputMaybe<StringFilterInput>;
  programmes_title?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  regions?: InputMaybe<RegionFiltersInput>;
  roles?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  users?: InputMaybe<UsersPermissionsUserFiltersInput>;
  users_confirm_details?: InputMaybe<BooleanFilterInput>;
  welcome_screen?: InputMaybe<ComponentTranslationsWelcomeScreenFiltersInput>;
  what_to_expect?: InputMaybe<ComponentTranslationsWhatToExpectFiltersInput>;
};

export type CompanyInput = {
  about_us?: InputMaybe<ComponentTranslationsAboutUsInput>;
  articles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  certificate_template?: InputMaybe<Scalars['ID']['input']>;
  divisions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  email_logs?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  is_template?: InputMaybe<Scalars['Boolean']['input']>;
  language_selection?: InputMaybe<ComponentTranslationsLanguageSelectionInput>;
  languages?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  lets_get_started_screen?: InputMaybe<ComponentTranslationsLetsGetStartedScreenInput>;
  logo?: InputMaybe<Scalars['ID']['input']>;
  modules?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  programmes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  programmes_subTitle?: InputMaybe<Scalars['String']['input']>;
  programmes_title?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  regions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  users_confirm_details?: InputMaybe<Scalars['Boolean']['input']>;
  welcome_screen?: InputMaybe<ComponentTranslationsWelcomeScreenInput>;
  what_to_expect?: InputMaybe<ComponentTranslationsWhatToExpectInput>;
};

export type CompanyRelationResponseCollection = {
  __typename?: 'CompanyRelationResponseCollection';
  nodes: Array<Company>;
};

export type CompetencyUrl = {
  __typename?: 'CompetencyUrl';
  coach_email?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  programme_submission?: Maybe<ProgrammeSubmission>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  sub_module_submission?: Maybe<SubModuleSubmission>;
  submission?: Maybe<Submission>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type CompetencyUrlEntityResponseCollection = {
  __typename?: 'CompetencyUrlEntityResponseCollection';
  nodes: Array<CompetencyUrl>;
  pageInfo: Pagination;
};

export type CompetencyUrlFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<CompetencyUrlFiltersInput>>>;
  coach_email?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<CompetencyUrlFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CompetencyUrlFiltersInput>>>;
  programme_submission?: InputMaybe<ProgrammeSubmissionFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  sub_module_submission?: InputMaybe<SubModuleSubmissionFiltersInput>;
  submission?: InputMaybe<SubmissionFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
};

export type CompetencyUrlInput = {
  coach_email?: InputMaybe<Scalars['String']['input']>;
  programme_submission?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  sub_module_submission?: InputMaybe<Scalars['ID']['input']>;
  submission?: InputMaybe<Scalars['ID']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentGravitasScaleItemsGravitasScaleItems = {
  __typename?: 'ComponentGravitasScaleItemsGravitasScaleItems';
  answerOne?: Maybe<Scalars['Int']['output']>;
  answerThree?: Maybe<Scalars['Int']['output']>;
  answerTwo?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  labelOne?: Maybe<Scalars['String']['output']>;
  labelThree?: Maybe<Scalars['String']['output']>;
  labelTwo?: Maybe<Scalars['String']['output']>;
  question?: Maybe<Scalars['String']['output']>;
};

export type ComponentGravitasScaleItemsGravitasScaleItemsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentGravitasScaleItemsGravitasScaleItemsFiltersInput>>>;
  answerOne?: InputMaybe<IntFilterInput>;
  answerThree?: InputMaybe<IntFilterInput>;
  answerTwo?: InputMaybe<IntFilterInput>;
  labelOne?: InputMaybe<StringFilterInput>;
  labelThree?: InputMaybe<StringFilterInput>;
  labelTwo?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentGravitasScaleItemsGravitasScaleItemsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentGravitasScaleItemsGravitasScaleItemsFiltersInput>>>;
  question?: InputMaybe<StringFilterInput>;
};

export type ComponentGravitasScaleItemsGravitasScaleItemsInput = {
  answerOne?: InputMaybe<Scalars['Int']['input']>;
  answerThree?: InputMaybe<Scalars['Int']['input']>;
  answerTwo?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  labelOne?: InputMaybe<Scalars['String']['input']>;
  labelThree?: InputMaybe<Scalars['String']['input']>;
  labelTwo?: InputMaybe<Scalars['String']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentOptionColorAndRating = {
  __typename?: 'ComponentOptionColorAndRating';
  color?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  rate?: Maybe<Scalars['Int']['output']>;
};

export type ComponentOptionColorAndRatingFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentOptionColorAndRatingFiltersInput>>>;
  color?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentOptionColorAndRatingFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentOptionColorAndRatingFiltersInput>>>;
  rate?: InputMaybe<IntFilterInput>;
};

export type ComponentOptionColorAndRatingInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  rate?: InputMaybe<Scalars['Int']['input']>;
};

export type ComponentOptionOption = {
  __typename?: 'ComponentOptionOption';
  id: Scalars['ID']['output'];
  isCorrect?: Maybe<Scalars['Boolean']['output']>;
  optionEnglish?: Maybe<Scalars['String']['output']>;
  optionFrench?: Maybe<Scalars['String']['output']>;
  optionGerman?: Maybe<Scalars['String']['output']>;
  optionMandarin?: Maybe<Scalars['String']['output']>;
  optionSpanish?: Maybe<Scalars['String']['output']>;
};

export type ComponentOptionOptionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentOptionOptionFiltersInput>>>;
  isCorrect?: InputMaybe<BooleanFilterInput>;
  not?: InputMaybe<ComponentOptionOptionFiltersInput>;
  optionEnglish?: InputMaybe<StringFilterInput>;
  optionFrench?: InputMaybe<StringFilterInput>;
  optionGerman?: InputMaybe<StringFilterInput>;
  optionMandarin?: InputMaybe<StringFilterInput>;
  optionSpanish?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentOptionOptionFiltersInput>>>;
};

export type ComponentOptionSliderHeadings = {
  __typename?: 'ComponentOptionSliderHeadings';
  color?: Maybe<Scalars['String']['output']>;
  headingEnglish?: Maybe<Scalars['String']['output']>;
  headingFrench?: Maybe<Scalars['String']['output']>;
  headingGerman?: Maybe<Scalars['String']['output']>;
  headingMandarin?: Maybe<Scalars['String']['output']>;
  headingSpanish?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  rating?: Maybe<Scalars['Int']['output']>;
};

export type ComponentOptionSliderHeadingsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentOptionSliderHeadingsFiltersInput>>>;
  color?: InputMaybe<StringFilterInput>;
  headingEnglish?: InputMaybe<StringFilterInput>;
  headingFrench?: InputMaybe<StringFilterInput>;
  headingGerman?: InputMaybe<StringFilterInput>;
  headingMandarin?: InputMaybe<StringFilterInput>;
  headingSpanish?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentOptionSliderHeadingsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentOptionSliderHeadingsFiltersInput>>>;
  rating?: InputMaybe<IntFilterInput>;
};

export type ComponentOptionSliderQuestions = {
  __typename?: 'ComponentOptionSliderQuestions';
  id: Scalars['ID']['output'];
  questionNegativeEnglish?: Maybe<Scalars['String']['output']>;
  questionNegativeFrench?: Maybe<Scalars['String']['output']>;
  questionNegativeGerman?: Maybe<Scalars['String']['output']>;
  questionNegativeMandarin?: Maybe<Scalars['String']['output']>;
  questionNegativeSpanish?: Maybe<Scalars['String']['output']>;
  questionPositiveEnglish?: Maybe<Scalars['String']['output']>;
  questionPositiveFrench?: Maybe<Scalars['String']['output']>;
  questionPositiveGerman?: Maybe<Scalars['String']['output']>;
  questionPositiveMandarin?: Maybe<Scalars['String']['output']>;
  questionPositiveSpanish?: Maybe<Scalars['String']['output']>;
};

export type ComponentOptionSliderQuestionsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentOptionSliderQuestionsFiltersInput>>>;
  not?: InputMaybe<ComponentOptionSliderQuestionsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentOptionSliderQuestionsFiltersInput>>>;
  questionNegativeEnglish?: InputMaybe<StringFilterInput>;
  questionNegativeFrench?: InputMaybe<StringFilterInput>;
  questionNegativeGerman?: InputMaybe<StringFilterInput>;
  questionNegativeMandarin?: InputMaybe<StringFilterInput>;
  questionNegativeSpanish?: InputMaybe<StringFilterInput>;
  questionPositiveEnglish?: InputMaybe<StringFilterInput>;
  questionPositiveFrench?: InputMaybe<StringFilterInput>;
  questionPositiveGerman?: InputMaybe<StringFilterInput>;
  questionPositiveMandarin?: InputMaybe<StringFilterInput>;
  questionPositiveSpanish?: InputMaybe<StringFilterInput>;
};

export type ComponentOptionTimezone = {
  __typename?: 'ComponentOptionTimezone';
  abbrev?: Maybe<Scalars['String']['output']>;
  altName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ComponentOptionTimezoneFiltersInput = {
  abbrev?: InputMaybe<StringFilterInput>;
  altName?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentOptionTimezoneFiltersInput>>>;
  label?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentOptionTimezoneFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentOptionTimezoneFiltersInput>>>;
  value?: InputMaybe<StringFilterInput>;
};

export type ComponentOptionTimezoneInput = {
  abbrev?: InputMaybe<Scalars['String']['input']>;
  altName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentQuestionTypesCompetency = {
  __typename?: 'ComponentQuestionTypesCompetency';
  id: Scalars['ID']['output'];
  maxNumber?: Maybe<Scalars['Long']['output']>;
  maxiLabel?: Maybe<Scalars['String']['output']>;
  minNumber?: Maybe<Scalars['Long']['output']>;
  miniLabel?: Maybe<Scalars['String']['output']>;
  question?: Maybe<Scalars['String']['output']>;
  simpleQuestion?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ComponentQuestionTypesCompetency2 = {
  __typename?: 'ComponentQuestionTypesCompetency2';
  id: Scalars['ID']['output'];
  questionscompetency2?: Maybe<Array<Maybe<ComponentQuestionTypesQuestionscompetency2>>>;
  titleEnglish?: Maybe<Scalars['String']['output']>;
  titleFrench?: Maybe<Scalars['String']['output']>;
  titleMandarin?: Maybe<Scalars['String']['output']>;
};


export type ComponentQuestionTypesCompetency2Questionscompetency2Args = {
  filters?: InputMaybe<ComponentQuestionTypesQuestionscompetency2FiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentQuestionTypesDocuments = {
  __typename?: 'ComponentQuestionTypesDocuments';
  document: Array<Maybe<UploadFile>>;
  document_connection?: Maybe<UploadFileRelationResponseCollection>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};


export type ComponentQuestionTypesDocumentsDocumentArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentQuestionTypesDocumentsDocument_ConnectionArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentQuestionTypesDocumentsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentQuestionTypesDocumentsFiltersInput>>>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentQuestionTypesDocumentsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentQuestionTypesDocumentsFiltersInput>>>;
};

export type ComponentQuestionTypesDocumentsInput = {
  document?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentQuestionTypesFeedForward1 = {
  __typename?: 'ComponentQuestionTypesFeedForward1';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  question?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ComponentQuestionTypesFeedForward2 = {
  __typename?: 'ComponentQuestionTypesFeedForward2';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  question?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ComponentQuestionTypesGravitasGap = {
  __typename?: 'ComponentQuestionTypesGravitasGap';
  color1?: Maybe<Scalars['String']['output']>;
  color2?: Maybe<Scalars['String']['output']>;
  color3?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  question?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ComponentQuestionTypesGravitasScale = {
  __typename?: 'ComponentQuestionTypesGravitasScale';
  id: Scalars['ID']['output'];
  questionOneEnglish?: Maybe<Scalars['String']['output']>;
  questionOneFrench?: Maybe<Scalars['String']['output']>;
  questionOneGerman?: Maybe<Scalars['String']['output']>;
  questionOneMandarin?: Maybe<Scalars['String']['output']>;
  questionOneSpanish?: Maybe<Scalars['String']['output']>;
  questionThreeEnglish?: Maybe<Scalars['String']['output']>;
  questionThreeFrench?: Maybe<Scalars['String']['output']>;
  questionThreeGerman?: Maybe<Scalars['String']['output']>;
  questionThreeMandarin?: Maybe<Scalars['String']['output']>;
  questionThreeSpanish?: Maybe<Scalars['String']['output']>;
  questionTwoEnglish?: Maybe<Scalars['String']['output']>;
  questionTwoFrench?: Maybe<Scalars['String']['output']>;
  questionTwoGerman?: Maybe<Scalars['String']['output']>;
  questionTwoMandarin?: Maybe<Scalars['String']['output']>;
  questionTwoSpanish?: Maybe<Scalars['String']['output']>;
  ratingInput?: Maybe<Array<Maybe<ComponentRatingInputRatingInput>>>;
  subTitleEnglish?: Maybe<Scalars['String']['output']>;
  subTitleFrench?: Maybe<Scalars['String']['output']>;
  subTitleGerman?: Maybe<Scalars['String']['output']>;
  subTitleMandarin?: Maybe<Scalars['String']['output']>;
  subTitleSpanish?: Maybe<Scalars['String']['output']>;
  titleEnglish?: Maybe<Scalars['String']['output']>;
  titleFrench?: Maybe<Scalars['String']['output']>;
  titleGerman?: Maybe<Scalars['String']['output']>;
  titleMandarin?: Maybe<Scalars['String']['output']>;
  titleOneEnglish?: Maybe<Scalars['String']['output']>;
  titleOneFrench?: Maybe<Scalars['String']['output']>;
  titleOneGerman?: Maybe<Scalars['String']['output']>;
  titleOneMandarin?: Maybe<Scalars['String']['output']>;
  titleOneSpanish?: Maybe<Scalars['String']['output']>;
  titleSpanish?: Maybe<Scalars['String']['output']>;
  titleTwoEnglish?: Maybe<Scalars['String']['output']>;
  titleTwoFrench?: Maybe<Scalars['String']['output']>;
  titleTwoGerman?: Maybe<Scalars['String']['output']>;
  titleTwoMandarin?: Maybe<Scalars['String']['output']>;
  titleTwoSpanish?: Maybe<Scalars['String']['output']>;
};


export type ComponentQuestionTypesGravitasScaleRatingInputArgs = {
  filters?: InputMaybe<ComponentRatingInputRatingInputFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentQuestionTypesGravitasSliders = {
  __typename?: 'ComponentQuestionTypesGravitasSliders';
  id: Scalars['ID']['output'];
  negativeHeadingEnglish?: Maybe<Scalars['String']['output']>;
  negativeHeadingFrench?: Maybe<Scalars['String']['output']>;
  negativeHeadingGerman?: Maybe<Scalars['String']['output']>;
  negativeHeadingMandarin?: Maybe<Scalars['String']['output']>;
  negativeHeadingSpanish?: Maybe<Scalars['String']['output']>;
  positiveHeadingEnglish?: Maybe<Scalars['String']['output']>;
  positiveHeadingFrench?: Maybe<Scalars['String']['output']>;
  positiveHeadingGerman?: Maybe<Scalars['String']['output']>;
  positiveHeadingMandarin?: Maybe<Scalars['String']['output']>;
  positiveHeadingSpanish?: Maybe<Scalars['String']['output']>;
  sliderHeadings?: Maybe<Array<Maybe<ComponentOptionSliderHeadings>>>;
  sliderQuestions?: Maybe<Array<Maybe<ComponentOptionSliderQuestions>>>;
  subTitleEnglish?: Maybe<Scalars['String']['output']>;
  subTitleFrench?: Maybe<Scalars['String']['output']>;
  subTitleGerman?: Maybe<Scalars['String']['output']>;
  subTitleMandarin?: Maybe<Scalars['String']['output']>;
  subTitleSpanish?: Maybe<Scalars['String']['output']>;
  titleEnglish?: Maybe<Scalars['String']['output']>;
  titleFrench?: Maybe<Scalars['String']['output']>;
  titleGerman?: Maybe<Scalars['String']['output']>;
  titleMandarin?: Maybe<Scalars['String']['output']>;
  titleSpanish?: Maybe<Scalars['String']['output']>;
};


export type ComponentQuestionTypesGravitasSlidersSliderHeadingsArgs = {
  filters?: InputMaybe<ComponentOptionSliderHeadingsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentQuestionTypesGravitasSlidersSliderQuestionsArgs = {
  filters?: InputMaybe<ComponentOptionSliderQuestionsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentQuestionTypesMultipleChoice = {
  __typename?: 'ComponentQuestionTypesMultipleChoice';
  id: Scalars['ID']['output'];
  numberOfAnswers?: Maybe<Scalars['Int']['output']>;
  option?: Maybe<Array<Maybe<ComponentOptionOption>>>;
  titleEnglish?: Maybe<Scalars['String']['output']>;
  titleFrench?: Maybe<Scalars['String']['output']>;
  titleGerman?: Maybe<Scalars['String']['output']>;
  titleMandarin?: Maybe<Scalars['String']['output']>;
  titleSpanish?: Maybe<Scalars['String']['output']>;
  viewPrevious?: Maybe<Scalars['Boolean']['output']>;
};


export type ComponentQuestionTypesMultipleChoiceOptionArgs = {
  filters?: InputMaybe<ComponentOptionOptionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentQuestionTypesNestedQuestions = {
  __typename?: 'ComponentQuestionTypesNestedQuestions';
  id: Scalars['ID']['output'];
  questions?: Maybe<Array<Maybe<ComponentQuestionTypesSimpleQuestion>>>;
  titleEnglish?: Maybe<Scalars['String']['output']>;
  titleFrench?: Maybe<Scalars['String']['output']>;
  titleGerman?: Maybe<Scalars['String']['output']>;
  titleMandarin?: Maybe<Scalars['String']['output']>;
  titleSpanish?: Maybe<Scalars['String']['output']>;
  viewPrevious?: Maybe<Scalars['Boolean']['output']>;
};


export type ComponentQuestionTypesNestedQuestionsQuestionsArgs = {
  filters?: InputMaybe<ComponentQuestionTypesSimpleQuestionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentQuestionTypesParticipant = {
  __typename?: 'ComponentQuestionTypesParticipant';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentQuestionTypesQuestionscompetency2 = {
  __typename?: 'ComponentQuestionTypesQuestionscompetency2';
  id: Scalars['ID']['output'];
  maxiLabel?: Maybe<Scalars['String']['output']>;
  maxiNumber?: Maybe<Scalars['Long']['output']>;
  midiLabel?: Maybe<Scalars['String']['output']>;
  miniLabel?: Maybe<Scalars['String']['output']>;
  miniNumber?: Maybe<Scalars['Long']['output']>;
  question?: Maybe<Scalars['String']['output']>;
  simpleQuestion?: Maybe<Scalars['Boolean']['output']>;
  textboxQuestion?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ComponentQuestionTypesQuestionscompetency2FiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentQuestionTypesQuestionscompetency2FiltersInput>>>;
  maxiLabel?: InputMaybe<StringFilterInput>;
  maxiNumber?: InputMaybe<LongFilterInput>;
  midiLabel?: InputMaybe<StringFilterInput>;
  miniLabel?: InputMaybe<StringFilterInput>;
  miniNumber?: InputMaybe<LongFilterInput>;
  not?: InputMaybe<ComponentQuestionTypesQuestionscompetency2FiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentQuestionTypesQuestionscompetency2FiltersInput>>>;
  question?: InputMaybe<StringFilterInput>;
  simpleQuestion?: InputMaybe<BooleanFilterInput>;
  textboxQuestion?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentQuestionTypesSaboteur = {
  __typename?: 'ComponentQuestionTypesSaboteur';
  id: Scalars['ID']['output'];
  labelEnglish?: Maybe<Scalars['String']['output']>;
  labelFrench?: Maybe<Scalars['String']['output']>;
  labelGerman?: Maybe<Scalars['String']['output']>;
  labelSpanish?: Maybe<Scalars['String']['output']>;
  saboteurQuestions?: Maybe<Array<Maybe<ComponentQuestionTypesSaboteurQuestions>>>;
  subTitleEnglish?: Maybe<Scalars['String']['output']>;
  subTitleFrench?: Maybe<Scalars['String']['output']>;
  subTitleGerman?: Maybe<Scalars['String']['output']>;
  subTitleMandarin?: Maybe<Scalars['String']['output']>;
  subTitleSpanish?: Maybe<Scalars['String']['output']>;
  titleEnglish?: Maybe<Scalars['String']['output']>;
  titleFrench?: Maybe<Scalars['String']['output']>;
  titleGerman?: Maybe<Scalars['String']['output']>;
  titleMandarin?: Maybe<Scalars['String']['output']>;
  titleSpanish?: Maybe<Scalars['String']['output']>;
};


export type ComponentQuestionTypesSaboteurSaboteurQuestionsArgs = {
  filters?: InputMaybe<ComponentQuestionTypesSaboteurQuestionsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentQuestionTypesSaboteurQuestions = {
  __typename?: 'ComponentQuestionTypesSaboteurQuestions';
  id: Scalars['ID']['output'];
  labelEnglish?: Maybe<Scalars['String']['output']>;
  labelFrench?: Maybe<Scalars['String']['output']>;
  labelGerman?: Maybe<Scalars['String']['output']>;
  labelMandarin?: Maybe<Scalars['String']['output']>;
  labelSpanish?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  proof: Array<Maybe<UploadFile>>;
  proof_connection?: Maybe<UploadFileRelationResponseCollection>;
  skipProof?: Maybe<Scalars['Boolean']['output']>;
};


export type ComponentQuestionTypesSaboteurQuestionsProofArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentQuestionTypesSaboteurQuestionsProof_ConnectionArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentQuestionTypesSaboteurQuestionsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentQuestionTypesSaboteurQuestionsFiltersInput>>>;
  labelEnglish?: InputMaybe<StringFilterInput>;
  labelFrench?: InputMaybe<StringFilterInput>;
  labelGerman?: InputMaybe<StringFilterInput>;
  labelMandarin?: InputMaybe<StringFilterInput>;
  labelSpanish?: InputMaybe<StringFilterInput>;
  link?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentQuestionTypesSaboteurQuestionsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentQuestionTypesSaboteurQuestionsFiltersInput>>>;
  skipProof?: InputMaybe<BooleanFilterInput>;
};

export type ComponentQuestionTypesSaboteurVideos = {
  __typename?: 'ComponentQuestionTypesSaboteurVideos';
  SaboteurVideo?: Maybe<Array<Maybe<ComponentSaboteurVideoSaboteurVideo>>>;
  id: Scalars['ID']['output'];
  subTitleEnglish?: Maybe<Scalars['String']['output']>;
  subTitleFrench?: Maybe<Scalars['String']['output']>;
  subTitleGerman?: Maybe<Scalars['String']['output']>;
  subTitleMandarin?: Maybe<Scalars['String']['output']>;
  subTitleSpanish?: Maybe<Scalars['String']['output']>;
  titleEnglish?: Maybe<Scalars['String']['output']>;
  titleFrench?: Maybe<Scalars['String']['output']>;
  titleGerman?: Maybe<Scalars['String']['output']>;
  titleMandarin?: Maybe<Scalars['String']['output']>;
  titleSpanish?: Maybe<Scalars['String']['output']>;
};


export type ComponentQuestionTypesSaboteurVideosSaboteurVideoArgs = {
  filters?: InputMaybe<ComponentSaboteurVideoSaboteurVideoFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentQuestionTypesSimpleQuestion = {
  __typename?: 'ComponentQuestionTypesSimpleQuestion';
  id: Scalars['ID']['output'];
  isNumeric?: Maybe<Scalars['Boolean']['output']>;
  subTitleEnglish?: Maybe<Scalars['String']['output']>;
  subTitleFrench?: Maybe<Scalars['String']['output']>;
  subTitleGerman?: Maybe<Scalars['String']['output']>;
  subTitleMandarin?: Maybe<Scalars['String']['output']>;
  subTitleSpanish?: Maybe<Scalars['String']['output']>;
  titleEnglish?: Maybe<Scalars['String']['output']>;
  titleFrench?: Maybe<Scalars['String']['output']>;
  titleGerman?: Maybe<Scalars['String']['output']>;
  titleMandarin?: Maybe<Scalars['String']['output']>;
  titleSpanish?: Maybe<Scalars['String']['output']>;
  viewPrevious?: Maybe<Scalars['Boolean']['output']>;
};

export type ComponentQuestionTypesSimpleQuestionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentQuestionTypesSimpleQuestionFiltersInput>>>;
  isNumeric?: InputMaybe<BooleanFilterInput>;
  not?: InputMaybe<ComponentQuestionTypesSimpleQuestionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentQuestionTypesSimpleQuestionFiltersInput>>>;
  subTitleEnglish?: InputMaybe<StringFilterInput>;
  subTitleFrench?: InputMaybe<StringFilterInput>;
  subTitleGerman?: InputMaybe<StringFilterInput>;
  subTitleMandarin?: InputMaybe<StringFilterInput>;
  subTitleSpanish?: InputMaybe<StringFilterInput>;
  titleEnglish?: InputMaybe<StringFilterInput>;
  titleFrench?: InputMaybe<StringFilterInput>;
  titleGerman?: InputMaybe<StringFilterInput>;
  titleMandarin?: InputMaybe<StringFilterInput>;
  titleSpanish?: InputMaybe<StringFilterInput>;
  viewPrevious?: InputMaybe<BooleanFilterInput>;
};

export type ComponentQuestionTypesSimpleReadOnly = {
  __typename?: 'ComponentQuestionTypesSimpleReadOnly';
  contentEnglish?: Maybe<Scalars['String']['output']>;
  contentFrench?: Maybe<Scalars['String']['output']>;
  contentGerman?: Maybe<Scalars['String']['output']>;
  contentMandarin?: Maybe<Scalars['String']['output']>;
  contentSpanish?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  photo?: Maybe<UploadFile>;
  subTitleEnglish?: Maybe<Scalars['String']['output']>;
  subTitleFrench?: Maybe<Scalars['String']['output']>;
  subTitleGerman?: Maybe<Scalars['String']['output']>;
  subTitleMandarin?: Maybe<Scalars['String']['output']>;
  subTitleSpanish?: Maybe<Scalars['String']['output']>;
  titleEnglish?: Maybe<Scalars['String']['output']>;
  titleFrench?: Maybe<Scalars['String']['output']>;
  titleGerman?: Maybe<Scalars['String']['output']>;
  titleMandarin?: Maybe<Scalars['String']['output']>;
  titleSpanish?: Maybe<Scalars['String']['output']>;
};

export type ComponentQuestionTypesSliderQuestions = {
  __typename?: 'ComponentQuestionTypesSliderQuestions';
  color?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  question?: Maybe<Scalars['String']['output']>;
};

export type ComponentQuestionTypesSliderQuestionsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentQuestionTypesSliderQuestionsFiltersInput>>>;
  color?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentQuestionTypesSliderQuestionsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentQuestionTypesSliderQuestionsFiltersInput>>>;
  question?: InputMaybe<StringFilterInput>;
};

export type ComponentQuestionTypesStakeholderMap = {
  __typename?: 'ComponentQuestionTypesStakeholderMap';
  id: Scalars['ID']['output'];
  questionX?: Maybe<Scalars['String']['output']>;
  questionY?: Maybe<Scalars['String']['output']>;
  subTitleEnglish?: Maybe<Scalars['String']['output']>;
  subTitleFrench?: Maybe<Scalars['String']['output']>;
  subTitleGerman?: Maybe<Scalars['String']['output']>;
  subTitleMandarin?: Maybe<Scalars['String']['output']>;
  subTitleSpanish?: Maybe<Scalars['String']['output']>;
  titleEnglish?: Maybe<Scalars['String']['output']>;
  titleFrench?: Maybe<Scalars['String']['output']>;
  titleGerman?: Maybe<Scalars['String']['output']>;
  titleMandarin?: Maybe<Scalars['String']['output']>;
  titleSpanish?: Maybe<Scalars['String']['output']>;
};

export type ComponentQuestionTypesUploadDocuments = {
  __typename?: 'ComponentQuestionTypesUploadDocuments';
  id: Scalars['ID']['output'];
  subTitleEnglish?: Maybe<Scalars['String']['output']>;
  subTitleFrench?: Maybe<Scalars['String']['output']>;
  subTitleGerman?: Maybe<Scalars['String']['output']>;
  subTitleMandarin?: Maybe<Scalars['String']['output']>;
  subTitleSpanish?: Maybe<Scalars['String']['output']>;
  titleEnglish?: Maybe<Scalars['String']['output']>;
  titleFrench?: Maybe<Scalars['String']['output']>;
  titleGerman?: Maybe<Scalars['String']['output']>;
  titleMandarin?: Maybe<Scalars['String']['output']>;
  titleSpanish?: Maybe<Scalars['String']['output']>;
};

export type ComponentQuestionTypesUploadQuestion = {
  __typename?: 'ComponentQuestionTypesUploadQuestion';
  file: Array<Maybe<UploadFile>>;
  file_connection?: Maybe<UploadFileRelationResponseCollection>;
  id: Scalars['ID']['output'];
};


export type ComponentQuestionTypesUploadQuestionFileArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentQuestionTypesUploadQuestionFile_ConnectionArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentQuestionTypesValuesBubble = {
  __typename?: 'ComponentQuestionTypesValuesBubble';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  question?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ComponentQuestionTypesValuesCharacters = {
  __typename?: 'ComponentQuestionTypesValuesCharacters';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  question?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ComponentQuestionTypesValuesGaps = {
  __typename?: 'ComponentQuestionTypesValuesGaps';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  question?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ComponentQuestionTypesValuesNested = {
  __typename?: 'ComponentQuestionTypesValuesNested';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  question?: Maybe<Scalars['String']['output']>;
  questions?: Maybe<Array<Maybe<ComponentQuestionTypesSimpleQuestion>>>;
  title?: Maybe<Scalars['String']['output']>;
};


export type ComponentQuestionTypesValuesNestedQuestionsArgs = {
  filters?: InputMaybe<ComponentQuestionTypesSimpleQuestionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentQuestionTypesValuesSliders = {
  __typename?: 'ComponentQuestionTypesValuesSliders';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  question?: Maybe<Scalars['String']['output']>;
  sliderQuestions?: Maybe<Array<Maybe<ComponentQuestionTypesSliderQuestions>>>;
  title?: Maybe<Scalars['String']['output']>;
};


export type ComponentQuestionTypesValuesSlidersSliderQuestionsArgs = {
  filters?: InputMaybe<ComponentQuestionTypesSliderQuestionsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentQuestionTypesXyGraph = {
  __typename?: 'ComponentQuestionTypesXYGraph';
  id: Scalars['ID']['output'];
  labelXEnglish?: Maybe<Scalars['String']['output']>;
  labelXFrench?: Maybe<Scalars['String']['output']>;
  labelXGerman?: Maybe<Scalars['String']['output']>;
  labelXMandarin?: Maybe<Scalars['String']['output']>;
  labelXSpanish?: Maybe<Scalars['String']['output']>;
  labelYEnglish?: Maybe<Scalars['String']['output']>;
  labelYFrench?: Maybe<Scalars['String']['output']>;
  labelYGerman?: Maybe<Scalars['String']['output']>;
  labelYMandarin?: Maybe<Scalars['String']['output']>;
  labelYSpanish?: Maybe<Scalars['String']['output']>;
  subTitleEnglish?: Maybe<Scalars['String']['output']>;
  subTitleFrench?: Maybe<Scalars['String']['output']>;
  subTitleGerman?: Maybe<Scalars['String']['output']>;
  subTitleMandarin?: Maybe<Scalars['String']['output']>;
  subTitleSpanish?: Maybe<Scalars['String']['output']>;
  titleEnglish?: Maybe<Scalars['String']['output']>;
  titleFrench?: Maybe<Scalars['String']['output']>;
  titleGerman?: Maybe<Scalars['String']['output']>;
  titleMandarin?: Maybe<Scalars['String']['output']>;
  titleSpanish?: Maybe<Scalars['String']['output']>;
};

export type ComponentRatingInputRatingInput = {
  __typename?: 'ComponentRatingInputRatingInput';
  id: Scalars['ID']['output'];
  labelOneEnglish?: Maybe<Scalars['String']['output']>;
  labelOneFrench?: Maybe<Scalars['String']['output']>;
  labelOneGerman?: Maybe<Scalars['String']['output']>;
  labelOneMandarin?: Maybe<Scalars['String']['output']>;
  labelOneSpanish?: Maybe<Scalars['String']['output']>;
  labelTwoEnglish?: Maybe<Scalars['String']['output']>;
  labelTwoFrench?: Maybe<Scalars['String']['output']>;
  labelTwoGerman?: Maybe<Scalars['String']['output']>;
  labelTwoMandarin?: Maybe<Scalars['String']['output']>;
  labelTwoSpanish?: Maybe<Scalars['String']['output']>;
};

export type ComponentRatingInputRatingInputFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentRatingInputRatingInputFiltersInput>>>;
  labelOneEnglish?: InputMaybe<StringFilterInput>;
  labelOneFrench?: InputMaybe<StringFilterInput>;
  labelOneGerman?: InputMaybe<StringFilterInput>;
  labelOneMandarin?: InputMaybe<StringFilterInput>;
  labelOneSpanish?: InputMaybe<StringFilterInput>;
  labelTwoEnglish?: InputMaybe<StringFilterInput>;
  labelTwoFrench?: InputMaybe<StringFilterInput>;
  labelTwoGerman?: InputMaybe<StringFilterInput>;
  labelTwoMandarin?: InputMaybe<StringFilterInput>;
  labelTwoSpanish?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentRatingInputRatingInputFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentRatingInputRatingInputFiltersInput>>>;
};

export type ComponentSaboteurVideoSaboteurVideo = {
  __typename?: 'ComponentSaboteurVideoSaboteurVideo';
  id: Scalars['ID']['output'];
  video?: Maybe<UploadFile>;
  videoDescriptionEnglish?: Maybe<Scalars['String']['output']>;
  videoDescriptionFrench?: Maybe<Scalars['String']['output']>;
  videoDescriptionGerman?: Maybe<Scalars['String']['output']>;
  videoDescriptionMandarin?: Maybe<Scalars['String']['output']>;
  videoDescriptionSpanish?: Maybe<Scalars['String']['output']>;
  videoTitleEnglish?: Maybe<Scalars['String']['output']>;
  videoTitleFrench?: Maybe<Scalars['String']['output']>;
  videoTitleGerman?: Maybe<Scalars['String']['output']>;
  videoTitleMandarin?: Maybe<Scalars['String']['output']>;
  videoTitleSpanish?: Maybe<Scalars['String']['output']>;
};

export type ComponentSaboteurVideoSaboteurVideoFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSaboteurVideoSaboteurVideoFiltersInput>>>;
  not?: InputMaybe<ComponentSaboteurVideoSaboteurVideoFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSaboteurVideoSaboteurVideoFiltersInput>>>;
  videoDescriptionEnglish?: InputMaybe<StringFilterInput>;
  videoDescriptionFrench?: InputMaybe<StringFilterInput>;
  videoDescriptionGerman?: InputMaybe<StringFilterInput>;
  videoDescriptionMandarin?: InputMaybe<StringFilterInput>;
  videoDescriptionSpanish?: InputMaybe<StringFilterInput>;
  videoTitleEnglish?: InputMaybe<StringFilterInput>;
  videoTitleFrench?: InputMaybe<StringFilterInput>;
  videoTitleGerman?: InputMaybe<StringFilterInput>;
  videoTitleMandarin?: InputMaybe<StringFilterInput>;
  videoTitleSpanish?: InputMaybe<StringFilterInput>;
};

export type ComponentStakeholderMapItemStackholderMapItem = {
  __typename?: 'ComponentStakeholderMapItemStackholderMapItem';
  color?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  valueX?: Maybe<Scalars['Int']['output']>;
  valueY?: Maybe<Scalars['Int']['output']>;
};

export type ComponentStakeholderMapItemStackholderMapItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentStakeholderMapItemStackholderMapItemFiltersInput>>>;
  color?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentStakeholderMapItemStackholderMapItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentStakeholderMapItemStackholderMapItemFiltersInput>>>;
  valueX?: InputMaybe<IntFilterInput>;
  valueY?: InputMaybe<IntFilterInput>;
};

export type ComponentStakeholderMapItemStackholderMapItemInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  valueX?: InputMaybe<Scalars['Int']['input']>;
  valueY?: InputMaybe<Scalars['Int']['input']>;
};

export type ComponentSubmissionsAnswer = {
  __typename?: 'ComponentSubmissionsAnswer';
  answer?: Maybe<Scalars['String']['output']>;
  feedback?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isCorrect?: Maybe<Scalars['Boolean']['output']>;
  nestedAnswers?: Maybe<Array<Maybe<ComponentSubmissionsRepeatAnswer>>>;
  outcome?: Maybe<Enum_Componentsubmissionsanswer_Outcome>;
  questionId?: Maybe<Scalars['String']['output']>;
  questionTitle?: Maybe<Scalars['String']['output']>;
  questionType?: Maybe<Scalars['String']['output']>;
};


export type ComponentSubmissionsAnswerNestedAnswersArgs = {
  filters?: InputMaybe<ComponentSubmissionsRepeatAnswerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSubmissionsAnswerFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSubmissionsAnswerFiltersInput>>>;
  answer?: InputMaybe<StringFilterInput>;
  feedback?: InputMaybe<StringFilterInput>;
  isCorrect?: InputMaybe<BooleanFilterInput>;
  nestedAnswers?: InputMaybe<ComponentSubmissionsRepeatAnswerFiltersInput>;
  not?: InputMaybe<ComponentSubmissionsAnswerFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSubmissionsAnswerFiltersInput>>>;
  outcome?: InputMaybe<StringFilterInput>;
  questionId?: InputMaybe<StringFilterInput>;
  questionTitle?: InputMaybe<StringFilterInput>;
  questionType?: InputMaybe<StringFilterInput>;
};

export type ComponentSubmissionsAnswerInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isCorrect?: InputMaybe<Scalars['Boolean']['input']>;
  nestedAnswers?: InputMaybe<Array<InputMaybe<ComponentSubmissionsRepeatAnswerInput>>>;
  outcome?: InputMaybe<Enum_Componentsubmissionsanswer_Outcome>;
  questionId?: InputMaybe<Scalars['String']['input']>;
  questionTitle?: InputMaybe<Scalars['String']['input']>;
  questionType?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSubmissionsCharacteristics = {
  __typename?: 'ComponentSubmissionsCharacteristics';
  answer?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type ComponentSubmissionsCharacteristicsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSubmissionsCharacteristicsFiltersInput>>>;
  answer?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSubmissionsCharacteristicsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSubmissionsCharacteristicsFiltersInput>>>;
  type?: InputMaybe<StringFilterInput>;
};

export type ComponentSubmissionsCharacteristicsInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSubmissionsCompetencyAnswer = {
  __typename?: 'ComponentSubmissionsCompetencyAnswer';
  headingQuestion?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isSimpleQuestion?: Maybe<Scalars['Boolean']['output']>;
  question?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  response?: Maybe<Scalars['String']['output']>;
  steps?: Maybe<Scalars['Int']['output']>;
  textboxQuestion?: Maybe<Scalars['String']['output']>;
};

export type ComponentSubmissionsCompetencyAnswerFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSubmissionsCompetencyAnswerFiltersInput>>>;
  headingQuestion?: InputMaybe<StringFilterInput>;
  isSimpleQuestion?: InputMaybe<BooleanFilterInput>;
  not?: InputMaybe<ComponentSubmissionsCompetencyAnswerFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSubmissionsCompetencyAnswerFiltersInput>>>;
  question?: InputMaybe<StringFilterInput>;
  rating?: InputMaybe<IntFilterInput>;
  response?: InputMaybe<StringFilterInput>;
  steps?: InputMaybe<IntFilterInput>;
  textboxQuestion?: InputMaybe<StringFilterInput>;
};

export type ComponentSubmissionsCompetencyAnswerInput = {
  headingQuestion?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isSimpleQuestion?: InputMaybe<Scalars['Boolean']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  response?: InputMaybe<Scalars['String']['input']>;
  steps?: InputMaybe<Scalars['Int']['input']>;
  textboxQuestion?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSubmissionsCompetencyParticipants = {
  __typename?: 'ComponentSubmissionsCompetencyParticipants';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type ComponentSubmissionsCompetencyParticipantsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSubmissionsCompetencyParticipantsFiltersInput>>>;
  email?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSubmissionsCompetencyParticipantsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSubmissionsCompetencyParticipantsFiltersInput>>>;
};

export type ComponentSubmissionsCompetencyParticipantsInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSubmissionsGravitasGap = {
  __typename?: 'ComponentSubmissionsGravitasGap';
  commitment?: Maybe<Scalars['String']['output']>;
  gap?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentSubmissionsGravitasGapFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSubmissionsGravitasGapFiltersInput>>>;
  commitment?: InputMaybe<StringFilterInput>;
  gap?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSubmissionsGravitasGapFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSubmissionsGravitasGapFiltersInput>>>;
};

export type ComponentSubmissionsGravitasGapInput = {
  commitment?: InputMaybe<Scalars['String']['input']>;
  gap?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentSubmissionsGravitasSlidersAnswers = {
  __typename?: 'ComponentSubmissionsGravitasSlidersAnswers';
  colorAndRating?: Maybe<Array<Maybe<ComponentOptionColorAndRating>>>;
  id: Scalars['ID']['output'];
  negativeQuestion?: Maybe<Scalars['String']['output']>;
  positiveQuestion?: Maybe<Scalars['String']['output']>;
};


export type ComponentSubmissionsGravitasSlidersAnswersColorAndRatingArgs = {
  filters?: InputMaybe<ComponentOptionColorAndRatingFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSubmissionsGravitasSlidersAnswersFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSubmissionsGravitasSlidersAnswersFiltersInput>>>;
  colorAndRating?: InputMaybe<ComponentOptionColorAndRatingFiltersInput>;
  negativeQuestion?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSubmissionsGravitasSlidersAnswersFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSubmissionsGravitasSlidersAnswersFiltersInput>>>;
  positiveQuestion?: InputMaybe<StringFilterInput>;
};

export type ComponentSubmissionsGravitasSlidersAnswersInput = {
  colorAndRating?: InputMaybe<Array<InputMaybe<ComponentOptionColorAndRatingInput>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  negativeQuestion?: InputMaybe<Scalars['String']['input']>;
  positiveQuestion?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSubmissionsNotes = {
  __typename?: 'ComponentSubmissionsNotes';
  description?: Maybe<Scalars['String']['output']>;
  document?: Maybe<UploadFile>;
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type ComponentSubmissionsNotesFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSubmissionsNotesFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSubmissionsNotesFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSubmissionsNotesFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentSubmissionsNotesInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  document?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSubmissionsParticipants = {
  __typename?: 'ComponentSubmissionsParticipants';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type ComponentSubmissionsParticipantsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSubmissionsParticipantsFiltersInput>>>;
  email?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSubmissionsParticipantsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSubmissionsParticipantsFiltersInput>>>;
};

export type ComponentSubmissionsParticipantsInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSubmissionsProgrammeSubmissions = {
  __typename?: 'ComponentSubmissionsProgrammeSubmissions';
  answers?: Maybe<Array<Maybe<ComponentSubmissionsAnswer>>>;
  characteristics?: Maybe<Array<Maybe<ComponentSubmissionsCharacteristics>>>;
  competencyAnswers?: Maybe<Array<Maybe<ComponentSubmissionsCompetencyAnswer>>>;
  gapsAnswers?: Maybe<Array<Maybe<ComponentSubmissionsValuesGaps>>>;
  gravitasGap?: Maybe<Array<Maybe<ComponentSubmissionsGravitasGap>>>;
  gravitasScales?: Maybe<Array<Maybe<ComponentGravitasScaleItemsGravitasScaleItems>>>;
  gravitasSliderAnswers?: Maybe<Array<Maybe<ComponentSubmissionsGravitasSlidersAnswers>>>;
  id: Scalars['ID']['output'];
  saboteur?: Maybe<Array<Maybe<ComponentSubmissionsSaboteurComponent>>>;
  saboteurImage?: Maybe<UploadFile>;
  saboteurSkipProofs?: Maybe<Array<Maybe<ComponentSubmissionsSkipProofComponent>>>;
  sabtourVideosProofs?: Maybe<Array<Maybe<ComponentSubmissionsSabtourVideosComponent>>>;
  sliderAnswers?: Maybe<Scalars['JSON']['output']>;
  sliderImage?: Maybe<UploadFile>;
  stakeholderChart?: Maybe<UploadFile>;
  stakeholderItems?: Maybe<Array<Maybe<ComponentStakeholderMapItemStackholderMapItem>>>;
  xYGraphChart?: Maybe<UploadFile>;
  xYGraphItems?: Maybe<Array<Maybe<ComponentXyGraphItemXyGraphItem>>>;
};


export type ComponentSubmissionsProgrammeSubmissionsAnswersArgs = {
  filters?: InputMaybe<ComponentSubmissionsAnswerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentSubmissionsProgrammeSubmissionsCharacteristicsArgs = {
  filters?: InputMaybe<ComponentSubmissionsCharacteristicsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentSubmissionsProgrammeSubmissionsCompetencyAnswersArgs = {
  filters?: InputMaybe<ComponentSubmissionsCompetencyAnswerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentSubmissionsProgrammeSubmissionsGapsAnswersArgs = {
  filters?: InputMaybe<ComponentSubmissionsValuesGapsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentSubmissionsProgrammeSubmissionsGravitasGapArgs = {
  filters?: InputMaybe<ComponentSubmissionsGravitasGapFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentSubmissionsProgrammeSubmissionsGravitasScalesArgs = {
  filters?: InputMaybe<ComponentGravitasScaleItemsGravitasScaleItemsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentSubmissionsProgrammeSubmissionsGravitasSliderAnswersArgs = {
  filters?: InputMaybe<ComponentSubmissionsGravitasSlidersAnswersFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentSubmissionsProgrammeSubmissionsSaboteurArgs = {
  filters?: InputMaybe<ComponentSubmissionsSaboteurComponentFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentSubmissionsProgrammeSubmissionsSaboteurSkipProofsArgs = {
  filters?: InputMaybe<ComponentSubmissionsSkipProofComponentFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentSubmissionsProgrammeSubmissionsSabtourVideosProofsArgs = {
  filters?: InputMaybe<ComponentSubmissionsSabtourVideosComponentFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentSubmissionsProgrammeSubmissionsStakeholderItemsArgs = {
  filters?: InputMaybe<ComponentStakeholderMapItemStackholderMapItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentSubmissionsProgrammeSubmissionsXyGraphItemsArgs = {
  filters?: InputMaybe<ComponentXyGraphItemXyGraphItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSubmissionsProgrammeSubmissionsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSubmissionsProgrammeSubmissionsFiltersInput>>>;
  answers?: InputMaybe<ComponentSubmissionsAnswerFiltersInput>;
  characteristics?: InputMaybe<ComponentSubmissionsCharacteristicsFiltersInput>;
  competencyAnswers?: InputMaybe<ComponentSubmissionsCompetencyAnswerFiltersInput>;
  gapsAnswers?: InputMaybe<ComponentSubmissionsValuesGapsFiltersInput>;
  gravitasGap?: InputMaybe<ComponentSubmissionsGravitasGapFiltersInput>;
  gravitasScales?: InputMaybe<ComponentGravitasScaleItemsGravitasScaleItemsFiltersInput>;
  gravitasSliderAnswers?: InputMaybe<ComponentSubmissionsGravitasSlidersAnswersFiltersInput>;
  not?: InputMaybe<ComponentSubmissionsProgrammeSubmissionsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSubmissionsProgrammeSubmissionsFiltersInput>>>;
  saboteur?: InputMaybe<ComponentSubmissionsSaboteurComponentFiltersInput>;
  saboteurSkipProofs?: InputMaybe<ComponentSubmissionsSkipProofComponentFiltersInput>;
  sabtourVideosProofs?: InputMaybe<ComponentSubmissionsSabtourVideosComponentFiltersInput>;
  sliderAnswers?: InputMaybe<JsonFilterInput>;
  stakeholderItems?: InputMaybe<ComponentStakeholderMapItemStackholderMapItemFiltersInput>;
  xYGraphItems?: InputMaybe<ComponentXyGraphItemXyGraphItemFiltersInput>;
};

export type ComponentSubmissionsProgrammeSubmissionsInput = {
  answers?: InputMaybe<Array<InputMaybe<ComponentSubmissionsAnswerInput>>>;
  characteristics?: InputMaybe<Array<InputMaybe<ComponentSubmissionsCharacteristicsInput>>>;
  competencyAnswers?: InputMaybe<Array<InputMaybe<ComponentSubmissionsCompetencyAnswerInput>>>;
  gapsAnswers?: InputMaybe<Array<InputMaybe<ComponentSubmissionsValuesGapsInput>>>;
  gravitasGap?: InputMaybe<Array<InputMaybe<ComponentSubmissionsGravitasGapInput>>>;
  gravitasScales?: InputMaybe<Array<InputMaybe<ComponentGravitasScaleItemsGravitasScaleItemsInput>>>;
  gravitasSliderAnswers?: InputMaybe<Array<InputMaybe<ComponentSubmissionsGravitasSlidersAnswersInput>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  saboteur?: InputMaybe<Array<InputMaybe<ComponentSubmissionsSaboteurComponentInput>>>;
  saboteurImage?: InputMaybe<Scalars['ID']['input']>;
  saboteurSkipProofs?: InputMaybe<Array<InputMaybe<ComponentSubmissionsSkipProofComponentInput>>>;
  sabtourVideosProofs?: InputMaybe<Array<InputMaybe<ComponentSubmissionsSabtourVideosComponentInput>>>;
  sliderAnswers?: InputMaybe<Scalars['JSON']['input']>;
  sliderImage?: InputMaybe<Scalars['ID']['input']>;
  stakeholderChart?: InputMaybe<Scalars['ID']['input']>;
  stakeholderItems?: InputMaybe<Array<InputMaybe<ComponentStakeholderMapItemStackholderMapItemInput>>>;
  xYGraphChart?: InputMaybe<Scalars['ID']['input']>;
  xYGraphItems?: InputMaybe<Array<InputMaybe<ComponentXyGraphItemXyGraphItemInput>>>;
};

export type ComponentSubmissionsRepeatAnswer = {
  __typename?: 'ComponentSubmissionsRepeatAnswer';
  answer?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  questionTitle?: Maybe<Scalars['String']['output']>;
};

export type ComponentSubmissionsRepeatAnswerFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSubmissionsRepeatAnswerFiltersInput>>>;
  answer?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSubmissionsRepeatAnswerFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSubmissionsRepeatAnswerFiltersInput>>>;
  questionTitle?: InputMaybe<StringFilterInput>;
};

export type ComponentSubmissionsRepeatAnswerInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  questionTitle?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSubmissionsSaboteurComponent = {
  __typename?: 'ComponentSubmissionsSaboteurComponent';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  saboteurProofValue?: Maybe<UploadFile>;
};

export type ComponentSubmissionsSaboteurComponentFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSubmissionsSaboteurComponentFiltersInput>>>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSubmissionsSaboteurComponentFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSubmissionsSaboteurComponentFiltersInput>>>;
};

export type ComponentSubmissionsSaboteurComponentInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  saboteurProofValue?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentSubmissionsSabtourVideosComponent = {
  __typename?: 'ComponentSubmissionsSabtourVideosComponent';
  id: Scalars['ID']['output'];
  sabtourValue?: Maybe<Scalars['String']['output']>;
};

export type ComponentSubmissionsSabtourVideosComponentFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSubmissionsSabtourVideosComponentFiltersInput>>>;
  not?: InputMaybe<ComponentSubmissionsSabtourVideosComponentFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSubmissionsSabtourVideosComponentFiltersInput>>>;
  sabtourValue?: InputMaybe<StringFilterInput>;
};

export type ComponentSubmissionsSabtourVideosComponentInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  sabtourValue?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSubmissionsSectionSubmission = {
  __typename?: 'ComponentSubmissionsSectionSubmission';
  answers?: Maybe<Array<Maybe<ComponentSubmissionsAnswer>>>;
  characteristics?: Maybe<Array<Maybe<ComponentSubmissionsCharacteristics>>>;
  competencyAnswers?: Maybe<Array<Maybe<ComponentSubmissionsCompetencyAnswer>>>;
  emailSent?: Maybe<Scalars['Boolean']['output']>;
  gapsAnswers?: Maybe<Array<Maybe<ComponentSubmissionsValuesGaps>>>;
  gravitasGap?: Maybe<Array<Maybe<ComponentSubmissionsGravitasGap>>>;
  gravitasScales?: Maybe<Array<Maybe<ComponentGravitasScaleItemsGravitasScaleItems>>>;
  gravitasSliderAnswers?: Maybe<Array<Maybe<ComponentSubmissionsGravitasSlidersAnswers>>>;
  id: Scalars['ID']['output'];
  progress?: Maybe<Scalars['Int']['output']>;
  saboteur?: Maybe<Array<Maybe<ComponentSubmissionsSaboteurComponent>>>;
  saboteurImage?: Maybe<UploadFile>;
  saboteurSkipProofs?: Maybe<Array<Maybe<ComponentSubmissionsSkipProofComponent>>>;
  sabtourVideosProofs?: Maybe<Array<Maybe<ComponentSubmissionsSabtourVideosComponent>>>;
  section?: Maybe<Section>;
  sliderAnswers?: Maybe<Scalars['JSON']['output']>;
  sliderImage?: Maybe<UploadFile>;
  stakeholderChart?: Maybe<UploadFile>;
  stakeholderItems?: Maybe<Array<Maybe<ComponentStakeholderMapItemStackholderMapItem>>>;
  uploadDocuments?: Maybe<Array<Maybe<ComponentSubmissionsUploadDocuments>>>;
  xYGraphChart?: Maybe<UploadFile>;
  xYGraphItems?: Maybe<Array<Maybe<ComponentXyGraphItemXyGraphItem>>>;
};


export type ComponentSubmissionsSectionSubmissionAnswersArgs = {
  filters?: InputMaybe<ComponentSubmissionsAnswerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentSubmissionsSectionSubmissionCharacteristicsArgs = {
  filters?: InputMaybe<ComponentSubmissionsCharacteristicsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentSubmissionsSectionSubmissionCompetencyAnswersArgs = {
  filters?: InputMaybe<ComponentSubmissionsCompetencyAnswerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentSubmissionsSectionSubmissionGapsAnswersArgs = {
  filters?: InputMaybe<ComponentSubmissionsValuesGapsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentSubmissionsSectionSubmissionGravitasGapArgs = {
  filters?: InputMaybe<ComponentSubmissionsGravitasGapFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentSubmissionsSectionSubmissionGravitasScalesArgs = {
  filters?: InputMaybe<ComponentGravitasScaleItemsGravitasScaleItemsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentSubmissionsSectionSubmissionGravitasSliderAnswersArgs = {
  filters?: InputMaybe<ComponentSubmissionsGravitasSlidersAnswersFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentSubmissionsSectionSubmissionSaboteurArgs = {
  filters?: InputMaybe<ComponentSubmissionsSaboteurComponentFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentSubmissionsSectionSubmissionSaboteurSkipProofsArgs = {
  filters?: InputMaybe<ComponentSubmissionsSkipProofComponentFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentSubmissionsSectionSubmissionSabtourVideosProofsArgs = {
  filters?: InputMaybe<ComponentSubmissionsSabtourVideosComponentFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentSubmissionsSectionSubmissionStakeholderItemsArgs = {
  filters?: InputMaybe<ComponentStakeholderMapItemStackholderMapItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentSubmissionsSectionSubmissionUploadDocumentsArgs = {
  filters?: InputMaybe<ComponentSubmissionsUploadDocumentsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentSubmissionsSectionSubmissionXyGraphItemsArgs = {
  filters?: InputMaybe<ComponentXyGraphItemXyGraphItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSubmissionsSectionSubmissionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSubmissionsSectionSubmissionFiltersInput>>>;
  answers?: InputMaybe<ComponentSubmissionsAnswerFiltersInput>;
  characteristics?: InputMaybe<ComponentSubmissionsCharacteristicsFiltersInput>;
  competencyAnswers?: InputMaybe<ComponentSubmissionsCompetencyAnswerFiltersInput>;
  emailSent?: InputMaybe<BooleanFilterInput>;
  gapsAnswers?: InputMaybe<ComponentSubmissionsValuesGapsFiltersInput>;
  gravitasGap?: InputMaybe<ComponentSubmissionsGravitasGapFiltersInput>;
  gravitasScales?: InputMaybe<ComponentGravitasScaleItemsGravitasScaleItemsFiltersInput>;
  gravitasSliderAnswers?: InputMaybe<ComponentSubmissionsGravitasSlidersAnswersFiltersInput>;
  not?: InputMaybe<ComponentSubmissionsSectionSubmissionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSubmissionsSectionSubmissionFiltersInput>>>;
  progress?: InputMaybe<IntFilterInput>;
  saboteur?: InputMaybe<ComponentSubmissionsSaboteurComponentFiltersInput>;
  saboteurSkipProofs?: InputMaybe<ComponentSubmissionsSkipProofComponentFiltersInput>;
  sabtourVideosProofs?: InputMaybe<ComponentSubmissionsSabtourVideosComponentFiltersInput>;
  section?: InputMaybe<SectionFiltersInput>;
  sliderAnswers?: InputMaybe<JsonFilterInput>;
  stakeholderItems?: InputMaybe<ComponentStakeholderMapItemStackholderMapItemFiltersInput>;
  uploadDocuments?: InputMaybe<ComponentSubmissionsUploadDocumentsFiltersInput>;
  xYGraphItems?: InputMaybe<ComponentXyGraphItemXyGraphItemFiltersInput>;
};

export type ComponentSubmissionsSectionSubmissionInput = {
  answers?: InputMaybe<Array<InputMaybe<ComponentSubmissionsAnswerInput>>>;
  characteristics?: InputMaybe<Array<InputMaybe<ComponentSubmissionsCharacteristicsInput>>>;
  competencyAnswers?: InputMaybe<Array<InputMaybe<ComponentSubmissionsCompetencyAnswerInput>>>;
  emailSent?: InputMaybe<Scalars['Boolean']['input']>;
  gapsAnswers?: InputMaybe<Array<InputMaybe<ComponentSubmissionsValuesGapsInput>>>;
  gravitasGap?: InputMaybe<Array<InputMaybe<ComponentSubmissionsGravitasGapInput>>>;
  gravitasScales?: InputMaybe<Array<InputMaybe<ComponentGravitasScaleItemsGravitasScaleItemsInput>>>;
  gravitasSliderAnswers?: InputMaybe<Array<InputMaybe<ComponentSubmissionsGravitasSlidersAnswersInput>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  progress?: InputMaybe<Scalars['Int']['input']>;
  saboteur?: InputMaybe<Array<InputMaybe<ComponentSubmissionsSaboteurComponentInput>>>;
  saboteurImage?: InputMaybe<Scalars['ID']['input']>;
  saboteurSkipProofs?: InputMaybe<Array<InputMaybe<ComponentSubmissionsSkipProofComponentInput>>>;
  sabtourVideosProofs?: InputMaybe<Array<InputMaybe<ComponentSubmissionsSabtourVideosComponentInput>>>;
  section?: InputMaybe<Scalars['ID']['input']>;
  sliderAnswers?: InputMaybe<Scalars['JSON']['input']>;
  sliderImage?: InputMaybe<Scalars['ID']['input']>;
  stakeholderChart?: InputMaybe<Scalars['ID']['input']>;
  stakeholderItems?: InputMaybe<Array<InputMaybe<ComponentStakeholderMapItemStackholderMapItemInput>>>;
  uploadDocuments?: InputMaybe<Array<InputMaybe<ComponentSubmissionsUploadDocumentsInput>>>;
  xYGraphChart?: InputMaybe<Scalars['ID']['input']>;
  xYGraphItems?: InputMaybe<Array<InputMaybe<ComponentXyGraphItemXyGraphItemInput>>>;
};

export type ComponentSubmissionsSkipProofComponent = {
  __typename?: 'ComponentSubmissionsSkipProofComponent';
  id: Scalars['ID']['output'];
  skipProofValue?: Maybe<Scalars['String']['output']>;
};

export type ComponentSubmissionsSkipProofComponentFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSubmissionsSkipProofComponentFiltersInput>>>;
  not?: InputMaybe<ComponentSubmissionsSkipProofComponentFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSubmissionsSkipProofComponentFiltersInput>>>;
  skipProofValue?: InputMaybe<StringFilterInput>;
};

export type ComponentSubmissionsSkipProofComponentInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  skipProofValue?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSubmissionsSubModuleSubmission = {
  __typename?: 'ComponentSubmissionsSubModuleSubmission';
  answers?: Maybe<Array<Maybe<ComponentSubmissionsAnswer>>>;
  characteristics?: Maybe<Array<Maybe<ComponentSubmissionsCharacteristics>>>;
  competencyAnswers?: Maybe<Array<Maybe<ComponentSubmissionsCompetencyAnswer>>>;
  emailSent?: Maybe<Scalars['Boolean']['output']>;
  gapsAnswers?: Maybe<Array<Maybe<ComponentSubmissionsValuesGaps>>>;
  gravitasScales?: Maybe<Array<Maybe<ComponentGravitasScaleItemsGravitasScaleItems>>>;
  id: Scalars['ID']['output'];
  progress?: Maybe<Scalars['Int']['output']>;
  saboteurImage?: Maybe<UploadFile>;
  saboteurSkipProofs?: Maybe<Array<Maybe<ComponentSubmissionsSkipProofComponent>>>;
  section?: Maybe<Section>;
  sliderAnswers?: Maybe<Scalars['JSON']['output']>;
  sliderImage?: Maybe<UploadFile>;
  stakeholderChart?: Maybe<UploadFile>;
  stakeholderItems?: Maybe<Array<Maybe<ComponentStakeholderMapItemStackholderMapItem>>>;
  xYGraphChart?: Maybe<UploadFile>;
  xYGraphItems?: Maybe<Array<Maybe<ComponentXyGraphItemXyGraphItem>>>;
};


export type ComponentSubmissionsSubModuleSubmissionAnswersArgs = {
  filters?: InputMaybe<ComponentSubmissionsAnswerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentSubmissionsSubModuleSubmissionCharacteristicsArgs = {
  filters?: InputMaybe<ComponentSubmissionsCharacteristicsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentSubmissionsSubModuleSubmissionCompetencyAnswersArgs = {
  filters?: InputMaybe<ComponentSubmissionsCompetencyAnswerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentSubmissionsSubModuleSubmissionGapsAnswersArgs = {
  filters?: InputMaybe<ComponentSubmissionsValuesGapsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentSubmissionsSubModuleSubmissionGravitasScalesArgs = {
  filters?: InputMaybe<ComponentGravitasScaleItemsGravitasScaleItemsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentSubmissionsSubModuleSubmissionSaboteurSkipProofsArgs = {
  filters?: InputMaybe<ComponentSubmissionsSkipProofComponentFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentSubmissionsSubModuleSubmissionStakeholderItemsArgs = {
  filters?: InputMaybe<ComponentStakeholderMapItemStackholderMapItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentSubmissionsSubModuleSubmissionXyGraphItemsArgs = {
  filters?: InputMaybe<ComponentXyGraphItemXyGraphItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSubmissionsUploadDocuments = {
  __typename?: 'ComponentSubmissionsUploadDocuments';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  saboteurProofValue?: Maybe<UploadFile>;
};

export type ComponentSubmissionsUploadDocumentsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSubmissionsUploadDocumentsFiltersInput>>>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSubmissionsUploadDocumentsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSubmissionsUploadDocumentsFiltersInput>>>;
};

export type ComponentSubmissionsUploadDocumentsInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  saboteurProofValue?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentSubmissionsValuesGaps = {
  __typename?: 'ComponentSubmissionsValuesGaps';
  commitment?: Maybe<Scalars['String']['output']>;
  gap?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentSubmissionsValuesGapsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSubmissionsValuesGapsFiltersInput>>>;
  commitment?: InputMaybe<StringFilterInput>;
  gap?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSubmissionsValuesGapsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSubmissionsValuesGapsFiltersInput>>>;
};

export type ComponentSubmissionsValuesGapsInput = {
  commitment?: InputMaybe<Scalars['String']['input']>;
  gap?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentTranslationsAboutUs = {
  __typename?: 'ComponentTranslationsAboutUs';
  id: Scalars['ID']['output'];
  textEnglish?: Maybe<Scalars['String']['output']>;
  textFrench?: Maybe<Scalars['String']['output']>;
  textGerman?: Maybe<Scalars['String']['output']>;
  userGuidelinesEnglish: Array<Maybe<UploadFile>>;
  userGuidelinesEnglish_connection?: Maybe<UploadFileRelationResponseCollection>;
  userGuidelinesFrench: Array<Maybe<UploadFile>>;
  userGuidelinesFrench_connection?: Maybe<UploadFileRelationResponseCollection>;
  userGuidelinesGerman: Array<Maybe<UploadFile>>;
  userGuidelinesGerman_connection?: Maybe<UploadFileRelationResponseCollection>;
  userGuidelinesTextEnglish?: Maybe<Scalars['String']['output']>;
  userGuidelinesTextFrench?: Maybe<Scalars['String']['output']>;
  userGuidelinesTextGerman?: Maybe<Scalars['String']['output']>;
};


export type ComponentTranslationsAboutUsUserGuidelinesEnglishArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentTranslationsAboutUsUserGuidelinesEnglish_ConnectionArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentTranslationsAboutUsUserGuidelinesFrenchArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentTranslationsAboutUsUserGuidelinesFrench_ConnectionArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentTranslationsAboutUsUserGuidelinesGermanArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentTranslationsAboutUsUserGuidelinesGerman_ConnectionArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentTranslationsAboutUsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentTranslationsAboutUsFiltersInput>>>;
  not?: InputMaybe<ComponentTranslationsAboutUsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentTranslationsAboutUsFiltersInput>>>;
  textEnglish?: InputMaybe<StringFilterInput>;
  textFrench?: InputMaybe<StringFilterInput>;
  textGerman?: InputMaybe<StringFilterInput>;
  userGuidelinesTextEnglish?: InputMaybe<StringFilterInput>;
  userGuidelinesTextFrench?: InputMaybe<StringFilterInput>;
  userGuidelinesTextGerman?: InputMaybe<StringFilterInput>;
};

export type ComponentTranslationsAboutUsInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  textEnglish?: InputMaybe<Scalars['String']['input']>;
  textFrench?: InputMaybe<Scalars['String']['input']>;
  textGerman?: InputMaybe<Scalars['String']['input']>;
  userGuidelinesEnglish?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  userGuidelinesFrench?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  userGuidelinesGerman?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  userGuidelinesTextEnglish?: InputMaybe<Scalars['String']['input']>;
  userGuidelinesTextFrench?: InputMaybe<Scalars['String']['input']>;
  userGuidelinesTextGerman?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentTranslationsButtons = {
  __typename?: 'ComponentTranslationsButtons';
  addMoreBtnsEnglish?: Maybe<Scalars['String']['output']>;
  addMoreBtnsFrench?: Maybe<Scalars['String']['output']>;
  addMoreBtnsGerman?: Maybe<Scalars['String']['output']>;
  backBtnsEnglish?: Maybe<Scalars['String']['output']>;
  backBtnsFrench?: Maybe<Scalars['String']['output']>;
  backBtnsGerman?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  nextBtnsEnglish?: Maybe<Scalars['String']['output']>;
  nextBtnsFrench?: Maybe<Scalars['String']['output']>;
  nextBtnsGerman?: Maybe<Scalars['String']['output']>;
};

export type ComponentTranslationsButtonsInput = {
  addMoreBtnsEnglish?: InputMaybe<Scalars['String']['input']>;
  addMoreBtnsFrench?: InputMaybe<Scalars['String']['input']>;
  addMoreBtnsGerman?: InputMaybe<Scalars['String']['input']>;
  backBtnsEnglish?: InputMaybe<Scalars['String']['input']>;
  backBtnsFrench?: InputMaybe<Scalars['String']['input']>;
  backBtnsGerman?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  nextBtnsEnglish?: InputMaybe<Scalars['String']['input']>;
  nextBtnsFrench?: InputMaybe<Scalars['String']['input']>;
  nextBtnsGerman?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentTranslationsDashboardScreen = {
  __typename?: 'ComponentTranslationsDashboardScreen';
  id: Scalars['ID']['output'];
  logOutDashboardEnglish?: Maybe<Scalars['String']['output']>;
  logOutDashboardFrench?: Maybe<Scalars['String']['output']>;
  logOutDashboardGerman?: Maybe<Scalars['String']['output']>;
  logOutDashboardMandarin?: Maybe<Scalars['String']['output']>;
  logOutDashboardSpanish?: Maybe<Scalars['String']['output']>;
  myProgrammesEnglish?: Maybe<Scalars['String']['output']>;
  myProgrammesFrench?: Maybe<Scalars['String']['output']>;
  myProgrammesGerman?: Maybe<Scalars['String']['output']>;
  myProgrammesMandarin?: Maybe<Scalars['String']['output']>;
  myProgrammesSpanish?: Maybe<Scalars['String']['output']>;
  notepadTextEnglish?: Maybe<Scalars['String']['output']>;
  notepadTextFrench?: Maybe<Scalars['String']['output']>;
  notepadTextGerman?: Maybe<Scalars['String']['output']>;
  notepadTextMandarin?: Maybe<Scalars['String']['output']>;
  notepadTextSpanish?: Maybe<Scalars['String']['output']>;
  suggestedTitleEnglish?: Maybe<Scalars['String']['output']>;
  suggestedTitleFrench?: Maybe<Scalars['String']['output']>;
  suggestedTitleGerman?: Maybe<Scalars['String']['output']>;
  suggestedTitleMandarin?: Maybe<Scalars['String']['output']>;
  suggestedTitleSpanish?: Maybe<Scalars['String']['output']>;
  uploadTitleEnglish?: Maybe<Scalars['String']['output']>;
  uploadTitleFrench?: Maybe<Scalars['String']['output']>;
  uploadTitleGerman?: Maybe<Scalars['String']['output']>;
  uploadTitleMandarin?: Maybe<Scalars['String']['output']>;
  uploadTitleSpanish?: Maybe<Scalars['String']['output']>;
  viewAllEnglish?: Maybe<Scalars['String']['output']>;
  viewAllFrench?: Maybe<Scalars['String']['output']>;
  viewAllGerman?: Maybe<Scalars['String']['output']>;
  viewAllMandarin?: Maybe<Scalars['String']['output']>;
  viewAllSpanish?: Maybe<Scalars['String']['output']>;
};

export type ComponentTranslationsDashboardScreenInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  logOutDashboardEnglish?: InputMaybe<Scalars['String']['input']>;
  logOutDashboardFrench?: InputMaybe<Scalars['String']['input']>;
  logOutDashboardGerman?: InputMaybe<Scalars['String']['input']>;
  logOutDashboardMandarin?: InputMaybe<Scalars['String']['input']>;
  logOutDashboardSpanish?: InputMaybe<Scalars['String']['input']>;
  myProgrammesEnglish?: InputMaybe<Scalars['String']['input']>;
  myProgrammesFrench?: InputMaybe<Scalars['String']['input']>;
  myProgrammesGerman?: InputMaybe<Scalars['String']['input']>;
  myProgrammesMandarin?: InputMaybe<Scalars['String']['input']>;
  myProgrammesSpanish?: InputMaybe<Scalars['String']['input']>;
  notepadTextEnglish?: InputMaybe<Scalars['String']['input']>;
  notepadTextFrench?: InputMaybe<Scalars['String']['input']>;
  notepadTextGerman?: InputMaybe<Scalars['String']['input']>;
  notepadTextMandarin?: InputMaybe<Scalars['String']['input']>;
  notepadTextSpanish?: InputMaybe<Scalars['String']['input']>;
  suggestedTitleEnglish?: InputMaybe<Scalars['String']['input']>;
  suggestedTitleFrench?: InputMaybe<Scalars['String']['input']>;
  suggestedTitleGerman?: InputMaybe<Scalars['String']['input']>;
  suggestedTitleMandarin?: InputMaybe<Scalars['String']['input']>;
  suggestedTitleSpanish?: InputMaybe<Scalars['String']['input']>;
  uploadTitleEnglish?: InputMaybe<Scalars['String']['input']>;
  uploadTitleFrench?: InputMaybe<Scalars['String']['input']>;
  uploadTitleGerman?: InputMaybe<Scalars['String']['input']>;
  uploadTitleMandarin?: InputMaybe<Scalars['String']['input']>;
  uploadTitleSpanish?: InputMaybe<Scalars['String']['input']>;
  viewAllEnglish?: InputMaybe<Scalars['String']['input']>;
  viewAllFrench?: InputMaybe<Scalars['String']['input']>;
  viewAllGerman?: InputMaybe<Scalars['String']['input']>;
  viewAllMandarin?: InputMaybe<Scalars['String']['input']>;
  viewAllSpanish?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentTranslationsFaqs = {
  __typename?: 'ComponentTranslationsFaqs';
  faqsEnglish?: Maybe<Array<Maybe<ComponentTranslationsFaqsQuestionAnswer>>>;
  faqsFrench?: Maybe<Array<Maybe<ComponentTranslationsFaqsFrench>>>;
  faqsGerman?: Maybe<Array<Maybe<ComponentTranslationsFaqsGerman>>>;
  faqsMandarin?: Maybe<Array<Maybe<ComponentTranslationsFaqsMandarin>>>;
  faqsSpanish?: Maybe<Array<Maybe<ComponentTranslationsFaqsSpanish>>>;
  id: Scalars['ID']['output'];
};


export type ComponentTranslationsFaqsFaqsEnglishArgs = {
  filters?: InputMaybe<ComponentTranslationsFaqsQuestionAnswerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentTranslationsFaqsFaqsFrenchArgs = {
  filters?: InputMaybe<ComponentTranslationsFaqsFrenchFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentTranslationsFaqsFaqsGermanArgs = {
  filters?: InputMaybe<ComponentTranslationsFaqsGermanFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentTranslationsFaqsFaqsMandarinArgs = {
  filters?: InputMaybe<ComponentTranslationsFaqsMandarinFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentTranslationsFaqsFaqsSpanishArgs = {
  filters?: InputMaybe<ComponentTranslationsFaqsSpanishFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentTranslationsFaqsFrench = {
  __typename?: 'ComponentTranslationsFaqsFrench';
  answer?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  question?: Maybe<Scalars['String']['output']>;
};

export type ComponentTranslationsFaqsFrenchFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentTranslationsFaqsFrenchFiltersInput>>>;
  answer?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentTranslationsFaqsFrenchFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentTranslationsFaqsFrenchFiltersInput>>>;
  question?: InputMaybe<StringFilterInput>;
};

export type ComponentTranslationsFaqsFrenchInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentTranslationsFaqsGerman = {
  __typename?: 'ComponentTranslationsFaqsGerman';
  answer?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  question?: Maybe<Scalars['String']['output']>;
};

export type ComponentTranslationsFaqsGermanFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentTranslationsFaqsGermanFiltersInput>>>;
  answer?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentTranslationsFaqsGermanFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentTranslationsFaqsGermanFiltersInput>>>;
  question?: InputMaybe<StringFilterInput>;
};

export type ComponentTranslationsFaqsGermanInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentTranslationsFaqsInput = {
  faqsEnglish?: InputMaybe<Array<InputMaybe<ComponentTranslationsFaqsQuestionAnswerInput>>>;
  faqsFrench?: InputMaybe<Array<InputMaybe<ComponentTranslationsFaqsFrenchInput>>>;
  faqsGerman?: InputMaybe<Array<InputMaybe<ComponentTranslationsFaqsGermanInput>>>;
  faqsMandarin?: InputMaybe<Array<InputMaybe<ComponentTranslationsFaqsMandarinInput>>>;
  faqsSpanish?: InputMaybe<Array<InputMaybe<ComponentTranslationsFaqsSpanishInput>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentTranslationsFaqsMandarin = {
  __typename?: 'ComponentTranslationsFaqsMandarin';
  answer?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  question?: Maybe<Scalars['String']['output']>;
};

export type ComponentTranslationsFaqsMandarinFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentTranslationsFaqsMandarinFiltersInput>>>;
  answer?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentTranslationsFaqsMandarinFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentTranslationsFaqsMandarinFiltersInput>>>;
  question?: InputMaybe<StringFilterInput>;
};

export type ComponentTranslationsFaqsMandarinInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentTranslationsFaqsQuestionAnswer = {
  __typename?: 'ComponentTranslationsFaqsQuestionAnswer';
  answer?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  question?: Maybe<Scalars['String']['output']>;
};

export type ComponentTranslationsFaqsQuestionAnswerFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentTranslationsFaqsQuestionAnswerFiltersInput>>>;
  answer?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentTranslationsFaqsQuestionAnswerFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentTranslationsFaqsQuestionAnswerFiltersInput>>>;
  question?: InputMaybe<StringFilterInput>;
};

export type ComponentTranslationsFaqsQuestionAnswerInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentTranslationsFaqsSpanish = {
  __typename?: 'ComponentTranslationsFaqsSpanish';
  answer?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  question?: Maybe<Scalars['String']['output']>;
};

export type ComponentTranslationsFaqsSpanishFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentTranslationsFaqsSpanishFiltersInput>>>;
  answer?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentTranslationsFaqsSpanishFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentTranslationsFaqsSpanishFiltersInput>>>;
  question?: InputMaybe<StringFilterInput>;
};

export type ComponentTranslationsFaqsSpanishInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentTranslationsHelpAndSupport = {
  __typename?: 'ComponentTranslationsHelpAndSupport';
  id: Scalars['ID']['output'];
  knowledgeBaseEnglish?: Maybe<Scalars['String']['output']>;
  knowledgeBaseFrench?: Maybe<Scalars['String']['output']>;
  knowledgeBaseGerman?: Maybe<Scalars['String']['output']>;
  knowledgeBaseMandarin?: Maybe<Scalars['String']['output']>;
  knowledgeBaseSpanish?: Maybe<Scalars['String']['output']>;
  liveChatEnglish?: Maybe<Scalars['String']['output']>;
  liveChatFrench?: Maybe<Scalars['String']['output']>;
  liveChatGerman?: Maybe<Scalars['String']['output']>;
  liveChatMandarin?: Maybe<Scalars['String']['output']>;
  liveChatSpanish?: Maybe<Scalars['String']['output']>;
  myTicketsEnglish?: Maybe<Scalars['String']['output']>;
  myTicketsFrench?: Maybe<Scalars['String']['output']>;
  myTicketsGerman?: Maybe<Scalars['String']['output']>;
  myTicketsMandarin?: Maybe<Scalars['String']['output']>;
  myTicketsSpanish?: Maybe<Scalars['String']['output']>;
  titleEnglish?: Maybe<Scalars['String']['output']>;
  titleFrench?: Maybe<Scalars['String']['output']>;
  titleGerman?: Maybe<Scalars['String']['output']>;
  titleMandarin?: Maybe<Scalars['String']['output']>;
  titleSpanish?: Maybe<Scalars['String']['output']>;
};

export type ComponentTranslationsHelpAndSupportInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  knowledgeBaseEnglish?: InputMaybe<Scalars['String']['input']>;
  knowledgeBaseFrench?: InputMaybe<Scalars['String']['input']>;
  knowledgeBaseGerman?: InputMaybe<Scalars['String']['input']>;
  knowledgeBaseMandarin?: InputMaybe<Scalars['String']['input']>;
  knowledgeBaseSpanish?: InputMaybe<Scalars['String']['input']>;
  liveChatEnglish?: InputMaybe<Scalars['String']['input']>;
  liveChatFrench?: InputMaybe<Scalars['String']['input']>;
  liveChatGerman?: InputMaybe<Scalars['String']['input']>;
  liveChatMandarin?: InputMaybe<Scalars['String']['input']>;
  liveChatSpanish?: InputMaybe<Scalars['String']['input']>;
  myTicketsEnglish?: InputMaybe<Scalars['String']['input']>;
  myTicketsFrench?: InputMaybe<Scalars['String']['input']>;
  myTicketsGerman?: InputMaybe<Scalars['String']['input']>;
  myTicketsMandarin?: InputMaybe<Scalars['String']['input']>;
  myTicketsSpanish?: InputMaybe<Scalars['String']['input']>;
  titleEnglish?: InputMaybe<Scalars['String']['input']>;
  titleFrench?: InputMaybe<Scalars['String']['input']>;
  titleGerman?: InputMaybe<Scalars['String']['input']>;
  titleMandarin?: InputMaybe<Scalars['String']['input']>;
  titleSpanish?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentTranslationsHomeScreen = {
  __typename?: 'ComponentTranslationsHomeScreen';
  changesDownEnglish?: Maybe<Scalars['String']['output']>;
  changesDownFrench?: Maybe<Scalars['String']['output']>;
  changesDownGerman?: Maybe<Scalars['String']['output']>;
  changesDownMandarin?: Maybe<Scalars['String']['output']>;
  changesDownSpanish?: Maybe<Scalars['String']['output']>;
  changesUpEnglish?: Maybe<Scalars['String']['output']>;
  changesUpFrench?: Maybe<Scalars['String']['output']>;
  changesUpGerman?: Maybe<Scalars['String']['output']>;
  changesUpMandarin?: Maybe<Scalars['String']['output']>;
  changesUpSpanish?: Maybe<Scalars['String']['output']>;
  completedModulesEnglish?: Maybe<Scalars['String']['output']>;
  completedModulesFrench?: Maybe<Scalars['String']['output']>;
  completedModulesGerman?: Maybe<Scalars['String']['output']>;
  completedModulesMandarin?: Maybe<Scalars['String']['output']>;
  completedModulesSpanish?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  myLibraryEnglish?: Maybe<Scalars['String']['output']>;
  myLibraryFrench?: Maybe<Scalars['String']['output']>;
  myLibraryGerman?: Maybe<Scalars['String']['output']>;
  myLibraryMandarin?: Maybe<Scalars['String']['output']>;
  myLibrarySpanish?: Maybe<Scalars['String']['output']>;
  myProgrammeEnglish?: Maybe<Scalars['String']['output']>;
  myProgrammeFrench?: Maybe<Scalars['String']['output']>;
  myProgrammeGerman?: Maybe<Scalars['String']['output']>;
  myProgrammeMandarin?: Maybe<Scalars['String']['output']>;
  myProgrammeSpanish?: Maybe<Scalars['String']['output']>;
  noChangesEnglish?: Maybe<Scalars['String']['output']>;
  noChangesFrench?: Maybe<Scalars['String']['output']>;
  noChangesGerman?: Maybe<Scalars['String']['output']>;
  noChangesMandarin?: Maybe<Scalars['String']['output']>;
  noChangesSpanish?: Maybe<Scalars['String']['output']>;
  programmeProgressEnglish?: Maybe<Scalars['String']['output']>;
  programmeProgressFrench?: Maybe<Scalars['String']['output']>;
  programmeProgressGerman?: Maybe<Scalars['String']['output']>;
  programmeProgressMandarin?: Maybe<Scalars['String']['output']>;
  programmeProgressSpanish?: Maybe<Scalars['String']['output']>;
  titleEnglish?: Maybe<Scalars['String']['output']>;
  titleFrench?: Maybe<Scalars['String']['output']>;
  titleGerman?: Maybe<Scalars['String']['output']>;
  titleMandarin?: Maybe<Scalars['String']['output']>;
  titleSpanish?: Maybe<Scalars['String']['output']>;
  viewLibraryEnglish?: Maybe<Scalars['String']['output']>;
  viewLibraryFrench?: Maybe<Scalars['String']['output']>;
  viewLibraryGerman?: Maybe<Scalars['String']['output']>;
  viewLibraryMandarin?: Maybe<Scalars['String']['output']>;
  viewLibrarySpanish?: Maybe<Scalars['String']['output']>;
  viewModulesEnglish?: Maybe<Scalars['String']['output']>;
  viewModulesFrench?: Maybe<Scalars['String']['output']>;
  viewModulesGerman?: Maybe<Scalars['String']['output']>;
  viewModulesMandarin?: Maybe<Scalars['String']['output']>;
  viewModulesSpanish?: Maybe<Scalars['String']['output']>;
  viewedArticlesEnglish?: Maybe<Scalars['String']['output']>;
  viewedArticlesFrench?: Maybe<Scalars['String']['output']>;
  viewedArticlesGerman?: Maybe<Scalars['String']['output']>;
  viewedArticlesMandarin?: Maybe<Scalars['String']['output']>;
  viewedArticlesSpanish?: Maybe<Scalars['String']['output']>;
  welcomeEnglish?: Maybe<Scalars['String']['output']>;
  welcomeFrench?: Maybe<Scalars['String']['output']>;
  welcomeGerman?: Maybe<Scalars['String']['output']>;
  welcomeMandarin?: Maybe<Scalars['String']['output']>;
  welcomeSpanish?: Maybe<Scalars['String']['output']>;
  whatToExpectEnglish?: Maybe<Scalars['String']['output']>;
  whatToExpectFrench?: Maybe<Scalars['String']['output']>;
  whatToExpectGerman?: Maybe<Scalars['String']['output']>;
  whatToExpectMandarin?: Maybe<Scalars['String']['output']>;
  whatToExpectSpanish?: Maybe<Scalars['String']['output']>;
  whatsNextEnglish?: Maybe<Scalars['String']['output']>;
  whatsNextFrench?: Maybe<Scalars['String']['output']>;
  whatsNextGerman?: Maybe<Scalars['String']['output']>;
  whatsNextMandarin?: Maybe<Scalars['String']['output']>;
  whatsNextSpanish?: Maybe<Scalars['String']['output']>;
};

export type ComponentTranslationsHomeScreenInput = {
  changesDownEnglish?: InputMaybe<Scalars['String']['input']>;
  changesDownFrench?: InputMaybe<Scalars['String']['input']>;
  changesDownGerman?: InputMaybe<Scalars['String']['input']>;
  changesDownMandarin?: InputMaybe<Scalars['String']['input']>;
  changesDownSpanish?: InputMaybe<Scalars['String']['input']>;
  changesUpEnglish?: InputMaybe<Scalars['String']['input']>;
  changesUpFrench?: InputMaybe<Scalars['String']['input']>;
  changesUpGerman?: InputMaybe<Scalars['String']['input']>;
  changesUpMandarin?: InputMaybe<Scalars['String']['input']>;
  changesUpSpanish?: InputMaybe<Scalars['String']['input']>;
  completedModulesEnglish?: InputMaybe<Scalars['String']['input']>;
  completedModulesFrench?: InputMaybe<Scalars['String']['input']>;
  completedModulesGerman?: InputMaybe<Scalars['String']['input']>;
  completedModulesMandarin?: InputMaybe<Scalars['String']['input']>;
  completedModulesSpanish?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  myLibraryEnglish?: InputMaybe<Scalars['String']['input']>;
  myLibraryFrench?: InputMaybe<Scalars['String']['input']>;
  myLibraryGerman?: InputMaybe<Scalars['String']['input']>;
  myLibraryMandarin?: InputMaybe<Scalars['String']['input']>;
  myLibrarySpanish?: InputMaybe<Scalars['String']['input']>;
  myProgrammeEnglish?: InputMaybe<Scalars['String']['input']>;
  myProgrammeFrench?: InputMaybe<Scalars['String']['input']>;
  myProgrammeGerman?: InputMaybe<Scalars['String']['input']>;
  myProgrammeMandarin?: InputMaybe<Scalars['String']['input']>;
  myProgrammeSpanish?: InputMaybe<Scalars['String']['input']>;
  noChangesEnglish?: InputMaybe<Scalars['String']['input']>;
  noChangesFrench?: InputMaybe<Scalars['String']['input']>;
  noChangesGerman?: InputMaybe<Scalars['String']['input']>;
  noChangesMandarin?: InputMaybe<Scalars['String']['input']>;
  noChangesSpanish?: InputMaybe<Scalars['String']['input']>;
  programmeProgressEnglish?: InputMaybe<Scalars['String']['input']>;
  programmeProgressFrench?: InputMaybe<Scalars['String']['input']>;
  programmeProgressGerman?: InputMaybe<Scalars['String']['input']>;
  programmeProgressMandarin?: InputMaybe<Scalars['String']['input']>;
  programmeProgressSpanish?: InputMaybe<Scalars['String']['input']>;
  titleEnglish?: InputMaybe<Scalars['String']['input']>;
  titleFrench?: InputMaybe<Scalars['String']['input']>;
  titleGerman?: InputMaybe<Scalars['String']['input']>;
  titleMandarin?: InputMaybe<Scalars['String']['input']>;
  titleSpanish?: InputMaybe<Scalars['String']['input']>;
  viewLibraryEnglish?: InputMaybe<Scalars['String']['input']>;
  viewLibraryFrench?: InputMaybe<Scalars['String']['input']>;
  viewLibraryGerman?: InputMaybe<Scalars['String']['input']>;
  viewLibraryMandarin?: InputMaybe<Scalars['String']['input']>;
  viewLibrarySpanish?: InputMaybe<Scalars['String']['input']>;
  viewModulesEnglish?: InputMaybe<Scalars['String']['input']>;
  viewModulesFrench?: InputMaybe<Scalars['String']['input']>;
  viewModulesGerman?: InputMaybe<Scalars['String']['input']>;
  viewModulesMandarin?: InputMaybe<Scalars['String']['input']>;
  viewModulesSpanish?: InputMaybe<Scalars['String']['input']>;
  viewedArticlesEnglish?: InputMaybe<Scalars['String']['input']>;
  viewedArticlesFrench?: InputMaybe<Scalars['String']['input']>;
  viewedArticlesGerman?: InputMaybe<Scalars['String']['input']>;
  viewedArticlesMandarin?: InputMaybe<Scalars['String']['input']>;
  viewedArticlesSpanish?: InputMaybe<Scalars['String']['input']>;
  welcomeEnglish?: InputMaybe<Scalars['String']['input']>;
  welcomeFrench?: InputMaybe<Scalars['String']['input']>;
  welcomeGerman?: InputMaybe<Scalars['String']['input']>;
  welcomeMandarin?: InputMaybe<Scalars['String']['input']>;
  welcomeSpanish?: InputMaybe<Scalars['String']['input']>;
  whatToExpectEnglish?: InputMaybe<Scalars['String']['input']>;
  whatToExpectFrench?: InputMaybe<Scalars['String']['input']>;
  whatToExpectGerman?: InputMaybe<Scalars['String']['input']>;
  whatToExpectMandarin?: InputMaybe<Scalars['String']['input']>;
  whatToExpectSpanish?: InputMaybe<Scalars['String']['input']>;
  whatsNextEnglish?: InputMaybe<Scalars['String']['input']>;
  whatsNextFrench?: InputMaybe<Scalars['String']['input']>;
  whatsNextGerman?: InputMaybe<Scalars['String']['input']>;
  whatsNextMandarin?: InputMaybe<Scalars['String']['input']>;
  whatsNextSpanish?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentTranslationsLanguageSelection = {
  __typename?: 'ComponentTranslationsLanguageSelection';
  bodyEnglish?: Maybe<Scalars['String']['output']>;
  bodyFrench?: Maybe<Scalars['String']['output']>;
  bodyGerman?: Maybe<Scalars['String']['output']>;
  bodyMandarin?: Maybe<Scalars['String']['output']>;
  bodySpanish?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  nextButtonEnglish?: Maybe<Scalars['String']['output']>;
  nextButtonFrench?: Maybe<Scalars['String']['output']>;
  nextButtonGerman?: Maybe<Scalars['String']['output']>;
  nextButtonMandarin?: Maybe<Scalars['String']['output']>;
  nextButtonSpanish?: Maybe<Scalars['String']['output']>;
  titleEnglish?: Maybe<Scalars['String']['output']>;
  titleFrench?: Maybe<Scalars['String']['output']>;
  titleGerman?: Maybe<Scalars['String']['output']>;
  titleMandarin?: Maybe<Scalars['String']['output']>;
  titleSpanish?: Maybe<Scalars['String']['output']>;
};

export type ComponentTranslationsLanguageSelectionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentTranslationsLanguageSelectionFiltersInput>>>;
  bodyEnglish?: InputMaybe<StringFilterInput>;
  bodyFrench?: InputMaybe<StringFilterInput>;
  bodyGerman?: InputMaybe<StringFilterInput>;
  bodyMandarin?: InputMaybe<StringFilterInput>;
  bodySpanish?: InputMaybe<StringFilterInput>;
  nextButtonEnglish?: InputMaybe<StringFilterInput>;
  nextButtonFrench?: InputMaybe<StringFilterInput>;
  nextButtonGerman?: InputMaybe<StringFilterInput>;
  nextButtonMandarin?: InputMaybe<StringFilterInput>;
  nextButtonSpanish?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentTranslationsLanguageSelectionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentTranslationsLanguageSelectionFiltersInput>>>;
  titleEnglish?: InputMaybe<StringFilterInput>;
  titleFrench?: InputMaybe<StringFilterInput>;
  titleGerman?: InputMaybe<StringFilterInput>;
  titleMandarin?: InputMaybe<StringFilterInput>;
  titleSpanish?: InputMaybe<StringFilterInput>;
};

export type ComponentTranslationsLanguageSelectionInput = {
  bodyEnglish?: InputMaybe<Scalars['String']['input']>;
  bodyFrench?: InputMaybe<Scalars['String']['input']>;
  bodyGerman?: InputMaybe<Scalars['String']['input']>;
  bodyMandarin?: InputMaybe<Scalars['String']['input']>;
  bodySpanish?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  nextButtonEnglish?: InputMaybe<Scalars['String']['input']>;
  nextButtonFrench?: InputMaybe<Scalars['String']['input']>;
  nextButtonGerman?: InputMaybe<Scalars['String']['input']>;
  nextButtonMandarin?: InputMaybe<Scalars['String']['input']>;
  nextButtonSpanish?: InputMaybe<Scalars['String']['input']>;
  titleEnglish?: InputMaybe<Scalars['String']['input']>;
  titleFrench?: InputMaybe<Scalars['String']['input']>;
  titleGerman?: InputMaybe<Scalars['String']['input']>;
  titleMandarin?: InputMaybe<Scalars['String']['input']>;
  titleSpanish?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentTranslationsLetsGetStartedScreen = {
  __typename?: 'ComponentTranslationsLetsGetStartedScreen';
  divisionErrorEnglish?: Maybe<Scalars['String']['output']>;
  divisionErrorFrench?: Maybe<Scalars['String']['output']>;
  divisionErrorGerman?: Maybe<Scalars['String']['output']>;
  divisionErrorMandarin?: Maybe<Scalars['String']['output']>;
  divisionErrorSpanish?: Maybe<Scalars['String']['output']>;
  divisionLabelEnglish?: Maybe<Scalars['String']['output']>;
  divisionLabelFrench?: Maybe<Scalars['String']['output']>;
  divisionLabelGerman?: Maybe<Scalars['String']['output']>;
  divisionLabelMandarin?: Maybe<Scalars['String']['output']>;
  divisionLabelSpanish?: Maybe<Scalars['String']['output']>;
  firstNameErrorEnglish?: Maybe<Scalars['String']['output']>;
  firstNameErrorFrench?: Maybe<Scalars['String']['output']>;
  firstNameErrorGerman?: Maybe<Scalars['String']['output']>;
  firstNameErrorMandarin?: Maybe<Scalars['String']['output']>;
  firstNameErrorSpanish?: Maybe<Scalars['String']['output']>;
  firstNameLabelEnglish?: Maybe<Scalars['String']['output']>;
  firstNameLabelFrench?: Maybe<Scalars['String']['output']>;
  firstNameLabelGerman?: Maybe<Scalars['String']['output']>;
  firstNameLabelMandarin?: Maybe<Scalars['String']['output']>;
  firstNameLabelSpanish?: Maybe<Scalars['String']['output']>;
  getHelpButtonEnglish?: Maybe<Scalars['String']['output']>;
  getHelpButtonFrench?: Maybe<Scalars['String']['output']>;
  getHelpButtonGerman?: Maybe<Scalars['String']['output']>;
  getHelpButtonMandarin?: Maybe<Scalars['String']['output']>;
  getHelpButtonSpanish?: Maybe<Scalars['String']['output']>;
  havingTroubleEnglish?: Maybe<Scalars['String']['output']>;
  havingTroubleFrench?: Maybe<Scalars['String']['output']>;
  havingTroubleGerman?: Maybe<Scalars['String']['output']>;
  havingTroubleMandarin?: Maybe<Scalars['String']['output']>;
  havingTroubleSpanish?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<UploadFile>;
  jobTitleErrorEnglish?: Maybe<Scalars['String']['output']>;
  jobTitleErrorFrench?: Maybe<Scalars['String']['output']>;
  jobTitleErrorGerman?: Maybe<Scalars['String']['output']>;
  jobTitleErrorMandarin?: Maybe<Scalars['String']['output']>;
  jobTitleErrorSpanish?: Maybe<Scalars['String']['output']>;
  jobTitleLabelEnglish?: Maybe<Scalars['String']['output']>;
  jobTitleLabelFrench?: Maybe<Scalars['String']['output']>;
  jobTitleLabelGerman?: Maybe<Scalars['String']['output']>;
  jobTitleLabelMandarin?: Maybe<Scalars['String']['output']>;
  jobTitleLabelSpanish?: Maybe<Scalars['String']['output']>;
  lastNameErrorEnglish?: Maybe<Scalars['String']['output']>;
  lastNameErrorFrench?: Maybe<Scalars['String']['output']>;
  lastNameErrorGerman?: Maybe<Scalars['String']['output']>;
  lastNameErrorMandarin?: Maybe<Scalars['String']['output']>;
  lastNameErrorSpanish?: Maybe<Scalars['String']['output']>;
  lastNameLabelEnglish?: Maybe<Scalars['String']['output']>;
  lastNameLabelFrench?: Maybe<Scalars['String']['output']>;
  lastNameLabelGerman?: Maybe<Scalars['String']['output']>;
  lastNameLabelMandarin?: Maybe<Scalars['String']['output']>;
  lastNameLabelSpanish?: Maybe<Scalars['String']['output']>;
  leftSubTitleMandarin?: Maybe<Scalars['String']['output']>;
  leftSubtitleEnglish?: Maybe<Scalars['String']['output']>;
  leftSubtitleFrench?: Maybe<Scalars['String']['output']>;
  leftSubtitleGerman?: Maybe<Scalars['String']['output']>;
  leftSubtitleSpanish?: Maybe<Scalars['String']['output']>;
  leftTitleCzech?: Maybe<Scalars['String']['output']>;
  leftTitleEnglish?: Maybe<Scalars['String']['output']>;
  leftTitleFrench?: Maybe<Scalars['String']['output']>;
  leftTitleGerman?: Maybe<Scalars['String']['output']>;
  leftTitleMandarin?: Maybe<Scalars['String']['output']>;
  leftTitleSpanish?: Maybe<Scalars['String']['output']>;
  nextButtonEnglish?: Maybe<Scalars['String']['output']>;
  nextButtonFrench?: Maybe<Scalars['String']['output']>;
  nextButtonGerman?: Maybe<Scalars['String']['output']>;
  nextButtonMandarin?: Maybe<Scalars['String']['output']>;
  nextButtonSpanish?: Maybe<Scalars['String']['output']>;
  regionErrorEnglish?: Maybe<Scalars['String']['output']>;
  regionErrorFrench?: Maybe<Scalars['String']['output']>;
  regionErrorGerman?: Maybe<Scalars['String']['output']>;
  regionErrorMandarin?: Maybe<Scalars['String']['output']>;
  regionErrorSpanish?: Maybe<Scalars['String']['output']>;
  regionLabelEnglish?: Maybe<Scalars['String']['output']>;
  regionLabelFrench?: Maybe<Scalars['String']['output']>;
  regionLabelGerman?: Maybe<Scalars['String']['output']>;
  regionLabelMandarin?: Maybe<Scalars['String']['output']>;
  regionLabelSpanish?: Maybe<Scalars['String']['output']>;
  subTitleEnglish?: Maybe<Scalars['String']['output']>;
  subTitleFrench?: Maybe<Scalars['String']['output']>;
  subTitleGerman?: Maybe<Scalars['String']['output']>;
  subTitleMandarin?: Maybe<Scalars['String']['output']>;
  subTitleSpanish?: Maybe<Scalars['String']['output']>;
  timezoneErrorEnglish?: Maybe<Scalars['String']['output']>;
  timezoneErrorFrench?: Maybe<Scalars['String']['output']>;
  timezoneErrorGerman?: Maybe<Scalars['String']['output']>;
  timezoneErrorMandarin?: Maybe<Scalars['String']['output']>;
  timezoneErrorSpanish?: Maybe<Scalars['String']['output']>;
  timezoneLabelEnglish?: Maybe<Scalars['String']['output']>;
  timezoneLabelFrench?: Maybe<Scalars['String']['output']>;
  timezoneLabelGerman?: Maybe<Scalars['String']['output']>;
  timezoneLabelMandarin?: Maybe<Scalars['String']['output']>;
  timezoneLabelSpanish?: Maybe<Scalars['String']['output']>;
  titleEnglish?: Maybe<Scalars['String']['output']>;
  titleFrench?: Maybe<Scalars['String']['output']>;
  titleGerman?: Maybe<Scalars['String']['output']>;
  titleMandarin?: Maybe<Scalars['String']['output']>;
  titleSpanish?: Maybe<Scalars['String']['output']>;
};

export type ComponentTranslationsLetsGetStartedScreenFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentTranslationsLetsGetStartedScreenFiltersInput>>>;
  divisionErrorEnglish?: InputMaybe<StringFilterInput>;
  divisionErrorFrench?: InputMaybe<StringFilterInput>;
  divisionErrorGerman?: InputMaybe<StringFilterInput>;
  divisionErrorMandarin?: InputMaybe<StringFilterInput>;
  divisionErrorSpanish?: InputMaybe<StringFilterInput>;
  divisionLabelEnglish?: InputMaybe<StringFilterInput>;
  divisionLabelFrench?: InputMaybe<StringFilterInput>;
  divisionLabelGerman?: InputMaybe<StringFilterInput>;
  divisionLabelMandarin?: InputMaybe<StringFilterInput>;
  divisionLabelSpanish?: InputMaybe<StringFilterInput>;
  firstNameErrorEnglish?: InputMaybe<StringFilterInput>;
  firstNameErrorFrench?: InputMaybe<StringFilterInput>;
  firstNameErrorGerman?: InputMaybe<StringFilterInput>;
  firstNameErrorMandarin?: InputMaybe<StringFilterInput>;
  firstNameErrorSpanish?: InputMaybe<StringFilterInput>;
  firstNameLabelEnglish?: InputMaybe<StringFilterInput>;
  firstNameLabelFrench?: InputMaybe<StringFilterInput>;
  firstNameLabelGerman?: InputMaybe<StringFilterInput>;
  firstNameLabelMandarin?: InputMaybe<StringFilterInput>;
  firstNameLabelSpanish?: InputMaybe<StringFilterInput>;
  getHelpButtonEnglish?: InputMaybe<StringFilterInput>;
  getHelpButtonFrench?: InputMaybe<StringFilterInput>;
  getHelpButtonGerman?: InputMaybe<StringFilterInput>;
  getHelpButtonMandarin?: InputMaybe<StringFilterInput>;
  getHelpButtonSpanish?: InputMaybe<StringFilterInput>;
  havingTroubleEnglish?: InputMaybe<StringFilterInput>;
  havingTroubleFrench?: InputMaybe<StringFilterInput>;
  havingTroubleGerman?: InputMaybe<StringFilterInput>;
  havingTroubleMandarin?: InputMaybe<StringFilterInput>;
  havingTroubleSpanish?: InputMaybe<StringFilterInput>;
  jobTitleErrorEnglish?: InputMaybe<StringFilterInput>;
  jobTitleErrorFrench?: InputMaybe<StringFilterInput>;
  jobTitleErrorGerman?: InputMaybe<StringFilterInput>;
  jobTitleErrorMandarin?: InputMaybe<StringFilterInput>;
  jobTitleErrorSpanish?: InputMaybe<StringFilterInput>;
  jobTitleLabelEnglish?: InputMaybe<StringFilterInput>;
  jobTitleLabelFrench?: InputMaybe<StringFilterInput>;
  jobTitleLabelGerman?: InputMaybe<StringFilterInput>;
  jobTitleLabelMandarin?: InputMaybe<StringFilterInput>;
  jobTitleLabelSpanish?: InputMaybe<StringFilterInput>;
  lastNameErrorEnglish?: InputMaybe<StringFilterInput>;
  lastNameErrorFrench?: InputMaybe<StringFilterInput>;
  lastNameErrorGerman?: InputMaybe<StringFilterInput>;
  lastNameErrorMandarin?: InputMaybe<StringFilterInput>;
  lastNameErrorSpanish?: InputMaybe<StringFilterInput>;
  lastNameLabelEnglish?: InputMaybe<StringFilterInput>;
  lastNameLabelFrench?: InputMaybe<StringFilterInput>;
  lastNameLabelGerman?: InputMaybe<StringFilterInput>;
  lastNameLabelMandarin?: InputMaybe<StringFilterInput>;
  lastNameLabelSpanish?: InputMaybe<StringFilterInput>;
  leftSubTitleMandarin?: InputMaybe<StringFilterInput>;
  leftSubtitleEnglish?: InputMaybe<StringFilterInput>;
  leftSubtitleFrench?: InputMaybe<StringFilterInput>;
  leftSubtitleGerman?: InputMaybe<StringFilterInput>;
  leftSubtitleSpanish?: InputMaybe<StringFilterInput>;
  leftTitleCzech?: InputMaybe<StringFilterInput>;
  leftTitleEnglish?: InputMaybe<StringFilterInput>;
  leftTitleFrench?: InputMaybe<StringFilterInput>;
  leftTitleGerman?: InputMaybe<StringFilterInput>;
  leftTitleMandarin?: InputMaybe<StringFilterInput>;
  leftTitleSpanish?: InputMaybe<StringFilterInput>;
  nextButtonEnglish?: InputMaybe<StringFilterInput>;
  nextButtonFrench?: InputMaybe<StringFilterInput>;
  nextButtonGerman?: InputMaybe<StringFilterInput>;
  nextButtonMandarin?: InputMaybe<StringFilterInput>;
  nextButtonSpanish?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentTranslationsLetsGetStartedScreenFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentTranslationsLetsGetStartedScreenFiltersInput>>>;
  regionErrorEnglish?: InputMaybe<StringFilterInput>;
  regionErrorFrench?: InputMaybe<StringFilterInput>;
  regionErrorGerman?: InputMaybe<StringFilterInput>;
  regionErrorMandarin?: InputMaybe<StringFilterInput>;
  regionErrorSpanish?: InputMaybe<StringFilterInput>;
  regionLabelEnglish?: InputMaybe<StringFilterInput>;
  regionLabelFrench?: InputMaybe<StringFilterInput>;
  regionLabelGerman?: InputMaybe<StringFilterInput>;
  regionLabelMandarin?: InputMaybe<StringFilterInput>;
  regionLabelSpanish?: InputMaybe<StringFilterInput>;
  subTitleEnglish?: InputMaybe<StringFilterInput>;
  subTitleFrench?: InputMaybe<StringFilterInput>;
  subTitleGerman?: InputMaybe<StringFilterInput>;
  subTitleMandarin?: InputMaybe<StringFilterInput>;
  subTitleSpanish?: InputMaybe<StringFilterInput>;
  timezoneErrorEnglish?: InputMaybe<StringFilterInput>;
  timezoneErrorFrench?: InputMaybe<StringFilterInput>;
  timezoneErrorGerman?: InputMaybe<StringFilterInput>;
  timezoneErrorMandarin?: InputMaybe<StringFilterInput>;
  timezoneErrorSpanish?: InputMaybe<StringFilterInput>;
  timezoneLabelEnglish?: InputMaybe<StringFilterInput>;
  timezoneLabelFrench?: InputMaybe<StringFilterInput>;
  timezoneLabelGerman?: InputMaybe<StringFilterInput>;
  timezoneLabelMandarin?: InputMaybe<StringFilterInput>;
  timezoneLabelSpanish?: InputMaybe<StringFilterInput>;
  titleEnglish?: InputMaybe<StringFilterInput>;
  titleFrench?: InputMaybe<StringFilterInput>;
  titleGerman?: InputMaybe<StringFilterInput>;
  titleMandarin?: InputMaybe<StringFilterInput>;
  titleSpanish?: InputMaybe<StringFilterInput>;
};

export type ComponentTranslationsLetsGetStartedScreenInput = {
  divisionErrorEnglish?: InputMaybe<Scalars['String']['input']>;
  divisionErrorFrench?: InputMaybe<Scalars['String']['input']>;
  divisionErrorGerman?: InputMaybe<Scalars['String']['input']>;
  divisionErrorMandarin?: InputMaybe<Scalars['String']['input']>;
  divisionErrorSpanish?: InputMaybe<Scalars['String']['input']>;
  divisionLabelEnglish?: InputMaybe<Scalars['String']['input']>;
  divisionLabelFrench?: InputMaybe<Scalars['String']['input']>;
  divisionLabelGerman?: InputMaybe<Scalars['String']['input']>;
  divisionLabelMandarin?: InputMaybe<Scalars['String']['input']>;
  divisionLabelSpanish?: InputMaybe<Scalars['String']['input']>;
  firstNameErrorEnglish?: InputMaybe<Scalars['String']['input']>;
  firstNameErrorFrench?: InputMaybe<Scalars['String']['input']>;
  firstNameErrorGerman?: InputMaybe<Scalars['String']['input']>;
  firstNameErrorMandarin?: InputMaybe<Scalars['String']['input']>;
  firstNameErrorSpanish?: InputMaybe<Scalars['String']['input']>;
  firstNameLabelEnglish?: InputMaybe<Scalars['String']['input']>;
  firstNameLabelFrench?: InputMaybe<Scalars['String']['input']>;
  firstNameLabelGerman?: InputMaybe<Scalars['String']['input']>;
  firstNameLabelMandarin?: InputMaybe<Scalars['String']['input']>;
  firstNameLabelSpanish?: InputMaybe<Scalars['String']['input']>;
  getHelpButtonEnglish?: InputMaybe<Scalars['String']['input']>;
  getHelpButtonFrench?: InputMaybe<Scalars['String']['input']>;
  getHelpButtonGerman?: InputMaybe<Scalars['String']['input']>;
  getHelpButtonMandarin?: InputMaybe<Scalars['String']['input']>;
  getHelpButtonSpanish?: InputMaybe<Scalars['String']['input']>;
  havingTroubleEnglish?: InputMaybe<Scalars['String']['input']>;
  havingTroubleFrench?: InputMaybe<Scalars['String']['input']>;
  havingTroubleGerman?: InputMaybe<Scalars['String']['input']>;
  havingTroubleMandarin?: InputMaybe<Scalars['String']['input']>;
  havingTroubleSpanish?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  jobTitleErrorEnglish?: InputMaybe<Scalars['String']['input']>;
  jobTitleErrorFrench?: InputMaybe<Scalars['String']['input']>;
  jobTitleErrorGerman?: InputMaybe<Scalars['String']['input']>;
  jobTitleErrorMandarin?: InputMaybe<Scalars['String']['input']>;
  jobTitleErrorSpanish?: InputMaybe<Scalars['String']['input']>;
  jobTitleLabelEnglish?: InputMaybe<Scalars['String']['input']>;
  jobTitleLabelFrench?: InputMaybe<Scalars['String']['input']>;
  jobTitleLabelGerman?: InputMaybe<Scalars['String']['input']>;
  jobTitleLabelMandarin?: InputMaybe<Scalars['String']['input']>;
  jobTitleLabelSpanish?: InputMaybe<Scalars['String']['input']>;
  lastNameErrorEnglish?: InputMaybe<Scalars['String']['input']>;
  lastNameErrorFrench?: InputMaybe<Scalars['String']['input']>;
  lastNameErrorGerman?: InputMaybe<Scalars['String']['input']>;
  lastNameErrorMandarin?: InputMaybe<Scalars['String']['input']>;
  lastNameErrorSpanish?: InputMaybe<Scalars['String']['input']>;
  lastNameLabelEnglish?: InputMaybe<Scalars['String']['input']>;
  lastNameLabelFrench?: InputMaybe<Scalars['String']['input']>;
  lastNameLabelGerman?: InputMaybe<Scalars['String']['input']>;
  lastNameLabelMandarin?: InputMaybe<Scalars['String']['input']>;
  lastNameLabelSpanish?: InputMaybe<Scalars['String']['input']>;
  leftSubTitleMandarin?: InputMaybe<Scalars['String']['input']>;
  leftSubtitleEnglish?: InputMaybe<Scalars['String']['input']>;
  leftSubtitleFrench?: InputMaybe<Scalars['String']['input']>;
  leftSubtitleGerman?: InputMaybe<Scalars['String']['input']>;
  leftSubtitleSpanish?: InputMaybe<Scalars['String']['input']>;
  leftTitleCzech?: InputMaybe<Scalars['String']['input']>;
  leftTitleEnglish?: InputMaybe<Scalars['String']['input']>;
  leftTitleFrench?: InputMaybe<Scalars['String']['input']>;
  leftTitleGerman?: InputMaybe<Scalars['String']['input']>;
  leftTitleMandarin?: InputMaybe<Scalars['String']['input']>;
  leftTitleSpanish?: InputMaybe<Scalars['String']['input']>;
  nextButtonEnglish?: InputMaybe<Scalars['String']['input']>;
  nextButtonFrench?: InputMaybe<Scalars['String']['input']>;
  nextButtonGerman?: InputMaybe<Scalars['String']['input']>;
  nextButtonMandarin?: InputMaybe<Scalars['String']['input']>;
  nextButtonSpanish?: InputMaybe<Scalars['String']['input']>;
  regionErrorEnglish?: InputMaybe<Scalars['String']['input']>;
  regionErrorFrench?: InputMaybe<Scalars['String']['input']>;
  regionErrorGerman?: InputMaybe<Scalars['String']['input']>;
  regionErrorMandarin?: InputMaybe<Scalars['String']['input']>;
  regionErrorSpanish?: InputMaybe<Scalars['String']['input']>;
  regionLabelEnglish?: InputMaybe<Scalars['String']['input']>;
  regionLabelFrench?: InputMaybe<Scalars['String']['input']>;
  regionLabelGerman?: InputMaybe<Scalars['String']['input']>;
  regionLabelMandarin?: InputMaybe<Scalars['String']['input']>;
  regionLabelSpanish?: InputMaybe<Scalars['String']['input']>;
  subTitleEnglish?: InputMaybe<Scalars['String']['input']>;
  subTitleFrench?: InputMaybe<Scalars['String']['input']>;
  subTitleGerman?: InputMaybe<Scalars['String']['input']>;
  subTitleMandarin?: InputMaybe<Scalars['String']['input']>;
  subTitleSpanish?: InputMaybe<Scalars['String']['input']>;
  timezoneErrorEnglish?: InputMaybe<Scalars['String']['input']>;
  timezoneErrorFrench?: InputMaybe<Scalars['String']['input']>;
  timezoneErrorGerman?: InputMaybe<Scalars['String']['input']>;
  timezoneErrorMandarin?: InputMaybe<Scalars['String']['input']>;
  timezoneErrorSpanish?: InputMaybe<Scalars['String']['input']>;
  timezoneLabelEnglish?: InputMaybe<Scalars['String']['input']>;
  timezoneLabelFrench?: InputMaybe<Scalars['String']['input']>;
  timezoneLabelGerman?: InputMaybe<Scalars['String']['input']>;
  timezoneLabelMandarin?: InputMaybe<Scalars['String']['input']>;
  timezoneLabelSpanish?: InputMaybe<Scalars['String']['input']>;
  titleEnglish?: InputMaybe<Scalars['String']['input']>;
  titleFrench?: InputMaybe<Scalars['String']['input']>;
  titleGerman?: InputMaybe<Scalars['String']['input']>;
  titleMandarin?: InputMaybe<Scalars['String']['input']>;
  titleSpanish?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentTranslationsMenu = {
  __typename?: 'ComponentTranslationsMenu';
  aboutUsEnglish?: Maybe<Scalars['String']['output']>;
  aboutUsFrench?: Maybe<Scalars['String']['output']>;
  aboutUsGerman?: Maybe<Scalars['String']['output']>;
  helpAndSupportEnglish?: Maybe<Scalars['String']['output']>;
  helpAndSupportFrench?: Maybe<Scalars['String']['output']>;
  helpAndSupportGerman?: Maybe<Scalars['String']['output']>;
  helpAndSupportMandarin?: Maybe<Scalars['String']['output']>;
  helpAndSupportSpanish?: Maybe<Scalars['String']['output']>;
  homeEnglish?: Maybe<Scalars['String']['output']>;
  homeFrench?: Maybe<Scalars['String']['output']>;
  homeGerman?: Maybe<Scalars['String']['output']>;
  homeMandarin?: Maybe<Scalars['String']['output']>;
  homeSpanish?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  myLibraryEnglish?: Maybe<Scalars['String']['output']>;
  myLibraryFrench?: Maybe<Scalars['String']['output']>;
  myLibraryGerman?: Maybe<Scalars['String']['output']>;
  myLibraryMandarin?: Maybe<Scalars['String']['output']>;
  myLibrarySpanish?: Maybe<Scalars['String']['output']>;
  myNotesEnglish?: Maybe<Scalars['String']['output']>;
  myNotesFrench?: Maybe<Scalars['String']['output']>;
  myNotesGerman?: Maybe<Scalars['String']['output']>;
  myNotesMandarin?: Maybe<Scalars['String']['output']>;
  myNotesSpanish?: Maybe<Scalars['String']['output']>;
  myProfileEnglish?: Maybe<Scalars['String']['output']>;
  myProfileFrench?: Maybe<Scalars['String']['output']>;
  myProfileGerman?: Maybe<Scalars['String']['output']>;
  myProfileMandarin?: Maybe<Scalars['String']['output']>;
  myProfileSpanish?: Maybe<Scalars['String']['output']>;
  myProgrammeEnglish?: Maybe<Scalars['String']['output']>;
  myProgrammeFrench?: Maybe<Scalars['String']['output']>;
  myProgrammeGerman?: Maybe<Scalars['String']['output']>;
  myProgrammeMandarin?: Maybe<Scalars['String']['output']>;
  myProgrammeSpanish?: Maybe<Scalars['String']['output']>;
  myWorkEnglish?: Maybe<Scalars['String']['output']>;
  myWorkFrench?: Maybe<Scalars['String']['output']>;
  myWorkGerman?: Maybe<Scalars['String']['output']>;
  myWorkMandarin?: Maybe<Scalars['String']['output']>;
  myWorkSpanish?: Maybe<Scalars['String']['output']>;
  notificationsEnglish?: Maybe<Scalars['String']['output']>;
  notificationsFrench?: Maybe<Scalars['String']['output']>;
  notificationsGerman?: Maybe<Scalars['String']['output']>;
  notificationsMandarin?: Maybe<Scalars['String']['output']>;
  notificationsSpanish?: Maybe<Scalars['String']['output']>;
  signOutEnglish?: Maybe<Scalars['String']['output']>;
  signOutFrench?: Maybe<Scalars['String']['output']>;
  signOutGerman?: Maybe<Scalars['String']['output']>;
  signOutMandarin?: Maybe<Scalars['String']['output']>;
  signOutSpanish?: Maybe<Scalars['String']['output']>;
};

export type ComponentTranslationsMenuInput = {
  aboutUsEnglish?: InputMaybe<Scalars['String']['input']>;
  aboutUsFrench?: InputMaybe<Scalars['String']['input']>;
  aboutUsGerman?: InputMaybe<Scalars['String']['input']>;
  helpAndSupportEnglish?: InputMaybe<Scalars['String']['input']>;
  helpAndSupportFrench?: InputMaybe<Scalars['String']['input']>;
  helpAndSupportGerman?: InputMaybe<Scalars['String']['input']>;
  helpAndSupportMandarin?: InputMaybe<Scalars['String']['input']>;
  helpAndSupportSpanish?: InputMaybe<Scalars['String']['input']>;
  homeEnglish?: InputMaybe<Scalars['String']['input']>;
  homeFrench?: InputMaybe<Scalars['String']['input']>;
  homeGerman?: InputMaybe<Scalars['String']['input']>;
  homeMandarin?: InputMaybe<Scalars['String']['input']>;
  homeSpanish?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  myLibraryEnglish?: InputMaybe<Scalars['String']['input']>;
  myLibraryFrench?: InputMaybe<Scalars['String']['input']>;
  myLibraryGerman?: InputMaybe<Scalars['String']['input']>;
  myLibraryMandarin?: InputMaybe<Scalars['String']['input']>;
  myLibrarySpanish?: InputMaybe<Scalars['String']['input']>;
  myNotesEnglish?: InputMaybe<Scalars['String']['input']>;
  myNotesFrench?: InputMaybe<Scalars['String']['input']>;
  myNotesGerman?: InputMaybe<Scalars['String']['input']>;
  myNotesMandarin?: InputMaybe<Scalars['String']['input']>;
  myNotesSpanish?: InputMaybe<Scalars['String']['input']>;
  myProfileEnglish?: InputMaybe<Scalars['String']['input']>;
  myProfileFrench?: InputMaybe<Scalars['String']['input']>;
  myProfileGerman?: InputMaybe<Scalars['String']['input']>;
  myProfileMandarin?: InputMaybe<Scalars['String']['input']>;
  myProfileSpanish?: InputMaybe<Scalars['String']['input']>;
  myProgrammeEnglish?: InputMaybe<Scalars['String']['input']>;
  myProgrammeFrench?: InputMaybe<Scalars['String']['input']>;
  myProgrammeGerman?: InputMaybe<Scalars['String']['input']>;
  myProgrammeMandarin?: InputMaybe<Scalars['String']['input']>;
  myProgrammeSpanish?: InputMaybe<Scalars['String']['input']>;
  myWorkEnglish?: InputMaybe<Scalars['String']['input']>;
  myWorkFrench?: InputMaybe<Scalars['String']['input']>;
  myWorkGerman?: InputMaybe<Scalars['String']['input']>;
  myWorkMandarin?: InputMaybe<Scalars['String']['input']>;
  myWorkSpanish?: InputMaybe<Scalars['String']['input']>;
  notificationsEnglish?: InputMaybe<Scalars['String']['input']>;
  notificationsFrench?: InputMaybe<Scalars['String']['input']>;
  notificationsGerman?: InputMaybe<Scalars['String']['input']>;
  notificationsMandarin?: InputMaybe<Scalars['String']['input']>;
  notificationsSpanish?: InputMaybe<Scalars['String']['input']>;
  signOutEnglish?: InputMaybe<Scalars['String']['input']>;
  signOutFrench?: InputMaybe<Scalars['String']['input']>;
  signOutGerman?: InputMaybe<Scalars['String']['input']>;
  signOutMandarin?: InputMaybe<Scalars['String']['input']>;
  signOutSpanish?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentTranslationsMyLibraryScreen = {
  __typename?: 'ComponentTranslationsMyLibraryScreen';
  allArticlesEnglish?: Maybe<Scalars['String']['output']>;
  allArticlesFrench?: Maybe<Scalars['String']['output']>;
  allArticlesGerman?: Maybe<Scalars['String']['output']>;
  allArticlesMandarin?: Maybe<Scalars['String']['output']>;
  allArticlesSpanish?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  myBookmarksEnglish?: Maybe<Scalars['String']['output']>;
  myBookmarksFrench?: Maybe<Scalars['String']['output']>;
  myBookmarksGerman?: Maybe<Scalars['String']['output']>;
  myBookmarksMandarin?: Maybe<Scalars['String']['output']>;
  myBookmarksSpanish?: Maybe<Scalars['String']['output']>;
  viewArticleEnglish?: Maybe<Scalars['String']['output']>;
  viewArticleFrench?: Maybe<Scalars['String']['output']>;
  viewArticleGerman?: Maybe<Scalars['String']['output']>;
  viewArticleMandarin?: Maybe<Scalars['String']['output']>;
  viewArticleSpanish?: Maybe<Scalars['String']['output']>;
};

export type ComponentTranslationsMyLibraryScreenInput = {
  allArticlesEnglish?: InputMaybe<Scalars['String']['input']>;
  allArticlesFrench?: InputMaybe<Scalars['String']['input']>;
  allArticlesGerman?: InputMaybe<Scalars['String']['input']>;
  allArticlesMandarin?: InputMaybe<Scalars['String']['input']>;
  allArticlesSpanish?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  myBookmarksEnglish?: InputMaybe<Scalars['String']['input']>;
  myBookmarksFrench?: InputMaybe<Scalars['String']['input']>;
  myBookmarksGerman?: InputMaybe<Scalars['String']['input']>;
  myBookmarksMandarin?: InputMaybe<Scalars['String']['input']>;
  myBookmarksSpanish?: InputMaybe<Scalars['String']['input']>;
  viewArticleEnglish?: InputMaybe<Scalars['String']['input']>;
  viewArticleFrench?: InputMaybe<Scalars['String']['input']>;
  viewArticleGerman?: InputMaybe<Scalars['String']['input']>;
  viewArticleMandarin?: InputMaybe<Scalars['String']['input']>;
  viewArticleSpanish?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentTranslationsMyProfileScreen = {
  __typename?: 'ComponentTranslationsMyProfileScreen';
  detailsEnglish?: Maybe<Scalars['String']['output']>;
  detailsFrench?: Maybe<Scalars['String']['output']>;
  detailsGerman?: Maybe<Scalars['String']['output']>;
  detailsMandarin?: Maybe<Scalars['String']['output']>;
  detailsSpanish?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  joinEnglish?: Maybe<Scalars['String']['output']>;
  joinFrench?: Maybe<Scalars['String']['output']>;
  joinGerman?: Maybe<Scalars['String']['output']>;
  joinMandarin?: Maybe<Scalars['String']['output']>;
  joinSpanish?: Maybe<Scalars['String']['output']>;
  logoutEnglish?: Maybe<Scalars['String']['output']>;
  logoutFrench?: Maybe<Scalars['String']['output']>;
  logoutGerman?: Maybe<Scalars['String']['output']>;
  logoutMandarin?: Maybe<Scalars['String']['output']>;
  logoutSpanish?: Maybe<Scalars['String']['output']>;
  settingsEnglish?: Maybe<Scalars['String']['output']>;
  settingsFrench?: Maybe<Scalars['String']['output']>;
  settingsGerman?: Maybe<Scalars['String']['output']>;
  settingsMandarin?: Maybe<Scalars['String']['output']>;
  settingsSpanish?: Maybe<Scalars['String']['output']>;
};

export type ComponentTranslationsMyProfileScreenInput = {
  detailsEnglish?: InputMaybe<Scalars['String']['input']>;
  detailsFrench?: InputMaybe<Scalars['String']['input']>;
  detailsGerman?: InputMaybe<Scalars['String']['input']>;
  detailsMandarin?: InputMaybe<Scalars['String']['input']>;
  detailsSpanish?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  joinEnglish?: InputMaybe<Scalars['String']['input']>;
  joinFrench?: InputMaybe<Scalars['String']['input']>;
  joinGerman?: InputMaybe<Scalars['String']['input']>;
  joinMandarin?: InputMaybe<Scalars['String']['input']>;
  joinSpanish?: InputMaybe<Scalars['String']['input']>;
  logoutEnglish?: InputMaybe<Scalars['String']['input']>;
  logoutFrench?: InputMaybe<Scalars['String']['input']>;
  logoutGerman?: InputMaybe<Scalars['String']['input']>;
  logoutMandarin?: InputMaybe<Scalars['String']['input']>;
  logoutSpanish?: InputMaybe<Scalars['String']['input']>;
  settingsEnglish?: InputMaybe<Scalars['String']['input']>;
  settingsFrench?: InputMaybe<Scalars['String']['input']>;
  settingsGerman?: InputMaybe<Scalars['String']['input']>;
  settingsMandarin?: InputMaybe<Scalars['String']['input']>;
  settingsSpanish?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentTranslationsMyWorkScreen = {
  __typename?: 'ComponentTranslationsMyWorkScreen';
  deleteHeadingEnglish?: Maybe<Scalars['String']['output']>;
  deleteHeadingFrench?: Maybe<Scalars['String']['output']>;
  deleteHeadingGerman?: Maybe<Scalars['String']['output']>;
  deleteHeadingMandarin?: Maybe<Scalars['String']['output']>;
  deleteHeadingSpanish?: Maybe<Scalars['String']['output']>;
  deleteMessageEnglish?: Maybe<Scalars['String']['output']>;
  deleteMessageFrench?: Maybe<Scalars['String']['output']>;
  deleteMessageGerman?: Maybe<Scalars['String']['output']>;
  deleteMessageMandarin?: Maybe<Scalars['String']['output']>;
  deleteMessageSpanish?: Maybe<Scalars['String']['output']>;
  documentsEnglish?: Maybe<Scalars['String']['output']>;
  documentsFrench?: Maybe<Scalars['String']['output']>;
  documentsGerman?: Maybe<Scalars['String']['output']>;
  documentsMandarin?: Maybe<Scalars['String']['output']>;
  documentsSpanish?: Maybe<Scalars['String']['output']>;
  documentsUploadedEnglish?: Maybe<Scalars['String']['output']>;
  documentsUploadedFrench?: Maybe<Scalars['String']['output']>;
  documentsUploadedGerman?: Maybe<Scalars['String']['output']>;
  documentsUploadedMandarin?: Maybe<Scalars['String']['output']>;
  documentsUploadedSpanish?: Maybe<Scalars['String']['output']>;
  downloadContentTextEnglish?: Maybe<Scalars['String']['output']>;
  downloadContentTextFrench?: Maybe<Scalars['String']['output']>;
  downloadContentTextGerman?: Maybe<Scalars['String']['output']>;
  downloadContentTextMandarin?: Maybe<Scalars['String']['output']>;
  downloadContentTextSpanish?: Maybe<Scalars['String']['output']>;
  emptyStateDescEnglish?: Maybe<Scalars['String']['output']>;
  emptyStateDescFrench?: Maybe<Scalars['String']['output']>;
  emptyStateDescGerman?: Maybe<Scalars['String']['output']>;
  emptyStateDescMandarin?: Maybe<Scalars['String']['output']>;
  emptyStateDescSpanish?: Maybe<Scalars['String']['output']>;
  emptyStateTitleEnglish?: Maybe<Scalars['String']['output']>;
  emptyStateTitleFrench?: Maybe<Scalars['String']['output']>;
  emptyStateTitleGerman?: Maybe<Scalars['String']['output']>;
  emptyStateTitleMandarin?: Maybe<Scalars['String']['output']>;
  emptyStateTitleSpanish?: Maybe<Scalars['String']['output']>;
  feedbackEnglish?: Maybe<Scalars['String']['output']>;
  feedbackFrench?: Maybe<Scalars['String']['output']>;
  feedbackGerman?: Maybe<Scalars['String']['output']>;
  feedbackMandarin?: Maybe<Scalars['String']['output']>;
  feedbackNotEligibleEnglish?: Maybe<Scalars['String']['output']>;
  feedbackNotEligibleFrench?: Maybe<Scalars['String']['output']>;
  feedbackNotEligibleGerman?: Maybe<Scalars['String']['output']>;
  feedbackNotEligibleMandarin?: Maybe<Scalars['String']['output']>;
  feedbackNotEligibleSpanish?: Maybe<Scalars['String']['output']>;
  feedbackNotReceivedEnglish?: Maybe<Scalars['String']['output']>;
  feedbackNotReceivedFrench?: Maybe<Scalars['String']['output']>;
  feedbackNotReceivedGerman?: Maybe<Scalars['String']['output']>;
  feedbackNotReceivedMandarin?: Maybe<Scalars['String']['output']>;
  feedbackNotReceivedSpanish?: Maybe<Scalars['String']['output']>;
  feedbackSpanish?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  moduleReportsEnglish?: Maybe<Scalars['String']['output']>;
  moduleReportsFrench?: Maybe<Scalars['String']['output']>;
  moduleReportsGerman?: Maybe<Scalars['String']['output']>;
  moduleReportsMandarin?: Maybe<Scalars['String']['output']>;
  moduleReportsSpanish?: Maybe<Scalars['String']['output']>;
  myNotesEnglish?: Maybe<Scalars['String']['output']>;
  myNotesFrench?: Maybe<Scalars['String']['output']>;
  myNotesGerman?: Maybe<Scalars['String']['output']>;
  myNotesMandarin?: Maybe<Scalars['String']['output']>;
  myNotesSpanish?: Maybe<Scalars['String']['output']>;
  noDocumentsHeadingEnglish?: Maybe<Scalars['String']['output']>;
  noDocumentsHeadingFrench?: Maybe<Scalars['String']['output']>;
  noDocumentsHeadingGerman?: Maybe<Scalars['String']['output']>;
  noDocumentsHeadingMandarin?: Maybe<Scalars['String']['output']>;
  noDocumentsHeadingSpanish?: Maybe<Scalars['String']['output']>;
  noDocumentsSubHeadingEnglish?: Maybe<Scalars['String']['output']>;
  noDocumentsSubHeadingFrench?: Maybe<Scalars['String']['output']>;
  noDocumentsSubHeadingGerman?: Maybe<Scalars['String']['output']>;
  noDocumentsSubHeadingMandarin?: Maybe<Scalars['String']['output']>;
  noDocumentsSubHeadingSpanish?: Maybe<Scalars['String']['output']>;
  noModuleReportsHeadingEnglish?: Maybe<Scalars['String']['output']>;
  noModuleReportsHeadingFrench?: Maybe<Scalars['String']['output']>;
  noModuleReportsHeadingGerman?: Maybe<Scalars['String']['output']>;
  noModuleReportsHeadingMandarin?: Maybe<Scalars['String']['output']>;
  noModuleReportsHeadingSpanish?: Maybe<Scalars['String']['output']>;
  noModuleReportsSubHeadingEnglish?: Maybe<Scalars['String']['output']>;
  noModuleReportsSubHeadingFrench?: Maybe<Scalars['String']['output']>;
  noModuleReportsSubHeadingGerman?: Maybe<Scalars['String']['output']>;
  noModuleReportsSubHeadingMandarin?: Maybe<Scalars['String']['output']>;
  noModuleReportsSubHeadingSpanish?: Maybe<Scalars['String']['output']>;
  noNotesHeadingEnglish?: Maybe<Scalars['String']['output']>;
  noNotesHeadingFrench?: Maybe<Scalars['String']['output']>;
  noNotesHeadingGerman?: Maybe<Scalars['String']['output']>;
  noNotesHeadingMandarin?: Maybe<Scalars['String']['output']>;
  noNotesHeadingSpanish?: Maybe<Scalars['String']['output']>;
  noNotesSubHeadingEnglish?: Maybe<Scalars['String']['output']>;
  noNotesSubHeadingFrench?: Maybe<Scalars['String']['output']>;
  noNotesSubHeadingGerman?: Maybe<Scalars['String']['output']>;
  noNotesSubHeadingMandarin?: Maybe<Scalars['String']['output']>;
  noNotesSubHeadingSpanish?: Maybe<Scalars['String']['output']>;
  notStartedEnglish?: Maybe<Scalars['String']['output']>;
  notStartedFrench?: Maybe<Scalars['String']['output']>;
  notStartedGerman?: Maybe<Scalars['String']['output']>;
  notStartedMandarin?: Maybe<Scalars['String']['output']>;
  notStartedSpanish?: Maybe<Scalars['String']['output']>;
  programmeHeadingEnglish?: Maybe<Scalars['String']['output']>;
  programmeHeadingFrench?: Maybe<Scalars['String']['output']>;
  programmeHeadingGerman?: Maybe<Scalars['String']['output']>;
  programmeHeadingMandarin?: Maybe<Scalars['String']['output']>;
  programmeHeadingSpanish?: Maybe<Scalars['String']['output']>;
  recentNotesEnglish?: Maybe<Scalars['String']['output']>;
  recentNotesFrench?: Maybe<Scalars['String']['output']>;
  recentNotesGerman?: Maybe<Scalars['String']['output']>;
  recentNotesMandarin?: Maybe<Scalars['String']['output']>;
  recentNotesSpanish?: Maybe<Scalars['String']['output']>;
  sectionCompletedEnglish?: Maybe<Scalars['String']['output']>;
  sectionCompletedFrench?: Maybe<Scalars['String']['output']>;
  sectionCompletedGerman?: Maybe<Scalars['String']['output']>;
  sectionCompletedMandarin?: Maybe<Scalars['String']['output']>;
  sectionCompletedSpanish?: Maybe<Scalars['String']['output']>;
  subtitleEnglish?: Maybe<Scalars['String']['output']>;
  subtitleFrench?: Maybe<Scalars['String']['output']>;
  subtitleGerman?: Maybe<Scalars['String']['output']>;
  subtitleMandarin?: Maybe<Scalars['String']['output']>;
  subtitleSpanish?: Maybe<Scalars['String']['output']>;
  uploadButtonEnglish?: Maybe<Scalars['String']['output']>;
  uploadButtonFrench?: Maybe<Scalars['String']['output']>;
  uploadButtonGerman?: Maybe<Scalars['String']['output']>;
  uploadButtonMandarin?: Maybe<Scalars['String']['output']>;
  uploadButtonSpanish?: Maybe<Scalars['String']['output']>;
};

export type ComponentTranslationsMyWorkScreenInput = {
  deleteHeadingEnglish?: InputMaybe<Scalars['String']['input']>;
  deleteHeadingFrench?: InputMaybe<Scalars['String']['input']>;
  deleteHeadingGerman?: InputMaybe<Scalars['String']['input']>;
  deleteHeadingMandarin?: InputMaybe<Scalars['String']['input']>;
  deleteHeadingSpanish?: InputMaybe<Scalars['String']['input']>;
  deleteMessageEnglish?: InputMaybe<Scalars['String']['input']>;
  deleteMessageFrench?: InputMaybe<Scalars['String']['input']>;
  deleteMessageGerman?: InputMaybe<Scalars['String']['input']>;
  deleteMessageMandarin?: InputMaybe<Scalars['String']['input']>;
  deleteMessageSpanish?: InputMaybe<Scalars['String']['input']>;
  documentsEnglish?: InputMaybe<Scalars['String']['input']>;
  documentsFrench?: InputMaybe<Scalars['String']['input']>;
  documentsGerman?: InputMaybe<Scalars['String']['input']>;
  documentsMandarin?: InputMaybe<Scalars['String']['input']>;
  documentsSpanish?: InputMaybe<Scalars['String']['input']>;
  documentsUploadedEnglish?: InputMaybe<Scalars['String']['input']>;
  documentsUploadedFrench?: InputMaybe<Scalars['String']['input']>;
  documentsUploadedGerman?: InputMaybe<Scalars['String']['input']>;
  documentsUploadedMandarin?: InputMaybe<Scalars['String']['input']>;
  documentsUploadedSpanish?: InputMaybe<Scalars['String']['input']>;
  downloadContentTextEnglish?: InputMaybe<Scalars['String']['input']>;
  downloadContentTextFrench?: InputMaybe<Scalars['String']['input']>;
  downloadContentTextGerman?: InputMaybe<Scalars['String']['input']>;
  downloadContentTextMandarin?: InputMaybe<Scalars['String']['input']>;
  downloadContentTextSpanish?: InputMaybe<Scalars['String']['input']>;
  emptyStateDescEnglish?: InputMaybe<Scalars['String']['input']>;
  emptyStateDescFrench?: InputMaybe<Scalars['String']['input']>;
  emptyStateDescGerman?: InputMaybe<Scalars['String']['input']>;
  emptyStateDescMandarin?: InputMaybe<Scalars['String']['input']>;
  emptyStateDescSpanish?: InputMaybe<Scalars['String']['input']>;
  emptyStateTitleEnglish?: InputMaybe<Scalars['String']['input']>;
  emptyStateTitleFrench?: InputMaybe<Scalars['String']['input']>;
  emptyStateTitleGerman?: InputMaybe<Scalars['String']['input']>;
  emptyStateTitleMandarin?: InputMaybe<Scalars['String']['input']>;
  emptyStateTitleSpanish?: InputMaybe<Scalars['String']['input']>;
  feedbackEnglish?: InputMaybe<Scalars['String']['input']>;
  feedbackFrench?: InputMaybe<Scalars['String']['input']>;
  feedbackGerman?: InputMaybe<Scalars['String']['input']>;
  feedbackMandarin?: InputMaybe<Scalars['String']['input']>;
  feedbackNotEligibleEnglish?: InputMaybe<Scalars['String']['input']>;
  feedbackNotEligibleFrench?: InputMaybe<Scalars['String']['input']>;
  feedbackNotEligibleGerman?: InputMaybe<Scalars['String']['input']>;
  feedbackNotEligibleMandarin?: InputMaybe<Scalars['String']['input']>;
  feedbackNotEligibleSpanish?: InputMaybe<Scalars['String']['input']>;
  feedbackNotReceivedEnglish?: InputMaybe<Scalars['String']['input']>;
  feedbackNotReceivedFrench?: InputMaybe<Scalars['String']['input']>;
  feedbackNotReceivedGerman?: InputMaybe<Scalars['String']['input']>;
  feedbackNotReceivedMandarin?: InputMaybe<Scalars['String']['input']>;
  feedbackNotReceivedSpanish?: InputMaybe<Scalars['String']['input']>;
  feedbackSpanish?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  moduleReportsEnglish?: InputMaybe<Scalars['String']['input']>;
  moduleReportsFrench?: InputMaybe<Scalars['String']['input']>;
  moduleReportsGerman?: InputMaybe<Scalars['String']['input']>;
  moduleReportsMandarin?: InputMaybe<Scalars['String']['input']>;
  moduleReportsSpanish?: InputMaybe<Scalars['String']['input']>;
  myNotesEnglish?: InputMaybe<Scalars['String']['input']>;
  myNotesFrench?: InputMaybe<Scalars['String']['input']>;
  myNotesGerman?: InputMaybe<Scalars['String']['input']>;
  myNotesMandarin?: InputMaybe<Scalars['String']['input']>;
  myNotesSpanish?: InputMaybe<Scalars['String']['input']>;
  noDocumentsHeadingEnglish?: InputMaybe<Scalars['String']['input']>;
  noDocumentsHeadingFrench?: InputMaybe<Scalars['String']['input']>;
  noDocumentsHeadingGerman?: InputMaybe<Scalars['String']['input']>;
  noDocumentsHeadingMandarin?: InputMaybe<Scalars['String']['input']>;
  noDocumentsHeadingSpanish?: InputMaybe<Scalars['String']['input']>;
  noDocumentsSubHeadingEnglish?: InputMaybe<Scalars['String']['input']>;
  noDocumentsSubHeadingFrench?: InputMaybe<Scalars['String']['input']>;
  noDocumentsSubHeadingGerman?: InputMaybe<Scalars['String']['input']>;
  noDocumentsSubHeadingMandarin?: InputMaybe<Scalars['String']['input']>;
  noDocumentsSubHeadingSpanish?: InputMaybe<Scalars['String']['input']>;
  noModuleReportsHeadingEnglish?: InputMaybe<Scalars['String']['input']>;
  noModuleReportsHeadingFrench?: InputMaybe<Scalars['String']['input']>;
  noModuleReportsHeadingGerman?: InputMaybe<Scalars['String']['input']>;
  noModuleReportsHeadingMandarin?: InputMaybe<Scalars['String']['input']>;
  noModuleReportsHeadingSpanish?: InputMaybe<Scalars['String']['input']>;
  noModuleReportsSubHeadingEnglish?: InputMaybe<Scalars['String']['input']>;
  noModuleReportsSubHeadingFrench?: InputMaybe<Scalars['String']['input']>;
  noModuleReportsSubHeadingGerman?: InputMaybe<Scalars['String']['input']>;
  noModuleReportsSubHeadingMandarin?: InputMaybe<Scalars['String']['input']>;
  noModuleReportsSubHeadingSpanish?: InputMaybe<Scalars['String']['input']>;
  noNotesHeadingEnglish?: InputMaybe<Scalars['String']['input']>;
  noNotesHeadingFrench?: InputMaybe<Scalars['String']['input']>;
  noNotesHeadingGerman?: InputMaybe<Scalars['String']['input']>;
  noNotesHeadingMandarin?: InputMaybe<Scalars['String']['input']>;
  noNotesHeadingSpanish?: InputMaybe<Scalars['String']['input']>;
  noNotesSubHeadingEnglish?: InputMaybe<Scalars['String']['input']>;
  noNotesSubHeadingFrench?: InputMaybe<Scalars['String']['input']>;
  noNotesSubHeadingGerman?: InputMaybe<Scalars['String']['input']>;
  noNotesSubHeadingMandarin?: InputMaybe<Scalars['String']['input']>;
  noNotesSubHeadingSpanish?: InputMaybe<Scalars['String']['input']>;
  notStartedEnglish?: InputMaybe<Scalars['String']['input']>;
  notStartedFrench?: InputMaybe<Scalars['String']['input']>;
  notStartedGerman?: InputMaybe<Scalars['String']['input']>;
  notStartedMandarin?: InputMaybe<Scalars['String']['input']>;
  notStartedSpanish?: InputMaybe<Scalars['String']['input']>;
  programmeHeadingEnglish?: InputMaybe<Scalars['String']['input']>;
  programmeHeadingFrench?: InputMaybe<Scalars['String']['input']>;
  programmeHeadingGerman?: InputMaybe<Scalars['String']['input']>;
  programmeHeadingMandarin?: InputMaybe<Scalars['String']['input']>;
  programmeHeadingSpanish?: InputMaybe<Scalars['String']['input']>;
  recentNotesEnglish?: InputMaybe<Scalars['String']['input']>;
  recentNotesFrench?: InputMaybe<Scalars['String']['input']>;
  recentNotesGerman?: InputMaybe<Scalars['String']['input']>;
  recentNotesMandarin?: InputMaybe<Scalars['String']['input']>;
  recentNotesSpanish?: InputMaybe<Scalars['String']['input']>;
  sectionCompletedEnglish?: InputMaybe<Scalars['String']['input']>;
  sectionCompletedFrench?: InputMaybe<Scalars['String']['input']>;
  sectionCompletedGerman?: InputMaybe<Scalars['String']['input']>;
  sectionCompletedMandarin?: InputMaybe<Scalars['String']['input']>;
  sectionCompletedSpanish?: InputMaybe<Scalars['String']['input']>;
  subtitleEnglish?: InputMaybe<Scalars['String']['input']>;
  subtitleFrench?: InputMaybe<Scalars['String']['input']>;
  subtitleGerman?: InputMaybe<Scalars['String']['input']>;
  subtitleMandarin?: InputMaybe<Scalars['String']['input']>;
  subtitleSpanish?: InputMaybe<Scalars['String']['input']>;
  uploadButtonEnglish?: InputMaybe<Scalars['String']['input']>;
  uploadButtonFrench?: InputMaybe<Scalars['String']['input']>;
  uploadButtonGerman?: InputMaybe<Scalars['String']['input']>;
  uploadButtonMandarin?: InputMaybe<Scalars['String']['input']>;
  uploadButtonSpanish?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentTranslationsPersonalScreen = {
  __typename?: 'ComponentTranslationsPersonalScreen';
  changePhotoEnglish?: Maybe<Scalars['String']['output']>;
  changePhotoFrench?: Maybe<Scalars['String']['output']>;
  changePhotoGerman?: Maybe<Scalars['String']['output']>;
  changePhotoMandarin?: Maybe<Scalars['String']['output']>;
  changePhotoSpanish?: Maybe<Scalars['String']['output']>;
  divisionLabelEnglish?: Maybe<Scalars['String']['output']>;
  divisionLabelFrench?: Maybe<Scalars['String']['output']>;
  divisionLabelGerman?: Maybe<Scalars['String']['output']>;
  divisionLabelMandarin?: Maybe<Scalars['String']['output']>;
  divisionLabelSpanish?: Maybe<Scalars['String']['output']>;
  editInfoButtonEnglish?: Maybe<Scalars['String']['output']>;
  editInfoButtonFrench?: Maybe<Scalars['String']['output']>;
  editInfoButtonGerman?: Maybe<Scalars['String']['output']>;
  editInfoButtonMandarin?: Maybe<Scalars['String']['output']>;
  editInfoButtonSpanish?: Maybe<Scalars['String']['output']>;
  emailLabelEnglish?: Maybe<Scalars['String']['output']>;
  emailLabelFrench?: Maybe<Scalars['String']['output']>;
  emailLabelGerman?: Maybe<Scalars['String']['output']>;
  emailLabelMandarin?: Maybe<Scalars['String']['output']>;
  emailLabelSpanish?: Maybe<Scalars['String']['output']>;
  firstNameLabelEnglish?: Maybe<Scalars['String']['output']>;
  firstNameLabelFrench?: Maybe<Scalars['String']['output']>;
  firstNameLabelGerman?: Maybe<Scalars['String']['output']>;
  firstNameLabelMandarin?: Maybe<Scalars['String']['output']>;
  firstNameLabelSpanish?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  jobTitleLabelEnglish?: Maybe<Scalars['String']['output']>;
  jobTitleLabelFrench?: Maybe<Scalars['String']['output']>;
  jobTitleLabelGerman?: Maybe<Scalars['String']['output']>;
  jobTitleLabelMandarin?: Maybe<Scalars['String']['output']>;
  jobTitleLabelSpanish?: Maybe<Scalars['String']['output']>;
  lastNameLabelEnglish?: Maybe<Scalars['String']['output']>;
  lastNameLabelFrench?: Maybe<Scalars['String']['output']>;
  lastNameLabelGerman?: Maybe<Scalars['String']['output']>;
  lastNameLabelMandarin?: Maybe<Scalars['String']['output']>;
  lastNameLabelSpanish?: Maybe<Scalars['String']['output']>;
  resetPasswordEnglish?: Maybe<Scalars['String']['output']>;
  resetPasswordFrench?: Maybe<Scalars['String']['output']>;
  resetPasswordGerman?: Maybe<Scalars['String']['output']>;
  resetPasswordMandarin?: Maybe<Scalars['String']['output']>;
  resetPasswordSpanish?: Maybe<Scalars['String']['output']>;
};

export type ComponentTranslationsPersonalScreenInput = {
  changePhotoEnglish?: InputMaybe<Scalars['String']['input']>;
  changePhotoFrench?: InputMaybe<Scalars['String']['input']>;
  changePhotoGerman?: InputMaybe<Scalars['String']['input']>;
  changePhotoMandarin?: InputMaybe<Scalars['String']['input']>;
  changePhotoSpanish?: InputMaybe<Scalars['String']['input']>;
  divisionLabelEnglish?: InputMaybe<Scalars['String']['input']>;
  divisionLabelFrench?: InputMaybe<Scalars['String']['input']>;
  divisionLabelGerman?: InputMaybe<Scalars['String']['input']>;
  divisionLabelMandarin?: InputMaybe<Scalars['String']['input']>;
  divisionLabelSpanish?: InputMaybe<Scalars['String']['input']>;
  editInfoButtonEnglish?: InputMaybe<Scalars['String']['input']>;
  editInfoButtonFrench?: InputMaybe<Scalars['String']['input']>;
  editInfoButtonGerman?: InputMaybe<Scalars['String']['input']>;
  editInfoButtonMandarin?: InputMaybe<Scalars['String']['input']>;
  editInfoButtonSpanish?: InputMaybe<Scalars['String']['input']>;
  emailLabelEnglish?: InputMaybe<Scalars['String']['input']>;
  emailLabelFrench?: InputMaybe<Scalars['String']['input']>;
  emailLabelGerman?: InputMaybe<Scalars['String']['input']>;
  emailLabelMandarin?: InputMaybe<Scalars['String']['input']>;
  emailLabelSpanish?: InputMaybe<Scalars['String']['input']>;
  firstNameLabelEnglish?: InputMaybe<Scalars['String']['input']>;
  firstNameLabelFrench?: InputMaybe<Scalars['String']['input']>;
  firstNameLabelGerman?: InputMaybe<Scalars['String']['input']>;
  firstNameLabelMandarin?: InputMaybe<Scalars['String']['input']>;
  firstNameLabelSpanish?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  jobTitleLabelEnglish?: InputMaybe<Scalars['String']['input']>;
  jobTitleLabelFrench?: InputMaybe<Scalars['String']['input']>;
  jobTitleLabelGerman?: InputMaybe<Scalars['String']['input']>;
  jobTitleLabelMandarin?: InputMaybe<Scalars['String']['input']>;
  jobTitleLabelSpanish?: InputMaybe<Scalars['String']['input']>;
  lastNameLabelEnglish?: InputMaybe<Scalars['String']['input']>;
  lastNameLabelFrench?: InputMaybe<Scalars['String']['input']>;
  lastNameLabelGerman?: InputMaybe<Scalars['String']['input']>;
  lastNameLabelMandarin?: InputMaybe<Scalars['String']['input']>;
  lastNameLabelSpanish?: InputMaybe<Scalars['String']['input']>;
  resetPasswordEnglish?: InputMaybe<Scalars['String']['input']>;
  resetPasswordFrench?: InputMaybe<Scalars['String']['input']>;
  resetPasswordGerman?: InputMaybe<Scalars['String']['input']>;
  resetPasswordMandarin?: InputMaybe<Scalars['String']['input']>;
  resetPasswordSpanish?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentTranslationsPrivacyPolicy = {
  __typename?: 'ComponentTranslationsPrivacyPolicy';
  id: Scalars['ID']['output'];
  textEnglish?: Maybe<Scalars['String']['output']>;
  textFrench?: Maybe<Scalars['String']['output']>;
  textGerman?: Maybe<Scalars['String']['output']>;
  textMandarin?: Maybe<Scalars['String']['output']>;
  textSpanish?: Maybe<Scalars['String']['output']>;
  titleEnglish?: Maybe<Scalars['String']['output']>;
  titleFrench?: Maybe<Scalars['String']['output']>;
  titleGerman?: Maybe<Scalars['String']['output']>;
  titleMandarin?: Maybe<Scalars['String']['output']>;
  titleSpanish?: Maybe<Scalars['String']['output']>;
};

export type ComponentTranslationsPrivacyPolicyInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  textEnglish?: InputMaybe<Scalars['String']['input']>;
  textFrench?: InputMaybe<Scalars['String']['input']>;
  textGerman?: InputMaybe<Scalars['String']['input']>;
  textMandarin?: InputMaybe<Scalars['String']['input']>;
  textSpanish?: InputMaybe<Scalars['String']['input']>;
  titleEnglish?: InputMaybe<Scalars['String']['input']>;
  titleFrench?: InputMaybe<Scalars['String']['input']>;
  titleGerman?: InputMaybe<Scalars['String']['input']>;
  titleMandarin?: InputMaybe<Scalars['String']['input']>;
  titleSpanish?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentTranslationsProgrammeScreen = {
  __typename?: 'ComponentTranslationsProgrammeScreen';
  changeButtonEnglish?: Maybe<Scalars['String']['output']>;
  changeButtonFrench?: Maybe<Scalars['String']['output']>;
  changeButtonGerman?: Maybe<Scalars['String']['output']>;
  changeButtonMandarin?: Maybe<Scalars['String']['output']>;
  changeButtonSpanish?: Maybe<Scalars['String']['output']>;
  changeProgrammeTypeEnglish?: Maybe<Scalars['String']['output']>;
  changeProgrammeTypeFrench?: Maybe<Scalars['String']['output']>;
  changeProgrammeTypeGerman?: Maybe<Scalars['String']['output']>;
  changeProgrammeTypeMandarin?: Maybe<Scalars['String']['output']>;
  changeProgrammeTypeSpanish?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  informationEnglish?: Maybe<Scalars['String']['output']>;
  informationFrench?: Maybe<Scalars['String']['output']>;
  informationGerman?: Maybe<Scalars['String']['output']>;
  informationMandarin?: Maybe<Scalars['String']['output']>;
  informationSpanish?: Maybe<Scalars['String']['output']>;
  programmeOverviewEnglish?: Maybe<Scalars['String']['output']>;
  programmeOverviewFrench?: Maybe<Scalars['String']['output']>;
  programmeOverviewGerman?: Maybe<Scalars['String']['output']>;
  programmeOverviewMandarin?: Maybe<Scalars['String']['output']>;
  programmeOverviewSpanish?: Maybe<Scalars['String']['output']>;
  programmeTextEnglish?: Maybe<Scalars['String']['output']>;
  programmeTextFrench?: Maybe<Scalars['String']['output']>;
  programmeTextGerman?: Maybe<Scalars['String']['output']>;
  programmeTextMandarin?: Maybe<Scalars['String']['output']>;
  programmeTextSpanish?: Maybe<Scalars['String']['output']>;
  selectButtonEnglish?: Maybe<Scalars['String']['output']>;
  selectButtonFrench?: Maybe<Scalars['String']['output']>;
  selectButtonGerman?: Maybe<Scalars['String']['output']>;
  selectButtonMandarin?: Maybe<Scalars['String']['output']>;
  selectButtonSpanish?: Maybe<Scalars['String']['output']>;
  selectProgrammesSubTitleEnglish?: Maybe<Scalars['String']['output']>;
  selectProgrammesSubTitleFrench?: Maybe<Scalars['String']['output']>;
  selectProgrammesSubTitleGerman?: Maybe<Scalars['String']['output']>;
  selectProgrammesSubTitleMandarin?: Maybe<Scalars['String']['output']>;
  selectProgrammesSubTitleSpanish?: Maybe<Scalars['String']['output']>;
  selectProgrammesTitleEnglish?: Maybe<Scalars['String']['output']>;
  selectProgrammesTitleFrench?: Maybe<Scalars['String']['output']>;
  selectProgrammesTitleGerman?: Maybe<Scalars['String']['output']>;
  selectProgrammesTitleMandarin?: Maybe<Scalars['String']['output']>;
  selectProgrammesTitleSpanish?: Maybe<Scalars['String']['output']>;
};

export type ComponentTranslationsProgrammeScreenInput = {
  changeButtonEnglish?: InputMaybe<Scalars['String']['input']>;
  changeButtonFrench?: InputMaybe<Scalars['String']['input']>;
  changeButtonGerman?: InputMaybe<Scalars['String']['input']>;
  changeButtonMandarin?: InputMaybe<Scalars['String']['input']>;
  changeButtonSpanish?: InputMaybe<Scalars['String']['input']>;
  changeProgrammeTypeEnglish?: InputMaybe<Scalars['String']['input']>;
  changeProgrammeTypeFrench?: InputMaybe<Scalars['String']['input']>;
  changeProgrammeTypeGerman?: InputMaybe<Scalars['String']['input']>;
  changeProgrammeTypeMandarin?: InputMaybe<Scalars['String']['input']>;
  changeProgrammeTypeSpanish?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  informationEnglish?: InputMaybe<Scalars['String']['input']>;
  informationFrench?: InputMaybe<Scalars['String']['input']>;
  informationGerman?: InputMaybe<Scalars['String']['input']>;
  informationMandarin?: InputMaybe<Scalars['String']['input']>;
  informationSpanish?: InputMaybe<Scalars['String']['input']>;
  programmeOverviewEnglish?: InputMaybe<Scalars['String']['input']>;
  programmeOverviewFrench?: InputMaybe<Scalars['String']['input']>;
  programmeOverviewGerman?: InputMaybe<Scalars['String']['input']>;
  programmeOverviewMandarin?: InputMaybe<Scalars['String']['input']>;
  programmeOverviewSpanish?: InputMaybe<Scalars['String']['input']>;
  programmeTextEnglish?: InputMaybe<Scalars['String']['input']>;
  programmeTextFrench?: InputMaybe<Scalars['String']['input']>;
  programmeTextGerman?: InputMaybe<Scalars['String']['input']>;
  programmeTextMandarin?: InputMaybe<Scalars['String']['input']>;
  programmeTextSpanish?: InputMaybe<Scalars['String']['input']>;
  selectButtonEnglish?: InputMaybe<Scalars['String']['input']>;
  selectButtonFrench?: InputMaybe<Scalars['String']['input']>;
  selectButtonGerman?: InputMaybe<Scalars['String']['input']>;
  selectButtonMandarin?: InputMaybe<Scalars['String']['input']>;
  selectButtonSpanish?: InputMaybe<Scalars['String']['input']>;
  selectProgrammesSubTitleEnglish?: InputMaybe<Scalars['String']['input']>;
  selectProgrammesSubTitleFrench?: InputMaybe<Scalars['String']['input']>;
  selectProgrammesSubTitleGerman?: InputMaybe<Scalars['String']['input']>;
  selectProgrammesSubTitleMandarin?: InputMaybe<Scalars['String']['input']>;
  selectProgrammesSubTitleSpanish?: InputMaybe<Scalars['String']['input']>;
  selectProgrammesTitleEnglish?: InputMaybe<Scalars['String']['input']>;
  selectProgrammesTitleFrench?: InputMaybe<Scalars['String']['input']>;
  selectProgrammesTitleGerman?: InputMaybe<Scalars['String']['input']>;
  selectProgrammesTitleMandarin?: InputMaybe<Scalars['String']['input']>;
  selectProgrammesTitleSpanish?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentTranslationsSettingsScreen = {
  __typename?: 'ComponentTranslationsSettingsScreen';
  id: Scalars['ID']['output'];
  saveButtonEnglish?: Maybe<Scalars['String']['output']>;
  saveButtonFrench?: Maybe<Scalars['String']['output']>;
  saveButtonGerman?: Maybe<Scalars['String']['output']>;
  saveButtonMandarin?: Maybe<Scalars['String']['output']>;
  saveButtonSpanish?: Maybe<Scalars['String']['output']>;
  titleEnglish?: Maybe<Scalars['String']['output']>;
  titleFrench?: Maybe<Scalars['String']['output']>;
  titleGerman?: Maybe<Scalars['String']['output']>;
  titleMandarin?: Maybe<Scalars['String']['output']>;
  titleSpanish?: Maybe<Scalars['String']['output']>;
};

export type ComponentTranslationsSettingsScreenInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  saveButtonEnglish?: InputMaybe<Scalars['String']['input']>;
  saveButtonFrench?: InputMaybe<Scalars['String']['input']>;
  saveButtonGerman?: InputMaybe<Scalars['String']['input']>;
  saveButtonMandarin?: InputMaybe<Scalars['String']['input']>;
  saveButtonSpanish?: InputMaybe<Scalars['String']['input']>;
  titleEnglish?: InputMaybe<Scalars['String']['input']>;
  titleFrench?: InputMaybe<Scalars['String']['input']>;
  titleGerman?: InputMaybe<Scalars['String']['input']>;
  titleMandarin?: InputMaybe<Scalars['String']['input']>;
  titleSpanish?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentTranslationsTermsOfService = {
  __typename?: 'ComponentTranslationsTermsOfService';
  id: Scalars['ID']['output'];
  textEnglish?: Maybe<Scalars['String']['output']>;
  textFrench?: Maybe<Scalars['String']['output']>;
  textGerman?: Maybe<Scalars['String']['output']>;
  textMandarin?: Maybe<Scalars['String']['output']>;
  textSpanish?: Maybe<Scalars['String']['output']>;
  titleEnglish?: Maybe<Scalars['String']['output']>;
  titleFrench?: Maybe<Scalars['String']['output']>;
  titleGerman?: Maybe<Scalars['String']['output']>;
  titleMandarin?: Maybe<Scalars['String']['output']>;
  titleSpanish?: Maybe<Scalars['String']['output']>;
};

export type ComponentTranslationsTermsOfServiceInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  textEnglish?: InputMaybe<Scalars['String']['input']>;
  textFrench?: InputMaybe<Scalars['String']['input']>;
  textGerman?: InputMaybe<Scalars['String']['input']>;
  textMandarin?: InputMaybe<Scalars['String']['input']>;
  textSpanish?: InputMaybe<Scalars['String']['input']>;
  titleEnglish?: InputMaybe<Scalars['String']['input']>;
  titleFrench?: InputMaybe<Scalars['String']['input']>;
  titleGerman?: InputMaybe<Scalars['String']['input']>;
  titleMandarin?: InputMaybe<Scalars['String']['input']>;
  titleSpanish?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentTranslationsWelcomeScreen = {
  __typename?: 'ComponentTranslationsWelcomeScreen';
  bodyEnglish?: Maybe<Scalars['String']['output']>;
  bodyFrench?: Maybe<Scalars['String']['output']>;
  bodyGerman?: Maybe<Scalars['String']['output']>;
  bodyMandarin?: Maybe<Scalars['String']['output']>;
  bodySpanish?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  nextButtonEnglish?: Maybe<Scalars['String']['output']>;
  nextButtonFrench?: Maybe<Scalars['String']['output']>;
  nextButtonGerman?: Maybe<Scalars['String']['output']>;
  nextButtonMandarin?: Maybe<Scalars['String']['output']>;
  nextButtonSpanish?: Maybe<Scalars['String']['output']>;
  titleEnglish?: Maybe<Scalars['String']['output']>;
  titleFrench?: Maybe<Scalars['String']['output']>;
  titleGerman?: Maybe<Scalars['String']['output']>;
  titleMandarin?: Maybe<Scalars['String']['output']>;
  titleSpanish?: Maybe<Scalars['String']['output']>;
  videoEnglish?: Maybe<UploadFile>;
  videoFrench?: Maybe<UploadFile>;
  videoGerman?: Maybe<UploadFile>;
  videoMandarin?: Maybe<UploadFile>;
  videoSpanish?: Maybe<UploadFile>;
};

export type ComponentTranslationsWelcomeScreenFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentTranslationsWelcomeScreenFiltersInput>>>;
  bodyEnglish?: InputMaybe<StringFilterInput>;
  bodyFrench?: InputMaybe<StringFilterInput>;
  bodyGerman?: InputMaybe<StringFilterInput>;
  bodyMandarin?: InputMaybe<StringFilterInput>;
  bodySpanish?: InputMaybe<StringFilterInput>;
  nextButtonEnglish?: InputMaybe<StringFilterInput>;
  nextButtonFrench?: InputMaybe<StringFilterInput>;
  nextButtonGerman?: InputMaybe<StringFilterInput>;
  nextButtonMandarin?: InputMaybe<StringFilterInput>;
  nextButtonSpanish?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentTranslationsWelcomeScreenFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentTranslationsWelcomeScreenFiltersInput>>>;
  titleEnglish?: InputMaybe<StringFilterInput>;
  titleFrench?: InputMaybe<StringFilterInput>;
  titleGerman?: InputMaybe<StringFilterInput>;
  titleMandarin?: InputMaybe<StringFilterInput>;
  titleSpanish?: InputMaybe<StringFilterInput>;
};

export type ComponentTranslationsWelcomeScreenInput = {
  bodyEnglish?: InputMaybe<Scalars['String']['input']>;
  bodyFrench?: InputMaybe<Scalars['String']['input']>;
  bodyGerman?: InputMaybe<Scalars['String']['input']>;
  bodyMandarin?: InputMaybe<Scalars['String']['input']>;
  bodySpanish?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  nextButtonEnglish?: InputMaybe<Scalars['String']['input']>;
  nextButtonFrench?: InputMaybe<Scalars['String']['input']>;
  nextButtonGerman?: InputMaybe<Scalars['String']['input']>;
  nextButtonMandarin?: InputMaybe<Scalars['String']['input']>;
  nextButtonSpanish?: InputMaybe<Scalars['String']['input']>;
  titleEnglish?: InputMaybe<Scalars['String']['input']>;
  titleFrench?: InputMaybe<Scalars['String']['input']>;
  titleGerman?: InputMaybe<Scalars['String']['input']>;
  titleMandarin?: InputMaybe<Scalars['String']['input']>;
  titleSpanish?: InputMaybe<Scalars['String']['input']>;
  videoEnglish?: InputMaybe<Scalars['ID']['input']>;
  videoFrench?: InputMaybe<Scalars['ID']['input']>;
  videoGerman?: InputMaybe<Scalars['ID']['input']>;
  videoMandarin?: InputMaybe<Scalars['ID']['input']>;
  videoSpanish?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentTranslationsWhatToExpect = {
  __typename?: 'ComponentTranslationsWhatToExpect';
  bodyEnglish?: Maybe<Scalars['String']['output']>;
  bodyFrench?: Maybe<Scalars['String']['output']>;
  bodyGerman?: Maybe<Scalars['String']['output']>;
  bodyMandarin?: Maybe<Scalars['String']['output']>;
  bodySpanish?: Maybe<Scalars['String']['output']>;
  getStartedButtonEnglish?: Maybe<Scalars['String']['output']>;
  getStartedButtonFrench?: Maybe<Scalars['String']['output']>;
  getStartedButtonGerman?: Maybe<Scalars['String']['output']>;
  getStartedButtonMandarin?: Maybe<Scalars['String']['output']>;
  getStartedButtonSpanish?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<UploadFile>;
  titleEnglish?: Maybe<Scalars['String']['output']>;
  titleFrench?: Maybe<Scalars['String']['output']>;
  titleGerman?: Maybe<Scalars['String']['output']>;
  titleMandarin?: Maybe<Scalars['String']['output']>;
  titleSpanish?: Maybe<Scalars['String']['output']>;
};

export type ComponentTranslationsWhatToExpectFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentTranslationsWhatToExpectFiltersInput>>>;
  bodyEnglish?: InputMaybe<StringFilterInput>;
  bodyFrench?: InputMaybe<StringFilterInput>;
  bodyGerman?: InputMaybe<StringFilterInput>;
  bodyMandarin?: InputMaybe<StringFilterInput>;
  bodySpanish?: InputMaybe<StringFilterInput>;
  getStartedButtonEnglish?: InputMaybe<StringFilterInput>;
  getStartedButtonFrench?: InputMaybe<StringFilterInput>;
  getStartedButtonGerman?: InputMaybe<StringFilterInput>;
  getStartedButtonMandarin?: InputMaybe<StringFilterInput>;
  getStartedButtonSpanish?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentTranslationsWhatToExpectFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentTranslationsWhatToExpectFiltersInput>>>;
  titleEnglish?: InputMaybe<StringFilterInput>;
  titleFrench?: InputMaybe<StringFilterInput>;
  titleGerman?: InputMaybe<StringFilterInput>;
  titleMandarin?: InputMaybe<StringFilterInput>;
  titleSpanish?: InputMaybe<StringFilterInput>;
};

export type ComponentTranslationsWhatToExpectInput = {
  bodyEnglish?: InputMaybe<Scalars['String']['input']>;
  bodyFrench?: InputMaybe<Scalars['String']['input']>;
  bodyGerman?: InputMaybe<Scalars['String']['input']>;
  bodyMandarin?: InputMaybe<Scalars['String']['input']>;
  bodySpanish?: InputMaybe<Scalars['String']['input']>;
  getStartedButtonEnglish?: InputMaybe<Scalars['String']['input']>;
  getStartedButtonFrench?: InputMaybe<Scalars['String']['input']>;
  getStartedButtonGerman?: InputMaybe<Scalars['String']['input']>;
  getStartedButtonMandarin?: InputMaybe<Scalars['String']['input']>;
  getStartedButtonSpanish?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  titleEnglish?: InputMaybe<Scalars['String']['input']>;
  titleFrench?: InputMaybe<Scalars['String']['input']>;
  titleGerman?: InputMaybe<Scalars['String']['input']>;
  titleMandarin?: InputMaybe<Scalars['String']['input']>;
  titleSpanish?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentXyGraphItemXyGraphItem = {
  __typename?: 'ComponentXYGraphItemXYGraphItem';
  color?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<UploadFile>;
  valueX?: Maybe<Scalars['Int']['output']>;
  valueY?: Maybe<Scalars['Int']['output']>;
};

export type ComponentXyGraphItemXyGraphItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentXyGraphItemXyGraphItemFiltersInput>>>;
  color?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentXyGraphItemXyGraphItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentXyGraphItemXyGraphItemFiltersInput>>>;
  valueX?: InputMaybe<IntFilterInput>;
  valueY?: InputMaybe<IntFilterInput>;
};

export type ComponentXyGraphItemXyGraphItemInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  valueX?: InputMaybe<Scalars['Int']['input']>;
  valueY?: InputMaybe<Scalars['Int']['input']>;
};

export type ConfirmAppointmentResponse = {
  __typename?: 'ConfirmAppointmentResponse';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DateFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  contains?: InputMaybe<Scalars['Date']['input']>;
  containsi?: InputMaybe<Scalars['Date']['input']>;
  endsWith?: InputMaybe<Scalars['Date']['input']>;
  eq?: InputMaybe<Scalars['Date']['input']>;
  eqi?: InputMaybe<Scalars['Date']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nei?: InputMaybe<Scalars['Date']['input']>;
  not?: InputMaybe<DateFilterInput>;
  notContains?: InputMaybe<Scalars['Date']['input']>;
  notContainsi?: InputMaybe<Scalars['Date']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  startsWith?: InputMaybe<Scalars['Date']['input']>;
};

export type DateTimeFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  contains?: InputMaybe<Scalars['DateTime']['input']>;
  containsi?: InputMaybe<Scalars['DateTime']['input']>;
  endsWith?: InputMaybe<Scalars['DateTime']['input']>;
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  eqi?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  ne?: InputMaybe<Scalars['DateTime']['input']>;
  nei?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<DateTimeFilterInput>;
  notContains?: InputMaybe<Scalars['DateTime']['input']>;
  notContainsi?: InputMaybe<Scalars['DateTime']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  startsWith?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DeleteMutationResponse = {
  __typename?: 'DeleteMutationResponse';
  documentId: Scalars['ID']['output'];
};

export type Division = {
  __typename?: 'Division';
  companies: Array<Maybe<Company>>;
  companies_connection?: Maybe<CompanyRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  title_english?: Maybe<Scalars['String']['output']>;
  title_french?: Maybe<Scalars['String']['output']>;
  title_german?: Maybe<Scalars['String']['output']>;
  title_mandarin?: Maybe<Scalars['String']['output']>;
  title_spanish?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  users: Array<Maybe<UsersPermissionsUser>>;
  users_connection?: Maybe<UsersPermissionsUserRelationResponseCollection>;
};


export type DivisionCompaniesArgs = {
  filters?: InputMaybe<CompanyFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type DivisionCompanies_ConnectionArgs = {
  filters?: InputMaybe<CompanyFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type DivisionUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type DivisionUsers_ConnectionArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DivisionEntityResponseCollection = {
  __typename?: 'DivisionEntityResponseCollection';
  nodes: Array<Division>;
  pageInfo: Pagination;
};

export type DivisionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<DivisionFiltersInput>>>;
  companies?: InputMaybe<CompanyFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<DivisionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<DivisionFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  title_english?: InputMaybe<StringFilterInput>;
  title_french?: InputMaybe<StringFilterInput>;
  title_german?: InputMaybe<StringFilterInput>;
  title_mandarin?: InputMaybe<StringFilterInput>;
  title_spanish?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  users?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type DivisionInput = {
  companies?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  title_english?: InputMaybe<Scalars['String']['input']>;
  title_french?: InputMaybe<Scalars['String']['input']>;
  title_german?: InputMaybe<Scalars['String']['input']>;
  title_mandarin?: InputMaybe<Scalars['String']['input']>;
  title_spanish?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type DivisionRelationResponseCollection = {
  __typename?: 'DivisionRelationResponseCollection';
  nodes: Array<Division>;
};

export type EBooking = {
  __typename?: 'EBooking';
  endTime?: Maybe<Scalars['String']['output']>;
  eventTypeId?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  uid?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export enum Enum_Componentsubmissionsanswer_Outcome {
  ResubmissionNeeded = 'Resubmission_Needed'
}

export enum Enum_Language_Name {
  English = 'English',
  French = 'French',
  German = 'German',
  Mandarin = 'Mandarin',
  Spanish = 'Spanish'
}

export enum Enum_Participant_Type {
  Competency = 'Competency',
  Feedforward = 'Feedforward'
}

export enum Enum_Programmesubmission_Status {
  Completed = 'completed',
  InProgress = 'in_progress',
  NotStartedYet = 'not_started_yet',
  Resubmission = 'resubmission',
  UnderReview = 'under_review'
}

export enum Enum_Report_Type {
  AllModules = 'All_Modules',
  MiniSection = 'Mini_Section',
  Module = 'Module',
  Section = 'Section'
}

export enum Enum_Submission_Status {
  NotStarted = 'Not_Started',
  Passed = 'Passed',
  Resubmission = 'Resubmission',
  UnderReview = 'Under_Review',
  InProgress = 'in_progress'
}

export enum Enum_Submodulesubmission_Status {
  NotStarted = 'Not_Started',
  Passed = 'Passed',
  Resubmission = 'Resubmission',
  UnderReview = 'Under_Review',
  InProgress = 'in_progress'
}

export enum Enum_Uploadedreport_Type {
  Section = 'Section',
  UserUpload = 'UserUpload'
}

export type EmailLog = {
  __typename?: 'EmailLog';
  body?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  programme?: Maybe<Programme>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['DateTime']['output']>;
  to?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EmailLogEntityResponseCollection = {
  __typename?: 'EmailLogEntityResponseCollection';
  nodes: Array<EmailLog>;
  pageInfo: Pagination;
};

export type EmailLogFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<EmailLogFiltersInput>>>;
  body?: InputMaybe<StringFilterInput>;
  company?: InputMaybe<CompanyFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<EmailLogFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<EmailLogFiltersInput>>>;
  programme?: InputMaybe<ProgrammeFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  subject?: InputMaybe<StringFilterInput>;
  timestamp?: InputMaybe<DateTimeFilterInput>;
  to?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type EmailLogInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['ID']['input']>;
  programme?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type EmailLogRelationResponseCollection = {
  __typename?: 'EmailLogRelationResponseCollection';
  nodes: Array<EmailLog>;
};

export type EmailSent = {
  __typename?: 'EmailSent';
  success?: Maybe<Scalars['String']['output']>;
};

export type EmailSentProgramme = {
  __typename?: 'EmailSentProgramme';
  successed?: Maybe<Scalars['String']['output']>;
};

export type EmailTemplate = {
  __typename?: 'EmailTemplate';
  body?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  programme?: Maybe<Programme>;
  programme_types: Array<Maybe<ProgrammeType>>;
  programme_types_connection?: Maybe<ProgrammeTypeRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  sections: Array<Maybe<Section>>;
  sections_connection?: Maybe<SectionRelationResponseCollection>;
  subject?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type EmailTemplateProgramme_TypesArgs = {
  filters?: InputMaybe<ProgrammeTypeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type EmailTemplateProgramme_Types_ConnectionArgs = {
  filters?: InputMaybe<ProgrammeTypeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type EmailTemplateSectionsArgs = {
  filters?: InputMaybe<SectionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type EmailTemplateSections_ConnectionArgs = {
  filters?: InputMaybe<SectionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type EmailTemplateEntityResponseCollection = {
  __typename?: 'EmailTemplateEntityResponseCollection';
  nodes: Array<EmailTemplate>;
  pageInfo: Pagination;
};

export type EmailTemplateFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<EmailTemplateFiltersInput>>>;
  body?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<EmailTemplateFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<EmailTemplateFiltersInput>>>;
  programme?: InputMaybe<ProgrammeFiltersInput>;
  programme_types?: InputMaybe<ProgrammeTypeFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  sections?: InputMaybe<SectionFiltersInput>;
  subject?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type EmailTemplateInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  programme?: InputMaybe<Scalars['ID']['input']>;
  programme_types?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  sections?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type EmailTemplateRelationResponseCollection = {
  __typename?: 'EmailTemplateRelationResponseCollection';
  nodes: Array<EmailTemplate>;
};

export type Emails = {
  __typename?: 'Emails';
  emails?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type EmailsSent = {
  __typename?: 'EmailsSent';
  emails?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type Error = {
  __typename?: 'Error';
  code: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type Event = {
  __typename?: 'Event';
  class_id?: Maybe<Scalars['Long']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['ID']['output'];
  link?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  programme_types: Array<Maybe<ProgrammeType>>;
  programme_types_connection?: Maybe<ProgrammeTypeRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  sections: Array<Maybe<Section>>;
  sections_connection?: Maybe<SectionRelationResponseCollection>;
  service_id?: Maybe<Scalars['Long']['output']>;
  session_id?: Maybe<Scalars['Long']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type EventProgramme_TypesArgs = {
  filters?: InputMaybe<ProgrammeTypeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type EventProgramme_Types_ConnectionArgs = {
  filters?: InputMaybe<ProgrammeTypeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type EventSectionsArgs = {
  filters?: InputMaybe<SectionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type EventSections_ConnectionArgs = {
  filters?: InputMaybe<SectionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type EventEntityResponseCollection = {
  __typename?: 'EventEntityResponseCollection';
  nodes: Array<Event>;
  pageInfo: Pagination;
};

export type EventFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<EventFiltersInput>>>;
  class_id?: InputMaybe<LongFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  link?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<EventFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<EventFiltersInput>>>;
  programme_types?: InputMaybe<ProgrammeTypeFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  sections?: InputMaybe<SectionFiltersInput>;
  service_id?: InputMaybe<LongFilterInput>;
  session_id?: InputMaybe<LongFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type EventInput = {
  class_id?: InputMaybe<Scalars['Long']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  programme_types?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  sections?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  service_id?: InputMaybe<Scalars['Long']['input']>;
  session_id?: InputMaybe<Scalars['Long']['input']>;
};

export type EventLocation = {
  __typename?: 'EventLocation';
  type?: Maybe<Scalars['String']['output']>;
};

export type EventRelationResponseCollection = {
  __typename?: 'EventRelationResponseCollection';
  nodes: Array<Event>;
};

export type EventType = {
  __typename?: 'EventType';
  afterEventBuffer?: Maybe<Scalars['Int']['output']>;
  beforeEventBuffer?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disableGuests?: Maybe<Scalars['Boolean']['output']>;
  eventName?: Maybe<Scalars['String']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  hideCalendarNotes?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  length?: Maybe<Scalars['Int']['output']>;
  locations?: Maybe<Array<Maybe<EventLocation>>>;
  minimumBookingNotice?: Maybe<Scalars['Int']['output']>;
  periodCountCalendarDays?: Maybe<Scalars['Boolean']['output']>;
  periodDays?: Maybe<Scalars['Int']['output']>;
  periodEndDate?: Maybe<Scalars['String']['output']>;
  periodStartDate?: Maybe<Scalars['String']['output']>;
  periodType?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  recurringEvent?: Maybe<Scalars['Boolean']['output']>;
  requiresConfirmation?: Maybe<Scalars['Boolean']['output']>;
  scheduleId?: Maybe<Scalars['ID']['output']>;
  schedulingType?: Maybe<Scalars['String']['output']>;
  seatsPerTimeSlot?: Maybe<Scalars['Int']['output']>;
  slotInterval?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  successRedirectUrl?: Maybe<Scalars['String']['output']>;
  teamId?: Maybe<Scalars['ID']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type FeedfowardUrl = {
  __typename?: 'FeedfowardUrl';
  coach_email?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  programme_submission?: Maybe<ProgrammeSubmission>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  sub_module_submission?: Maybe<SubModuleSubmission>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type FeedfowardUrlEntityResponseCollection = {
  __typename?: 'FeedfowardUrlEntityResponseCollection';
  nodes: Array<FeedfowardUrl>;
  pageInfo: Pagination;
};

export type FeedfowardUrlFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<FeedfowardUrlFiltersInput>>>;
  coach_email?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<FeedfowardUrlFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<FeedfowardUrlFiltersInput>>>;
  programme_submission?: InputMaybe<ProgrammeSubmissionFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  sub_module_submission?: InputMaybe<SubModuleSubmissionFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
};

export type FeedfowardUrlInput = {
  coach_email?: InputMaybe<Scalars['String']['input']>;
  programme_submission?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  sub_module_submission?: InputMaybe<Scalars['ID']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type FileInfoInput = {
  alternativeText?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FloatFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  contains?: InputMaybe<Scalars['Float']['input']>;
  containsi?: InputMaybe<Scalars['Float']['input']>;
  endsWith?: InputMaybe<Scalars['Float']['input']>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  eqi?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nei?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<FloatFilterInput>;
  notContains?: InputMaybe<Scalars['Float']['input']>;
  notContainsi?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  startsWith?: InputMaybe<Scalars['Float']['input']>;
};

export type ForwardedCard = {
  __typename?: 'ForwardedCard';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dear: Scalars['String']['output'];
  documentId: Scalars['ID']['output'];
  from: Scalars['String']['output'];
  general_text?: Maybe<Scalars['String']['output']>;
  p1: Scalars['String']['output'];
  p1_sentence: Scalars['String']['output'];
  p2: Scalars['String']['output'];
  p2_sentence: Scalars['String']['output'];
  p3: Scalars['String']['output'];
  p3_sentence: Scalars['String']['output'];
  post_card?: Maybe<PostCard>;
  promotion_link?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  signature: Scalars['String']['output'];
  to: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ForwardedCardEntityResponseCollection = {
  __typename?: 'ForwardedCardEntityResponseCollection';
  nodes: Array<ForwardedCard>;
  pageInfo: Pagination;
};

export type ForwardedCardFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ForwardedCardFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  dear?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  from?: InputMaybe<StringFilterInput>;
  general_text?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ForwardedCardFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ForwardedCardFiltersInput>>>;
  p1?: InputMaybe<StringFilterInput>;
  p1_sentence?: InputMaybe<StringFilterInput>;
  p2?: InputMaybe<StringFilterInput>;
  p2_sentence?: InputMaybe<StringFilterInput>;
  p3?: InputMaybe<StringFilterInput>;
  p3_sentence?: InputMaybe<StringFilterInput>;
  post_card?: InputMaybe<PostCardFiltersInput>;
  promotion_link?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  signature?: InputMaybe<StringFilterInput>;
  to?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ForwardedCardInput = {
  dear?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  general_text?: InputMaybe<Scalars['String']['input']>;
  p1?: InputMaybe<Scalars['String']['input']>;
  p1_sentence?: InputMaybe<Scalars['String']['input']>;
  p2?: InputMaybe<Scalars['String']['input']>;
  p2_sentence?: InputMaybe<Scalars['String']['input']>;
  p3?: InputMaybe<Scalars['String']['input']>;
  p3_sentence?: InputMaybe<Scalars['String']['input']>;
  post_card?: InputMaybe<Scalars['ID']['input']>;
  promotion_link?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  signature?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type ForwardedCardRelationResponseCollection = {
  __typename?: 'ForwardedCardRelationResponseCollection';
  nodes: Array<ForwardedCard>;
};

export type GenericMorph = AccountChange | Appointment | Article | AuditTrail | Booking | Coach | CoachSession | CoachSubmittedReport | Company | CompetencyUrl | ComponentGravitasScaleItemsGravitasScaleItems | ComponentOptionColorAndRating | ComponentOptionOption | ComponentOptionSliderHeadings | ComponentOptionSliderQuestions | ComponentOptionTimezone | ComponentQuestionTypesCompetency | ComponentQuestionTypesCompetency2 | ComponentQuestionTypesDocuments | ComponentQuestionTypesFeedForward1 | ComponentQuestionTypesFeedForward2 | ComponentQuestionTypesGravitasGap | ComponentQuestionTypesGravitasScale | ComponentQuestionTypesGravitasSliders | ComponentQuestionTypesMultipleChoice | ComponentQuestionTypesNestedQuestions | ComponentQuestionTypesParticipant | ComponentQuestionTypesQuestionscompetency2 | ComponentQuestionTypesSaboteur | ComponentQuestionTypesSaboteurQuestions | ComponentQuestionTypesSaboteurVideos | ComponentQuestionTypesSimpleQuestion | ComponentQuestionTypesSimpleReadOnly | ComponentQuestionTypesSliderQuestions | ComponentQuestionTypesStakeholderMap | ComponentQuestionTypesUploadDocuments | ComponentQuestionTypesUploadQuestion | ComponentQuestionTypesValuesBubble | ComponentQuestionTypesValuesCharacters | ComponentQuestionTypesValuesGaps | ComponentQuestionTypesValuesNested | ComponentQuestionTypesValuesSliders | ComponentQuestionTypesXyGraph | ComponentRatingInputRatingInput | ComponentSaboteurVideoSaboteurVideo | ComponentStakeholderMapItemStackholderMapItem | ComponentSubmissionsAnswer | ComponentSubmissionsCharacteristics | ComponentSubmissionsCompetencyAnswer | ComponentSubmissionsCompetencyParticipants | ComponentSubmissionsGravitasGap | ComponentSubmissionsGravitasSlidersAnswers | ComponentSubmissionsNotes | ComponentSubmissionsParticipants | ComponentSubmissionsProgrammeSubmissions | ComponentSubmissionsRepeatAnswer | ComponentSubmissionsSaboteurComponent | ComponentSubmissionsSabtourVideosComponent | ComponentSubmissionsSectionSubmission | ComponentSubmissionsSkipProofComponent | ComponentSubmissionsSubModuleSubmission | ComponentSubmissionsUploadDocuments | ComponentSubmissionsValuesGaps | ComponentTranslationsAboutUs | ComponentTranslationsButtons | ComponentTranslationsDashboardScreen | ComponentTranslationsFaqs | ComponentTranslationsFaqsFrench | ComponentTranslationsFaqsGerman | ComponentTranslationsFaqsMandarin | ComponentTranslationsFaqsQuestionAnswer | ComponentTranslationsFaqsSpanish | ComponentTranslationsHelpAndSupport | ComponentTranslationsHomeScreen | ComponentTranslationsLanguageSelection | ComponentTranslationsLetsGetStartedScreen | ComponentTranslationsMenu | ComponentTranslationsMyLibraryScreen | ComponentTranslationsMyProfileScreen | ComponentTranslationsMyWorkScreen | ComponentTranslationsPersonalScreen | ComponentTranslationsPrivacyPolicy | ComponentTranslationsProgrammeScreen | ComponentTranslationsSettingsScreen | ComponentTranslationsTermsOfService | ComponentTranslationsWelcomeScreen | ComponentTranslationsWhatToExpect | ComponentXyGraphItemXyGraphItem | Division | EmailLog | EmailTemplate | Event | FeedfowardUrl | ForwardedCard | I18NLocale | Invite | Language | Logo | Modal | Module | Note | Notification | Participant | PostCard | PostCardImage | PostCardSentence | Programme | ProgrammeReport | ProgrammeSubmission | ProgrammeType | Region | Report | RespondentsAnswer | ReviewWorkflowsWorkflow | ReviewWorkflowsWorkflowStage | Section | SubModule | SubModuleSubmission | Submission | SubmoduleReport | SurveyReport | Translation | TypeFormCollection | UploadFile | UploadedReport | UserUploadedDocument | UsersPermissionsPermission | UsersPermissionsRole | UsersPermissionsUser;

export type I18NLocale = {
  __typename?: 'I18NLocale';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type I18NLocaleEntityResponseCollection = {
  __typename?: 'I18NLocaleEntityResponseCollection';
  nodes: Array<I18NLocale>;
  pageInfo: Pagination;
};

export type I18NLocaleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  code?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<I18NLocaleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type IdFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contains?: InputMaybe<Scalars['ID']['input']>;
  containsi?: InputMaybe<Scalars['ID']['input']>;
  endsWith?: InputMaybe<Scalars['ID']['input']>;
  eq?: InputMaybe<Scalars['ID']['input']>;
  eqi?: InputMaybe<Scalars['ID']['input']>;
  gt?: InputMaybe<Scalars['ID']['input']>;
  gte?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  lt?: InputMaybe<Scalars['ID']['input']>;
  lte?: InputMaybe<Scalars['ID']['input']>;
  ne?: InputMaybe<Scalars['ID']['input']>;
  nei?: InputMaybe<Scalars['ID']['input']>;
  not?: InputMaybe<IdFilterInput>;
  notContains?: InputMaybe<Scalars['ID']['input']>;
  notContainsi?: InputMaybe<Scalars['ID']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  startsWith?: InputMaybe<Scalars['ID']['input']>;
};

export type IntFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  contains?: InputMaybe<Scalars['Int']['input']>;
  containsi?: InputMaybe<Scalars['Int']['input']>;
  endsWith?: InputMaybe<Scalars['Int']['input']>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  eqi?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  nei?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<IntFilterInput>;
  notContains?: InputMaybe<Scalars['Int']['input']>;
  notContainsi?: InputMaybe<Scalars['Int']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  startsWith?: InputMaybe<Scalars['Int']['input']>;
};

export type Invite = {
  __typename?: 'Invite';
  company?: Maybe<Company>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  email?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type InviteEntityResponseCollection = {
  __typename?: 'InviteEntityResponseCollection';
  nodes: Array<Invite>;
  pageInfo: Pagination;
};

export type InviteFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<InviteFiltersInput>>>;
  company?: InputMaybe<CompanyFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<InviteFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<InviteFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type InviteInput = {
  company?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type JsonFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  contains?: InputMaybe<Scalars['JSON']['input']>;
  containsi?: InputMaybe<Scalars['JSON']['input']>;
  endsWith?: InputMaybe<Scalars['JSON']['input']>;
  eq?: InputMaybe<Scalars['JSON']['input']>;
  eqi?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  ne?: InputMaybe<Scalars['JSON']['input']>;
  nei?: InputMaybe<Scalars['JSON']['input']>;
  not?: InputMaybe<JsonFilterInput>;
  notContains?: InputMaybe<Scalars['JSON']['input']>;
  notContainsi?: InputMaybe<Scalars['JSON']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  startsWith?: InputMaybe<Scalars['JSON']['input']>;
};

export type Language = {
  __typename?: 'Language';
  companies: Array<Maybe<Company>>;
  companies_connection?: Maybe<CompanyRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  image?: Maybe<UploadFile>;
  name?: Maybe<Enum_Language_Name>;
  programme_submissions: Array<Maybe<ProgrammeSubmission>>;
  programme_submissions_connection?: Maybe<ProgrammeSubmissionRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  users: Array<Maybe<UsersPermissionsUser>>;
  users_connection?: Maybe<UsersPermissionsUserRelationResponseCollection>;
};


export type LanguageCompaniesArgs = {
  filters?: InputMaybe<CompanyFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type LanguageCompanies_ConnectionArgs = {
  filters?: InputMaybe<CompanyFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type LanguageProgramme_SubmissionsArgs = {
  filters?: InputMaybe<ProgrammeSubmissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type LanguageProgramme_Submissions_ConnectionArgs = {
  filters?: InputMaybe<ProgrammeSubmissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type LanguageUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type LanguageUsers_ConnectionArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LanguageEntityResponseCollection = {
  __typename?: 'LanguageEntityResponseCollection';
  nodes: Array<Language>;
  pageInfo: Pagination;
};

export type LanguageFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<LanguageFiltersInput>>>;
  companies?: InputMaybe<CompanyFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<LanguageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<LanguageFiltersInput>>>;
  programme_submissions?: InputMaybe<ProgrammeSubmissionFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  users?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type LanguageInput = {
  companies?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  image?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Enum_Language_Name>;
  programme_submissions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type LanguageRelationResponseCollection = {
  __typename?: 'LanguageRelationResponseCollection';
  nodes: Array<Language>;
};

export type Logo = {
  __typename?: 'Logo';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  logo?: Maybe<UploadFile>;
  name?: Maybe<Scalars['String']['output']>;
  post_cards: Array<Maybe<PostCard>>;
  post_cards_connection?: Maybe<PostCardRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type LogoPost_CardsArgs = {
  filters?: InputMaybe<PostCardFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type LogoPost_Cards_ConnectionArgs = {
  filters?: InputMaybe<PostCardFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LogoEntityResponseCollection = {
  __typename?: 'LogoEntityResponseCollection';
  nodes: Array<Logo>;
  pageInfo: Pagination;
};

export type LogoFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<LogoFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<LogoFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<LogoFiltersInput>>>;
  post_cards?: InputMaybe<PostCardFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type LogoInput = {
  logo?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  post_cards?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LongFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  contains?: InputMaybe<Scalars['Long']['input']>;
  containsi?: InputMaybe<Scalars['Long']['input']>;
  endsWith?: InputMaybe<Scalars['Long']['input']>;
  eq?: InputMaybe<Scalars['Long']['input']>;
  eqi?: InputMaybe<Scalars['Long']['input']>;
  gt?: InputMaybe<Scalars['Long']['input']>;
  gte?: InputMaybe<Scalars['Long']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  lt?: InputMaybe<Scalars['Long']['input']>;
  lte?: InputMaybe<Scalars['Long']['input']>;
  ne?: InputMaybe<Scalars['Long']['input']>;
  nei?: InputMaybe<Scalars['Long']['input']>;
  not?: InputMaybe<LongFilterInput>;
  notContains?: InputMaybe<Scalars['Long']['input']>;
  notContainsi?: InputMaybe<Scalars['Long']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  startsWith?: InputMaybe<Scalars['Long']['input']>;
};

export type Modal = {
  __typename?: 'Modal';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  image?: Maybe<UploadFile>;
  message?: Maybe<Scalars['String']['output']>;
  programme_types: Array<Maybe<ProgrammeType>>;
  programme_types_connection?: Maybe<ProgrammeTypeRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ModalProgramme_TypesArgs = {
  filters?: InputMaybe<ProgrammeTypeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ModalProgramme_Types_ConnectionArgs = {
  filters?: InputMaybe<ProgrammeTypeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ModalEntityResponseCollection = {
  __typename?: 'ModalEntityResponseCollection';
  nodes: Array<Modal>;
  pageInfo: Pagination;
};

export type ModalFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ModalFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  message?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ModalFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ModalFiltersInput>>>;
  programme_types?: InputMaybe<ProgrammeTypeFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  subtitle?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ModalInput = {
  image?: InputMaybe<Scalars['ID']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  programme_types?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Module = {
  __typename?: 'Module';
  companies: Array<Maybe<Company>>;
  companies_connection?: Maybe<CompanyRelationResponseCollection>;
  cover?: Maybe<UploadFile>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description_english?: Maybe<Scalars['String']['output']>;
  description_french?: Maybe<Scalars['String']['output']>;
  description_german?: Maybe<Scalars['String']['output']>;
  description_mandarin?: Maybe<Scalars['String']['output']>;
  description_spanish?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['ID']['output'];
  name_english?: Maybe<Scalars['String']['output']>;
  name_french?: Maybe<Scalars['String']['output']>;
  name_german?: Maybe<Scalars['String']['output']>;
  name_mandarin?: Maybe<Scalars['String']['output']>;
  name_spanish?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  sections: Array<Maybe<Section>>;
  sections_connection?: Maybe<SectionRelationResponseCollection>;
  submissions: Array<Maybe<Submission>>;
  submissions_connection?: Maybe<SubmissionRelationResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ModuleCompaniesArgs = {
  filters?: InputMaybe<CompanyFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ModuleCompanies_ConnectionArgs = {
  filters?: InputMaybe<CompanyFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ModuleSectionsArgs = {
  filters?: InputMaybe<SectionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ModuleSections_ConnectionArgs = {
  filters?: InputMaybe<SectionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ModuleSubmissionsArgs = {
  filters?: InputMaybe<SubmissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ModuleSubmissions_ConnectionArgs = {
  filters?: InputMaybe<SubmissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ModuleEntityResponseCollection = {
  __typename?: 'ModuleEntityResponseCollection';
  nodes: Array<Module>;
  pageInfo: Pagination;
};

export type ModuleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ModuleFiltersInput>>>;
  companies?: InputMaybe<CompanyFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description_english?: InputMaybe<StringFilterInput>;
  description_french?: InputMaybe<StringFilterInput>;
  description_german?: InputMaybe<StringFilterInput>;
  description_mandarin?: InputMaybe<StringFilterInput>;
  description_spanish?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name_english?: InputMaybe<StringFilterInput>;
  name_french?: InputMaybe<StringFilterInput>;
  name_german?: InputMaybe<StringFilterInput>;
  name_mandarin?: InputMaybe<StringFilterInput>;
  name_spanish?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ModuleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ModuleFiltersInput>>>;
  position?: InputMaybe<IntFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  sections?: InputMaybe<SectionFiltersInput>;
  submissions?: InputMaybe<SubmissionFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ModuleInput = {
  companies?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  cover?: InputMaybe<Scalars['ID']['input']>;
  description_english?: InputMaybe<Scalars['String']['input']>;
  description_french?: InputMaybe<Scalars['String']['input']>;
  description_german?: InputMaybe<Scalars['String']['input']>;
  description_mandarin?: InputMaybe<Scalars['String']['input']>;
  description_spanish?: InputMaybe<Scalars['String']['input']>;
  name_english?: InputMaybe<Scalars['String']['input']>;
  name_french?: InputMaybe<Scalars['String']['input']>;
  name_german?: InputMaybe<Scalars['String']['input']>;
  name_mandarin?: InputMaybe<Scalars['String']['input']>;
  name_spanish?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  sections?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  submissions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type ModuleRelationResponseCollection = {
  __typename?: 'ModuleRelationResponseCollection';
  nodes: Array<Module>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addDocument: UserUploadedDocument;
  addNote: Notes;
  /** Change user password. Confirm with the current password. */
  changePassword?: Maybe<UsersPermissionsLoginPayload>;
  confirmMyAppointments: ConfirmAppointmentResponse;
  createAccountChange?: Maybe<AccountChange>;
  createAppointment?: Maybe<Appointment>;
  createArticle?: Maybe<Article>;
  createAuditTrail?: Maybe<AuditTrail>;
  createBooking?: Maybe<Booking>;
  createCoach?: Maybe<Coach>;
  createCoachSession?: Maybe<CoachSession>;
  createCoachSubmittedReport?: Maybe<CoachSubmittedReport>;
  createCompany?: Maybe<Company>;
  createCompetencyUrl?: Maybe<CompetencyUrl>;
  createDivision?: Maybe<Division>;
  createEmailLog?: Maybe<EmailLog>;
  createEmailTemplate?: Maybe<EmailTemplate>;
  createEvent?: Maybe<Event>;
  createFeedfowardUrl?: Maybe<FeedfowardUrl>;
  createForwardedCard?: Maybe<ForwardedCard>;
  createInvite?: Maybe<Invite>;
  createLanguage?: Maybe<Language>;
  createLogo?: Maybe<Logo>;
  createModal?: Maybe<Modal>;
  createModule?: Maybe<Module>;
  createNote?: Maybe<Note>;
  createNotification?: Maybe<Notification>;
  createParticipant?: Maybe<Participant>;
  createPostCard?: Maybe<PostCard>;
  createPostCardImage?: Maybe<PostCardImage>;
  createPostCardSentence?: Maybe<PostCardSentence>;
  createProgramme?: Maybe<Programme>;
  createProgrammeReport?: Maybe<ProgrammeReport>;
  createProgrammeSubmission?: Maybe<ProgrammeSubmission>;
  createProgrammeType?: Maybe<ProgrammeType>;
  createRegion?: Maybe<Region>;
  createReport?: Maybe<Report>;
  createRespondentsAnswer?: Maybe<RespondentsAnswer>;
  createReviewWorkflowsWorkflow?: Maybe<ReviewWorkflowsWorkflow>;
  createReviewWorkflowsWorkflowStage?: Maybe<ReviewWorkflowsWorkflowStage>;
  createSection?: Maybe<Section>;
  createSubModule?: Maybe<SubModule>;
  createSubModuleSubmission?: Maybe<SubModuleSubmission>;
  createSubmission?: Maybe<Submission>;
  createSubmoduleReport?: Maybe<SubmoduleReport>;
  createSurveyReport?: Maybe<SurveyReport>;
  createTypeFormCollection?: Maybe<TypeFormCollection>;
  createUploadedReport?: Maybe<UploadedReport>;
  createUserUploadedDocument?: Maybe<UserUploadedDocument>;
  /** Create a new role */
  createUsersPermissionsRole?: Maybe<UsersPermissionsCreateRolePayload>;
  /** Create a new user */
  createUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  deleteAccountChange?: Maybe<DeleteMutationResponse>;
  deleteAppointment?: Maybe<DeleteMutationResponse>;
  deleteArticle?: Maybe<DeleteMutationResponse>;
  deleteAuditTrail?: Maybe<DeleteMutationResponse>;
  deleteBooking?: Maybe<DeleteMutationResponse>;
  deleteCoach?: Maybe<DeleteMutationResponse>;
  deleteCoachSession?: Maybe<DeleteMutationResponse>;
  deleteCoachSubmittedReport?: Maybe<DeleteMutationResponse>;
  deleteCompany?: Maybe<DeleteMutationResponse>;
  deleteCompetencyUrl?: Maybe<DeleteMutationResponse>;
  deleteDivision?: Maybe<DeleteMutationResponse>;
  deleteEmailLog?: Maybe<DeleteMutationResponse>;
  deleteEmailTemplate?: Maybe<DeleteMutationResponse>;
  deleteEvent?: Maybe<DeleteMutationResponse>;
  deleteFeedfowardUrl?: Maybe<DeleteMutationResponse>;
  deleteForwardedCard?: Maybe<DeleteMutationResponse>;
  deleteInvite?: Maybe<DeleteMutationResponse>;
  deleteLanguage?: Maybe<DeleteMutationResponse>;
  deleteLogo?: Maybe<DeleteMutationResponse>;
  deleteModal?: Maybe<DeleteMutationResponse>;
  deleteModule?: Maybe<DeleteMutationResponse>;
  deleteNote?: Maybe<DeleteMutationResponse>;
  deleteNotification?: Maybe<DeleteMutationResponse>;
  deleteParticipant?: Maybe<DeleteMutationResponse>;
  deletePostCard?: Maybe<DeleteMutationResponse>;
  deletePostCardImage?: Maybe<DeleteMutationResponse>;
  deletePostCardSentence?: Maybe<DeleteMutationResponse>;
  deleteProgramme?: Maybe<DeleteMutationResponse>;
  deleteProgrammeReport?: Maybe<DeleteMutationResponse>;
  deleteProgrammeSubmission?: Maybe<DeleteMutationResponse>;
  deleteProgrammeType?: Maybe<DeleteMutationResponse>;
  deleteRegion?: Maybe<DeleteMutationResponse>;
  deleteReport?: Maybe<DeleteMutationResponse>;
  deleteRespondentsAnswer?: Maybe<DeleteMutationResponse>;
  deleteReviewWorkflowsWorkflow?: Maybe<DeleteMutationResponse>;
  deleteReviewWorkflowsWorkflowStage?: Maybe<DeleteMutationResponse>;
  deleteSection?: Maybe<DeleteMutationResponse>;
  deleteSubModule?: Maybe<DeleteMutationResponse>;
  deleteSubModuleSubmission?: Maybe<DeleteMutationResponse>;
  deleteSubmission?: Maybe<DeleteMutationResponse>;
  deleteSubmoduleReport?: Maybe<DeleteMutationResponse>;
  deleteSurveyReport?: Maybe<DeleteMutationResponse>;
  deleteTranslation?: Maybe<DeleteMutationResponse>;
  deleteTypeFormCollection?: Maybe<DeleteMutationResponse>;
  deleteUploadFile?: Maybe<UploadFile>;
  deleteUploadedReport?: Maybe<DeleteMutationResponse>;
  deleteUserUploadedDocument?: Maybe<DeleteMutationResponse>;
  /** Delete an existing role */
  deleteUsersPermissionsRole?: Maybe<UsersPermissionsDeleteRolePayload>;
  /** Delete an existing user */
  deleteUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  deletedNote?: Maybe<Notes>;
  /** Confirm an email users email address */
  emailConfirmation?: Maybe<UsersPermissionsLoginPayload>;
  /** Request a reset password token */
  forgotPassword?: Maybe<UsersPermissionsPasswordPayload>;
  generateCompetencyResponses?: Maybe<ProgrammeSubmissionResponse>;
  generateMyMiniSectionSubmissionResponse?: Maybe<SubModuleSubmissionResponse>;
  generateMyProgrammeSubmissionResponses?: Maybe<ProgrammeSubmissionResponse>;
  generateMySubModuleSubmissionComptencyResponses?: Maybe<SubModuleSubmissionResponse>;
  generateMySubModuleSubmissionResponses?: Maybe<SubModuleSubmissionResponse>;
  login: UsersPermissionsLoginPayload;
  /** Register a user */
  register: UsersPermissionsLoginPayload;
  resendMail?: Maybe<EmailSent>;
  resendProgrammeMail?: Maybe<EmailSentProgramme>;
  /** Reset user password. Confirm with a code (resetToken from forgotPassword) */
  resetPassword?: Maybe<UsersPermissionsLoginPayload>;
  updateAccountChange?: Maybe<AccountChange>;
  updateAppointment?: Maybe<Appointment>;
  updateArticle?: Maybe<Article>;
  updateAuditTrail?: Maybe<AuditTrail>;
  updateBooking?: Maybe<Booking>;
  updateCoach?: Maybe<Coach>;
  updateCoachSession?: Maybe<CoachSession>;
  updateCoachSubmittedReport?: Maybe<CoachSubmittedReport>;
  updateCompany?: Maybe<Company>;
  updateCompetencyUrl?: Maybe<CompetencyUrl>;
  updateDivision?: Maybe<Division>;
  updateEmailLog?: Maybe<EmailLog>;
  updateEmailTemplate?: Maybe<EmailTemplate>;
  updateEvent?: Maybe<Event>;
  updateFeedfowardUrl?: Maybe<FeedfowardUrl>;
  updateForwardedCard?: Maybe<ForwardedCard>;
  updateInvite?: Maybe<Invite>;
  updateLanguage?: Maybe<Language>;
  updateLogo?: Maybe<Logo>;
  updateModal?: Maybe<Modal>;
  updateModule?: Maybe<Module>;
  updateMyProgrammeSubmissions: ProgrammeSubmission;
  updateMySubModuleSubmission: SubModuleSubmission;
  updateMySubmission: Submission;
  updateNote?: Maybe<Note>;
  updateNotification?: Maybe<Notification>;
  updateParticipant?: Maybe<Participant>;
  updatePostCard?: Maybe<PostCard>;
  updatePostCardImage?: Maybe<PostCardImage>;
  updatePostCardSentence?: Maybe<PostCardSentence>;
  updateProgramme?: Maybe<Programme>;
  updateProgrammeReport?: Maybe<ProgrammeReport>;
  updateProgrammeSubmission?: Maybe<ProgrammeSubmission>;
  updateProgrammeType?: Maybe<ProgrammeType>;
  updateRegion?: Maybe<Region>;
  updateReport?: Maybe<Report>;
  updateRespondentsAnswer?: Maybe<RespondentsAnswer>;
  updateReviewWorkflowsWorkflow?: Maybe<ReviewWorkflowsWorkflow>;
  updateReviewWorkflowsWorkflowStage?: Maybe<ReviewWorkflowsWorkflowStage>;
  updateSection?: Maybe<Section>;
  updateSelf: UsersPermissionsUser;
  updateSubModule?: Maybe<SubModule>;
  updateSubModuleSubmission?: Maybe<SubModuleSubmission>;
  updateSubmission?: Maybe<Submission>;
  updateSubmoduleReport?: Maybe<SubmoduleReport>;
  updateSurveyReport?: Maybe<SurveyReport>;
  updateTranslation?: Maybe<Translation>;
  updateTypeFormCollection?: Maybe<TypeFormCollection>;
  updateUploadFile: UploadFile;
  updateUploadedReport?: Maybe<UploadedReport>;
  updateUserUploadedDocument?: Maybe<UserUploadedDocument>;
  /** Update an existing role */
  updateUsersPermissionsRole?: Maybe<UsersPermissionsUpdateRolePayload>;
  /** Update an existing user */
  updateUsersPermissionsUser: UsersPermissionsUserEntityResponse;
};


export type MutationAddDocumentArgs = {
  editFlag?: InputMaybe<Scalars['Boolean']['input']>;
  input: EditUserUploadedDocumentInput;
};


export type MutationAddNoteArgs = {
  input: EditNoteInput;
};


export type MutationChangePasswordArgs = {
  currentPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};


export type MutationConfirmMyAppointmentsArgs = {
  appointmentScheduleId: Scalars['ID']['input'];
  programmeSubmissionId: Scalars['ID']['input'];
  subModule: Scalars['Boolean']['input'];
};


export type MutationCreateAccountChangeArgs = {
  data: AccountChangeInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateAppointmentArgs = {
  data: AppointmentInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateArticleArgs = {
  data: ArticleInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateAuditTrailArgs = {
  data: AuditTrailInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateBookingArgs = {
  data: BookingInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateCoachArgs = {
  data: CoachInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateCoachSessionArgs = {
  data: CoachSessionInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateCoachSubmittedReportArgs = {
  data: CoachSubmittedReportInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateCompanyArgs = {
  data: CompanyInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateCompetencyUrlArgs = {
  data: CompetencyUrlInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateDivisionArgs = {
  data: DivisionInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateEmailLogArgs = {
  data: EmailLogInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateEmailTemplateArgs = {
  data: EmailTemplateInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateEventArgs = {
  data: EventInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateFeedfowardUrlArgs = {
  data: FeedfowardUrlInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateForwardedCardArgs = {
  data: ForwardedCardInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateInviteArgs = {
  data: InviteInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateLanguageArgs = {
  data: LanguageInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateLogoArgs = {
  data: LogoInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateModalArgs = {
  data: ModalInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateModuleArgs = {
  data: ModuleInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateNoteArgs = {
  data: NoteInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateNotificationArgs = {
  data: NotificationInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateParticipantArgs = {
  data: ParticipantInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreatePostCardArgs = {
  data: PostCardInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreatePostCardImageArgs = {
  data: PostCardImageInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreatePostCardSentenceArgs = {
  data: PostCardSentenceInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateProgrammeArgs = {
  data: ProgrammeInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateProgrammeReportArgs = {
  data: ProgrammeReportInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateProgrammeSubmissionArgs = {
  data: ProgrammeSubmissionInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateProgrammeTypeArgs = {
  data: ProgrammeTypeInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateRegionArgs = {
  data: RegionInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateReportArgs = {
  data: ReportInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateRespondentsAnswerArgs = {
  data: RespondentsAnswerInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateReviewWorkflowsWorkflowArgs = {
  data: ReviewWorkflowsWorkflowInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateReviewWorkflowsWorkflowStageArgs = {
  data: ReviewWorkflowsWorkflowStageInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateSectionArgs = {
  data: SectionInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateSubModuleArgs = {
  data: SubModuleInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateSubModuleSubmissionArgs = {
  data: SubModuleSubmissionInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateSubmissionArgs = {
  data: SubmissionInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateSubmoduleReportArgs = {
  data: SubmoduleReportInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateSurveyReportArgs = {
  data: SurveyReportInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateTypeFormCollectionArgs = {
  data: TypeFormCollectionInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateUploadedReportArgs = {
  data: UploadedReportInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateUserUploadedDocumentArgs = {
  data: UserUploadedDocumentInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
};


export type MutationCreateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
};


export type MutationDeleteAccountChangeArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteAppointmentArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteArticleArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteAuditTrailArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteBookingArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteCoachArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteCoachSessionArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteCoachSubmittedReportArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteCompanyArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteCompetencyUrlArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteDivisionArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteEmailLogArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteEmailTemplateArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteEventArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteFeedfowardUrlArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteForwardedCardArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteInviteArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteLanguageArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteLogoArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteModalArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteModuleArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteNoteArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteNotificationArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteParticipantArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeletePostCardArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeletePostCardImageArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeletePostCardSentenceArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteProgrammeArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteProgrammeReportArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteProgrammeSubmissionArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteProgrammeTypeArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteRegionArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteReportArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteRespondentsAnswerArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteReviewWorkflowsWorkflowArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteReviewWorkflowsWorkflowStageArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteSectionArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteSubModuleArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteSubModuleSubmissionArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteSubmissionArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteSubmoduleReportArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteSurveyReportArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteTypeFormCollectionArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteUploadFileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUploadedReportArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteUserUploadedDocumentArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteUsersPermissionsRoleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUsersPermissionsUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletedNoteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEmailConfirmationArgs = {
  confirmation: Scalars['String']['input'];
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationGenerateCompetencyResponsesArgs = {
  id: Scalars['ID']['input'];
};


export type MutationGenerateMyMiniSectionSubmissionResponseArgs = {
  id: Scalars['ID']['input'];
  secId?: InputMaybe<Scalars['Int']['input']>;
  sectionId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationGenerateMyProgrammeSubmissionResponsesArgs = {
  id: Scalars['ID']['input'];
};


export type MutationGenerateMySubModuleSubmissionComptencyResponsesArgs = {
  id: Scalars['ID']['input'];
  sectionId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationGenerateMySubModuleSubmissionResponsesArgs = {
  id: Scalars['ID']['input'];
  sectionId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationLoginArgs = {
  input: UsersPermissionsLoginInput;
};


export type MutationRegisterArgs = {
  input: UsersPermissionsRegisterInput;
};


export type MutationResendMailArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationResendProgrammeMailArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationResetPasswordArgs = {
  code: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};


export type MutationUpdateAccountChangeArgs = {
  data: AccountChangeInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateAppointmentArgs = {
  data: AppointmentInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateArticleArgs = {
  data: ArticleInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateAuditTrailArgs = {
  data: AuditTrailInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateBookingArgs = {
  data: BookingInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateCoachArgs = {
  data: CoachInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateCoachSessionArgs = {
  data: CoachSessionInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateCoachSubmittedReportArgs = {
  data: CoachSubmittedReportInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateCompanyArgs = {
  data: CompanyInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateCompetencyUrlArgs = {
  data: CompetencyUrlInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateDivisionArgs = {
  data: DivisionInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateEmailLogArgs = {
  data: EmailLogInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateEmailTemplateArgs = {
  data: EmailTemplateInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateEventArgs = {
  data: EventInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateFeedfowardUrlArgs = {
  data: FeedfowardUrlInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateForwardedCardArgs = {
  data: ForwardedCardInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateInviteArgs = {
  data: InviteInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateLanguageArgs = {
  data: LanguageInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateLogoArgs = {
  data: LogoInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateModalArgs = {
  data: ModalInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateModuleArgs = {
  data: ModuleInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateMyProgrammeSubmissionsArgs = {
  id: Scalars['ID']['input'];
  input: EditProgrammeSubmissionInput;
  isPdf?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateMySubModuleSubmissionArgs = {
  currentSection?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  input: EditSubModuleSubmissionInput;
  isPdf?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  programmeSubmissionId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateMySubmissionArgs = {
  currentSection?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  input: EditSubmissionInput;
  programmeSubmissionId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateNoteArgs = {
  data: NoteInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateNotificationArgs = {
  data: NotificationInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateParticipantArgs = {
  data: ParticipantInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdatePostCardArgs = {
  data: PostCardInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdatePostCardImageArgs = {
  data: PostCardImageInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdatePostCardSentenceArgs = {
  data: PostCardSentenceInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateProgrammeArgs = {
  data: ProgrammeInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateProgrammeReportArgs = {
  data: ProgrammeReportInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateProgrammeSubmissionArgs = {
  data: ProgrammeSubmissionInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateProgrammeTypeArgs = {
  data: ProgrammeTypeInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateRegionArgs = {
  data: RegionInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateReportArgs = {
  data: ReportInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateRespondentsAnswerArgs = {
  data: RespondentsAnswerInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateReviewWorkflowsWorkflowArgs = {
  data: ReviewWorkflowsWorkflowInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateReviewWorkflowsWorkflowStageArgs = {
  data: ReviewWorkflowsWorkflowStageInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateSectionArgs = {
  data: SectionInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateSelfArgs = {
  user: EditUserInput;
};


export type MutationUpdateSubModuleArgs = {
  data: SubModuleInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateSubModuleSubmissionArgs = {
  data: SubModuleSubmissionInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateSubmissionArgs = {
  data: SubmissionInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateSubmoduleReportArgs = {
  data: SubmoduleReportInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateSurveyReportArgs = {
  data: SurveyReportInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateTranslationArgs = {
  data: TranslationInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateTypeFormCollectionArgs = {
  data: TypeFormCollectionInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateUploadFileArgs = {
  id: Scalars['ID']['input'];
  info?: InputMaybe<FileInfoInput>;
};


export type MutationUpdateUploadedReportArgs = {
  data: UploadedReportInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateUserUploadedDocumentArgs = {
  data: UserUploadedDocumentInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
  id: Scalars['ID']['input'];
};

export type Note = {
  __typename?: 'Note';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  document: Array<Maybe<UploadFile>>;
  documentId: Scalars['ID']['output'];
  document_connection?: Maybe<UploadFileRelationResponseCollection>;
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  notes_id?: Maybe<Array<Maybe<ComponentSubmissionsSaboteurComponent>>>;
  programme?: Maybe<Programme>;
  programme_submission?: Maybe<ProgrammeSubmission>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  section_or_submission_id?: Maybe<Scalars['String']['output']>;
  sub_module_submission?: Maybe<SubModuleSubmission>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<UsersPermissionsUser>;
};


export type NoteDocumentArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type NoteDocument_ConnectionArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type NoteNotes_IdArgs = {
  filters?: InputMaybe<ComponentSubmissionsSaboteurComponentFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type NoteEntityResponseCollection = {
  __typename?: 'NoteEntityResponseCollection';
  nodes: Array<Note>;
  pageInfo: Pagination;
};

export type NoteFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<NoteFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<NoteFiltersInput>;
  note?: InputMaybe<StringFilterInput>;
  notes_id?: InputMaybe<ComponentSubmissionsSaboteurComponentFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<NoteFiltersInput>>>;
  programme?: InputMaybe<ProgrammeFiltersInput>;
  programme_submission?: InputMaybe<ProgrammeSubmissionFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  section_or_submission_id?: InputMaybe<StringFilterInput>;
  sub_module_submission?: InputMaybe<SubModuleSubmissionFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  user?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type NoteInput = {
  document?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  notes_id?: InputMaybe<Array<InputMaybe<ComponentSubmissionsSaboteurComponentInput>>>;
  programme?: InputMaybe<Scalars['ID']['input']>;
  programme_submission?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  section_or_submission_id?: InputMaybe<Scalars['String']['input']>;
  sub_module_submission?: InputMaybe<Scalars['ID']['input']>;
  user?: InputMaybe<Scalars['ID']['input']>;
};

export type NoteRelationResponseCollection = {
  __typename?: 'NoteRelationResponseCollection';
  nodes: Array<Note>;
};

export type Notes = {
  __typename?: 'Notes';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<AdminUser>;
  document?: Maybe<Array<Maybe<UploadFile>>>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  notesId?: Maybe<Array<Maybe<ComponentSubmissionsSaboteurComponent>>>;
  programme?: Maybe<Programmes>;
  programmeSubmission?: Maybe<ProgrammeSubmission>;
  sectionOrSubmissionId?: Maybe<Scalars['String']['output']>;
  subModuleSubmission?: Maybe<SubModuleSubmission>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<AdminUser>;
  user?: Maybe<UsersPermissionsUser>;
};


export type NotesDocumentArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};

export type Notification = {
  __typename?: 'Notification';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  path?: Maybe<Scalars['String']['output']>;
  programme_report?: Maybe<ProgrammeReport>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  read?: Maybe<Scalars['Boolean']['output']>;
  report?: Maybe<Report>;
  submodule_report?: Maybe<SubmoduleReport>;
  time_stamp?: Maybe<Scalars['DateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  users: Array<Maybe<UsersPermissionsUser>>;
  users_connection?: Maybe<UsersPermissionsUserRelationResponseCollection>;
};


export type NotificationUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type NotificationUsers_ConnectionArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type NotificationEntityResponseCollection = {
  __typename?: 'NotificationEntityResponseCollection';
  nodes: Array<Notification>;
  pageInfo: Pagination;
};

export type NotificationFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<NotificationFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<NotificationFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<NotificationFiltersInput>>>;
  path?: InputMaybe<StringFilterInput>;
  programme_report?: InputMaybe<ProgrammeReportFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  read?: InputMaybe<BooleanFilterInput>;
  report?: InputMaybe<ReportFiltersInput>;
  submodule_report?: InputMaybe<SubmoduleReportFiltersInput>;
  time_stamp?: InputMaybe<DateTimeFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  users?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type NotificationInput = {
  path?: InputMaybe<Scalars['String']['input']>;
  programme_report?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  report?: InputMaybe<Scalars['ID']['input']>;
  submodule_report?: InputMaybe<Scalars['ID']['input']>;
  time_stamp?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type NotificationRelationResponseCollection = {
  __typename?: 'NotificationRelationResponseCollection';
  nodes: Array<Notification>;
};

export type OrderedSubmissions = {
  __typename?: 'OrderedSubmissions';
  programmeSubmission: ProgrammeSubmission;
  subModuleSubmissions: Array<SubModuleSubmission>;
};

export type Pagination = {
  __typename?: 'Pagination';
  page: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PaginationArg = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
};

export type Participant = {
  __typename?: 'Participant';
  coach_email?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  programme_submission?: Maybe<ProgrammeSubmission>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  sub_module_submission?: Maybe<SubModuleSubmission>;
  survey_sent_date?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<Enum_Participant_Type>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ParticipantEntityResponseCollection = {
  __typename?: 'ParticipantEntityResponseCollection';
  nodes: Array<Participant>;
  pageInfo: Pagination;
};

export type ParticipantFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ParticipantFiltersInput>>>;
  coach_email?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ParticipantFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ParticipantFiltersInput>>>;
  programme_submission?: InputMaybe<ProgrammeSubmissionFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  sub_module_submission?: InputMaybe<SubModuleSubmissionFiltersInput>;
  survey_sent_date?: InputMaybe<DateTimeFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ParticipantInput = {
  coach_email?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  programme_submission?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  sub_module_submission?: InputMaybe<Scalars['ID']['input']>;
  survey_sent_date?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<Enum_Participant_Type>;
};

export type ParticipantRelationResponseCollection = {
  __typename?: 'ParticipantRelationResponseCollection';
  nodes: Array<Participant>;
};

export type PostCard = {
  __typename?: 'PostCard';
  company_logo?: Maybe<Logo>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  expiration_time?: Maybe<Scalars['Long']['output']>;
  forwarded_cards: Array<Maybe<ForwardedCard>>;
  forwarded_cards_connection?: Maybe<ForwardedCardRelationResponseCollection>;
  front_image?: Maybe<Scalars['String']['output']>;
  front_text?: Maybe<Scalars['String']['output']>;
  post_card_image?: Maybe<PostCardImage>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<UsersPermissionsUser>;
};


export type PostCardForwarded_CardsArgs = {
  filters?: InputMaybe<ForwardedCardFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type PostCardForwarded_Cards_ConnectionArgs = {
  filters?: InputMaybe<ForwardedCardFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PostCardEntityResponseCollection = {
  __typename?: 'PostCardEntityResponseCollection';
  nodes: Array<PostCard>;
  pageInfo: Pagination;
};

export type PostCardFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<PostCardFiltersInput>>>;
  company_logo?: InputMaybe<LogoFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  expiration_time?: InputMaybe<LongFilterInput>;
  forwarded_cards?: InputMaybe<ForwardedCardFiltersInput>;
  front_image?: InputMaybe<StringFilterInput>;
  front_text?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<PostCardFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<PostCardFiltersInput>>>;
  post_card_image?: InputMaybe<PostCardImageFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  token?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  user?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type PostCardImage = {
  __typename?: 'PostCardImage';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  image?: Maybe<UploadFile>;
  post_cards: Array<Maybe<PostCard>>;
  post_cards_connection?: Maybe<PostCardRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type PostCardImagePost_CardsArgs = {
  filters?: InputMaybe<PostCardFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type PostCardImagePost_Cards_ConnectionArgs = {
  filters?: InputMaybe<PostCardFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PostCardImageEntityResponseCollection = {
  __typename?: 'PostCardImageEntityResponseCollection';
  nodes: Array<PostCardImage>;
  pageInfo: Pagination;
};

export type PostCardImageFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<PostCardImageFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<PostCardImageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<PostCardImageFiltersInput>>>;
  post_cards?: InputMaybe<PostCardFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type PostCardImageInput = {
  image?: InputMaybe<Scalars['ID']['input']>;
  post_cards?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PostCardInput = {
  company_logo?: InputMaybe<Scalars['ID']['input']>;
  expiration_time?: InputMaybe<Scalars['Long']['input']>;
  forwarded_cards?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  front_image?: InputMaybe<Scalars['String']['input']>;
  front_text?: InputMaybe<Scalars['String']['input']>;
  post_card_image?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['ID']['input']>;
};

export type PostCardRelationResponseCollection = {
  __typename?: 'PostCardRelationResponseCollection';
  nodes: Array<PostCard>;
};

export type PostCardSentence = {
  __typename?: 'PostCardSentence';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  post_card_sentence?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PostCardSentenceEntityResponseCollection = {
  __typename?: 'PostCardSentenceEntityResponseCollection';
  nodes: Array<PostCardSentence>;
  pageInfo: Pagination;
};

export type PostCardSentenceFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<PostCardSentenceFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<PostCardSentenceFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<PostCardSentenceFiltersInput>>>;
  post_card_sentence?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type PostCardSentenceInput = {
  post_card_sentence?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Programme = {
  __typename?: 'Programme';
  articles: Array<Maybe<Article>>;
  articles_connection?: Maybe<ArticleRelationResponseCollection>;
  companies: Array<Maybe<Company>>;
  companies_connection?: Maybe<CompanyRelationResponseCollection>;
  completion?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['ID']['output'];
  email_logs: Array<Maybe<EmailLog>>;
  email_logs_connection?: Maybe<EmailLogRelationResponseCollection>;
  email_templates: Array<Maybe<EmailTemplate>>;
  email_templates_connection?: Maybe<EmailTemplateRelationResponseCollection>;
  is_custom_journey?: Maybe<Scalars['Boolean']['output']>;
  is_template?: Maybe<Scalars['Boolean']['output']>;
  logo?: Maybe<UploadFile>;
  name?: Maybe<Scalars['String']['output']>;
  notes: Array<Maybe<Note>>;
  notes_connection?: Maybe<NoteRelationResponseCollection>;
  position?: Maybe<Scalars['Int']['output']>;
  programme_submissions: Array<Maybe<ProgrammeSubmission>>;
  programme_submissions_connection?: Maybe<ProgrammeSubmissionRelationResponseCollection>;
  programme_title?: Maybe<Scalars['String']['output']>;
  programme_types: Array<Maybe<ProgrammeType>>;
  programme_types_connection?: Maybe<ProgrammeTypeRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  send_type_form?: Maybe<Scalars['Boolean']['output']>;
  show_timeline?: Maybe<Scalars['Boolean']['output']>;
  start?: Maybe<Scalars['DateTime']['output']>;
  sub_module_submissions: Array<Maybe<SubModuleSubmission>>;
  sub_module_submissions_connection?: Maybe<SubModuleSubmissionRelationResponseCollection>;
  three_60_form_id?: Maybe<Scalars['String']['output']>;
  type_form_collection?: Maybe<TypeFormCollection>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  users: Array<Maybe<UsersPermissionsUser>>;
  users_connection?: Maybe<UsersPermissionsUserRelationResponseCollection>;
  what_to_expect?: Maybe<Scalars['String']['output']>;
};


export type ProgrammeArticlesArgs = {
  filters?: InputMaybe<ArticleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ProgrammeArticles_ConnectionArgs = {
  filters?: InputMaybe<ArticleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ProgrammeCompaniesArgs = {
  filters?: InputMaybe<CompanyFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ProgrammeCompanies_ConnectionArgs = {
  filters?: InputMaybe<CompanyFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ProgrammeEmail_LogsArgs = {
  filters?: InputMaybe<EmailLogFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ProgrammeEmail_Logs_ConnectionArgs = {
  filters?: InputMaybe<EmailLogFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ProgrammeEmail_TemplatesArgs = {
  filters?: InputMaybe<EmailTemplateFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ProgrammeEmail_Templates_ConnectionArgs = {
  filters?: InputMaybe<EmailTemplateFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ProgrammeNotesArgs = {
  filters?: InputMaybe<NoteFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ProgrammeNotes_ConnectionArgs = {
  filters?: InputMaybe<NoteFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ProgrammeProgramme_SubmissionsArgs = {
  filters?: InputMaybe<ProgrammeSubmissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ProgrammeProgramme_Submissions_ConnectionArgs = {
  filters?: InputMaybe<ProgrammeSubmissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ProgrammeProgramme_TypesArgs = {
  filters?: InputMaybe<ProgrammeTypeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ProgrammeProgramme_Types_ConnectionArgs = {
  filters?: InputMaybe<ProgrammeTypeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ProgrammeSub_Module_SubmissionsArgs = {
  filters?: InputMaybe<SubModuleSubmissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ProgrammeSub_Module_Submissions_ConnectionArgs = {
  filters?: InputMaybe<SubModuleSubmissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ProgrammeUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ProgrammeUsers_ConnectionArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ProgrammeEntityResponseCollection = {
  __typename?: 'ProgrammeEntityResponseCollection';
  nodes: Array<Programme>;
  pageInfo: Pagination;
};

export type ProgrammeFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ProgrammeFiltersInput>>>;
  articles?: InputMaybe<ArticleFiltersInput>;
  companies?: InputMaybe<CompanyFiltersInput>;
  completion?: InputMaybe<DateTimeFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  email_logs?: InputMaybe<EmailLogFiltersInput>;
  email_templates?: InputMaybe<EmailTemplateFiltersInput>;
  is_custom_journey?: InputMaybe<BooleanFilterInput>;
  is_template?: InputMaybe<BooleanFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ProgrammeFiltersInput>;
  notes?: InputMaybe<NoteFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ProgrammeFiltersInput>>>;
  position?: InputMaybe<IntFilterInput>;
  programme_submissions?: InputMaybe<ProgrammeSubmissionFiltersInput>;
  programme_title?: InputMaybe<StringFilterInput>;
  programme_types?: InputMaybe<ProgrammeTypeFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  send_type_form?: InputMaybe<BooleanFilterInput>;
  show_timeline?: InputMaybe<BooleanFilterInput>;
  start?: InputMaybe<DateTimeFilterInput>;
  sub_module_submissions?: InputMaybe<SubModuleSubmissionFiltersInput>;
  three_60_form_id?: InputMaybe<StringFilterInput>;
  type_form_collection?: InputMaybe<TypeFormCollectionFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  users?: InputMaybe<UsersPermissionsUserFiltersInput>;
  what_to_expect?: InputMaybe<StringFilterInput>;
};

export type ProgrammeInput = {
  articles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  companies?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  completion?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email_logs?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  email_templates?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  is_custom_journey?: InputMaybe<Scalars['Boolean']['input']>;
  is_template?: InputMaybe<Scalars['Boolean']['input']>;
  logo?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  position?: InputMaybe<Scalars['Int']['input']>;
  programme_submissions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  programme_title?: InputMaybe<Scalars['String']['input']>;
  programme_types?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  send_type_form?: InputMaybe<Scalars['Boolean']['input']>;
  show_timeline?: InputMaybe<Scalars['Boolean']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  sub_module_submissions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  three_60_form_id?: InputMaybe<Scalars['String']['input']>;
  type_form_collection?: InputMaybe<Scalars['ID']['input']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  what_to_expect?: InputMaybe<Scalars['String']['input']>;
};

export type ProgrammeRelationResponseCollection = {
  __typename?: 'ProgrammeRelationResponseCollection';
  nodes: Array<Programme>;
};

export type ProgrammeReport = {
  __typename?: 'ProgrammeReport';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  notification?: Maybe<Notification>;
  programme_submission?: Maybe<ProgrammeSubmission>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  report: Array<Maybe<UploadFile>>;
  report_connection?: Maybe<UploadFileRelationResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ProgrammeReportReportArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ProgrammeReportReport_ConnectionArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ProgrammeReportEntityResponseCollection = {
  __typename?: 'ProgrammeReportEntityResponseCollection';
  nodes: Array<ProgrammeReport>;
  pageInfo: Pagination;
};

export type ProgrammeReportFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ProgrammeReportFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ProgrammeReportFiltersInput>;
  notification?: InputMaybe<NotificationFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ProgrammeReportFiltersInput>>>;
  programme_submission?: InputMaybe<ProgrammeSubmissionFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ProgrammeReportInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  notification?: InputMaybe<Scalars['ID']['input']>;
  programme_submission?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  report?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type ProgrammeSubmission = {
  __typename?: 'ProgrammeSubmission';
  coach_sessions: Array<Maybe<CoachSession>>;
  coach_sessions_connection?: Maybe<CoachSessionRelationResponseCollection>;
  competency_url?: Maybe<CompetencyUrl>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  email_sent?: Maybe<Scalars['Boolean']['output']>;
  feedfoward_url?: Maybe<FeedfowardUrl>;
  id: Scalars['ID']['output'];
  is_updated_by_stakeholder?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Language>;
  my_notes?: Maybe<Array<Maybe<ComponentSubmissionsNotes>>>;
  notes: Array<Maybe<Note>>;
  notes_connection?: Maybe<NoteRelationResponseCollection>;
  participants: Array<Maybe<Participant>>;
  participants_connection?: Maybe<ParticipantRelationResponseCollection>;
  programme?: Maybe<Programme>;
  programme_report?: Maybe<ProgrammeReport>;
  programme_responses?: Maybe<Array<Maybe<ComponentSubmissionsProgrammeSubmissions>>>;
  programme_type?: Maybe<ProgrammeType>;
  progress?: Maybe<Scalars['Int']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  respondents_answers: Array<Maybe<RespondentsAnswer>>;
  respondents_answers_connection?: Maybe<RespondentsAnswerRelationResponseCollection>;
  selected?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Enum_Programmesubmission_Status>;
  submission_participants?: Maybe<Array<Maybe<ComponentSubmissionsParticipants>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uploaded_reports: Array<Maybe<UploadedReport>>;
  uploaded_reports_connection?: Maybe<UploadedReportRelationResponseCollection>;
  user?: Maybe<UsersPermissionsUser>;
};


export type ProgrammeSubmissionCoach_SessionsArgs = {
  filters?: InputMaybe<CoachSessionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ProgrammeSubmissionCoach_Sessions_ConnectionArgs = {
  filters?: InputMaybe<CoachSessionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ProgrammeSubmissionMy_NotesArgs = {
  filters?: InputMaybe<ComponentSubmissionsNotesFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ProgrammeSubmissionNotesArgs = {
  filters?: InputMaybe<NoteFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ProgrammeSubmissionNotes_ConnectionArgs = {
  filters?: InputMaybe<NoteFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ProgrammeSubmissionParticipantsArgs = {
  filters?: InputMaybe<ParticipantFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ProgrammeSubmissionParticipants_ConnectionArgs = {
  filters?: InputMaybe<ParticipantFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ProgrammeSubmissionProgramme_ResponsesArgs = {
  filters?: InputMaybe<ComponentSubmissionsProgrammeSubmissionsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ProgrammeSubmissionRespondents_AnswersArgs = {
  filters?: InputMaybe<RespondentsAnswerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ProgrammeSubmissionRespondents_Answers_ConnectionArgs = {
  filters?: InputMaybe<RespondentsAnswerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ProgrammeSubmissionSubmission_ParticipantsArgs = {
  filters?: InputMaybe<ComponentSubmissionsParticipantsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ProgrammeSubmissionUploaded_ReportsArgs = {
  filters?: InputMaybe<UploadedReportFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ProgrammeSubmissionUploaded_Reports_ConnectionArgs = {
  filters?: InputMaybe<UploadedReportFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ProgrammeSubmissionEntityResponseCollection = {
  __typename?: 'ProgrammeSubmissionEntityResponseCollection';
  nodes: Array<ProgrammeSubmission>;
  pageInfo: Pagination;
};

export type ProgrammeSubmissionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ProgrammeSubmissionFiltersInput>>>;
  coach_sessions?: InputMaybe<CoachSessionFiltersInput>;
  competency_url?: InputMaybe<CompetencyUrlFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  email_sent?: InputMaybe<BooleanFilterInput>;
  feedfoward_url?: InputMaybe<FeedfowardUrlFiltersInput>;
  is_updated_by_stakeholder?: InputMaybe<BooleanFilterInput>;
  language?: InputMaybe<LanguageFiltersInput>;
  my_notes?: InputMaybe<ComponentSubmissionsNotesFiltersInput>;
  not?: InputMaybe<ProgrammeSubmissionFiltersInput>;
  notes?: InputMaybe<NoteFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ProgrammeSubmissionFiltersInput>>>;
  participants?: InputMaybe<ParticipantFiltersInput>;
  programme?: InputMaybe<ProgrammeFiltersInput>;
  programme_report?: InputMaybe<ProgrammeReportFiltersInput>;
  programme_responses?: InputMaybe<ComponentSubmissionsProgrammeSubmissionsFiltersInput>;
  programme_type?: InputMaybe<ProgrammeTypeFiltersInput>;
  progress?: InputMaybe<IntFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  respondents_answers?: InputMaybe<RespondentsAnswerFiltersInput>;
  selected?: InputMaybe<BooleanFilterInput>;
  status?: InputMaybe<StringFilterInput>;
  submission_participants?: InputMaybe<ComponentSubmissionsParticipantsFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  uploaded_reports?: InputMaybe<UploadedReportFiltersInput>;
  user?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type ProgrammeSubmissionInput = {
  coach_sessions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  competency_url?: InputMaybe<Scalars['ID']['input']>;
  email_sent?: InputMaybe<Scalars['Boolean']['input']>;
  feedfoward_url?: InputMaybe<Scalars['ID']['input']>;
  is_updated_by_stakeholder?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['ID']['input']>;
  my_notes?: InputMaybe<Array<InputMaybe<ComponentSubmissionsNotesInput>>>;
  notes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  participants?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  programme?: InputMaybe<Scalars['ID']['input']>;
  programme_report?: InputMaybe<Scalars['ID']['input']>;
  programme_responses?: InputMaybe<Array<InputMaybe<ComponentSubmissionsProgrammeSubmissionsInput>>>;
  programme_type?: InputMaybe<Scalars['ID']['input']>;
  progress?: InputMaybe<Scalars['Int']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  respondents_answers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  selected?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Enum_Programmesubmission_Status>;
  submission_participants?: InputMaybe<Array<InputMaybe<ComponentSubmissionsParticipantsInput>>>;
  uploaded_reports?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  user?: InputMaybe<Scalars['ID']['input']>;
};

export type ProgrammeSubmissionRelationResponseCollection = {
  __typename?: 'ProgrammeSubmissionRelationResponseCollection';
  nodes: Array<ProgrammeSubmission>;
};

export type ProgrammeSubmissionResponse = {
  __typename?: 'ProgrammeSubmissionResponse';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ProgrammeType = {
  __typename?: 'ProgrammeType';
  archive?: Maybe<Scalars['Boolean']['output']>;
  articles: Array<Maybe<Article>>;
  articles_connection?: Maybe<ArticleRelationResponseCollection>;
  competency_email_title?: Maybe<Scalars['String']['output']>;
  competency_survey?: Maybe<Scalars['Boolean']['output']>;
  cover?: Maybe<UploadFile>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deadline?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['ID']['output'];
  email_send?: Maybe<Scalars['Boolean']['output']>;
  email_template?: Maybe<EmailTemplate>;
  events: Array<Maybe<Event>>;
  events_connection?: Maybe<EventRelationResponseCollection>;
  feedForward_survey?: Maybe<Scalars['Boolean']['output']>;
  is_coaching?: Maybe<Scalars['Boolean']['output']>;
  is_sub_module?: Maybe<Scalars['Boolean']['output']>;
  is_template?: Maybe<Scalars['Boolean']['output']>;
  modal?: Maybe<Modal>;
  module?: Maybe<Module>;
  notes?: Maybe<Scalars['Boolean']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  programme_questions?: Maybe<Array<Maybe<ProgrammeTypeProgrammeQuestionsDynamicZone>>>;
  programme_submissions: Array<Maybe<ProgrammeSubmission>>;
  programme_submissions_connection?: Maybe<ProgrammeSubmissionRelationResponseCollection>;
  programme_type_instructions?: Maybe<Scalars['String']['output']>;
  programmes: Array<Maybe<Programme>>;
  programmes_connection?: Maybe<ProgrammeRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  show_article?: Maybe<Scalars['Boolean']['output']>;
  show_participants?: Maybe<Scalars['Boolean']['output']>;
  show_session?: Maybe<Scalars['Boolean']['output']>;
  show_statistics?: Maybe<Scalars['Boolean']['output']>;
  sub_modules: Array<Maybe<SubModule>>;
  sub_modules_connection?: Maybe<SubModuleRelationResponseCollection>;
  title?: Maybe<Scalars['String']['output']>;
  type_form_collection?: Maybe<TypeFormCollection>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ProgrammeTypeArticlesArgs = {
  filters?: InputMaybe<ArticleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ProgrammeTypeArticles_ConnectionArgs = {
  filters?: InputMaybe<ArticleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ProgrammeTypeEventsArgs = {
  filters?: InputMaybe<EventFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ProgrammeTypeEvents_ConnectionArgs = {
  filters?: InputMaybe<EventFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ProgrammeTypeProgramme_SubmissionsArgs = {
  filters?: InputMaybe<ProgrammeSubmissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ProgrammeTypeProgramme_Submissions_ConnectionArgs = {
  filters?: InputMaybe<ProgrammeSubmissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ProgrammeTypeProgrammesArgs = {
  filters?: InputMaybe<ProgrammeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ProgrammeTypeProgrammes_ConnectionArgs = {
  filters?: InputMaybe<ProgrammeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ProgrammeTypeSub_ModulesArgs = {
  filters?: InputMaybe<SubModuleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ProgrammeTypeSub_Modules_ConnectionArgs = {
  filters?: InputMaybe<SubModuleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ProgrammeTypeEntityResponseCollection = {
  __typename?: 'ProgrammeTypeEntityResponseCollection';
  nodes: Array<ProgrammeType>;
  pageInfo: Pagination;
};

export type ProgrammeTypeFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ProgrammeTypeFiltersInput>>>;
  archive?: InputMaybe<BooleanFilterInput>;
  articles?: InputMaybe<ArticleFiltersInput>;
  competency_email_title?: InputMaybe<StringFilterInput>;
  competency_survey?: InputMaybe<BooleanFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  deadline?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  email_send?: InputMaybe<BooleanFilterInput>;
  email_template?: InputMaybe<EmailTemplateFiltersInput>;
  events?: InputMaybe<EventFiltersInput>;
  feedForward_survey?: InputMaybe<BooleanFilterInput>;
  is_coaching?: InputMaybe<BooleanFilterInput>;
  is_sub_module?: InputMaybe<BooleanFilterInput>;
  is_template?: InputMaybe<BooleanFilterInput>;
  modal?: InputMaybe<ModalFiltersInput>;
  module?: InputMaybe<ModuleFiltersInput>;
  not?: InputMaybe<ProgrammeTypeFiltersInput>;
  notes?: InputMaybe<BooleanFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ProgrammeTypeFiltersInput>>>;
  position?: InputMaybe<IntFilterInput>;
  programme_submissions?: InputMaybe<ProgrammeSubmissionFiltersInput>;
  programme_type_instructions?: InputMaybe<StringFilterInput>;
  programmes?: InputMaybe<ProgrammeFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  show_article?: InputMaybe<BooleanFilterInput>;
  show_participants?: InputMaybe<BooleanFilterInput>;
  show_session?: InputMaybe<BooleanFilterInput>;
  show_statistics?: InputMaybe<BooleanFilterInput>;
  sub_modules?: InputMaybe<SubModuleFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
  type_form_collection?: InputMaybe<TypeFormCollectionFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ProgrammeTypeInput = {
  archive?: InputMaybe<Scalars['Boolean']['input']>;
  articles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  competency_email_title?: InputMaybe<Scalars['String']['input']>;
  competency_survey?: InputMaybe<Scalars['Boolean']['input']>;
  cover?: InputMaybe<Scalars['ID']['input']>;
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email_send?: InputMaybe<Scalars['Boolean']['input']>;
  email_template?: InputMaybe<Scalars['ID']['input']>;
  events?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  feedForward_survey?: InputMaybe<Scalars['Boolean']['input']>;
  is_coaching?: InputMaybe<Scalars['Boolean']['input']>;
  is_sub_module?: InputMaybe<Scalars['Boolean']['input']>;
  is_template?: InputMaybe<Scalars['Boolean']['input']>;
  modal?: InputMaybe<Scalars['ID']['input']>;
  module?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  programme_questions?: InputMaybe<Array<Scalars['ProgrammeTypeProgrammeQuestionsDynamicZoneInput']['input']>>;
  programme_submissions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  programme_type_instructions?: InputMaybe<Scalars['String']['input']>;
  programmes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  show_article?: InputMaybe<Scalars['Boolean']['input']>;
  show_participants?: InputMaybe<Scalars['Boolean']['input']>;
  show_session?: InputMaybe<Scalars['Boolean']['input']>;
  show_statistics?: InputMaybe<Scalars['Boolean']['input']>;
  sub_modules?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  type_form_collection?: InputMaybe<Scalars['ID']['input']>;
};

export type ProgrammeTypeProgrammeQuestionsDynamicZone = ComponentQuestionTypesCompetency | ComponentQuestionTypesCompetency2 | ComponentQuestionTypesFeedForward1 | ComponentQuestionTypesFeedForward2 | ComponentQuestionTypesGravitasGap | ComponentQuestionTypesGravitasScale | ComponentQuestionTypesGravitasSliders | ComponentQuestionTypesMultipleChoice | ComponentQuestionTypesNestedQuestions | ComponentQuestionTypesParticipant | ComponentQuestionTypesSaboteur | ComponentQuestionTypesSaboteurVideos | ComponentQuestionTypesSimpleQuestion | ComponentQuestionTypesSimpleReadOnly | ComponentQuestionTypesSliderQuestions | ComponentQuestionTypesStakeholderMap | ComponentQuestionTypesUploadQuestion | ComponentQuestionTypesValuesBubble | ComponentQuestionTypesValuesCharacters | ComponentQuestionTypesValuesGaps | ComponentQuestionTypesValuesNested | ComponentQuestionTypesValuesSliders | ComponentQuestionTypesXyGraph | Error;

export type ProgrammeTypeRelationResponseCollection = {
  __typename?: 'ProgrammeTypeRelationResponseCollection';
  nodes: Array<ProgrammeType>;
};

export type ProgrammeTypeReport = {
  __typename?: 'ProgrammeTypeReport';
  programmeName?: Maybe<Scalars['String']['output']>;
  programmeType?: Maybe<Scalars['String']['output']>;
  sections?: Maybe<Array<Maybe<SectionReport>>>;
};

export type Programmes = {
  __typename?: 'Programmes';
  articles?: Maybe<Array<Maybe<Article>>>;
  companies?: Maybe<Array<Maybe<Company>>>;
  completion?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<AdminUser>;
  description?: Maybe<Scalars['String']['output']>;
  emailLogs?: Maybe<Array<Maybe<EmailLog>>>;
  emailTemplates?: Maybe<Array<Maybe<EmailTemplate>>>;
  id: Scalars['ID']['output'];
  isCustomJourney?: Maybe<Scalars['Boolean']['output']>;
  isTemplate?: Maybe<Scalars['Boolean']['output']>;
  logo?: Maybe<UploadFile>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Array<Maybe<Notes>>>;
  position?: Maybe<Scalars['Int']['output']>;
  programmeSubmissions?: Maybe<Array<Maybe<ProgrammeSubmission>>>;
  programmeTitle?: Maybe<Scalars['String']['output']>;
  programmeTypes?: Maybe<Array<Maybe<ProgrammeType>>>;
  sendTypeform?: Maybe<Scalars['Boolean']['output']>;
  showTimeline?: Maybe<Scalars['Boolean']['output']>;
  start?: Maybe<Scalars['DateTime']['output']>;
  subModuleSubmissions?: Maybe<Array<Maybe<SubModuleSubmission>>>;
  three60FormId?: Maybe<Scalars['String']['output']>;
  typeFormCollection?: Maybe<TypeFormCollection>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<AdminUser>;
  users?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
  whatToExpect?: Maybe<Scalars['String']['output']>;
};


export type ProgrammesArticlesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type ProgrammesCompaniesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type ProgrammesEmailLogsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type ProgrammesEmailTemplatesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type ProgrammesNotesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type ProgrammesProgrammeSubmissionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type ProgrammesProgrammeTypesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type ProgrammesSubModuleSubmissionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};


export type ProgrammesUsersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['JSON']['input']>;
};

export enum PublicationFilter {
  HasPublishedVersion = 'HAS_PUBLISHED_VERSION',
  HasPublishedVersionDocument = 'HAS_PUBLISHED_VERSION_DOCUMENT',
  Modified = 'MODIFIED',
  NeverPublished = 'NEVER_PUBLISHED',
  NeverPublishedDocument = 'NEVER_PUBLISHED_DOCUMENT',
  PublishedWithoutDraft = 'PUBLISHED_WITHOUT_DRAFT',
  PublishedWithDraft = 'PUBLISHED_WITH_DRAFT',
  Unmodified = 'UNMODIFIED'
}

export enum PublicationStatus {
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type Query = {
  __typename?: 'Query';
  accountChange?: Maybe<AccountChange>;
  accountChanges: Array<Maybe<AccountChange>>;
  accountChanges_connection?: Maybe<AccountChangeEntityResponseCollection>;
  appointment?: Maybe<Appointment>;
  appointments: Array<Maybe<Appointment>>;
  appointments_connection?: Maybe<AppointmentEntityResponseCollection>;
  article?: Maybe<Article>;
  articles: Array<Maybe<Article>>;
  articles_connection?: Maybe<ArticleEntityResponseCollection>;
  auditTrail?: Maybe<AuditTrail>;
  auditTrails: Array<Maybe<AuditTrail>>;
  auditTrails_connection?: Maybe<AuditTrailEntityResponseCollection>;
  booking?: Maybe<Booking>;
  bookings: Array<Maybe<Booking>>;
  bookings_connection?: Maybe<BookingEntityResponseCollection>;
  checkResponsesFromTypeForm?: Maybe<Emails>;
  checkResponsesFromTypeFormProgramme?: Maybe<EmailsSent>;
  coach?: Maybe<Coach>;
  coachSession?: Maybe<CoachSession>;
  coachSessions: Array<Maybe<CoachSession>>;
  coachSessions_connection?: Maybe<CoachSessionEntityResponseCollection>;
  coachSubmittedReport?: Maybe<CoachSubmittedReport>;
  coachSubmittedReports: Array<Maybe<CoachSubmittedReport>>;
  coachSubmittedReports_connection?: Maybe<CoachSubmittedReportEntityResponseCollection>;
  coaches: Array<Maybe<Coach>>;
  coaches_connection?: Maybe<CoachEntityResponseCollection>;
  companies: Array<Maybe<Company>>;
  companies_connection?: Maybe<CompanyEntityResponseCollection>;
  company?: Maybe<Company>;
  competencyUrl?: Maybe<CompetencyUrl>;
  competencyUrls: Array<Maybe<CompetencyUrl>>;
  competencyUrls_connection?: Maybe<CompetencyUrlEntityResponseCollection>;
  division?: Maybe<Division>;
  divisions: Array<Maybe<Division>>;
  divisions_connection?: Maybe<DivisionEntityResponseCollection>;
  emailLog?: Maybe<EmailLog>;
  emailLogs: Array<Maybe<EmailLog>>;
  emailLogs_connection?: Maybe<EmailLogEntityResponseCollection>;
  emailTemplate?: Maybe<EmailTemplate>;
  emailTemplates: Array<Maybe<EmailTemplate>>;
  emailTemplates_connection?: Maybe<EmailTemplateEntityResponseCollection>;
  event?: Maybe<Event>;
  events: Array<Maybe<Event>>;
  events_connection?: Maybe<EventEntityResponseCollection>;
  feedfowardUrl?: Maybe<FeedfowardUrl>;
  feedfowardUrls: Array<Maybe<FeedfowardUrl>>;
  feedfowardUrls_connection?: Maybe<FeedfowardUrlEntityResponseCollection>;
  forwardedCard?: Maybe<ForwardedCard>;
  forwardedCards: Array<Maybe<ForwardedCard>>;
  forwardedCards_connection?: Maybe<ForwardedCardEntityResponseCollection>;
  generateMyMiniSectionSubmissionResponse?: Maybe<Array<Maybe<SubModuleSubmissionReport>>>;
  generateMySubModuleSubmissionResponses?: Maybe<Array<Maybe<SubModuleSubmissionReport>>>;
  getAllBookings?: Maybe<Array<EBooking>>;
  getAllEventTypes: Array<EventType>;
  getAllsectionReport?: Maybe<Array<Maybe<Report>>>;
  getFirstFourNotes?: Maybe<Array<Maybe<Notes>>>;
  getFirstTwelveArticles?: Maybe<Array<Maybe<Article>>>;
  getForwaredCards?: Maybe<Array<Maybe<ForwardedCard>>>;
  getMyAppointments: Array<Appointments>;
  getMyBookings?: Maybe<Array<EBooking>>;
  getMyProgrammeSubmissions?: Maybe<Array<Maybe<ProgrammeSubmission>>>;
  getMySubModuleSubmissions?: Maybe<Array<Maybe<SubModuleSubmission>>>;
  getMySubModuleSubmissionsReports?: Maybe<Array<Maybe<SubModuleSubmissionReport>>>;
  getMySubmissions?: Maybe<Array<Maybe<Submission>>>;
  getNewTypeformFeedResponses?: Maybe<CheckConfirmed>;
  getOrderedSubmissions?: Maybe<Array<Maybe<OrderedSubmissions>>>;
  getPostCards?: Maybe<Array<Maybe<PostCard>>>;
  getProgammeReportsGrouped?: Maybe<Array<Maybe<ReportsGrouped>>>;
  getReportsGrouped?: Maybe<Array<Maybe<ReportsGrouped>>>;
  getSectionReport: Report;
  getSubmissionReportGrouped?: Maybe<Array<Maybe<ReportsSubmissionGrouped>>>;
  getTypeformCompetencyResponses?: Maybe<CheckConfirmed>;
  i18NLocale?: Maybe<I18NLocale>;
  i18NLocales: Array<Maybe<I18NLocale>>;
  i18NLocales_connection?: Maybe<I18NLocaleEntityResponseCollection>;
  invite?: Maybe<Invite>;
  invites: Array<Maybe<Invite>>;
  invites_connection?: Maybe<InviteEntityResponseCollection>;
  language?: Maybe<Language>;
  languages: Array<Maybe<Language>>;
  languages_connection?: Maybe<LanguageEntityResponseCollection>;
  logo?: Maybe<Logo>;
  logos: Array<Maybe<Logo>>;
  logos_connection?: Maybe<LogoEntityResponseCollection>;
  me?: Maybe<UsersPermissionsMe>;
  modal?: Maybe<Modal>;
  modals: Array<Maybe<Modal>>;
  modals_connection?: Maybe<ModalEntityResponseCollection>;
  module?: Maybe<Module>;
  modules: Array<Maybe<Module>>;
  modules_connection?: Maybe<ModuleEntityResponseCollection>;
  note?: Maybe<Note>;
  notes: Array<Maybe<Note>>;
  notes_connection?: Maybe<NoteEntityResponseCollection>;
  notification?: Maybe<Notification>;
  notifications: Array<Maybe<Notification>>;
  notifications_connection?: Maybe<NotificationEntityResponseCollection>;
  participant?: Maybe<Participant>;
  participants: Array<Maybe<Participant>>;
  participants_connection?: Maybe<ParticipantEntityResponseCollection>;
  postCard?: Maybe<PostCard>;
  postCardImage?: Maybe<PostCardImage>;
  postCardImages: Array<Maybe<PostCardImage>>;
  postCardImages_connection?: Maybe<PostCardImageEntityResponseCollection>;
  postCardSentence?: Maybe<PostCardSentence>;
  postCardSentences: Array<Maybe<PostCardSentence>>;
  postCardSentences_connection?: Maybe<PostCardSentenceEntityResponseCollection>;
  postCards: Array<Maybe<PostCard>>;
  postCards_connection?: Maybe<PostCardEntityResponseCollection>;
  programme?: Maybe<Programme>;
  programmeReport?: Maybe<ProgrammeReport>;
  programmeReports: Array<Maybe<ProgrammeReport>>;
  programmeReports_connection?: Maybe<ProgrammeReportEntityResponseCollection>;
  programmeSubmission?: Maybe<ProgrammeSubmission>;
  programmeSubmissions: Array<Maybe<ProgrammeSubmission>>;
  programmeSubmissions_connection?: Maybe<ProgrammeSubmissionEntityResponseCollection>;
  programmeType?: Maybe<ProgrammeType>;
  programmeTypes: Array<Maybe<ProgrammeType>>;
  programmeTypes_connection?: Maybe<ProgrammeTypeEntityResponseCollection>;
  programmes: Array<Maybe<Programme>>;
  programmes_connection?: Maybe<ProgrammeEntityResponseCollection>;
  region?: Maybe<Region>;
  regions: Array<Maybe<Region>>;
  regions_connection?: Maybe<RegionEntityResponseCollection>;
  report?: Maybe<Report>;
  reports: Array<Maybe<Report>>;
  reports_connection?: Maybe<ReportEntityResponseCollection>;
  respondentsAnswer?: Maybe<RespondentsAnswer>;
  respondentsAnswers: Array<Maybe<RespondentsAnswer>>;
  respondentsAnswers_connection?: Maybe<RespondentsAnswerEntityResponseCollection>;
  reviewWorkflowsWorkflow?: Maybe<ReviewWorkflowsWorkflow>;
  reviewWorkflowsWorkflowStage?: Maybe<ReviewWorkflowsWorkflowStage>;
  reviewWorkflowsWorkflowStages: Array<Maybe<ReviewWorkflowsWorkflowStage>>;
  reviewWorkflowsWorkflowStages_connection?: Maybe<ReviewWorkflowsWorkflowStageEntityResponseCollection>;
  reviewWorkflowsWorkflows: Array<Maybe<ReviewWorkflowsWorkflow>>;
  reviewWorkflowsWorkflows_connection?: Maybe<ReviewWorkflowsWorkflowEntityResponseCollection>;
  section?: Maybe<Section>;
  sections: Array<Maybe<Section>>;
  sections_connection?: Maybe<SectionEntityResponseCollection>;
  subModule?: Maybe<SubModule>;
  subModuleSubmission?: Maybe<SubModuleSubmission>;
  subModuleSubmissions: Array<Maybe<SubModuleSubmission>>;
  subModuleSubmissions_connection?: Maybe<SubModuleSubmissionEntityResponseCollection>;
  subModules: Array<Maybe<SubModule>>;
  subModules_connection?: Maybe<SubModuleEntityResponseCollection>;
  submission?: Maybe<Submission>;
  submissions: Array<Maybe<Submission>>;
  submissions_connection?: Maybe<SubmissionEntityResponseCollection>;
  submoduleReport?: Maybe<SubmoduleReport>;
  submoduleReports: Array<Maybe<SubmoduleReport>>;
  submoduleReports_connection?: Maybe<SubmoduleReportEntityResponseCollection>;
  surveyReport?: Maybe<SurveyReport>;
  surveyReports: Array<Maybe<SurveyReport>>;
  surveyReports_connection?: Maybe<SurveyReportEntityResponseCollection>;
  translation?: Maybe<Translation>;
  typeFormCollection?: Maybe<TypeFormCollection>;
  typeFormCollections: Array<Maybe<TypeFormCollection>>;
  typeFormCollections_connection?: Maybe<TypeFormCollectionEntityResponseCollection>;
  uploadFile?: Maybe<UploadFile>;
  uploadFiles: Array<Maybe<UploadFile>>;
  uploadFiles_connection?: Maybe<UploadFileEntityResponseCollection>;
  uploadedReport?: Maybe<UploadedReport>;
  uploadedReports: Array<Maybe<UploadedReport>>;
  uploadedReports_connection?: Maybe<UploadedReportEntityResponseCollection>;
  userUploadedDocument?: Maybe<UserUploadedDocument>;
  userUploadedDocuments: Array<Maybe<UserUploadedDocument>>;
  userUploadedDocuments_connection?: Maybe<UserUploadedDocumentEntityResponseCollection>;
  usersPermissionsRole?: Maybe<UsersPermissionsRole>;
  usersPermissionsRoles: Array<Maybe<UsersPermissionsRole>>;
  usersPermissionsRoles_connection?: Maybe<UsersPermissionsRoleEntityResponseCollection>;
  usersPermissionsUser?: Maybe<UsersPermissionsUser>;
  usersPermissionsUsers: Array<Maybe<UsersPermissionsUser>>;
  usersPermissionsUsers_connection?: Maybe<UsersPermissionsUserEntityResponseCollection>;
};


export type QueryAccountChangeArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryAccountChangesArgs = {
  filters?: InputMaybe<AccountChangeFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryAccountChanges_ConnectionArgs = {
  filters?: InputMaybe<AccountChangeFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryAppointmentArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryAppointmentsArgs = {
  filters?: InputMaybe<AppointmentFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryAppointments_ConnectionArgs = {
  filters?: InputMaybe<AppointmentFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryArticleArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryArticlesArgs = {
  filters?: InputMaybe<ArticleFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryArticles_ConnectionArgs = {
  filters?: InputMaybe<ArticleFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryAuditTrailArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryAuditTrailsArgs = {
  filters?: InputMaybe<AuditTrailFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryAuditTrails_ConnectionArgs = {
  filters?: InputMaybe<AuditTrailFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryBookingArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryBookingsArgs = {
  filters?: InputMaybe<BookingFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryBookings_ConnectionArgs = {
  filters?: InputMaybe<BookingFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCheckResponsesFromTypeFormArgs = {
  id: Scalars['ID']['input'];
  sectionid?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCheckResponsesFromTypeFormProgrammeArgs = {
  id: Scalars['ID']['input'];
  sectionid?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCoachArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCoachSessionArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCoachSessionsArgs = {
  filters?: InputMaybe<CoachSessionFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCoachSessions_ConnectionArgs = {
  filters?: InputMaybe<CoachSessionFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCoachSubmittedReportArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCoachSubmittedReportsArgs = {
  filters?: InputMaybe<CoachSubmittedReportFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCoachSubmittedReports_ConnectionArgs = {
  filters?: InputMaybe<CoachSubmittedReportFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCoachesArgs = {
  filters?: InputMaybe<CoachFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCoaches_ConnectionArgs = {
  filters?: InputMaybe<CoachFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCompaniesArgs = {
  filters?: InputMaybe<CompanyFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCompanies_ConnectionArgs = {
  filters?: InputMaybe<CompanyFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCompanyArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCompetencyUrlArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCompetencyUrlsArgs = {
  filters?: InputMaybe<CompetencyUrlFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCompetencyUrls_ConnectionArgs = {
  filters?: InputMaybe<CompetencyUrlFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryDivisionArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryDivisionsArgs = {
  filters?: InputMaybe<DivisionFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryDivisions_ConnectionArgs = {
  filters?: InputMaybe<DivisionFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryEmailLogArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryEmailLogsArgs = {
  filters?: InputMaybe<EmailLogFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryEmailLogs_ConnectionArgs = {
  filters?: InputMaybe<EmailLogFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryEmailTemplateArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryEmailTemplatesArgs = {
  filters?: InputMaybe<EmailTemplateFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryEmailTemplates_ConnectionArgs = {
  filters?: InputMaybe<EmailTemplateFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryEventArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryEventsArgs = {
  filters?: InputMaybe<EventFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryEvents_ConnectionArgs = {
  filters?: InputMaybe<EventFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryFeedfowardUrlArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryFeedfowardUrlsArgs = {
  filters?: InputMaybe<FeedfowardUrlFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryFeedfowardUrls_ConnectionArgs = {
  filters?: InputMaybe<FeedfowardUrlFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryForwardedCardArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryForwardedCardsArgs = {
  filters?: InputMaybe<ForwardedCardFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryForwardedCards_ConnectionArgs = {
  filters?: InputMaybe<ForwardedCardFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryGetAllsectionReportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetMyAppointmentsArgs = {
  appointmentScheduleId: Scalars['ID']['input'];
};


export type QueryGetOrderedSubmissionsArgs = {
  programme: Scalars['ID']['input'];
};


export type QueryGetSectionReportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryI18NLocaleArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryI18NLocalesArgs = {
  filters?: InputMaybe<I18NLocaleFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryI18NLocales_ConnectionArgs = {
  filters?: InputMaybe<I18NLocaleFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryInviteArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryInvitesArgs = {
  filters?: InputMaybe<InviteFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryInvites_ConnectionArgs = {
  filters?: InputMaybe<InviteFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLanguageArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLanguagesArgs = {
  filters?: InputMaybe<LanguageFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLanguages_ConnectionArgs = {
  filters?: InputMaybe<LanguageFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLogoArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLogosArgs = {
  filters?: InputMaybe<LogoFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLogos_ConnectionArgs = {
  filters?: InputMaybe<LogoFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryModalArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryModalsArgs = {
  filters?: InputMaybe<ModalFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryModals_ConnectionArgs = {
  filters?: InputMaybe<ModalFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryModuleArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryModulesArgs = {
  filters?: InputMaybe<ModuleFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryModules_ConnectionArgs = {
  filters?: InputMaybe<ModuleFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryNoteArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryNotesArgs = {
  filters?: InputMaybe<NoteFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryNotes_ConnectionArgs = {
  filters?: InputMaybe<NoteFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryNotificationArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryNotificationsArgs = {
  filters?: InputMaybe<NotificationFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryNotifications_ConnectionArgs = {
  filters?: InputMaybe<NotificationFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryParticipantArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryParticipantsArgs = {
  filters?: InputMaybe<ParticipantFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryParticipants_ConnectionArgs = {
  filters?: InputMaybe<ParticipantFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryPostCardArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryPostCardImageArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryPostCardImagesArgs = {
  filters?: InputMaybe<PostCardImageFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryPostCardImages_ConnectionArgs = {
  filters?: InputMaybe<PostCardImageFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryPostCardSentenceArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryPostCardSentencesArgs = {
  filters?: InputMaybe<PostCardSentenceFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryPostCardSentences_ConnectionArgs = {
  filters?: InputMaybe<PostCardSentenceFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryPostCardsArgs = {
  filters?: InputMaybe<PostCardFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryPostCards_ConnectionArgs = {
  filters?: InputMaybe<PostCardFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryProgrammeArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryProgrammeReportArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryProgrammeReportsArgs = {
  filters?: InputMaybe<ProgrammeReportFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryProgrammeReports_ConnectionArgs = {
  filters?: InputMaybe<ProgrammeReportFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryProgrammeSubmissionArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryProgrammeSubmissionsArgs = {
  filters?: InputMaybe<ProgrammeSubmissionFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryProgrammeSubmissions_ConnectionArgs = {
  filters?: InputMaybe<ProgrammeSubmissionFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryProgrammeTypeArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryProgrammeTypesArgs = {
  filters?: InputMaybe<ProgrammeTypeFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryProgrammeTypes_ConnectionArgs = {
  filters?: InputMaybe<ProgrammeTypeFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryProgrammesArgs = {
  filters?: InputMaybe<ProgrammeFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryProgrammes_ConnectionArgs = {
  filters?: InputMaybe<ProgrammeFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryRegionArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryRegionsArgs = {
  filters?: InputMaybe<RegionFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryRegions_ConnectionArgs = {
  filters?: InputMaybe<RegionFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryReportArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryReportsArgs = {
  filters?: InputMaybe<ReportFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryReports_ConnectionArgs = {
  filters?: InputMaybe<ReportFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryRespondentsAnswerArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryRespondentsAnswersArgs = {
  filters?: InputMaybe<RespondentsAnswerFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryRespondentsAnswers_ConnectionArgs = {
  filters?: InputMaybe<RespondentsAnswerFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryReviewWorkflowsWorkflowArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryReviewWorkflowsWorkflowStageArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryReviewWorkflowsWorkflowStagesArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryReviewWorkflowsWorkflowStages_ConnectionArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryReviewWorkflowsWorkflowsArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryReviewWorkflowsWorkflows_ConnectionArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QuerySectionArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QuerySectionsArgs = {
  filters?: InputMaybe<SectionFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QuerySections_ConnectionArgs = {
  filters?: InputMaybe<SectionFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QuerySubModuleArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QuerySubModuleSubmissionArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QuerySubModuleSubmissionsArgs = {
  filters?: InputMaybe<SubModuleSubmissionFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QuerySubModuleSubmissions_ConnectionArgs = {
  filters?: InputMaybe<SubModuleSubmissionFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QuerySubModulesArgs = {
  filters?: InputMaybe<SubModuleFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QuerySubModules_ConnectionArgs = {
  filters?: InputMaybe<SubModuleFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QuerySubmissionArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QuerySubmissionsArgs = {
  filters?: InputMaybe<SubmissionFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QuerySubmissions_ConnectionArgs = {
  filters?: InputMaybe<SubmissionFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QuerySubmoduleReportArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QuerySubmoduleReportsArgs = {
  filters?: InputMaybe<SubmoduleReportFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QuerySubmoduleReports_ConnectionArgs = {
  filters?: InputMaybe<SubmoduleReportFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QuerySurveyReportArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QuerySurveyReportsArgs = {
  filters?: InputMaybe<SurveyReportFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QuerySurveyReports_ConnectionArgs = {
  filters?: InputMaybe<SurveyReportFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryTranslationArgs = {
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryTypeFormCollectionArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryTypeFormCollectionsArgs = {
  filters?: InputMaybe<TypeFormCollectionFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryTypeFormCollections_ConnectionArgs = {
  filters?: InputMaybe<TypeFormCollectionFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUploadFileArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUploadFilesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUploadFiles_ConnectionArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUploadedReportArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUploadedReportsArgs = {
  filters?: InputMaybe<UploadedReportFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUploadedReports_ConnectionArgs = {
  filters?: InputMaybe<UploadedReportFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUserUploadedDocumentArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUserUploadedDocumentsArgs = {
  filters?: InputMaybe<UserUploadedDocumentFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUserUploadedDocuments_ConnectionArgs = {
  filters?: InputMaybe<UserUploadedDocumentFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUsersPermissionsRoleArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUsersPermissionsRolesArgs = {
  filters?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUsersPermissionsRoles_ConnectionArgs = {
  filters?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUsersPermissionsUserArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUsersPermissionsUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUsersPermissionsUsers_ConnectionArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type Region = {
  __typename?: 'Region';
  companies: Array<Maybe<Company>>;
  companies_connection?: Maybe<CompanyRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  name_english?: Maybe<Scalars['String']['output']>;
  name_french?: Maybe<Scalars['String']['output']>;
  name_german?: Maybe<Scalars['String']['output']>;
  name_mandarin?: Maybe<Scalars['String']['output']>;
  name_spanish?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  users: Array<Maybe<UsersPermissionsUser>>;
  users_connection?: Maybe<UsersPermissionsUserRelationResponseCollection>;
};


export type RegionCompaniesArgs = {
  filters?: InputMaybe<CompanyFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type RegionCompanies_ConnectionArgs = {
  filters?: InputMaybe<CompanyFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type RegionUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type RegionUsers_ConnectionArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type RegionEntityResponseCollection = {
  __typename?: 'RegionEntityResponseCollection';
  nodes: Array<Region>;
  pageInfo: Pagination;
};

export type RegionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<RegionFiltersInput>>>;
  companies?: InputMaybe<CompanyFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name_english?: InputMaybe<StringFilterInput>;
  name_french?: InputMaybe<StringFilterInput>;
  name_german?: InputMaybe<StringFilterInput>;
  name_mandarin?: InputMaybe<StringFilterInput>;
  name_spanish?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<RegionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<RegionFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  users?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type RegionInput = {
  companies?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name_english?: InputMaybe<Scalars['String']['input']>;
  name_french?: InputMaybe<Scalars['String']['input']>;
  name_german?: InputMaybe<Scalars['String']['input']>;
  name_mandarin?: InputMaybe<Scalars['String']['input']>;
  name_spanish?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type RegionRelationResponseCollection = {
  __typename?: 'RegionRelationResponseCollection';
  nodes: Array<Region>;
};

export type Report = {
  __typename?: 'Report';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  notification?: Maybe<Notification>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  report?: Maybe<UploadFile>;
  section_or_module_id?: Maybe<Scalars['String']['output']>;
  sub_module_submission?: Maybe<SubModuleSubmission>;
  submission?: Maybe<Submission>;
  type?: Maybe<Enum_Report_Type>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ReportDetail = {
  __typename?: 'ReportDetail';
  id: Scalars['ID']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type ReportEntityResponseCollection = {
  __typename?: 'ReportEntityResponseCollection';
  nodes: Array<Report>;
  pageInfo: Pagination;
};

export type ReportFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ReportFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ReportFiltersInput>;
  notification?: InputMaybe<NotificationFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ReportFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  section_or_module_id?: InputMaybe<StringFilterInput>;
  sub_module_submission?: InputMaybe<SubModuleSubmissionFiltersInput>;
  submission?: InputMaybe<SubmissionFiltersInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ReportInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  notification?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  report?: InputMaybe<Scalars['ID']['input']>;
  section_or_module_id?: InputMaybe<Scalars['String']['input']>;
  sub_module_submission?: InputMaybe<Scalars['ID']['input']>;
  submission?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<Enum_Report_Type>;
};

export type ReportRelationResponseCollection = {
  __typename?: 'ReportRelationResponseCollection';
  nodes: Array<Report>;
};

export type ReportsGrouped = {
  __typename?: 'ReportsGrouped';
  companyName: Scalars['String']['output'];
  programmeType?: Maybe<Array<Maybe<ProgrammeTypeReport>>>;
};

export type ReportsSubmissionGrouped = {
  __typename?: 'ReportsSubmissionGrouped';
  createdBy?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notification?: Maybe<Scalars['String']['output']>;
  programmeType?: Maybe<Scalars['String']['output']>;
  report?: Maybe<ReportDetail>;
  sectionOrModuleId?: Maybe<Scalars['String']['output']>;
  subModuleSubmission?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['Int']['output']>;
};

export type RespondentsAnswer = {
  __typename?: 'RespondentsAnswer';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  email?: Maybe<Scalars['String']['output']>;
  form_id?: Maybe<Scalars['String']['output']>;
  programme_submission?: Maybe<ProgrammeSubmission>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  section_id?: Maybe<Scalars['String']['output']>;
  sub_module_submission?: Maybe<SubModuleSubmission>;
  submission?: Maybe<Submission>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<UsersPermissionsUser>;
};

export type RespondentsAnswerEntityResponseCollection = {
  __typename?: 'RespondentsAnswerEntityResponseCollection';
  nodes: Array<RespondentsAnswer>;
  pageInfo: Pagination;
};

export type RespondentsAnswerFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<RespondentsAnswerFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  form_id?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<RespondentsAnswerFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<RespondentsAnswerFiltersInput>>>;
  programme_submission?: InputMaybe<ProgrammeSubmissionFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  section_id?: InputMaybe<StringFilterInput>;
  sub_module_submission?: InputMaybe<SubModuleSubmissionFiltersInput>;
  submission?: InputMaybe<SubmissionFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  user?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type RespondentsAnswerInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  form_id?: InputMaybe<Scalars['String']['input']>;
  programme_submission?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  section_id?: InputMaybe<Scalars['String']['input']>;
  sub_module_submission?: InputMaybe<Scalars['ID']['input']>;
  submission?: InputMaybe<Scalars['ID']['input']>;
  user?: InputMaybe<Scalars['ID']['input']>;
};

export type RespondentsAnswerRelationResponseCollection = {
  __typename?: 'RespondentsAnswerRelationResponseCollection';
  nodes: Array<RespondentsAnswer>;
};

export type ReviewWorkflowsWorkflow = {
  __typename?: 'ReviewWorkflowsWorkflow';
  contentTypes: Scalars['JSON']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  stageRequiredToPublish?: Maybe<ReviewWorkflowsWorkflowStage>;
  stages: Array<Maybe<ReviewWorkflowsWorkflowStage>>;
  stages_connection?: Maybe<ReviewWorkflowsWorkflowStageRelationResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ReviewWorkflowsWorkflowStagesArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ReviewWorkflowsWorkflowStages_ConnectionArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ReviewWorkflowsWorkflowEntityResponseCollection = {
  __typename?: 'ReviewWorkflowsWorkflowEntityResponseCollection';
  nodes: Array<ReviewWorkflowsWorkflow>;
  pageInfo: Pagination;
};

export type ReviewWorkflowsWorkflowFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ReviewWorkflowsWorkflowFiltersInput>>>;
  contentTypes?: InputMaybe<JsonFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ReviewWorkflowsWorkflowFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ReviewWorkflowsWorkflowFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  stageRequiredToPublish?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  stages?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ReviewWorkflowsWorkflowInput = {
  contentTypes?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  stageRequiredToPublish?: InputMaybe<Scalars['ID']['input']>;
  stages?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type ReviewWorkflowsWorkflowStage = {
  __typename?: 'ReviewWorkflowsWorkflowStage';
  color?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  workflow?: Maybe<ReviewWorkflowsWorkflow>;
};

export type ReviewWorkflowsWorkflowStageEntityResponseCollection = {
  __typename?: 'ReviewWorkflowsWorkflowStageEntityResponseCollection';
  nodes: Array<ReviewWorkflowsWorkflowStage>;
  pageInfo: Pagination;
};

export type ReviewWorkflowsWorkflowStageFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>>>;
  color?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  workflow?: InputMaybe<ReviewWorkflowsWorkflowFiltersInput>;
};

export type ReviewWorkflowsWorkflowStageInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workflow?: InputMaybe<Scalars['ID']['input']>;
};

export type ReviewWorkflowsWorkflowStageRelationResponseCollection = {
  __typename?: 'ReviewWorkflowsWorkflowStageRelationResponseCollection';
  nodes: Array<ReviewWorkflowsWorkflowStage>;
};

export type Section = {
  __typename?: 'Section';
  archive?: Maybe<Scalars['Boolean']['output']>;
  competency_survey?: Maybe<Scalars['Boolean']['output']>;
  cover?: Maybe<UploadFile>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  email_template?: Maybe<EmailTemplate>;
  events: Array<Maybe<Event>>;
  events_connection?: Maybe<EventRelationResponseCollection>;
  feed_forward_survey?: Maybe<Scalars['Boolean']['output']>;
  get_started_text?: Maybe<Scalars['String']['output']>;
  instructions_text?: Maybe<Scalars['String']['output']>;
  is_coaching?: Maybe<Scalars['Boolean']['output']>;
  is_template?: Maybe<Scalars['Boolean']['output']>;
  module?: Maybe<Module>;
  notes?: Maybe<Scalars['Boolean']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  questions?: Maybe<Array<Maybe<SectionQuestionsDynamicZone>>>;
  send_type_form?: Maybe<Scalars['Boolean']['output']>;
  show_participants?: Maybe<Scalars['Boolean']['output']>;
  show_session?: Maybe<Scalars['Boolean']['output']>;
  sub_module?: Maybe<SubModule>;
  sub_title_english?: Maybe<Scalars['String']['output']>;
  sub_title_french?: Maybe<Scalars['String']['output']>;
  sub_title_german?: Maybe<Scalars['String']['output']>;
  sub_title_mandarin?: Maybe<Scalars['String']['output']>;
  sub_title_spanish?: Maybe<Scalars['String']['output']>;
  title_english?: Maybe<Scalars['String']['output']>;
  title_french?: Maybe<Scalars['String']['output']>;
  title_german?: Maybe<Scalars['String']['output']>;
  title_mandarin?: Maybe<Scalars['String']['output']>;
  title_spanish?: Maybe<Scalars['String']['output']>;
  type_form_collection?: Maybe<TypeFormCollection>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  video_english?: Maybe<UploadFile>;
  video_french?: Maybe<UploadFile>;
  video_german?: Maybe<UploadFile>;
  video_mandarin?: Maybe<UploadFile>;
  video_spanish?: Maybe<UploadFile>;
};


export type SectionEventsArgs = {
  filters?: InputMaybe<EventFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SectionEvents_ConnectionArgs = {
  filters?: InputMaybe<EventFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SectionEntityResponseCollection = {
  __typename?: 'SectionEntityResponseCollection';
  nodes: Array<Section>;
  pageInfo: Pagination;
};

export type SectionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<SectionFiltersInput>>>;
  archive?: InputMaybe<BooleanFilterInput>;
  competency_survey?: InputMaybe<BooleanFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  email_template?: InputMaybe<EmailTemplateFiltersInput>;
  events?: InputMaybe<EventFiltersInput>;
  feed_forward_survey?: InputMaybe<BooleanFilterInput>;
  get_started_text?: InputMaybe<StringFilterInput>;
  instructions_text?: InputMaybe<StringFilterInput>;
  is_coaching?: InputMaybe<BooleanFilterInput>;
  is_template?: InputMaybe<BooleanFilterInput>;
  module?: InputMaybe<ModuleFiltersInput>;
  not?: InputMaybe<SectionFiltersInput>;
  notes?: InputMaybe<BooleanFilterInput>;
  or?: InputMaybe<Array<InputMaybe<SectionFiltersInput>>>;
  position?: InputMaybe<IntFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  send_type_form?: InputMaybe<BooleanFilterInput>;
  show_participants?: InputMaybe<BooleanFilterInput>;
  show_session?: InputMaybe<BooleanFilterInput>;
  sub_module?: InputMaybe<SubModuleFiltersInput>;
  sub_title_english?: InputMaybe<StringFilterInput>;
  sub_title_french?: InputMaybe<StringFilterInput>;
  sub_title_german?: InputMaybe<StringFilterInput>;
  sub_title_mandarin?: InputMaybe<StringFilterInput>;
  sub_title_spanish?: InputMaybe<StringFilterInput>;
  title_english?: InputMaybe<StringFilterInput>;
  title_french?: InputMaybe<StringFilterInput>;
  title_german?: InputMaybe<StringFilterInput>;
  title_mandarin?: InputMaybe<StringFilterInput>;
  title_spanish?: InputMaybe<StringFilterInput>;
  type_form_collection?: InputMaybe<TypeFormCollectionFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type SectionInput = {
  archive?: InputMaybe<Scalars['Boolean']['input']>;
  competency_survey?: InputMaybe<Scalars['Boolean']['input']>;
  cover?: InputMaybe<Scalars['ID']['input']>;
  email_template?: InputMaybe<Scalars['ID']['input']>;
  events?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  feed_forward_survey?: InputMaybe<Scalars['Boolean']['input']>;
  get_started_text?: InputMaybe<Scalars['String']['input']>;
  instructions_text?: InputMaybe<Scalars['String']['input']>;
  is_coaching?: InputMaybe<Scalars['Boolean']['input']>;
  is_template?: InputMaybe<Scalars['Boolean']['input']>;
  module?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  questions?: InputMaybe<Array<Scalars['SectionQuestionsDynamicZoneInput']['input']>>;
  send_type_form?: InputMaybe<Scalars['Boolean']['input']>;
  show_participants?: InputMaybe<Scalars['Boolean']['input']>;
  show_session?: InputMaybe<Scalars['Boolean']['input']>;
  sub_module?: InputMaybe<Scalars['ID']['input']>;
  sub_title_english?: InputMaybe<Scalars['String']['input']>;
  sub_title_french?: InputMaybe<Scalars['String']['input']>;
  sub_title_german?: InputMaybe<Scalars['String']['input']>;
  sub_title_mandarin?: InputMaybe<Scalars['String']['input']>;
  sub_title_spanish?: InputMaybe<Scalars['String']['input']>;
  title_english?: InputMaybe<Scalars['String']['input']>;
  title_french?: InputMaybe<Scalars['String']['input']>;
  title_german?: InputMaybe<Scalars['String']['input']>;
  title_mandarin?: InputMaybe<Scalars['String']['input']>;
  title_spanish?: InputMaybe<Scalars['String']['input']>;
  type_form_collection?: InputMaybe<Scalars['ID']['input']>;
  video_english?: InputMaybe<Scalars['ID']['input']>;
  video_french?: InputMaybe<Scalars['ID']['input']>;
  video_german?: InputMaybe<Scalars['ID']['input']>;
  video_mandarin?: InputMaybe<Scalars['ID']['input']>;
  video_spanish?: InputMaybe<Scalars['ID']['input']>;
};

export type SectionQuestionsDynamicZone = ComponentQuestionTypesCompetency | ComponentQuestionTypesCompetency2 | ComponentQuestionTypesFeedForward1 | ComponentQuestionTypesFeedForward2 | ComponentQuestionTypesGravitasGap | ComponentQuestionTypesGravitasScale | ComponentQuestionTypesGravitasSliders | ComponentQuestionTypesMultipleChoice | ComponentQuestionTypesNestedQuestions | ComponentQuestionTypesParticipant | ComponentQuestionTypesSaboteur | ComponentQuestionTypesSaboteurVideos | ComponentQuestionTypesSimpleQuestion | ComponentQuestionTypesSimpleReadOnly | ComponentQuestionTypesSliderQuestions | ComponentQuestionTypesStakeholderMap | ComponentQuestionTypesUploadDocuments | ComponentQuestionTypesUploadQuestion | ComponentQuestionTypesValuesBubble | ComponentQuestionTypesValuesCharacters | ComponentQuestionTypesValuesGaps | ComponentQuestionTypesValuesNested | ComponentQuestionTypesValuesSliders | ComponentQuestionTypesXyGraph | Error;

export type SectionRelationResponseCollection = {
  __typename?: 'SectionRelationResponseCollection';
  nodes: Array<Section>;
};

export type SectionReport = {
  __typename?: 'SectionReport';
  name?: Maybe<Scalars['String']['output']>;
  programmeName?: Maybe<Scalars['String']['output']>;
  programmeType?: Maybe<Scalars['String']['output']>;
  report?: Maybe<ReportDetail>;
};

export type StringFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  containsi?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  eqi?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nei?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<StringFilterInput>;
  notContains?: InputMaybe<Scalars['String']['input']>;
  notContainsi?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type SubModule = {
  __typename?: 'SubModule';
  cover?: Maybe<UploadFile>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description_english?: Maybe<Scalars['String']['output']>;
  description_french?: Maybe<Scalars['String']['output']>;
  description_german?: Maybe<Scalars['String']['output']>;
  description_mandarin?: Maybe<Scalars['String']['output']>;
  description_spanish?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name_english?: Maybe<Scalars['String']['output']>;
  name_french?: Maybe<Scalars['String']['output']>;
  name_german?: Maybe<Scalars['String']['output']>;
  name_mandarin?: Maybe<Scalars['String']['output']>;
  name_spanish?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  programme_type?: Maybe<ProgrammeType>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  sections: Array<Maybe<Section>>;
  sections_connection?: Maybe<SectionRelationResponseCollection>;
  sub_module_submissions: Array<Maybe<SubModuleSubmission>>;
  sub_module_submissions_connection?: Maybe<SubModuleSubmissionRelationResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type SubModuleSectionsArgs = {
  filters?: InputMaybe<SectionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SubModuleSections_ConnectionArgs = {
  filters?: InputMaybe<SectionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SubModuleSub_Module_SubmissionsArgs = {
  filters?: InputMaybe<SubModuleSubmissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SubModuleSub_Module_Submissions_ConnectionArgs = {
  filters?: InputMaybe<SubModuleSubmissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SubModuleEntityResponseCollection = {
  __typename?: 'SubModuleEntityResponseCollection';
  nodes: Array<SubModule>;
  pageInfo: Pagination;
};

export type SubModuleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<SubModuleFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description_english?: InputMaybe<StringFilterInput>;
  description_french?: InputMaybe<StringFilterInput>;
  description_german?: InputMaybe<StringFilterInput>;
  description_mandarin?: InputMaybe<StringFilterInput>;
  description_spanish?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name_english?: InputMaybe<StringFilterInput>;
  name_french?: InputMaybe<StringFilterInput>;
  name_german?: InputMaybe<StringFilterInput>;
  name_mandarin?: InputMaybe<StringFilterInput>;
  name_spanish?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<SubModuleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<SubModuleFiltersInput>>>;
  position?: InputMaybe<IntFilterInput>;
  programme_type?: InputMaybe<ProgrammeTypeFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  sections?: InputMaybe<SectionFiltersInput>;
  sub_module_submissions?: InputMaybe<SubModuleSubmissionFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type SubModuleInput = {
  cover?: InputMaybe<Scalars['ID']['input']>;
  description_english?: InputMaybe<Scalars['String']['input']>;
  description_french?: InputMaybe<Scalars['String']['input']>;
  description_german?: InputMaybe<Scalars['String']['input']>;
  description_mandarin?: InputMaybe<Scalars['String']['input']>;
  description_spanish?: InputMaybe<Scalars['String']['input']>;
  name_english?: InputMaybe<Scalars['String']['input']>;
  name_french?: InputMaybe<Scalars['String']['input']>;
  name_german?: InputMaybe<Scalars['String']['input']>;
  name_mandarin?: InputMaybe<Scalars['String']['input']>;
  name_spanish?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  programme_type?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  sections?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  sub_module_submissions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type SubModuleRelationResponseCollection = {
  __typename?: 'SubModuleRelationResponseCollection';
  nodes: Array<SubModule>;
};

export type SubModuleSubmission = {
  __typename?: 'SubModuleSubmission';
  coach_sessions: Array<Maybe<CoachSession>>;
  coach_sessions_connection?: Maybe<CoachSessionRelationResponseCollection>;
  competency_participants?: Maybe<Array<Maybe<ComponentSubmissionsCompetencyParticipants>>>;
  competency_url?: Maybe<CompetencyUrl>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  feedfoward_url?: Maybe<FeedfowardUrl>;
  id: Scalars['ID']['output'];
  language?: Maybe<Language>;
  notes: Array<Maybe<Note>>;
  notes_connection?: Maybe<NoteRelationResponseCollection>;
  participants: Array<Maybe<Participant>>;
  participants_connection?: Maybe<ParticipantRelationResponseCollection>;
  programme?: Maybe<Programme>;
  programme_typeForm?: Maybe<Scalars['Boolean']['output']>;
  progress?: Maybe<Scalars['Int']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  reports: Array<Maybe<Report>>;
  reports_connection?: Maybe<ReportRelationResponseCollection>;
  respondents_answers: Array<Maybe<RespondentsAnswer>>;
  respondents_answers_connection?: Maybe<RespondentsAnswerRelationResponseCollection>;
  section?: Maybe<Array<Maybe<ComponentSubmissionsSectionSubmission>>>;
  section_typeform?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Enum_Submodulesubmission_Status>;
  sub_module?: Maybe<SubModule>;
  submission_participants?: Maybe<Array<Maybe<ComponentSubmissionsParticipants>>>;
  three_60_survey_form_id?: Maybe<Scalars['String']['output']>;
  time_spent?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uploaded_reports: Array<Maybe<UploadedReport>>;
  uploaded_reports_connection?: Maybe<UploadedReportRelationResponseCollection>;
  user?: Maybe<UsersPermissionsUser>;
  view?: Maybe<Scalars['Int']['output']>;
};


export type SubModuleSubmissionCoach_SessionsArgs = {
  filters?: InputMaybe<CoachSessionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SubModuleSubmissionCoach_Sessions_ConnectionArgs = {
  filters?: InputMaybe<CoachSessionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SubModuleSubmissionCompetency_ParticipantsArgs = {
  filters?: InputMaybe<ComponentSubmissionsCompetencyParticipantsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SubModuleSubmissionNotesArgs = {
  filters?: InputMaybe<NoteFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SubModuleSubmissionNotes_ConnectionArgs = {
  filters?: InputMaybe<NoteFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SubModuleSubmissionParticipantsArgs = {
  filters?: InputMaybe<ParticipantFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SubModuleSubmissionParticipants_ConnectionArgs = {
  filters?: InputMaybe<ParticipantFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SubModuleSubmissionReportsArgs = {
  filters?: InputMaybe<ReportFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SubModuleSubmissionReports_ConnectionArgs = {
  filters?: InputMaybe<ReportFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SubModuleSubmissionRespondents_AnswersArgs = {
  filters?: InputMaybe<RespondentsAnswerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SubModuleSubmissionRespondents_Answers_ConnectionArgs = {
  filters?: InputMaybe<RespondentsAnswerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SubModuleSubmissionSectionArgs = {
  filters?: InputMaybe<ComponentSubmissionsSectionSubmissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SubModuleSubmissionSubmission_ParticipantsArgs = {
  filters?: InputMaybe<ComponentSubmissionsParticipantsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SubModuleSubmissionUploaded_ReportsArgs = {
  filters?: InputMaybe<UploadedReportFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SubModuleSubmissionUploaded_Reports_ConnectionArgs = {
  filters?: InputMaybe<UploadedReportFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SubModuleSubmissionEntityResponseCollection = {
  __typename?: 'SubModuleSubmissionEntityResponseCollection';
  nodes: Array<SubModuleSubmission>;
  pageInfo: Pagination;
};

export type SubModuleSubmissionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<SubModuleSubmissionFiltersInput>>>;
  coach_sessions?: InputMaybe<CoachSessionFiltersInput>;
  competency_participants?: InputMaybe<ComponentSubmissionsCompetencyParticipantsFiltersInput>;
  competency_url?: InputMaybe<CompetencyUrlFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  feedfoward_url?: InputMaybe<FeedfowardUrlFiltersInput>;
  language?: InputMaybe<LanguageFiltersInput>;
  not?: InputMaybe<SubModuleSubmissionFiltersInput>;
  notes?: InputMaybe<NoteFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<SubModuleSubmissionFiltersInput>>>;
  participants?: InputMaybe<ParticipantFiltersInput>;
  programme?: InputMaybe<ProgrammeFiltersInput>;
  programme_typeForm?: InputMaybe<BooleanFilterInput>;
  progress?: InputMaybe<IntFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  reports?: InputMaybe<ReportFiltersInput>;
  respondents_answers?: InputMaybe<RespondentsAnswerFiltersInput>;
  section?: InputMaybe<ComponentSubmissionsSectionSubmissionFiltersInput>;
  section_typeform?: InputMaybe<BooleanFilterInput>;
  status?: InputMaybe<StringFilterInput>;
  sub_module?: InputMaybe<SubModuleFiltersInput>;
  submission_participants?: InputMaybe<ComponentSubmissionsParticipantsFiltersInput>;
  three_60_survey_form_id?: InputMaybe<StringFilterInput>;
  time_spent?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  uploaded_reports?: InputMaybe<UploadedReportFiltersInput>;
  user?: InputMaybe<UsersPermissionsUserFiltersInput>;
  view?: InputMaybe<IntFilterInput>;
};

export type SubModuleSubmissionInput = {
  coach_sessions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  competency_participants?: InputMaybe<Array<InputMaybe<ComponentSubmissionsCompetencyParticipantsInput>>>;
  competency_url?: InputMaybe<Scalars['ID']['input']>;
  feedfoward_url?: InputMaybe<Scalars['ID']['input']>;
  language?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  participants?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  programme?: InputMaybe<Scalars['ID']['input']>;
  programme_typeForm?: InputMaybe<Scalars['Boolean']['input']>;
  progress?: InputMaybe<Scalars['Int']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  reports?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  respondents_answers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  section?: InputMaybe<Array<InputMaybe<ComponentSubmissionsSectionSubmissionInput>>>;
  section_typeform?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Enum_Submodulesubmission_Status>;
  sub_module?: InputMaybe<Scalars['ID']['input']>;
  submission_participants?: InputMaybe<Array<InputMaybe<ComponentSubmissionsParticipantsInput>>>;
  three_60_survey_form_id?: InputMaybe<Scalars['String']['input']>;
  time_spent?: InputMaybe<Scalars['String']['input']>;
  uploaded_reports?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  user?: InputMaybe<Scalars['ID']['input']>;
  view?: InputMaybe<Scalars['Int']['input']>;
};

export type SubModuleSubmissionRelationResponseCollection = {
  __typename?: 'SubModuleSubmissionRelationResponseCollection';
  nodes: Array<SubModuleSubmission>;
};

export type SubModuleSubmissionReport = {
  __typename?: 'SubModuleSubmissionReport';
  id: Scalars['ID']['output'];
  reports: Array<Report>;
  subModule: SubModule;
};

export type SubModuleSubmissionResponse = {
  __typename?: 'SubModuleSubmissionResponse';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type Submission = {
  __typename?: 'Submission';
  competency_url?: Maybe<CompetencyUrl>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  language?: Maybe<Language>;
  module?: Maybe<Module>;
  participants?: Maybe<Array<Maybe<ComponentSubmissionsParticipants>>>;
  progress?: Maybe<Scalars['Int']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  reports: Array<Maybe<Report>>;
  reports_connection?: Maybe<ReportRelationResponseCollection>;
  respondents_answers: Array<Maybe<RespondentsAnswer>>;
  respondents_answers_connection?: Maybe<RespondentsAnswerRelationResponseCollection>;
  section?: Maybe<Array<Maybe<ComponentSubmissionsSectionSubmission>>>;
  status?: Maybe<Enum_Submission_Status>;
  time_spent?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uploaded_reports: Array<Maybe<UploadedReport>>;
  uploaded_reports_connection?: Maybe<UploadedReportRelationResponseCollection>;
  user?: Maybe<UsersPermissionsUser>;
  views?: Maybe<Scalars['Int']['output']>;
};


export type SubmissionParticipantsArgs = {
  filters?: InputMaybe<ComponentSubmissionsParticipantsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SubmissionReportsArgs = {
  filters?: InputMaybe<ReportFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SubmissionReports_ConnectionArgs = {
  filters?: InputMaybe<ReportFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SubmissionRespondents_AnswersArgs = {
  filters?: InputMaybe<RespondentsAnswerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SubmissionRespondents_Answers_ConnectionArgs = {
  filters?: InputMaybe<RespondentsAnswerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SubmissionSectionArgs = {
  filters?: InputMaybe<ComponentSubmissionsSectionSubmissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SubmissionUploaded_ReportsArgs = {
  filters?: InputMaybe<UploadedReportFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SubmissionUploaded_Reports_ConnectionArgs = {
  filters?: InputMaybe<UploadedReportFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SubmissionEntityResponseCollection = {
  __typename?: 'SubmissionEntityResponseCollection';
  nodes: Array<Submission>;
  pageInfo: Pagination;
};

export type SubmissionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<SubmissionFiltersInput>>>;
  competency_url?: InputMaybe<CompetencyUrlFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  language?: InputMaybe<LanguageFiltersInput>;
  module?: InputMaybe<ModuleFiltersInput>;
  not?: InputMaybe<SubmissionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<SubmissionFiltersInput>>>;
  participants?: InputMaybe<ComponentSubmissionsParticipantsFiltersInput>;
  progress?: InputMaybe<IntFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  reports?: InputMaybe<ReportFiltersInput>;
  respondents_answers?: InputMaybe<RespondentsAnswerFiltersInput>;
  section?: InputMaybe<ComponentSubmissionsSectionSubmissionFiltersInput>;
  status?: InputMaybe<StringFilterInput>;
  time_spent?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  uploaded_reports?: InputMaybe<UploadedReportFiltersInput>;
  user?: InputMaybe<UsersPermissionsUserFiltersInput>;
  views?: InputMaybe<IntFilterInput>;
};

export type SubmissionInput = {
  competency_url?: InputMaybe<Scalars['ID']['input']>;
  language?: InputMaybe<Scalars['ID']['input']>;
  module?: InputMaybe<Scalars['ID']['input']>;
  participants?: InputMaybe<Array<InputMaybe<ComponentSubmissionsParticipantsInput>>>;
  progress?: InputMaybe<Scalars['Int']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  reports?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  respondents_answers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  section?: InputMaybe<Array<InputMaybe<ComponentSubmissionsSectionSubmissionInput>>>;
  status?: InputMaybe<Enum_Submission_Status>;
  time_spent?: InputMaybe<Scalars['String']['input']>;
  uploaded_reports?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  user?: InputMaybe<Scalars['ID']['input']>;
  views?: InputMaybe<Scalars['Int']['input']>;
};

export type SubmissionRelationResponseCollection = {
  __typename?: 'SubmissionRelationResponseCollection';
  nodes: Array<Submission>;
};

export type SubmoduleReport = {
  __typename?: 'SubmoduleReport';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  notification?: Maybe<Notification>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  report: Array<Maybe<UploadFile>>;
  report_connection?: Maybe<UploadFileRelationResponseCollection>;
  section_title?: Maybe<Scalars['String']['output']>;
  sub_module_submission?: Maybe<SubModuleSubmission>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<UsersPermissionsUser>;
};


export type SubmoduleReportReportArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type SubmoduleReportReport_ConnectionArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SubmoduleReportEntityResponseCollection = {
  __typename?: 'SubmoduleReportEntityResponseCollection';
  nodes: Array<SubmoduleReport>;
  pageInfo: Pagination;
};

export type SubmoduleReportFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<SubmoduleReportFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<SubmoduleReportFiltersInput>;
  notification?: InputMaybe<NotificationFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<SubmoduleReportFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  section_title?: InputMaybe<StringFilterInput>;
  sub_module_submission?: InputMaybe<SubModuleSubmissionFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  user?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type SubmoduleReportInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  notification?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  report?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  section_title?: InputMaybe<Scalars['String']['input']>;
  sub_module_submission?: InputMaybe<Scalars['ID']['input']>;
  user?: InputMaybe<Scalars['ID']['input']>;
};

export type SubmoduleReportRelationResponseCollection = {
  __typename?: 'SubmoduleReportRelationResponseCollection';
  nodes: Array<SubmoduleReport>;
};

export type SurveyReport = {
  __typename?: 'SurveyReport';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  report?: Maybe<UploadFile>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SurveyReportEntityResponseCollection = {
  __typename?: 'SurveyReportEntityResponseCollection';
  nodes: Array<SurveyReport>;
  pageInfo: Pagination;
};

export type SurveyReportFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<SurveyReportFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<SurveyReportFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<SurveyReportFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type SurveyReportInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  report?: InputMaybe<Scalars['ID']['input']>;
};

export type Translation = {
  __typename?: 'Translation';
  about_us?: Maybe<ComponentTranslationsAboutUs>;
  buttons?: Maybe<ComponentTranslationsButtons>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dashboard_screen?: Maybe<ComponentTranslationsDashboardScreen>;
  documentId: Scalars['ID']['output'];
  faqs?: Maybe<ComponentTranslationsFaqs>;
  help_and_support?: Maybe<ComponentTranslationsHelpAndSupport>;
  home_screen?: Maybe<ComponentTranslationsHomeScreen>;
  language_selection?: Maybe<ComponentTranslationsLanguageSelection>;
  lets_get_started_screen?: Maybe<ComponentTranslationsLetsGetStartedScreen>;
  menu?: Maybe<ComponentTranslationsMenu>;
  my_library_screen?: Maybe<ComponentTranslationsMyLibraryScreen>;
  my_profile_screen?: Maybe<ComponentTranslationsMyProfileScreen>;
  my_work_screen?: Maybe<ComponentTranslationsMyWorkScreen>;
  personal_screen?: Maybe<ComponentTranslationsPersonalScreen>;
  privacy_policy?: Maybe<ComponentTranslationsPrivacyPolicy>;
  programmes_screen?: Maybe<ComponentTranslationsProgrammeScreen>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  settings_screen?: Maybe<ComponentTranslationsSettingsScreen>;
  terms_of_service?: Maybe<ComponentTranslationsTermsOfService>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  welcome_screen?: Maybe<ComponentTranslationsWelcomeScreen>;
  what_to_expect?: Maybe<ComponentTranslationsWhatToExpect>;
};

export type TranslationInput = {
  about_us?: InputMaybe<ComponentTranslationsAboutUsInput>;
  buttons?: InputMaybe<ComponentTranslationsButtonsInput>;
  dashboard_screen?: InputMaybe<ComponentTranslationsDashboardScreenInput>;
  faqs?: InputMaybe<ComponentTranslationsFaqsInput>;
  help_and_support?: InputMaybe<ComponentTranslationsHelpAndSupportInput>;
  home_screen?: InputMaybe<ComponentTranslationsHomeScreenInput>;
  language_selection?: InputMaybe<ComponentTranslationsLanguageSelectionInput>;
  lets_get_started_screen?: InputMaybe<ComponentTranslationsLetsGetStartedScreenInput>;
  menu?: InputMaybe<ComponentTranslationsMenuInput>;
  my_library_screen?: InputMaybe<ComponentTranslationsMyLibraryScreenInput>;
  my_profile_screen?: InputMaybe<ComponentTranslationsMyProfileScreenInput>;
  my_work_screen?: InputMaybe<ComponentTranslationsMyWorkScreenInput>;
  personal_screen?: InputMaybe<ComponentTranslationsPersonalScreenInput>;
  privacy_policy?: InputMaybe<ComponentTranslationsPrivacyPolicyInput>;
  programmes_screen?: InputMaybe<ComponentTranslationsProgrammeScreenInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  settings_screen?: InputMaybe<ComponentTranslationsSettingsScreenInput>;
  terms_of_service?: InputMaybe<ComponentTranslationsTermsOfServiceInput>;
  welcome_screen?: InputMaybe<ComponentTranslationsWelcomeScreenInput>;
  what_to_expect?: InputMaybe<ComponentTranslationsWhatToExpectInput>;
};

export type TypeFormCollection = {
  __typename?: 'TypeFormCollection';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  programme_types: Array<Maybe<ProgrammeType>>;
  programme_types_connection?: Maybe<ProgrammeTypeRelationResponseCollection>;
  programmes: Array<Maybe<Programme>>;
  programmes_connection?: Maybe<ProgrammeRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  sections: Array<Maybe<Section>>;
  sections_connection?: Maybe<SectionRelationResponseCollection>;
  submissions?: Maybe<Scalars['Long']['output']>;
  type_form_url?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type TypeFormCollectionProgramme_TypesArgs = {
  filters?: InputMaybe<ProgrammeTypeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type TypeFormCollectionProgramme_Types_ConnectionArgs = {
  filters?: InputMaybe<ProgrammeTypeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type TypeFormCollectionProgrammesArgs = {
  filters?: InputMaybe<ProgrammeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type TypeFormCollectionProgrammes_ConnectionArgs = {
  filters?: InputMaybe<ProgrammeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type TypeFormCollectionSectionsArgs = {
  filters?: InputMaybe<SectionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type TypeFormCollectionSections_ConnectionArgs = {
  filters?: InputMaybe<SectionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TypeFormCollectionEntityResponseCollection = {
  __typename?: 'TypeFormCollectionEntityResponseCollection';
  nodes: Array<TypeFormCollection>;
  pageInfo: Pagination;
};

export type TypeFormCollectionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<TypeFormCollectionFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<TypeFormCollectionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<TypeFormCollectionFiltersInput>>>;
  programme_types?: InputMaybe<ProgrammeTypeFiltersInput>;
  programmes?: InputMaybe<ProgrammeFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  sections?: InputMaybe<SectionFiltersInput>;
  submissions?: InputMaybe<LongFilterInput>;
  type_form_url?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type TypeFormCollectionInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  programme_types?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  programmes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  sections?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  submissions?: InputMaybe<Scalars['Long']['input']>;
  type_form_url?: InputMaybe<Scalars['String']['input']>;
};

export type UploadFile = {
  __typename?: 'UploadFile';
  alternativeText?: Maybe<Scalars['String']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  ext?: Maybe<Scalars['String']['output']>;
  focalPoint?: Maybe<Scalars['JSON']['output']>;
  formats?: Maybe<Scalars['JSON']['output']>;
  hash: Scalars['String']['output'];
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  mime: Scalars['String']['output'];
  name: Scalars['String']['output'];
  previewUrl?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  provider_metadata?: Maybe<Scalars['JSON']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  related?: Maybe<Array<Maybe<GenericMorph>>>;
  size: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

export type UploadFileEntityResponseCollection = {
  __typename?: 'UploadFileEntityResponseCollection';
  nodes: Array<UploadFile>;
  pageInfo: Pagination;
};

export type UploadFileFiltersInput = {
  alternativeText?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  caption?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  ext?: InputMaybe<StringFilterInput>;
  focalPoint?: InputMaybe<JsonFilterInput>;
  formats?: InputMaybe<JsonFilterInput>;
  hash?: InputMaybe<StringFilterInput>;
  height?: InputMaybe<IntFilterInput>;
  mime?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UploadFileFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  previewUrl?: InputMaybe<StringFilterInput>;
  provider?: InputMaybe<StringFilterInput>;
  provider_metadata?: InputMaybe<JsonFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  size?: InputMaybe<FloatFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
  width?: InputMaybe<IntFilterInput>;
};

export type UploadFileRelationResponseCollection = {
  __typename?: 'UploadFileRelationResponseCollection';
  nodes: Array<UploadFile>;
};

export type UploadedReport = {
  __typename?: 'UploadedReport';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  programme_submission?: Maybe<ProgrammeSubmission>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  report: Array<Maybe<UploadFile>>;
  report_connection?: Maybe<UploadFileRelationResponseCollection>;
  section_or_module_id?: Maybe<Scalars['String']['output']>;
  sub_module_submission?: Maybe<SubModuleSubmission>;
  submission?: Maybe<Submission>;
  type?: Maybe<Enum_Uploadedreport_Type>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type UploadedReportReportArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UploadedReportReport_ConnectionArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UploadedReportEntityResponseCollection = {
  __typename?: 'UploadedReportEntityResponseCollection';
  nodes: Array<UploadedReport>;
  pageInfo: Pagination;
};

export type UploadedReportFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UploadedReportFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UploadedReportFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UploadedReportFiltersInput>>>;
  programme_submission?: InputMaybe<ProgrammeSubmissionFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  section_or_module_id?: InputMaybe<StringFilterInput>;
  sub_module_submission?: InputMaybe<SubModuleSubmissionFiltersInput>;
  submission?: InputMaybe<SubmissionFiltersInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type UploadedReportInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  programme_submission?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  report?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  section_or_module_id?: InputMaybe<Scalars['String']['input']>;
  sub_module_submission?: InputMaybe<Scalars['ID']['input']>;
  submission?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<Enum_Uploadedreport_Type>;
};

export type UploadedReportRelationResponseCollection = {
  __typename?: 'UploadedReportRelationResponseCollection';
  nodes: Array<UploadedReport>;
};

export type UserUploadedDocument = {
  __typename?: 'UserUploadedDocument';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  documents?: Maybe<Array<Maybe<ComponentQuestionTypesDocuments>>>;
  name?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<UsersPermissionsUser>;
};


export type UserUploadedDocumentDocumentsArgs = {
  filters?: InputMaybe<ComponentQuestionTypesDocumentsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UserUploadedDocumentEntityResponseCollection = {
  __typename?: 'UserUploadedDocumentEntityResponseCollection';
  nodes: Array<UserUploadedDocument>;
  pageInfo: Pagination;
};

export type UserUploadedDocumentFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UserUploadedDocumentFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  documents?: InputMaybe<ComponentQuestionTypesDocumentsFiltersInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UserUploadedDocumentFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UserUploadedDocumentFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  user?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type UserUploadedDocumentInput = {
  documents?: InputMaybe<Array<InputMaybe<ComponentQuestionTypesDocumentsInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<Scalars['ID']['input']>;
};

export type UserUploadedDocumentRelationResponseCollection = {
  __typename?: 'UserUploadedDocumentRelationResponseCollection';
  nodes: Array<UserUploadedDocument>;
};

export type UsersPermissionsCreateRolePayload = {
  __typename?: 'UsersPermissionsCreateRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsDeleteRolePayload = {
  __typename?: 'UsersPermissionsDeleteRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsLoginInput = {
  identifier: Scalars['String']['input'];
  password: Scalars['String']['input'];
  provider?: Scalars['String']['input'];
};

export type UsersPermissionsLoginPayload = {
  __typename?: 'UsersPermissionsLoginPayload';
  jwt?: Maybe<Scalars['String']['output']>;
  user: UsersPermissionsMe;
};

export type UsersPermissionsMe = {
  __typename?: 'UsersPermissionsMe';
  blocked?: Maybe<Scalars['Boolean']['output']>;
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  documentId: Scalars['ID']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  role?: Maybe<UsersPermissionsMeRole>;
  username: Scalars['String']['output'];
};

export type UsersPermissionsMeRole = {
  __typename?: 'UsersPermissionsMeRole';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type UsersPermissionsPasswordPayload = {
  __typename?: 'UsersPermissionsPasswordPayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsPermission = {
  __typename?: 'UsersPermissionsPermission';
  action: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  role?: Maybe<UsersPermissionsRole>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UsersPermissionsPermissionFiltersInput = {
  action?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type UsersPermissionsPermissionRelationResponseCollection = {
  __typename?: 'UsersPermissionsPermissionRelationResponseCollection';
  nodes: Array<UsersPermissionsPermission>;
};

export type UsersPermissionsRegisterInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type UsersPermissionsRole = {
  __typename?: 'UsersPermissionsRole';
  companies: Array<Maybe<Company>>;
  companies_connection?: Maybe<CompanyRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  permissions: Array<Maybe<UsersPermissionsPermission>>;
  permissions_connection?: Maybe<UsersPermissionsPermissionRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  users: Array<Maybe<UsersPermissionsUser>>;
  users_connection?: Maybe<UsersPermissionsUserRelationResponseCollection>;
};


export type UsersPermissionsRoleCompaniesArgs = {
  filters?: InputMaybe<CompanyFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsRoleCompanies_ConnectionArgs = {
  filters?: InputMaybe<CompanyFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsRolePermissionsArgs = {
  filters?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsRolePermissions_ConnectionArgs = {
  filters?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsRoleUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsRoleUsers_ConnectionArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UsersPermissionsRoleEntityResponseCollection = {
  __typename?: 'UsersPermissionsRoleEntityResponseCollection';
  nodes: Array<UsersPermissionsRole>;
  pageInfo: Pagination;
};

export type UsersPermissionsRoleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  companies?: InputMaybe<CompanyFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  permissions?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  users?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type UsersPermissionsRoleInput = {
  companies?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type UsersPermissionsRoleRelationResponseCollection = {
  __typename?: 'UsersPermissionsRoleRelationResponseCollection';
  nodes: Array<UsersPermissionsRole>;
};

export type UsersPermissionsUpdateRolePayload = {
  __typename?: 'UsersPermissionsUpdateRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsUser = {
  __typename?: 'UsersPermissionsUser';
  account_changes: Array<Maybe<AccountChange>>;
  account_changes_connection?: Maybe<AccountChangeRelationResponseCollection>;
  articlesViewed?: Maybe<Scalars['JSON']['output']>;
  blocked?: Maybe<Scalars['Boolean']['output']>;
  bookings: Array<Maybe<Booking>>;
  bookings_connection?: Maybe<BookingRelationResponseCollection>;
  bookmarks?: Maybe<Scalars['JSON']['output']>;
  certificate?: Maybe<UploadFile>;
  clientId?: Maybe<Scalars['Long']['output']>;
  coach?: Maybe<Coach>;
  coach_submitted_reports: Array<Maybe<CoachSubmittedReport>>;
  coach_submitted_reports_connection?: Maybe<CoachSubmittedReportRelationResponseCollection>;
  company?: Maybe<Company>;
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  current_survey?: Maybe<Scalars['JSON']['output']>;
  division?: Maybe<Division>;
  documentId: Scalars['ID']['output'];
  email: Scalars['String']['output'];
  feedForwardUrl?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  homePromptsRead?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  jobTitle?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Language>;
  lastName?: Maybe<Scalars['String']['output']>;
  loginAttempts?: Maybe<Scalars['Int']['output']>;
  loginWithSSO?: Maybe<Scalars['Boolean']['output']>;
  modulePromptsRead?: Maybe<Scalars['Boolean']['output']>;
  modulesRead?: Maybe<Scalars['JSON']['output']>;
  notes: Array<Maybe<Note>>;
  notes_connection?: Maybe<NoteRelationResponseCollection>;
  notifications: Array<Maybe<Notification>>;
  notifications_connection?: Maybe<NotificationRelationResponseCollection>;
  onboarding?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  postCard?: Maybe<PostCard>;
  profilePicture?: Maybe<UploadFile>;
  programmeEvalutionEmailSent?: Maybe<Scalars['Boolean']['output']>;
  programmePromptsRead?: Maybe<Scalars['Boolean']['output']>;
  programme_submissions: Array<Maybe<ProgrammeSubmission>>;
  programme_submissions_connection?: Maybe<ProgrammeSubmissionRelationResponseCollection>;
  programmes: Array<Maybe<Programme>>;
  programmes_connection?: Maybe<ProgrammeRelationResponseCollection>;
  provider?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  region?: Maybe<Region>;
  report?: Maybe<UploadFile>;
  respondents_answers: Array<Maybe<RespondentsAnswer>>;
  respondents_answers_connection?: Maybe<RespondentsAnswerRelationResponseCollection>;
  role?: Maybe<UsersPermissionsRole>;
  sub_module_submissions: Array<Maybe<SubModuleSubmission>>;
  sub_module_submissions_connection?: Maybe<SubModuleSubmissionRelationResponseCollection>;
  submissions: Array<Maybe<Submission>>;
  submissions_connection?: Maybe<SubmissionRelationResponseCollection>;
  submodule_reports: Array<Maybe<SubmoduleReport>>;
  submodule_reports_connection?: Maybe<SubmoduleReportRelationResponseCollection>;
  three_60_form_id?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<ComponentOptionTimezone>;
  triggerReport?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedDetails?: Maybe<Scalars['Boolean']['output']>;
  user_uploaded_documents: Array<Maybe<UserUploadedDocument>>;
  user_uploaded_documents_connection?: Maybe<UserUploadedDocumentRelationResponseCollection>;
  username: Scalars['String']['output'];
};


export type UsersPermissionsUserAccount_ChangesArgs = {
  filters?: InputMaybe<AccountChangeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsUserAccount_Changes_ConnectionArgs = {
  filters?: InputMaybe<AccountChangeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsUserBookingsArgs = {
  filters?: InputMaybe<BookingFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsUserBookings_ConnectionArgs = {
  filters?: InputMaybe<BookingFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsUserCoach_Submitted_ReportsArgs = {
  filters?: InputMaybe<CoachSubmittedReportFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsUserCoach_Submitted_Reports_ConnectionArgs = {
  filters?: InputMaybe<CoachSubmittedReportFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsUserNotesArgs = {
  filters?: InputMaybe<NoteFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsUserNotes_ConnectionArgs = {
  filters?: InputMaybe<NoteFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsUserNotificationsArgs = {
  filters?: InputMaybe<NotificationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsUserNotifications_ConnectionArgs = {
  filters?: InputMaybe<NotificationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsUserProgramme_SubmissionsArgs = {
  filters?: InputMaybe<ProgrammeSubmissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsUserProgramme_Submissions_ConnectionArgs = {
  filters?: InputMaybe<ProgrammeSubmissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsUserProgrammesArgs = {
  filters?: InputMaybe<ProgrammeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsUserProgrammes_ConnectionArgs = {
  filters?: InputMaybe<ProgrammeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsUserRespondents_AnswersArgs = {
  filters?: InputMaybe<RespondentsAnswerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsUserRespondents_Answers_ConnectionArgs = {
  filters?: InputMaybe<RespondentsAnswerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsUserSub_Module_SubmissionsArgs = {
  filters?: InputMaybe<SubModuleSubmissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsUserSub_Module_Submissions_ConnectionArgs = {
  filters?: InputMaybe<SubModuleSubmissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsUserSubmissionsArgs = {
  filters?: InputMaybe<SubmissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsUserSubmissions_ConnectionArgs = {
  filters?: InputMaybe<SubmissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsUserSubmodule_ReportsArgs = {
  filters?: InputMaybe<SubmoduleReportFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsUserSubmodule_Reports_ConnectionArgs = {
  filters?: InputMaybe<SubmoduleReportFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsUserUser_Uploaded_DocumentsArgs = {
  filters?: InputMaybe<UserUploadedDocumentFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsUserUser_Uploaded_Documents_ConnectionArgs = {
  filters?: InputMaybe<UserUploadedDocumentFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UsersPermissionsUserEntityResponse = {
  __typename?: 'UsersPermissionsUserEntityResponse';
  data?: Maybe<UsersPermissionsUser>;
};

export type UsersPermissionsUserEntityResponseCollection = {
  __typename?: 'UsersPermissionsUserEntityResponseCollection';
  nodes: Array<UsersPermissionsUser>;
  pageInfo: Pagination;
};

export type UsersPermissionsUserFiltersInput = {
  account_changes?: InputMaybe<AccountChangeFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  articlesViewed?: InputMaybe<JsonFilterInput>;
  blocked?: InputMaybe<BooleanFilterInput>;
  bookings?: InputMaybe<BookingFiltersInput>;
  bookmarks?: InputMaybe<JsonFilterInput>;
  clientId?: InputMaybe<LongFilterInput>;
  coach?: InputMaybe<CoachFiltersInput>;
  coach_submitted_reports?: InputMaybe<CoachSubmittedReportFiltersInput>;
  company?: InputMaybe<CompanyFiltersInput>;
  confirmed?: InputMaybe<BooleanFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  current_survey?: InputMaybe<JsonFilterInput>;
  division?: InputMaybe<DivisionFiltersInput>;
  documentId?: InputMaybe<IdFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  feedForwardUrl?: InputMaybe<StringFilterInput>;
  firstName?: InputMaybe<StringFilterInput>;
  homePromptsRead?: InputMaybe<BooleanFilterInput>;
  jobTitle?: InputMaybe<StringFilterInput>;
  language?: InputMaybe<LanguageFiltersInput>;
  lastName?: InputMaybe<StringFilterInput>;
  loginAttempts?: InputMaybe<IntFilterInput>;
  loginWithSSO?: InputMaybe<BooleanFilterInput>;
  modulePromptsRead?: InputMaybe<BooleanFilterInput>;
  modulesRead?: InputMaybe<JsonFilterInput>;
  not?: InputMaybe<UsersPermissionsUserFiltersInput>;
  notes?: InputMaybe<NoteFiltersInput>;
  notifications?: InputMaybe<NotificationFiltersInput>;
  onboarding?: InputMaybe<BooleanFilterInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  phoneNumber?: InputMaybe<StringFilterInput>;
  postCard?: InputMaybe<PostCardFiltersInput>;
  programmeEvalutionEmailSent?: InputMaybe<BooleanFilterInput>;
  programmePromptsRead?: InputMaybe<BooleanFilterInput>;
  programme_submissions?: InputMaybe<ProgrammeSubmissionFiltersInput>;
  programmes?: InputMaybe<ProgrammeFiltersInput>;
  provider?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  region?: InputMaybe<RegionFiltersInput>;
  respondents_answers?: InputMaybe<RespondentsAnswerFiltersInput>;
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  sub_module_submissions?: InputMaybe<SubModuleSubmissionFiltersInput>;
  submissions?: InputMaybe<SubmissionFiltersInput>;
  submodule_reports?: InputMaybe<SubmoduleReportFiltersInput>;
  three_60_form_id?: InputMaybe<StringFilterInput>;
  timezone?: InputMaybe<ComponentOptionTimezoneFiltersInput>;
  triggerReport?: InputMaybe<BooleanFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  updatedDetails?: InputMaybe<BooleanFilterInput>;
  user_uploaded_documents?: InputMaybe<UserUploadedDocumentFiltersInput>;
  username?: InputMaybe<StringFilterInput>;
};

export type UsersPermissionsUserInput = {
  account_changes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  articlesViewed?: InputMaybe<Scalars['JSON']['input']>;
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  bookings?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  bookmarks?: InputMaybe<Scalars['JSON']['input']>;
  certificate?: InputMaybe<Scalars['ID']['input']>;
  clientId?: InputMaybe<Scalars['Long']['input']>;
  coach?: InputMaybe<Scalars['ID']['input']>;
  coach_submitted_reports?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  company?: InputMaybe<Scalars['ID']['input']>;
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  current_survey?: InputMaybe<Scalars['JSON']['input']>;
  division?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  feedForwardUrl?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  homePromptsRead?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['ID']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  loginAttempts?: InputMaybe<Scalars['Int']['input']>;
  loginWithSSO?: InputMaybe<Scalars['Boolean']['input']>;
  modulePromptsRead?: InputMaybe<Scalars['Boolean']['input']>;
  modulesRead?: InputMaybe<Scalars['JSON']['input']>;
  notes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  notifications?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  onboarding?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postCard?: InputMaybe<Scalars['ID']['input']>;
  profilePicture?: InputMaybe<Scalars['ID']['input']>;
  programmeEvalutionEmailSent?: InputMaybe<Scalars['Boolean']['input']>;
  programmePromptsRead?: InputMaybe<Scalars['Boolean']['input']>;
  programme_submissions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  programmes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  provider?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  region?: InputMaybe<Scalars['ID']['input']>;
  report?: InputMaybe<Scalars['ID']['input']>;
  respondents_answers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  role?: InputMaybe<Scalars['ID']['input']>;
  sub_module_submissions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  submissions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  submodule_reports?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  three_60_form_id?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<ComponentOptionTimezoneInput>;
  triggerReport?: InputMaybe<Scalars['Boolean']['input']>;
  updatedDetails?: InputMaybe<Scalars['Boolean']['input']>;
  user_uploaded_documents?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UsersPermissionsUserRelationResponseCollection = {
  __typename?: 'UsersPermissionsUserRelationResponseCollection';
  nodes: Array<UsersPermissionsUser>;
};

export type EditComponentGravitasScaleItemsGravitasScaleItemInput = {
  answerOne?: InputMaybe<Scalars['Int']['input']>;
  answerThree?: InputMaybe<Scalars['Int']['input']>;
  answerTwo?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  labelOne?: InputMaybe<Scalars['String']['input']>;
  labelThree?: InputMaybe<Scalars['String']['input']>;
  labelTwo?: InputMaybe<Scalars['String']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
};

export type EditComponentOptionColorAndRatingInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  rate?: InputMaybe<Scalars['Int']['input']>;
};

export type EditComponentOptionTimezoneInput = {
  abbrev?: InputMaybe<Scalars['String']['input']>;
  altName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type EditComponentQuestionTypesDocumentInput = {
  document?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type EditComponentStakeholderMapItemStackholderMapItemInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  valueX?: InputMaybe<Scalars['Int']['input']>;
  valueY?: InputMaybe<Scalars['Int']['input']>;
};

export type EditComponentSubmissionsAnswerInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isCorrect?: InputMaybe<Scalars['Boolean']['input']>;
  nestedAnswers?: InputMaybe<Array<InputMaybe<EditComponentSubmissionsRepeatAnswerInput>>>;
  outcome?: InputMaybe<Enum_Componentsubmissionsanswer_Outcome>;
  questionId?: InputMaybe<Scalars['String']['input']>;
  questionTitle?: InputMaybe<Scalars['String']['input']>;
  questionType?: InputMaybe<Scalars['String']['input']>;
};

export type EditComponentSubmissionsCharacteristicInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type EditComponentSubmissionsCompetencyAnswerInput = {
  headingQuestion?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isSimpleQuestion?: InputMaybe<Scalars['Boolean']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  response?: InputMaybe<Scalars['String']['input']>;
  steps?: InputMaybe<Scalars['Int']['input']>;
  textboxQuestion?: InputMaybe<Scalars['String']['input']>;
};

export type EditComponentSubmissionsCompetencyParticipantInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type EditComponentSubmissionsGravitasGapInput = {
  commitment?: InputMaybe<Scalars['String']['input']>;
  gap?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type EditComponentSubmissionsGravitasSlidersAnswerInput = {
  colorAndRating?: InputMaybe<Array<InputMaybe<EditComponentOptionColorAndRatingInput>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  negativeQuestion?: InputMaybe<Scalars['String']['input']>;
  positiveQuestion?: InputMaybe<Scalars['String']['input']>;
};

export type EditComponentSubmissionsNoteInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  document?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type EditComponentSubmissionsParticipantInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type EditComponentSubmissionsProgrammeSubmissionInput = {
  answers?: InputMaybe<Array<InputMaybe<EditComponentSubmissionsAnswerInput>>>;
  characteristics?: InputMaybe<Array<InputMaybe<EditComponentSubmissionsCharacteristicInput>>>;
  competencyAnswers?: InputMaybe<Array<InputMaybe<EditComponentSubmissionsCompetencyAnswerInput>>>;
  gapsAnswers?: InputMaybe<Array<InputMaybe<EditComponentSubmissionsValuesGapInput>>>;
  gravitasGap?: InputMaybe<Array<InputMaybe<EditComponentSubmissionsGravitasGapInput>>>;
  gravitasScales?: InputMaybe<Array<InputMaybe<EditComponentGravitasScaleItemsGravitasScaleItemInput>>>;
  gravitasSliderAnswers?: InputMaybe<Array<InputMaybe<EditComponentSubmissionsGravitasSlidersAnswerInput>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  saboteur?: InputMaybe<Array<InputMaybe<EditComponentSubmissionsSaboteurComponentInput>>>;
  saboteurImage?: InputMaybe<Scalars['ID']['input']>;
  saboteurSkipProofs?: InputMaybe<Array<InputMaybe<EditComponentSubmissionsSkipProofComponentInput>>>;
  sabtourVideosProofs?: InputMaybe<Array<InputMaybe<EditComponentSubmissionsSabtourVideosComponentInput>>>;
  sliderAnswers?: InputMaybe<Scalars['JSON']['input']>;
  sliderImage?: InputMaybe<Scalars['ID']['input']>;
  stakeholderChart?: InputMaybe<Scalars['ID']['input']>;
  stakeholderItems?: InputMaybe<Array<InputMaybe<EditComponentStakeholderMapItemStackholderMapItemInput>>>;
  xYGraphChart?: InputMaybe<Scalars['ID']['input']>;
  xYGraphItems?: InputMaybe<Array<InputMaybe<EditComponentXyGraphItemXyGraphItemInput>>>;
};

export type EditComponentSubmissionsRepeatAnswerInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  questionTitle?: InputMaybe<Scalars['String']['input']>;
};

export type EditComponentSubmissionsSaboteurComponentInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  saboteurProofValue?: InputMaybe<Scalars['ID']['input']>;
};

export type EditComponentSubmissionsSabtourVideosComponentInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  sabtourValue?: InputMaybe<Scalars['String']['input']>;
};

export type EditComponentSubmissionsSectionSubmissionInput = {
  answers?: InputMaybe<Array<InputMaybe<EditComponentSubmissionsAnswerInput>>>;
  characteristics?: InputMaybe<Array<InputMaybe<EditComponentSubmissionsCharacteristicInput>>>;
  competencyAnswers?: InputMaybe<Array<InputMaybe<EditComponentSubmissionsCompetencyAnswerInput>>>;
  emailSent?: InputMaybe<Scalars['Boolean']['input']>;
  gapsAnswers?: InputMaybe<Array<InputMaybe<EditComponentSubmissionsValuesGapInput>>>;
  gravitasGap?: InputMaybe<Array<InputMaybe<EditComponentSubmissionsGravitasGapInput>>>;
  gravitasScales?: InputMaybe<Array<InputMaybe<EditComponentGravitasScaleItemsGravitasScaleItemInput>>>;
  gravitasSliderAnswers?: InputMaybe<Array<InputMaybe<EditComponentSubmissionsGravitasSlidersAnswerInput>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  progress?: InputMaybe<Scalars['Int']['input']>;
  saboteur?: InputMaybe<Array<InputMaybe<EditComponentSubmissionsSaboteurComponentInput>>>;
  saboteurImage?: InputMaybe<Scalars['ID']['input']>;
  saboteurSkipProofs?: InputMaybe<Array<InputMaybe<EditComponentSubmissionsSkipProofComponentInput>>>;
  sabtourVideosProofs?: InputMaybe<Array<InputMaybe<EditComponentSubmissionsSabtourVideosComponentInput>>>;
  section?: InputMaybe<Scalars['ID']['input']>;
  sliderAnswers?: InputMaybe<Scalars['JSON']['input']>;
  sliderImage?: InputMaybe<Scalars['ID']['input']>;
  stakeholderChart?: InputMaybe<Scalars['ID']['input']>;
  stakeholderItems?: InputMaybe<Array<InputMaybe<EditComponentStakeholderMapItemStackholderMapItemInput>>>;
  uploadDocuments?: InputMaybe<Array<InputMaybe<EditComponentSubmissionsUploadDocumentInput>>>;
  xYGraphChart?: InputMaybe<Scalars['ID']['input']>;
  xYGraphItems?: InputMaybe<Array<InputMaybe<EditComponentXyGraphItemXyGraphItemInput>>>;
};

export type EditComponentSubmissionsSkipProofComponentInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  skipProofValue?: InputMaybe<Scalars['String']['input']>;
};

export type EditComponentSubmissionsUploadDocumentInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  saboteurProofValue?: InputMaybe<Scalars['ID']['input']>;
};

export type EditComponentSubmissionsValuesGapInput = {
  commitment?: InputMaybe<Scalars['String']['input']>;
  gap?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type EditComponentXyGraphItemXyGraphItemInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  valueX?: InputMaybe<Scalars['Int']['input']>;
  valueY?: InputMaybe<Scalars['Int']['input']>;
};

export type EditNoteInput = {
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  document?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  notesId?: InputMaybe<Array<InputMaybe<EditComponentSubmissionsSaboteurComponentInput>>>;
  programme?: InputMaybe<Scalars['ID']['input']>;
  programmeSubmission?: InputMaybe<Scalars['ID']['input']>;
  sectionOrSubmissionId?: InputMaybe<Scalars['String']['input']>;
  subModuleSubmission?: InputMaybe<Scalars['ID']['input']>;
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
  user?: InputMaybe<Scalars['ID']['input']>;
};

export type EditProgrammeSubmissionInput = {
  coachSessions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  competencyUrl?: InputMaybe<Scalars['ID']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  emailSent?: InputMaybe<Scalars['Boolean']['input']>;
  feedfowardUrl?: InputMaybe<Scalars['ID']['input']>;
  isUpdatedByStakeholder?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['ID']['input']>;
  myNotes?: InputMaybe<Array<InputMaybe<EditComponentSubmissionsNoteInput>>>;
  notes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  participants?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  programme?: InputMaybe<Scalars['ID']['input']>;
  programmeReport?: InputMaybe<Scalars['ID']['input']>;
  programmeResponses?: InputMaybe<Array<InputMaybe<EditComponentSubmissionsProgrammeSubmissionInput>>>;
  programmeType?: InputMaybe<Scalars['ID']['input']>;
  progress?: InputMaybe<Scalars['Int']['input']>;
  respondentsAnswers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  selected?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Enum_Programmesubmission_Status>;
  submissionparticipants?: InputMaybe<Array<InputMaybe<EditComponentSubmissionsParticipantInput>>>;
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
  uploadedReports?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  user?: InputMaybe<Scalars['ID']['input']>;
};

export type EditSubModuleSubmissionInput = {
  coachSessions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  competencyParticipants?: InputMaybe<Array<InputMaybe<EditComponentSubmissionsCompetencyParticipantInput>>>;
  competencyUrl?: InputMaybe<Scalars['ID']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  feedfowardUrl?: InputMaybe<Scalars['ID']['input']>;
  language?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  participants?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  programme?: InputMaybe<Scalars['ID']['input']>;
  programmeTypeForm?: InputMaybe<Scalars['Boolean']['input']>;
  progress?: InputMaybe<Scalars['Int']['input']>;
  reports?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  respondentsAnswers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  section?: InputMaybe<Array<InputMaybe<EditComponentSubmissionsSectionSubmissionInput>>>;
  sectionTypeform?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Enum_Submodulesubmission_Status>;
  subModule?: InputMaybe<Scalars['ID']['input']>;
  submissionparticipants?: InputMaybe<Array<InputMaybe<EditComponentSubmissionsParticipantInput>>>;
  three60SurveyFormId?: InputMaybe<Scalars['String']['input']>;
  timeSpent?: InputMaybe<Scalars['String']['input']>;
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
  uploadedReports?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  user?: InputMaybe<Scalars['ID']['input']>;
  view?: InputMaybe<Scalars['Int']['input']>;
};

export type EditSubmissionInput = {
  competencyUrl?: InputMaybe<Scalars['ID']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  language?: InputMaybe<Scalars['ID']['input']>;
  module?: InputMaybe<Scalars['ID']['input']>;
  participants?: InputMaybe<Array<InputMaybe<EditComponentSubmissionsParticipantInput>>>;
  progress?: InputMaybe<Scalars['Int']['input']>;
  reports?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  respondentsAnswers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  section?: InputMaybe<Array<InputMaybe<EditComponentSubmissionsSectionSubmissionInput>>>;
  status?: InputMaybe<Enum_Submission_Status>;
  timeSpent?: InputMaybe<Scalars['String']['input']>;
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
  uploadedReports?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  user?: InputMaybe<Scalars['ID']['input']>;
  views?: InputMaybe<Scalars['Int']['input']>;
};

export type EditUserInput = {
  accountChanges?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  articlesViewed?: InputMaybe<Scalars['JSON']['input']>;
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  bookings?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  bookmarks?: InputMaybe<Scalars['JSON']['input']>;
  certificate?: InputMaybe<Scalars['ID']['input']>;
  clientId?: InputMaybe<Scalars['Long']['input']>;
  coach?: InputMaybe<Scalars['ID']['input']>;
  coachSubmittedReports?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  company?: InputMaybe<Scalars['ID']['input']>;
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  currentSurvey?: InputMaybe<Scalars['JSON']['input']>;
  division?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  feedForwardUrl?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  homePromptsRead?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['ID']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  loginAttempts?: InputMaybe<Scalars['Int']['input']>;
  loginWithSSO?: InputMaybe<Scalars['Boolean']['input']>;
  modulePromptsRead?: InputMaybe<Scalars['Boolean']['input']>;
  modulesRead?: InputMaybe<Scalars['JSON']['input']>;
  notes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  notifications?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  onboarding?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postCard?: InputMaybe<Scalars['ID']['input']>;
  profilePicture?: InputMaybe<Scalars['ID']['input']>;
  programmeEvalutionEmailSent?: InputMaybe<Scalars['Boolean']['input']>;
  programmePromptsRead?: InputMaybe<Scalars['Boolean']['input']>;
  programmeSubmissions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  programmes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  provider?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['ID']['input']>;
  report?: InputMaybe<Scalars['ID']['input']>;
  resetPasswordToken?: InputMaybe<Scalars['String']['input']>;
  respondentsAnswers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  role?: InputMaybe<Scalars['ID']['input']>;
  subModuleSubmissions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  submissions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  submoduleReports?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  three60FormId?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<EditComponentOptionTimezoneInput>;
  triggerReport?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
  updatedDetails?: InputMaybe<Scalars['Boolean']['input']>;
  userUploadedDocuments?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type EditUserUploadedDocumentInput = {
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  documents?: InputMaybe<Array<InputMaybe<EditComponentQuestionTypesDocumentInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
  user?: InputMaybe<Scalars['ID']['input']>;
};

export type ModuleFragment = (
  { __typename?: 'Module' }
  & Pick<Module, 'name_french' | 'name_german' | 'name_english' | 'name_spanish' | 'name_mandarin' | 'description_french' | 'description_german' | 'description_english' | 'description_spanish' | 'description_mandarin'>
  & { cover?: Maybe<(
    { __typename?: 'UploadFile' }
    & Pick<UploadFile, 'documentId' | 'url'>
  )> }
);

type Questions_ComponentQuestionTypesCompetency_Fragment = { __typename: 'ComponentQuestionTypesCompetency' };

type Questions_ComponentQuestionTypesCompetency2_Fragment = (
  { __typename: 'ComponentQuestionTypesCompetency2' }
  & Pick<ComponentQuestionTypesCompetency2, 'titleEnglish' | 'titleFrench' | 'titleMandarin'>
  & { questionscompetency2?: Maybe<Array<Maybe<(
    { __typename?: 'ComponentQuestionTypesQuestionscompetency2' }
    & Pick<ComponentQuestionTypesQuestionscompetency2, 'title' | 'question' | 'maxiNumber' | 'miniNumber' | 'simpleQuestion' | 'miniLabel' | 'maxiLabel'>
  )>>> }
);

type Questions_ComponentQuestionTypesFeedForward1_Fragment = (
  { __typename: 'ComponentQuestionTypesFeedForward1' }
  & Pick<ComponentQuestionTypesFeedForward1, 'title' | 'question' | 'description'>
);

type Questions_ComponentQuestionTypesFeedForward2_Fragment = (
  { __typename: 'ComponentQuestionTypesFeedForward2' }
  & Pick<ComponentQuestionTypesFeedForward2, 'title' | 'question' | 'description'>
);

type Questions_ComponentQuestionTypesGravitasGap_Fragment = { __typename: 'ComponentQuestionTypesGravitasGap' };

type Questions_ComponentQuestionTypesGravitasScale_Fragment = (
  { __typename: 'ComponentQuestionTypesGravitasScale' }
  & Pick<ComponentQuestionTypesGravitasScale, 'titleEnglish' | 'subTitleEnglish' | 'questionOneEnglish' | 'questionTwoEnglish' | 'questionThreeEnglish' | 'titleOneEnglish' | 'titleTwoEnglish'>
  & { ratingInput?: Maybe<Array<Maybe<(
    { __typename?: 'ComponentRatingInputRatingInput' }
    & Pick<ComponentRatingInputRatingInput, 'labelOneEnglish' | 'labelTwoEnglish'>
  )>>> }
);

type Questions_ComponentQuestionTypesGravitasSliders_Fragment = { __typename: 'ComponentQuestionTypesGravitasSliders' };

type Questions_ComponentQuestionTypesMultipleChoice_Fragment = (
  { __typename: 'ComponentQuestionTypesMultipleChoice' }
  & Pick<ComponentQuestionTypesMultipleChoice, 'titleEnglish' | 'titleFrench' | 'titleGerman' | 'titleSpanish' | 'titleMandarin' | 'viewPrevious' | 'numberOfAnswers'>
  & { option?: Maybe<Array<Maybe<(
    { __typename?: 'ComponentOptionOption' }
    & Pick<ComponentOptionOption, 'optionEnglish' | 'optionFrench' | 'optionGerman' | 'optionSpanish' | 'optionMandarin' | 'isCorrect'>
  )>>> }
);

type Questions_ComponentQuestionTypesNestedQuestions_Fragment = (
  { __typename: 'ComponentQuestionTypesNestedQuestions' }
  & Pick<ComponentQuestionTypesNestedQuestions, 'titleEnglish' | 'titleFrench' | 'titleGerman' | 'titleSpanish' | 'titleMandarin' | 'viewPrevious'>
  & { questions?: Maybe<Array<Maybe<(
    { __typename?: 'ComponentQuestionTypesSimpleQuestion' }
    & Pick<ComponentQuestionTypesSimpleQuestion, 'titleEnglish' | 'subTitleEnglish' | 'titleFrench' | 'subTitleFrench' | 'titleGerman' | 'subTitleGerman' | 'titleSpanish' | 'subTitleSpanish' | 'titleMandarin' | 'subTitleMandarin' | 'isNumeric'>
  )>>> }
);

type Questions_ComponentQuestionTypesParticipant_Fragment = { __typename: 'ComponentQuestionTypesParticipant' };

type Questions_ComponentQuestionTypesSaboteur_Fragment = (
  { __typename: 'ComponentQuestionTypesSaboteur' }
  & Pick<ComponentQuestionTypesSaboteur, 'titleEnglish' | 'subTitleEnglish' | 'titleFrench' | 'subTitleFrench' | 'titleGerman' | 'subTitleGerman' | 'titleSpanish' | 'subTitleSpanish' | 'titleMandarin' | 'subTitleMandarin'>
  & { saboteurQuestions?: Maybe<Array<Maybe<(
    { __typename?: 'ComponentQuestionTypesSaboteurQuestions' }
    & Pick<ComponentQuestionTypesSaboteurQuestions, 'link' | 'skipProof' | 'labelEnglish' | 'labelFrench' | 'labelGerman' | 'labelSpanish' | 'labelMandarin'>
  )>>> }
);

type Questions_ComponentQuestionTypesSaboteurVideos_Fragment = (
  { __typename: 'ComponentQuestionTypesSaboteurVideos' }
  & Pick<ComponentQuestionTypesSaboteurVideos, 'titleEnglish' | 'titleFrench' | 'titleGerman' | 'titleSpanish' | 'titleMandarin' | 'subTitleEnglish' | 'subTitleFrench' | 'subTitleGerman' | 'subTitleSpanish' | 'subTitleMandarin'>
  & { SaboteurVideo?: Maybe<Array<Maybe<(
    { __typename?: 'ComponentSaboteurVideoSaboteurVideo' }
    & Pick<ComponentSaboteurVideoSaboteurVideo, 'videoTitleEnglish' | 'videoTitleFrench' | 'videoTitleGerman' | 'videoTitleSpanish' | 'videoTitleMandarin' | 'videoDescriptionEnglish' | 'videoDescriptionFrench' | 'videoDescriptionGerman' | 'videoDescriptionSpanish' | 'videoDescriptionMandarin'>
  )>>> }
);

type Questions_ComponentQuestionTypesSimpleQuestion_Fragment = (
  { __typename: 'ComponentQuestionTypesSimpleQuestion' }
  & Pick<ComponentQuestionTypesSimpleQuestion, 'titleEnglish' | 'subTitleEnglish' | 'titleFrench' | 'subTitleFrench' | 'titleGerman' | 'subTitleGerman' | 'titleSpanish' | 'subTitleSpanish' | 'titleMandarin' | 'subTitleMandarin' | 'viewPrevious'>
);

type Questions_ComponentQuestionTypesSimpleReadOnly_Fragment = { __typename: 'ComponentQuestionTypesSimpleReadOnly' };

type Questions_ComponentQuestionTypesSliderQuestions_Fragment = { __typename: 'ComponentQuestionTypesSliderQuestions' };

type Questions_ComponentQuestionTypesStakeholderMap_Fragment = (
  { __typename: 'ComponentQuestionTypesStakeholderMap' }
  & Pick<ComponentQuestionTypesStakeholderMap, 'titleEnglish' | 'subTitleEnglish' | 'titleFrench' | 'subTitleFrench' | 'titleSpanish' | 'subTitleSpanish' | 'titleGerman' | 'subTitleGerman' | 'titleMandarin' | 'subTitleMandarin' | 'questionX' | 'questionY'>
);

type Questions_ComponentQuestionTypesUploadDocuments_Fragment = { __typename: 'ComponentQuestionTypesUploadDocuments' };

type Questions_ComponentQuestionTypesUploadQuestion_Fragment = { __typename: 'ComponentQuestionTypesUploadQuestion' };

type Questions_ComponentQuestionTypesValuesBubble_Fragment = { __typename: 'ComponentQuestionTypesValuesBubble' };

type Questions_ComponentQuestionTypesValuesCharacters_Fragment = { __typename: 'ComponentQuestionTypesValuesCharacters' };

type Questions_ComponentQuestionTypesValuesGaps_Fragment = { __typename: 'ComponentQuestionTypesValuesGaps' };

type Questions_ComponentQuestionTypesValuesNested_Fragment = { __typename: 'ComponentQuestionTypesValuesNested' };

type Questions_ComponentQuestionTypesValuesSliders_Fragment = { __typename: 'ComponentQuestionTypesValuesSliders' };

type Questions_ComponentQuestionTypesXyGraph_Fragment = (
  { __typename: 'ComponentQuestionTypesXYGraph' }
  & Pick<ComponentQuestionTypesXyGraph, 'labelXEnglish' | 'labelYEnglish' | 'titleEnglish' | 'subTitleEnglish' | 'labelXFrench' | 'labelYFrench' | 'titleFrench' | 'subTitleFrench' | 'labelXGerman' | 'labelYGerman' | 'titleGerman' | 'subTitleGerman' | 'labelXSpanish' | 'labelYSpanish' | 'titleSpanish' | 'subTitleSpanish' | 'labelXMandarin' | 'labelYMandarin' | 'titleMandarin' | 'subTitleMandarin'>
);

type Questions_Error_Fragment = { __typename: 'Error' };

export type QuestionsFragment = Questions_ComponentQuestionTypesCompetency_Fragment | Questions_ComponentQuestionTypesCompetency2_Fragment | Questions_ComponentQuestionTypesFeedForward1_Fragment | Questions_ComponentQuestionTypesFeedForward2_Fragment | Questions_ComponentQuestionTypesGravitasGap_Fragment | Questions_ComponentQuestionTypesGravitasScale_Fragment | Questions_ComponentQuestionTypesGravitasSliders_Fragment | Questions_ComponentQuestionTypesMultipleChoice_Fragment | Questions_ComponentQuestionTypesNestedQuestions_Fragment | Questions_ComponentQuestionTypesParticipant_Fragment | Questions_ComponentQuestionTypesSaboteur_Fragment | Questions_ComponentQuestionTypesSaboteurVideos_Fragment | Questions_ComponentQuestionTypesSimpleQuestion_Fragment | Questions_ComponentQuestionTypesSimpleReadOnly_Fragment | Questions_ComponentQuestionTypesSliderQuestions_Fragment | Questions_ComponentQuestionTypesStakeholderMap_Fragment | Questions_ComponentQuestionTypesUploadDocuments_Fragment | Questions_ComponentQuestionTypesUploadQuestion_Fragment | Questions_ComponentQuestionTypesValuesBubble_Fragment | Questions_ComponentQuestionTypesValuesCharacters_Fragment | Questions_ComponentQuestionTypesValuesGaps_Fragment | Questions_ComponentQuestionTypesValuesNested_Fragment | Questions_ComponentQuestionTypesValuesSliders_Fragment | Questions_ComponentQuestionTypesXyGraph_Fragment | Questions_Error_Fragment;

export type SectionFragment = (
  { __typename?: 'Section' }
  & Pick<Section, 'title_french' | 'title_german' | 'title_english' | 'title_spanish' | 'title_mandarin' | 'sub_title_french' | 'sub_title_german' | 'sub_title_english' | 'sub_title_spanish' | 'sub_title_mandarin'>
  & { cover?: Maybe<(
    { __typename?: 'UploadFile' }
    & Pick<UploadFile, 'documentId' | 'url'>
  )> }
);

export type SubmissionFragment = (
  { __typename?: 'Submission' }
  & Pick<Submission, 'documentId' | 'views' | 'progress' | 'status' | 'time_spent'>
  & { language?: Maybe<(
    { __typename?: 'Language' }
    & Pick<Language, 'documentId' | 'name'>
  )> }
);

export type UploadFileFragment = (
  { __typename?: 'UploadFile' }
  & Pick<UploadFile, 'documentId' | 'name' | 'alternativeText' | 'caption' | 'width' | 'height' | 'formats' | 'hash' | 'ext' | 'mime' | 'size' | 'url' | 'previewUrl' | 'provider' | 'createdAt' | 'updatedAt'>
);

export type AddDocumentMutationVariables = Exact<{
  input: EditUserUploadedDocumentInput;
}>;


export type AddDocumentMutation = (
  { __typename?: 'Mutation' }
  & { addDocument: (
    { __typename?: 'UserUploadedDocument' }
    & Pick<UserUploadedDocument, 'name'>
  ) }
);

export type AddNoteMutationVariables = Exact<{
  input: EditNoteInput;
}>;


export type AddNoteMutation = (
  { __typename?: 'Mutation' }
  & { addNote: (
    { __typename?: 'Notes' }
    & Pick<Notes, 'note'>
  ) }
);

export type ConfirmMyAppointmentsMutationVariables = Exact<{
  appointmentScheduleId: Scalars['ID']['input'];
  programmeSubmissionId: Scalars['ID']['input'];
  subModule: Scalars['Boolean']['input'];
}>;


export type ConfirmMyAppointmentsMutation = (
  { __typename?: 'Mutation' }
  & { confirmMyAppointments: (
    { __typename?: 'ConfirmAppointmentResponse' }
    & Pick<ConfirmAppointmentResponse, 'success' | 'message'>
  ) }
);

export type CreateAccountChangeMutationVariables = Exact<{
  data: AccountChangeInput;
}>;


export type CreateAccountChangeMutation = (
  { __typename?: 'Mutation' }
  & { createAccountChange?: Maybe<(
    { __typename?: 'AccountChange' }
    & Pick<AccountChange, 'documentId'>
  )> }
);

export type CreateBookingMutationVariables = Exact<{
  data: BookingInput;
}>;


export type CreateBookingMutation = (
  { __typename?: 'Mutation' }
  & { createBooking?: Maybe<(
    { __typename?: 'Booking' }
    & Pick<Booking, 'documentId' | 'title'>
  )> }
);

export type CreateProgrammeSubmissionMutationVariables = Exact<{
  data: ProgrammeSubmissionInput;
}>;


export type CreateProgrammeSubmissionMutation = (
  { __typename?: 'Mutation' }
  & { createProgrammeSubmission?: Maybe<(
    { __typename?: 'ProgrammeSubmission' }
    & Pick<ProgrammeSubmission, 'documentId' | 'status' | 'progress'>
  )> }
);

export type CreateSessionMutationVariables = Exact<{
  data: CoachSessionInput;
}>;


export type CreateSessionMutation = (
  { __typename?: 'Mutation' }
  & { createCoachSession?: Maybe<(
    { __typename?: 'CoachSession' }
    & Pick<CoachSession, 'documentId' | 'title' | 'createdAt' | 'updatedAt'>
  )> }
);

export type DeletedNoteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeletedNoteMutation = (
  { __typename?: 'Mutation' }
  & { deletedNote?: Maybe<(
    { __typename?: 'Notes' }
    & Pick<Notes, 'note'>
  )> }
);

export type GenerateCompetencyResponsesMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GenerateCompetencyResponsesMutation = (
  { __typename?: 'Mutation' }
  & { generateCompetencyResponses?: Maybe<(
    { __typename?: 'ProgrammeSubmissionResponse' }
    & Pick<ProgrammeSubmissionResponse, 'success'>
  )> }
);

export type GenerateMyMiniSectionSubmissionResponseMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  sectionId?: InputMaybe<Scalars['Int']['input']>;
  secId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GenerateMyMiniSectionSubmissionResponseMutation = (
  { __typename?: 'Mutation' }
  & { generateMyMiniSectionSubmissionResponse?: Maybe<(
    { __typename?: 'SubModuleSubmissionResponse' }
    & Pick<SubModuleSubmissionResponse, 'success'>
  )> }
);

export type GenerateMyProgrammeSubmissionResponsesMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GenerateMyProgrammeSubmissionResponsesMutation = (
  { __typename?: 'Mutation' }
  & { generateMyProgrammeSubmissionResponses?: Maybe<(
    { __typename?: 'ProgrammeSubmissionResponse' }
    & Pick<ProgrammeSubmissionResponse, 'success'>
  )> }
);

export type GenerateMySubModuleSubmissionComptencyResponsesMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  sectionId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GenerateMySubModuleSubmissionComptencyResponsesMutation = (
  { __typename?: 'Mutation' }
  & { generateMySubModuleSubmissionComptencyResponses?: Maybe<(
    { __typename?: 'SubModuleSubmissionResponse' }
    & Pick<SubModuleSubmissionResponse, 'success'>
  )> }
);

export type GenerateMySubModuleSubmissionResponsesMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  sectionId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GenerateMySubModuleSubmissionResponsesMutation = (
  { __typename?: 'Mutation' }
  & { generateMySubModuleSubmissionResponses?: Maybe<(
    { __typename?: 'SubModuleSubmissionResponse' }
    & Pick<SubModuleSubmissionResponse, 'success'>
  )> }
);

export type ResendMailMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
}>;


export type ResendMailMutation = (
  { __typename?: 'Mutation' }
  & { resendMail?: Maybe<(
    { __typename?: 'EmailSent' }
    & Pick<EmailSent, 'success'>
  )> }
);

export type ResendProgrammeMailMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
}>;


export type ResendProgrammeMailMutation = (
  { __typename?: 'Mutation' }
  & { resendProgrammeMail?: Maybe<(
    { __typename?: 'EmailSentProgramme' }
    & Pick<EmailSentProgramme, 'successed'>
  )> }
);

export type UpdateMySubModuleSubmissionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  currentSection?: InputMaybe<Scalars['Int']['input']>;
  isPdf?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  programmeSubmissionId?: InputMaybe<Scalars['ID']['input']>;
  input: EditSubModuleSubmissionInput;
}>;


export type UpdateMySubModuleSubmissionMutation = (
  { __typename?: 'Mutation' }
  & { updateMySubModuleSubmission: (
    { __typename?: 'SubModuleSubmission' }
    & Pick<SubModuleSubmission, 'id' | 'view' | 'progress' | 'status' | 'time_spent'>
    & { language?: Maybe<(
      { __typename?: 'Language' }
      & Pick<Language, 'documentId' | 'name'>
    )>, participants: Array<Maybe<(
      { __typename?: 'Participant' }
      & Pick<Participant, 'documentId' | 'name' | 'email' | 'type'>
    )>>, submission_participants?: Maybe<Array<Maybe<(
      { __typename?: 'ComponentSubmissionsParticipants' }
      & Pick<ComponentSubmissionsParticipants, 'id' | 'name'>
    )>>>, sub_module?: Maybe<(
      { __typename?: 'SubModule' }
      & Pick<SubModule, 'documentId' | 'name_french' | 'name_german' | 'name_english' | 'name_spanish' | 'name_mandarin' | 'description_french' | 'description_german' | 'description_english' | 'description_spanish'>
      & { cover?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'documentId' | 'url'>
      )>, programme_type?: Maybe<(
        { __typename?: 'ProgrammeType' }
        & Pick<ProgrammeType, 'documentId'>
      )> }
    )>, section?: Maybe<Array<Maybe<(
      { __typename?: 'ComponentSubmissionsSectionSubmission' }
      & Pick<ComponentSubmissionsSectionSubmission, 'id' | 'progress'>
      & { section?: Maybe<(
        { __typename?: 'Section' }
        & Pick<Section, 'documentId'>
      )>, answers?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsAnswer' }
        & Pick<ComponentSubmissionsAnswer, 'id' | 'questionId' | 'answer' | 'isCorrect' | 'feedback' | 'outcome'>
        & { nestedAnswers?: Maybe<Array<Maybe<(
          { __typename?: 'ComponentSubmissionsRepeatAnswer' }
          & Pick<ComponentSubmissionsRepeatAnswer, 'answer' | 'questionTitle'>
        )>>> }
      )>>> }
    )>>> }
  ) }
);

export type UpdateNotificationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: NotificationInput;
}>;


export type UpdateNotificationMutation = (
  { __typename?: 'Mutation' }
  & { updateNotification?: Maybe<(
    { __typename?: 'Notification' }
    & Pick<Notification, 'documentId' | 'title' | 'time_stamp' | 'path' | 'read'>
  )> }
);

export type UpdateMyProgrammeSubmissionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: EditProgrammeSubmissionInput;
  isPdf?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateMyProgrammeSubmissionMutation = (
  { __typename?: 'Mutation' }
  & { updateMyProgrammeSubmissions: (
    { __typename?: 'ProgrammeSubmission' }
    & Pick<ProgrammeSubmission, 'id' | 'status' | 'progress'>
    & { programme_type?: Maybe<(
      { __typename?: 'ProgrammeType' }
      & Pick<ProgrammeType, 'documentId' | 'title' | 'description' | 'is_coaching' | 'notes' | 'deadline' | 'archive'>
      & { cover?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'documentId' | 'url'>
      )>, programme_questions?: Maybe<Array<Maybe<{ __typename: 'ComponentQuestionTypesCompetency' } | { __typename: 'ComponentQuestionTypesCompetency2' } | { __typename: 'ComponentQuestionTypesFeedForward1' } | { __typename: 'ComponentQuestionTypesFeedForward2' } | { __typename: 'ComponentQuestionTypesGravitasGap' } | { __typename: 'ComponentQuestionTypesGravitasScale' } | { __typename: 'ComponentQuestionTypesGravitasSliders' } | { __typename: 'ComponentQuestionTypesMultipleChoice' } | { __typename: 'ComponentQuestionTypesNestedQuestions' } | { __typename: 'ComponentQuestionTypesParticipant' } | { __typename: 'ComponentQuestionTypesSaboteur' } | { __typename: 'ComponentQuestionTypesSaboteurVideos' } | { __typename: 'ComponentQuestionTypesSimpleQuestion' } | { __typename: 'ComponentQuestionTypesSimpleReadOnly' } | { __typename: 'ComponentQuestionTypesSliderQuestions' } | { __typename: 'ComponentQuestionTypesStakeholderMap' } | { __typename: 'ComponentQuestionTypesUploadQuestion' } | { __typename: 'ComponentQuestionTypesValuesBubble' } | { __typename: 'ComponentQuestionTypesValuesCharacters' } | { __typename: 'ComponentQuestionTypesValuesGaps' } | (
        { __typename: 'ComponentQuestionTypesValuesNested' }
        & Pick<ComponentQuestionTypesValuesNested, 'id' | 'title' | 'question'>
        & { questions?: Maybe<Array<Maybe<(
          { __typename?: 'ComponentQuestionTypesSimpleQuestion' }
          & Pick<ComponentQuestionTypesSimpleQuestion, 'id' | 'titleEnglish' | 'subTitleEnglish' | 'titleFrench' | 'subTitleFrench' | 'titleGerman' | 'subTitleGerman' | 'titleSpanish' | 'subTitleSpanish' | 'titleMandarin' | 'subTitleMandarin'>
        )>>> }
      ) | { __typename: 'ComponentQuestionTypesValuesSliders' } | { __typename: 'ComponentQuestionTypesXYGraph' } | { __typename: 'Error' }>>>, articles: Array<Maybe<(
        { __typename?: 'Article' }
        & Pick<Article, 'documentId' | 'createdAt' | 'updatedAt' | 'title_english' | 'title_french' | 'title_german' | 'title_spanish' | 'title_mandarin' | 'content_english' | 'content_french' | 'content_german' | 'content_spanish' | 'content_mandarin' | 'date_published' | 'read_time' | 'link'>
        & { image?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'documentId' | 'url'>
        )> }
      )>>, sub_modules: Array<Maybe<(
        { __typename?: 'SubModule' }
        & Pick<SubModule, 'documentId' | 'name_english' | 'description_english'>
        & { cover?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'documentId' | 'url'>
        )>, programme_type?: Maybe<(
          { __typename?: 'ProgrammeType' }
          & Pick<ProgrammeType, 'documentId'>
        )> }
      )>> }
    )> }
  ) }
);

export type UpdateSessionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: CoachSessionInput;
}>;


export type UpdateSessionMutation = (
  { __typename?: 'Mutation' }
  & { updateCoachSession?: Maybe<(
    { __typename?: 'CoachSession' }
    & Pick<CoachSession, 'documentId' | 'title' | 'status'>
    & { user?: Maybe<(
      { __typename?: 'UsersPermissionsUser' }
      & Pick<UsersPermissionsUser, 'documentId'>
    )> }
  )> }
);

export type UpdateMySubmissionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  currentSection?: InputMaybe<Scalars['Int']['input']>;
  programmeSubmissionId?: InputMaybe<Scalars['ID']['input']>;
  input: EditSubmissionInput;
}>;


export type UpdateMySubmissionMutation = (
  { __typename?: 'Mutation' }
  & { updateMySubmission: (
    { __typename?: 'Submission' }
    & Pick<Submission, 'id' | 'views' | 'progress' | 'status' | 'time_spent'>
    & { language?: Maybe<(
      { __typename?: 'Language' }
      & Pick<Language, 'documentId' | 'name'>
    )>, module?: Maybe<(
      { __typename?: 'Module' }
      & Pick<Module, 'documentId' | 'name_french' | 'name_german' | 'name_english' | 'name_spanish' | 'name_mandarin' | 'description_french' | 'description_german' | 'description_english' | 'description_spanish' | 'description_mandarin'>
      & { cover?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'documentId' | 'url'>
      )> }
    )>, section?: Maybe<Array<Maybe<(
      { __typename?: 'ComponentSubmissionsSectionSubmission' }
      & Pick<ComponentSubmissionsSectionSubmission, 'id' | 'progress'>
      & { section?: Maybe<(
        { __typename?: 'Section' }
        & Pick<Section, 'documentId'>
      )>, answers?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsAnswer' }
        & Pick<ComponentSubmissionsAnswer, 'id' | 'questionId' | 'answer' | 'isCorrect' | 'feedback' | 'outcome'>
        & { nestedAnswers?: Maybe<Array<Maybe<(
          { __typename?: 'ComponentSubmissionsRepeatAnswer' }
          & Pick<ComponentSubmissionsRepeatAnswer, 'answer' | 'questionTitle'>
        )>>> }
      )>>> }
    )>>> }
  ) }
);

export type UpdateSelfMutationVariables = Exact<{
  user: EditUserInput;
}>;


export type UpdateSelfMutation = (
  { __typename?: 'Mutation' }
  & { updateSelf: (
    { __typename?: 'UsersPermissionsUser' }
    & Pick<UsersPermissionsUser, 'documentId' | 'createdAt' | 'updatedAt' | 'email' | 'confirmed' | 'blocked' | 'phoneNumber' | 'onboarding' | 'firstName' | 'lastName' | 'jobTitle' | 'modulesRead' | 'homePromptsRead' | 'programmePromptsRead' | 'modulePromptsRead' | 'bookmarks' | 'articlesViewed'>
    & { profilePicture?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'documentId' | 'url'>
    )>, language?: Maybe<(
      { __typename?: 'Language' }
      & Pick<Language, 'documentId' | 'name'>
    )>, division?: Maybe<(
      { __typename?: 'Division' }
      & Pick<Division, 'documentId' | 'title_french' | 'title_german' | 'title_english' | 'title_mandarin' | 'title_spanish'>
    )>, report?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'documentId' | 'url'>
    )>, company?: Maybe<(
      { __typename?: 'Company' }
      & Pick<Company, 'documentId' | 'name' | 'programmes_title' | 'programmes_subTitle' | 'users_confirm_details'>
      & { logo?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'documentId' | 'url'>
      )>, language_selection?: Maybe<(
        { __typename?: 'ComponentTranslationsLanguageSelection' }
        & Pick<ComponentTranslationsLanguageSelection, 'id' | 'titleEnglish' | 'bodyEnglish' | 'nextButtonEnglish' | 'titleFrench' | 'bodyFrench' | 'nextButtonFrench' | 'titleGerman' | 'bodyGerman' | 'nextButtonGerman' | 'titleMandarin' | 'bodyMandarin' | 'nextButtonMandarin' | 'titleSpanish' | 'bodySpanish' | 'nextButtonSpanish'>
      )>, welcome_screen?: Maybe<(
        { __typename?: 'ComponentTranslationsWelcomeScreen' }
        & Pick<ComponentTranslationsWelcomeScreen, 'id' | 'titleEnglish' | 'bodyEnglish' | 'nextButtonEnglish' | 'titleFrench' | 'bodyFrench' | 'nextButtonFrench' | 'titleGerman' | 'bodyGerman' | 'nextButtonGerman' | 'titleMandarin' | 'bodyMandarin' | 'nextButtonMandarin' | 'titleSpanish' | 'bodySpanish' | 'nextButtonSpanish'>
        & { videoEnglish?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'url'>
        )>, videoFrench?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'url'>
        )>, videoGerman?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'url'>
        )>, videoMandarin?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'url'>
        )>, videoSpanish?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'url'>
        )> }
      )>, lets_get_started_screen?: Maybe<(
        { __typename?: 'ComponentTranslationsLetsGetStartedScreen' }
        & Pick<ComponentTranslationsLetsGetStartedScreen, 'id' | 'titleEnglish' | 'subTitleEnglish' | 'firstNameLabelEnglish' | 'firstNameErrorEnglish' | 'lastNameLabelEnglish' | 'lastNameErrorEnglish' | 'jobTitleLabelEnglish' | 'jobTitleErrorEnglish' | 'divisionLabelEnglish' | 'divisionErrorEnglish' | 'timezoneLabelEnglish' | 'regionLabelEnglish' | 'regionErrorEnglish' | 'nextButtonEnglish' | 'titleFrench' | 'subTitleFrench' | 'firstNameLabelFrench' | 'firstNameErrorFrench' | 'lastNameLabelFrench' | 'lastNameErrorFrench' | 'jobTitleLabelFrench' | 'jobTitleErrorFrench' | 'divisionLabelFrench' | 'divisionErrorFrench' | 'timezoneLabelFrench' | 'regionLabelFrench' | 'regionErrorFrench' | 'nextButtonFrench' | 'titleGerman' | 'subTitleGerman' | 'firstNameLabelGerman' | 'firstNameErrorGerman' | 'lastNameLabelGerman' | 'lastNameErrorGerman' | 'jobTitleLabelGerman' | 'jobTitleErrorGerman' | 'divisionLabelGerman' | 'divisionErrorGerman' | 'timezoneLabelGerman' | 'regionLabelGerman' | 'regionErrorGerman' | 'nextButtonGerman' | 'titleMandarin' | 'subTitleMandarin' | 'firstNameLabelMandarin' | 'firstNameErrorMandarin' | 'lastNameLabelMandarin' | 'lastNameErrorMandarin' | 'jobTitleLabelMandarin' | 'jobTitleErrorMandarin' | 'divisionLabelMandarin' | 'divisionErrorMandarin' | 'timezoneLabelMandarin' | 'regionLabelMandarin' | 'regionErrorMandarin' | 'nextButtonMandarin' | 'titleSpanish' | 'subTitleSpanish' | 'firstNameLabelSpanish' | 'firstNameErrorSpanish' | 'lastNameLabelSpanish' | 'lastNameErrorSpanish' | 'jobTitleLabelSpanish' | 'jobTitleErrorSpanish' | 'divisionLabelSpanish' | 'divisionErrorSpanish' | 'timezoneLabelSpanish' | 'regionLabelSpanish' | 'regionErrorSpanish' | 'nextButtonSpanish' | 'leftTitleEnglish' | 'leftSubtitleEnglish' | 'leftTitleSpanish' | 'leftSubtitleSpanish' | 'leftTitleMandarin' | 'leftSubTitleMandarin' | 'leftTitleFrench' | 'leftSubtitleFrench' | 'leftSubtitleGerman' | 'leftTitleGerman'>
        & { image?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'url'>
        )> }
      )>, what_to_expect?: Maybe<(
        { __typename?: 'ComponentTranslationsWhatToExpect' }
        & Pick<ComponentTranslationsWhatToExpect, 'id' | 'titleEnglish' | 'bodyEnglish' | 'getStartedButtonEnglish' | 'titleFrench' | 'bodyFrench' | 'getStartedButtonFrench' | 'titleGerman' | 'bodyGerman' | 'getStartedButtonGerman' | 'titleMandarin' | 'bodyMandarin' | 'getStartedButtonMandarin' | 'titleSpanish' | 'bodySpanish' | 'getStartedButtonSpanish'>
        & { image?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'url'>
        )> }
      )>, about_us?: Maybe<(
        { __typename?: 'ComponentTranslationsAboutUs' }
        & Pick<ComponentTranslationsAboutUs, 'id' | 'textEnglish' | 'textFrench' | 'textGerman' | 'userGuidelinesTextEnglish' | 'userGuidelinesTextGerman' | 'userGuidelinesTextFrench'>
        & { userGuidelinesEnglish: Array<Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'url'>
        )>>, userGuidelinesGerman: Array<Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'url'>
        )>>, userGuidelinesFrench: Array<Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'url'>
        )>> }
      )> }
    )>, submissions: Array<Maybe<(
      { __typename?: 'Submission' }
      & Pick<Submission, 'documentId'>
    )>>, programmes: Array<Maybe<(
      { __typename?: 'Programme' }
      & Pick<Programme, 'documentId' | 'name' | 'description' | 'start' | 'is_custom_journey' | 'position'>
      & { logo?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'documentId' | 'url'>
      )> }
    )>> }
  ) }
);

export type CheckResponsesFromTypeFormQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  sectionid?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CheckResponsesFromTypeFormQuery = (
  { __typename?: 'Query' }
  & { checkResponsesFromTypeForm?: Maybe<(
    { __typename?: 'Emails' }
    & Pick<Emails, 'emails'>
  )> }
);

export type CheckResponsesFromTypeFormProgrammeQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  sectionid?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CheckResponsesFromTypeFormProgrammeQuery = (
  { __typename?: 'Query' }
  & { checkResponsesFromTypeFormProgramme?: Maybe<(
    { __typename?: 'EmailsSent' }
    & Pick<EmailsSent, 'emails'>
  )> }
);

export type GetAllsectionReportQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetAllsectionReportQuery = (
  { __typename?: 'Query' }
  & { getAllsectionReport?: Maybe<Array<Maybe<(
    { __typename?: 'Report' }
    & Pick<Report, 'id' | 'name' | 'type' | 'section_or_module_id'>
    & { report?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'documentId' | 'url'>
    )> }
  )>>> }
);

export type GetArticlesQueryVariables = Exact<{
  filters?: InputMaybe<ArticleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GetArticlesQuery = (
  { __typename?: 'Query' }
  & { articles: Array<Maybe<(
    { __typename?: 'Article' }
    & Pick<Article, 'documentId' | 'createdAt' | 'updatedAt' | 'title_english' | 'title_french' | 'title_german' | 'title_spanish' | 'title_mandarin' | 'content_english' | 'content_french' | 'content_german' | 'content_spanish' | 'content_mandarin' | 'position' | 'date_published' | 'read_time' | 'link'>
    & { companies: Array<Maybe<(
      { __typename?: 'Company' }
      & Pick<Company, 'documentId' | 'name'>
    )>>, image?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'documentId' | 'url'>
    )> }
  )>> }
);

export type GetCoachSubmittedReportsQueryVariables = Exact<{
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GetCoachSubmittedReportsQuery = (
  { __typename?: 'Query' }
  & { coachSubmittedReports: Array<Maybe<(
    { __typename?: 'CoachSubmittedReport' }
    & Pick<CoachSubmittedReport, 'documentId' | 'name'>
    & { notes_id?: Maybe<Array<Maybe<(
      { __typename?: 'ComponentSubmissionsSaboteurComponent' }
      & Pick<ComponentSubmissionsSaboteurComponent, 'name'>
      & { saboteurProofValue?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'documentId' | 'url'>
      )> }
    )>>> }
  )>> }
);

export type GetCompanyQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCompanyQuery = (
  { __typename?: 'Query' }
  & { company?: Maybe<(
    { __typename?: 'Company' }
    & { programmes: Array<Maybe<(
      { __typename?: 'Programme' }
      & Pick<Programme, 'documentId' | 'name' | 'description' | 'start' | 'is_custom_journey' | 'show_timeline' | 'position'>
      & { programme_types: Array<Maybe<(
        { __typename?: 'ProgrammeType' }
        & Pick<ProgrammeType, 'documentId'>
        & { programme_submissions: Array<Maybe<(
          { __typename?: 'ProgrammeSubmission' }
          & Pick<ProgrammeSubmission, 'documentId'>
          & { user?: Maybe<(
            { __typename?: 'UsersPermissionsUser' }
            & Pick<UsersPermissionsUser, 'documentId'>
          )>, programme?: Maybe<(
            { __typename?: 'Programme' }
            & Pick<Programme, 'documentId' | 'is_custom_journey' | 'show_timeline'>
            & { logo?: Maybe<(
              { __typename?: 'UploadFile' }
              & Pick<UploadFile, 'documentId' | 'url'>
            )> }
          )> }
        )>> }
      )>> }
    )>> }
  )> }
);

export type GetCompanyDivisionsQueryVariables = Exact<{
  filters?: InputMaybe<DivisionFiltersInput>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type GetCompanyDivisionsQuery = (
  { __typename?: 'Query' }
  & { divisions: Array<Maybe<(
    { __typename?: 'Division' }
    & Pick<Division, 'documentId' | 'title_english' | 'title_french' | 'title_german' | 'title_spanish' | 'title_mandarin' | 'createdAt' | 'updatedAt'>
  )>> }
);

export type GetCompanyRegionsQueryVariables = Exact<{
  filters?: InputMaybe<RegionFiltersInput>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type GetCompanyRegionsQuery = (
  { __typename?: 'Query' }
  & { regions: Array<Maybe<(
    { __typename?: 'Region' }
    & Pick<Region, 'documentId' | 'name_english' | 'name_french' | 'name_german' | 'name_spanish' | 'name_mandarin' | 'createdAt' | 'updatedAt'>
  )>> }
);

export type GetDivisionsQueryVariables = Exact<{
  filters?: InputMaybe<DivisionFiltersInput>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type GetDivisionsQuery = (
  { __typename?: 'Query' }
  & { divisions: Array<Maybe<(
    { __typename?: 'Division' }
    & Pick<Division, 'documentId' | 'title_english' | 'title_french' | 'title_german' | 'title_spanish' | 'title_mandarin' | 'createdAt' | 'updatedAt'>
  )>> }
);

export type GetFirstFourNotesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFirstFourNotesQuery = (
  { __typename?: 'Query' }
  & { getFirstFourNotes?: Maybe<Array<Maybe<(
    { __typename?: 'Notes' }
    & Pick<Notes, 'id' | 'name' | 'note' | 'sectionOrSubmissionId' | 'createdAt'>
    & { document?: Maybe<Array<Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'id' | 'url'>
    )>>>, programme?: Maybe<(
      { __typename?: 'Programmes' }
      & Pick<Programmes, 'name'>
    )>, notesId?: Maybe<Array<Maybe<(
      { __typename?: 'ComponentSubmissionsSaboteurComponent' }
      & { saboteurProofValue?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'documentId' | 'url' | 'name'>
      )> }
    )>>>, subModuleSubmission?: Maybe<(
      { __typename?: 'SubModuleSubmission' }
      & { sub_module?: Maybe<(
        { __typename?: 'SubModule' }
        & Pick<SubModule, 'documentId' | 'name_english'>
      )> }
    )> }
  )>>> }
);

export type GetFirstTwelveArticlesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFirstTwelveArticlesQuery = (
  { __typename?: 'Query' }
  & { articles: Array<Maybe<(
    { __typename?: 'Article' }
    & Pick<Article, 'documentId' | 'createdAt' | 'updatedAt' | 'title_english' | 'title_french' | 'title_german' | 'title_spanish' | 'title_mandarin' | 'content_english' | 'content_french' | 'content_german' | 'content_spanish' | 'content_mandarin' | 'position' | 'date_published' | 'read_time' | 'link'>
    & { companies: Array<Maybe<(
      { __typename?: 'Company' }
      & Pick<Company, 'documentId'>
    )>>, image?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'url'>
    )> }
  )>> }
);

export type GetInviteQueryVariables = Exact<{
  filters?: InputMaybe<InviteFiltersInput>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type GetInviteQuery = (
  { __typename?: 'Query' }
  & { invites: Array<Maybe<(
    { __typename?: 'Invite' }
    & Pick<Invite, 'documentId' | 'email'>
    & { company?: Maybe<(
      { __typename?: 'Company' }
      & Pick<Company, 'documentId' | 'name'>
    )> }
  )>> }
);

export type GetLanguagesQueryVariables = Exact<{
  filters?: InputMaybe<LanguageFiltersInput>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type GetLanguagesQuery = (
  { __typename?: 'Query' }
  & { languages: Array<Maybe<(
    { __typename?: 'Language' }
    & Pick<Language, 'documentId' | 'name'>
    & { image?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'documentId' | 'url'>
    )>, companies: Array<Maybe<(
      { __typename?: 'Company' }
      & Pick<Company, 'documentId' | 'name'>
    )>> }
  )>> }
);

export type GetModuleQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetModuleQuery = (
  { __typename?: 'Query' }
  & { module?: Maybe<(
    { __typename?: 'Module' }
    & Pick<Module, 'documentId' | 'name_english' | 'name_french' | 'name_spanish' | 'name_german' | 'name_mandarin' | 'description_english' | 'description_french' | 'description_german' | 'description_mandarin' | 'description_spanish'>
    & { sections: Array<Maybe<(
      { __typename?: 'Section' }
      & Pick<Section, 'documentId' | 'title_french' | 'title_german' | 'title_english' | 'title_spanish' | 'title_mandarin' | 'sub_title_french' | 'sub_title_german' | 'sub_title_english' | 'sub_title_spanish' | 'sub_title_mandarin' | 'position' | 'archive'>
    )>> }
  )> }
);

export type GetModulesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetModulesQuery = (
  { __typename?: 'Query' }
  & { modules: Array<Maybe<(
    { __typename?: 'Module' }
    & Pick<Module, 'documentId' | 'name_english' | 'name_french' | 'name_spanish' | 'name_german' | 'name_mandarin' | 'description_english' | 'description_french' | 'description_spanish' | 'description_german' | 'description_mandarin'>
    & { sections: Array<Maybe<(
      { __typename?: 'Section' }
      & Pick<Section, 'documentId' | 'title_french' | 'title_german' | 'title_english' | 'title_spanish' | 'title_mandarin' | 'sub_title_french' | 'sub_title_german' | 'sub_title_english' | 'sub_title_spanish' | 'sub_title_mandarin' | 'archive'>
    )>> }
  )>> }
);

export type GetMyBookingsQueryVariables = Exact<{
  filters?: InputMaybe<BookingFiltersInput>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type GetMyBookingsQuery = (
  { __typename?: 'Query' }
  & { bookings: Array<Maybe<(
    { __typename?: 'Booking' }
    & Pick<Booking, 'documentId' | 'title' | 'description' | 'duration' | 'date' | 'confirmed' | 'event_id' | 'cancelled' | 'organiser' | 'location' | 'is_updated' | 'end'>
  )>> }
);

export type GetMyCoachSessionsQueryVariables = Exact<{
  filters?: InputMaybe<CoachSessionFiltersInput>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type GetMyCoachSessionsQuery = (
  { __typename?: 'Query' }
  & { coachSessions: Array<Maybe<(
    { __typename?: 'CoachSession' }
    & Pick<CoachSession, 'documentId' | 'title' | 'status'>
    & { user?: Maybe<(
      { __typename?: 'UsersPermissionsUser' }
      & Pick<UsersPermissionsUser, 'documentId'>
    )>, programme_submission?: Maybe<(
      { __typename?: 'ProgrammeSubmission' }
      & Pick<ProgrammeSubmission, 'documentId'>
    )>, sub_module_submission?: Maybe<(
      { __typename?: 'SubModuleSubmission' }
      & Pick<SubModuleSubmission, 'documentId'>
    )>, appointment?: Maybe<(
      { __typename?: 'Appointment' }
      & Pick<Appointment, 'documentId' | 'appointment_url' | 'appointment_start_date' | 'appointment_end_date' | 'status'>
    )> }
  )>> }
);

export type GetMyNotificationsQueryVariables = Exact<{
  filters?: InputMaybe<NotificationFiltersInput>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type GetMyNotificationsQuery = (
  { __typename?: 'Query' }
  & { notifications: Array<Maybe<(
    { __typename?: 'Notification' }
    & Pick<Notification, 'documentId' | 'createdAt' | 'updatedAt' | 'title' | 'time_stamp' | 'path' | 'read'>
    & { users: Array<Maybe<(
      { __typename?: 'UsersPermissionsUser' }
      & Pick<UsersPermissionsUser, 'documentId'>
    )>> }
  )>> }
);

export type GetMySubModuleReportQueryVariables = Exact<{
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GetMySubModuleReportQuery = (
  { __typename?: 'Query' }
  & { reports: Array<Maybe<(
    { __typename?: 'Report' }
    & Pick<Report, 'documentId' | 'name' | 'type' | 'section_or_module_id'>
    & { report?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'documentId' | 'url'>
    )>, sub_module_submission?: Maybe<(
      { __typename?: 'SubModuleSubmission' }
      & Pick<SubModuleSubmission, 'documentId'>
      & { section?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsSectionSubmission' }
        & Pick<ComponentSubmissionsSectionSubmission, 'progress'>
        & { section?: Maybe<(
          { __typename?: 'Section' }
          & Pick<Section, 'documentId' | 'title_english'>
        )> }
      )>>>, sub_module?: Maybe<(
        { __typename?: 'SubModule' }
        & Pick<SubModule, 'documentId'>
        & { programme_type?: Maybe<(
          { __typename?: 'ProgrammeType' }
          & Pick<ProgrammeType, 'documentId' | 'title'>
          & { programmes: Array<Maybe<(
            { __typename?: 'Programme' }
            & Pick<Programme, 'documentId' | 'name'>
          )>> }
        )> }
      )> }
    )> }
  )>> }
);

export type GetMySubModuleSubmissionsReportsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMySubModuleSubmissionsReportsQuery = (
  { __typename?: 'Query' }
  & { getMySubModuleSubmissionsReports?: Maybe<Array<Maybe<(
    { __typename?: 'SubModuleSubmissionReport' }
    & Pick<SubModuleSubmissionReport, 'id'>
    & { subModule: (
      { __typename?: 'SubModule' }
      & Pick<SubModule, 'id' | 'name_french' | 'name_german' | 'name_english' | 'name_spanish' | 'name_mandarin' | 'description_french' | 'description_german' | 'description_english' | 'description_spanish' | 'description_mandarin' | 'position'>
      & { cover?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'documentId' | 'url'>
      )>, sections: Array<Maybe<(
        { __typename?: 'Section' }
        & Pick<Section, 'documentId' | 'title_french' | 'title_german' | 'title_english' | 'title_spanish' | 'title_mandarin' | 'sub_title_french' | 'sub_title_german' | 'sub_title_english' | 'sub_title_spanish' | 'sub_title_mandarin' | 'position'>
        & { cover?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'documentId' | 'url'>
        )> }
      )>>, programme_type?: Maybe<(
        { __typename?: 'ProgrammeType' }
        & Pick<ProgrammeType, 'documentId' | 'title' | 'description' | 'position' | 'is_coaching' | 'is_sub_module' | 'notes' | 'show_article' | 'show_session' | 'show_participants' | 'competency_survey' | 'feedForward_survey' | 'deadline'>
        & { cover?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'documentId' | 'url'>
        )>, articles: Array<Maybe<(
          { __typename?: 'Article' }
          & Pick<Article, 'documentId' | 'createdAt' | 'updatedAt' | 'title_english' | 'title_french' | 'title_german' | 'title_spanish' | 'title_mandarin' | 'content_english' | 'content_french' | 'content_german' | 'content_spanish' | 'content_mandarin' | 'date_published' | 'read_time' | 'link'>
          & { image?: Maybe<(
            { __typename?: 'UploadFile' }
            & Pick<UploadFile, 'documentId' | 'url'>
          )> }
        )>>, modal?: Maybe<(
          { __typename?: 'Modal' }
          & Pick<Modal, 'documentId' | 'title' | 'subtitle' | 'message'>
          & { image?: Maybe<(
            { __typename?: 'UploadFile' }
            & Pick<UploadFile, 'documentId' | 'url' | 'name'>
          )> }
        )>, events: Array<Maybe<(
          { __typename?: 'Event' }
          & Pick<Event, 'documentId' | 'name' | 'link'>
        )>> }
      )> }
    ), reports: Array<(
      { __typename?: 'Report' }
      & Pick<Report, 'id' | 'name' | 'type' | 'section_or_module_id'>
      & { report?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'documentId' | 'url'>
      )> }
    )> }
  )>>> }
);

export type GetMySubModuleNotesQueryVariables = Exact<{
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  filters?: InputMaybe<NoteFiltersInput>;
}>;


export type GetMySubModuleNotesQuery = (
  { __typename?: 'Query' }
  & { notes: Array<Maybe<(
    { __typename?: 'Note' }
    & Pick<Note, 'documentId' | 'name' | 'note' | 'section_or_submission_id' | 'createdAt'>
    & { document: Array<Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'documentId' | 'url'>
    )>>, programme?: Maybe<(
      { __typename?: 'Programme' }
      & Pick<Programme, 'documentId' | 'name'>
    )>, notes_id?: Maybe<Array<Maybe<(
      { __typename?: 'ComponentSubmissionsSaboteurComponent' }
      & { saboteurProofValue?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'documentId' | 'url' | 'name'>
      )> }
    )>>>, sub_module_submission?: Maybe<(
      { __typename?: 'SubModuleSubmission' }
      & Pick<SubModuleSubmission, 'documentId'>
      & { sub_module?: Maybe<(
        { __typename?: 'SubModule' }
        & Pick<SubModule, 'documentId' | 'name_english'>
      )> }
    )> }
  )>> }
);

export type GetMyUploadedReportQueryVariables = Exact<{
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GetMyUploadedReportQuery = (
  { __typename?: 'Query' }
  & { uploadedReports: Array<Maybe<(
    { __typename?: 'UploadedReport' }
    & Pick<UploadedReport, 'documentId' | 'name' | 'type' | 'section_or_module_id'>
    & { report: Array<Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'documentId' | 'url' | 'createdAt'>
    )>> }
  )>> }
);

export type GetMyWorkQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyWorkQuery = (
  { __typename?: 'Query' }
  & { getMySubmissions?: Maybe<Array<Maybe<(
    { __typename?: 'Submission' }
    & Pick<Submission, 'id' | 'views' | 'progress' | 'status' | 'time_spent'>
    & { language?: Maybe<(
      { __typename?: 'Language' }
      & Pick<Language, 'documentId' | 'name'>
    )>, module?: Maybe<(
      { __typename?: 'Module' }
      & Pick<Module, 'documentId' | 'name_french' | 'name_german' | 'name_english' | 'name_spanish' | 'name_mandarin' | 'description_french' | 'description_german' | 'description_english' | 'description_spanish' | 'description_mandarin'>
      & { sections: Array<Maybe<(
        { __typename?: 'Section' }
        & Pick<Section, 'documentId' | 'title_english' | 'title_french' | 'title_german' | 'title_spanish' | 'title_mandarin' | 'sub_title_english' | 'sub_title_french' | 'sub_title_german' | 'sub_title_spanish' | 'sub_title_mandarin'>
      )>> }
    )>, section?: Maybe<Array<Maybe<(
      { __typename?: 'ComponentSubmissionsSectionSubmission' }
      & Pick<ComponentSubmissionsSectionSubmission, 'id'>
      & { answers?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsAnswer' }
        & Pick<ComponentSubmissionsAnswer, 'id' | 'questionId' | 'answer' | 'isCorrect' | 'feedback' | 'outcome'>
        & { nestedAnswers?: Maybe<Array<Maybe<(
          { __typename?: 'ComponentSubmissionsRepeatAnswer' }
          & Pick<ComponentSubmissionsRepeatAnswer, 'answer' | 'questionTitle'>
        )>>> }
      )>>>, section?: Maybe<(
        { __typename?: 'Section' }
        & Pick<Section, 'documentId' | 'createdAt' | 'updatedAt' | 'title_english' | 'title_french' | 'title_german' | 'title_spanish' | 'title_mandarin' | 'sub_title_english' | 'sub_title_french' | 'sub_title_german' | 'sub_title_spanish' | 'sub_title_mandarin'>
      )> }
    )>>> }
  )>>> }
);

export type GetSubModuleSubmissionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSubModuleSubmissionQuery = (
  { __typename?: 'Query' }
  & { subModuleSubmission?: Maybe<(
    { __typename?: 'SubModuleSubmission' }
    & Pick<SubModuleSubmission, 'documentId' | 'view' | 'progress' | 'status' | 'time_spent'>
    & { feedfoward_url?: Maybe<(
      { __typename?: 'FeedfowardUrl' }
      & Pick<FeedfowardUrl, 'documentId'>
    )>, competency_url?: Maybe<(
      { __typename?: 'CompetencyUrl' }
      & Pick<CompetencyUrl, 'documentId'>
    )>, competency_participants?: Maybe<Array<Maybe<(
      { __typename?: 'ComponentSubmissionsCompetencyParticipants' }
      & Pick<ComponentSubmissionsCompetencyParticipants, 'name' | 'email'>
    )>>>, participants: Array<Maybe<(
      { __typename?: 'Participant' }
      & Pick<Participant, 'documentId' | 'name' | 'email' | 'type'>
    )>>, submission_participants?: Maybe<Array<Maybe<(
      { __typename?: 'ComponentSubmissionsParticipants' }
      & Pick<ComponentSubmissionsParticipants, 'id' | 'name' | 'email'>
    )>>>, language?: Maybe<(
      { __typename?: 'Language' }
      & Pick<Language, 'documentId' | 'name'>
    )>, section?: Maybe<Array<Maybe<(
      { __typename?: 'ComponentSubmissionsSectionSubmission' }
      & Pick<ComponentSubmissionsSectionSubmission, 'id' | 'progress' | 'sliderAnswers'>
      & { section?: Maybe<(
        { __typename?: 'Section' }
        & Pick<Section, 'documentId'>
      )>, answers?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsAnswer' }
        & Pick<ComponentSubmissionsAnswer, 'id' | 'questionId' | 'answer' | 'isCorrect' | 'feedback' | 'outcome' | 'questionType' | 'questionTitle'>
        & { nestedAnswers?: Maybe<Array<Maybe<(
          { __typename?: 'ComponentSubmissionsRepeatAnswer' }
          & Pick<ComponentSubmissionsRepeatAnswer, 'answer' | 'questionTitle'>
        )>>> }
      )>>>, stakeholderChart?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'documentId' | 'url'>
      )>, stakeholderItems?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentStakeholderMapItemStackholderMapItem' }
        & Pick<ComponentStakeholderMapItemStackholderMapItem, 'id' | 'valueX' | 'valueY' | 'name' | 'color'>
      )>>>, gravitasScales?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentGravitasScaleItemsGravitasScaleItems' }
        & Pick<ComponentGravitasScaleItemsGravitasScaleItems, 'id' | 'labelOne' | 'labelTwo' | 'labelThree' | 'question' | 'answerOne' | 'answerTwo' | 'answerThree'>
      )>>>, gravitasSliderAnswers?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsGravitasSlidersAnswers' }
        & Pick<ComponentSubmissionsGravitasSlidersAnswers, 'negativeQuestion' | 'positiveQuestion'>
        & { colorAndRating?: Maybe<Array<Maybe<(
          { __typename?: 'ComponentOptionColorAndRating' }
          & Pick<ComponentOptionColorAndRating, 'color' | 'rate'>
        )>>> }
      )>>>, gravitasGap?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsGravitasGap' }
        & Pick<ComponentSubmissionsGravitasGap, 'id' | 'gap' | 'commitment'>
      )>>>, xYGraphChart?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'documentId' | 'url'>
      )>, saboteurImage?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'documentId' | 'url'>
      )>, xYGraphItems?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentXYGraphItemXYGraphItem' }
        & Pick<ComponentXyGraphItemXyGraphItem, 'id' | 'valueX' | 'valueY' | 'color'>
      )>>>, characteristics?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsCharacteristics' }
        & Pick<ComponentSubmissionsCharacteristics, 'id' | 'answer' | 'type'>
      )>>>, gapsAnswers?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsValuesGaps' }
        & Pick<ComponentSubmissionsValuesGaps, 'id' | 'gap' | 'commitment'>
      )>>>, competencyAnswers?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsCompetencyAnswer' }
        & Pick<ComponentSubmissionsCompetencyAnswer, 'id' | 'question' | 'rating' | 'steps' | 'response'>
      )>>>, uploadDocuments?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsUploadDocuments' }
        & { saboteurProofValue?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'documentId'>
        )> }
      )>>> }
    )>>>, sub_module?: Maybe<(
      { __typename?: 'SubModule' }
      & Pick<SubModule, 'documentId' | 'name_french' | 'name_german' | 'name_english' | 'name_spanish' | 'name_mandarin' | 'description_french' | 'description_german' | 'description_english' | 'description_spanish' | 'description_mandarin' | 'position'>
      & { cover?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'documentId' | 'url'>
      )>, sections: Array<Maybe<(
        { __typename?: 'Section' }
        & Pick<Section, 'documentId' | 'title_french' | 'title_german' | 'title_english' | 'title_spanish' | 'title_mandarin' | 'sub_title_french' | 'sub_title_german' | 'sub_title_english' | 'sub_title_spanish' | 'sub_title_mandarin' | 'position' | 'archive'>
        & { cover?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'documentId' | 'url'>
        )> }
      )>>, programme_type?: Maybe<(
        { __typename?: 'ProgrammeType' }
        & Pick<ProgrammeType, 'documentId' | 'title' | 'description' | 'position' | 'is_coaching' | 'is_sub_module' | 'notes' | 'show_article' | 'show_session' | 'show_participants' | 'competency_survey' | 'feedForward_survey' | 'deadline'>
        & { cover?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'documentId' | 'url'>
        )>, articles: Array<Maybe<(
          { __typename?: 'Article' }
          & Pick<Article, 'documentId' | 'createdAt' | 'updatedAt' | 'title_english' | 'title_french' | 'title_german' | 'title_spanish' | 'title_mandarin' | 'content_english' | 'content_french' | 'content_german' | 'content_spanish' | 'content_mandarin' | 'date_published' | 'read_time' | 'link'>
          & { image?: Maybe<(
            { __typename?: 'UploadFile' }
            & Pick<UploadFile, 'documentId' | 'url'>
          )> }
        )>>, modal?: Maybe<(
          { __typename?: 'Modal' }
          & Pick<Modal, 'documentId' | 'title' | 'subtitle' | 'message'>
          & { image?: Maybe<(
            { __typename?: 'UploadFile' }
            & Pick<UploadFile, 'documentId' | 'url' | 'name'>
          )> }
        )>, events: Array<Maybe<(
          { __typename?: 'Event' }
          & Pick<Event, 'documentId' | 'name' | 'link'>
        )>> }
      )> }
    )>, reports: Array<Maybe<(
      { __typename?: 'Report' }
      & Pick<Report, 'documentId' | 'name' | 'type' | 'section_or_module_id'>
      & { report?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'documentId' | 'url'>
      )> }
    )>> }
  )> }
);

export type GetNewTypeformFeedResponsesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNewTypeformFeedResponsesQuery = (
  { __typename?: 'Query' }
  & { getNewTypeformFeedResponses?: Maybe<(
    { __typename?: 'CheckConfirmed' }
    & Pick<CheckConfirmed, 'success'>
  )> }
);

export type GetNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNotificationsQuery = (
  { __typename?: 'Query' }
  & { notifications: Array<Maybe<(
    { __typename?: 'Notification' }
    & Pick<Notification, 'documentId' | 'createdAt' | 'updatedAt' | 'title' | 'time_stamp' | 'path' | 'read'>
    & { users: Array<Maybe<(
      { __typename?: 'UsersPermissionsUser' }
      & Pick<UsersPermissionsUser, 'documentId'>
    )>> }
  )>> }
);

export type GetOrderedSubmissionsQueryVariables = Exact<{
  programme: Scalars['ID']['input'];
}>;


export type GetOrderedSubmissionsQuery = (
  { __typename?: 'Query' }
  & { getOrderedSubmissions?: Maybe<Array<Maybe<(
    { __typename?: 'OrderedSubmissions' }
    & { programmeSubmission: (
      { __typename?: 'ProgrammeSubmission' }
      & Pick<ProgrammeSubmission, 'id' | 'progress'>
      & { programme?: Maybe<(
        { __typename?: 'Programme' }
        & Pick<Programme, 'documentId' | 'name' | 'description'>
        & { logo?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'documentId' | 'url'>
        )> }
      )>, programme_type?: Maybe<(
        { __typename?: 'ProgrammeType' }
        & Pick<ProgrammeType, 'documentId' | 'title' | 'is_sub_module' | 'archive' | 'position'>
        & { sub_modules: Array<Maybe<(
          { __typename?: 'SubModule' }
          & Pick<SubModule, 'documentId' | 'name_english' | 'name_french' | 'name_spanish' | 'name_mandarin' | 'name_german' | 'position'>
          & { sections: Array<Maybe<(
            { __typename?: 'Section' }
            & Pick<Section, 'documentId' | 'title_english' | 'title_french' | 'title_german' | 'title_spanish' | 'title_mandarin' | 'position'>
          )>> }
        )>> }
      )> }
    ), subModuleSubmissions: Array<(
      { __typename?: 'SubModuleSubmission' }
      & Pick<SubModuleSubmission, 'id' | 'view' | 'progress'>
      & { sub_module?: Maybe<(
        { __typename?: 'SubModule' }
        & Pick<SubModule, 'documentId' | 'name_french' | 'name_german' | 'name_english' | 'name_spanish' | 'name_mandarin' | 'position'>
        & { sections: Array<Maybe<(
          { __typename?: 'Section' }
          & Pick<Section, 'documentId' | 'title_french' | 'title_german' | 'title_english' | 'title_spanish' | 'title_mandarin' | 'position'>
        )>> }
      )>, section?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsSectionSubmission' }
        & Pick<ComponentSubmissionsSectionSubmission, 'id' | 'progress'>
        & { section?: Maybe<(
          { __typename?: 'Section' }
          & Pick<Section, 'documentId'>
        )> }
      )>>> }
    )> }
  )>>> }
);

export type GetProgammeReportsGroupedQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProgammeReportsGroupedQuery = (
  { __typename?: 'Query' }
  & { getProgammeReportsGrouped?: Maybe<Array<Maybe<(
    { __typename?: 'ReportsGrouped' }
    & Pick<ReportsGrouped, 'companyName'>
    & { programmeType?: Maybe<Array<Maybe<(
      { __typename?: 'ProgrammeTypeReport' }
      & Pick<ProgrammeTypeReport, 'programmeType' | 'programmeName'>
      & { sections?: Maybe<Array<Maybe<(
        { __typename?: 'SectionReport' }
        & Pick<SectionReport, 'programmeName' | 'programmeType' | 'name'>
        & { report?: Maybe<(
          { __typename?: 'ReportDetail' }
          & Pick<ReportDetail, 'id' | 'url'>
        )> }
      )>>> }
    )>>> }
  )>>> }
);

export type GetProgrammeQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetProgrammeQuery = (
  { __typename?: 'Query' }
  & { programme?: Maybe<(
    { __typename?: 'Programme' }
    & Pick<Programme, 'documentId' | 'name' | 'description' | 'what_to_expect' | 'completion'>
    & { logo?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'documentId' | 'url'>
    )> }
  )> }
);

export type GetProgrammeProgrammeSubmissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProgrammeProgrammeSubmissionsQuery = (
  { __typename?: 'Query' }
  & { programmeSubmissions: Array<Maybe<(
    { __typename?: 'ProgrammeSubmission' }
    & Pick<ProgrammeSubmission, 'documentId' | 'progress'>
    & { programme?: Maybe<(
      { __typename?: 'Programme' }
      & Pick<Programme, 'documentId' | 'name' | 'description'>
      & { logo?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'documentId' | 'url'>
      )> }
    )>, programme_type?: Maybe<(
      { __typename?: 'ProgrammeType' }
      & Pick<ProgrammeType, 'documentId' | 'title' | 'is_sub_module' | 'archive' | 'position'>
      & { sub_modules: Array<Maybe<(
        { __typename?: 'SubModule' }
        & Pick<SubModule, 'documentId' | 'name_english' | 'name_french' | 'name_spanish' | 'name_mandarin' | 'name_german' | 'position'>
        & { sections: Array<Maybe<(
          { __typename?: 'Section' }
          & Pick<Section, 'documentId' | 'title_english' | 'title_french' | 'title_german' | 'title_spanish' | 'title_mandarin'>
        )>> }
      )>> }
    )> }
  )>> }
);

export type GetMyProgrammeSubmissionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetMyProgrammeSubmissionQuery = (
  { __typename?: 'Query' }
  & { programmeSubmission?: Maybe<(
    { __typename?: 'ProgrammeSubmission' }
    & Pick<ProgrammeSubmission, 'documentId' | 'status' | 'progress' | 'selected'>
    & { competency_url?: Maybe<(
      { __typename?: 'CompetencyUrl' }
      & Pick<CompetencyUrl, 'documentId' | 'url'>
    )>, feedfoward_url?: Maybe<(
      { __typename?: 'FeedfowardUrl' }
      & Pick<FeedfowardUrl, 'documentId' | 'url'>
    )>, programme_type?: Maybe<(
      { __typename?: 'ProgrammeType' }
      & Pick<ProgrammeType, 'documentId' | 'title' | 'description' | 'show_participants' | 'is_coaching' | 'is_sub_module' | 'notes' | 'deadline'>
      & { cover?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'documentId' | 'url'>
      )>, programme_questions?: Maybe<Array<Maybe<{ __typename: 'ComponentQuestionTypesCompetency' } | (
        { __typename: 'ComponentQuestionTypesCompetency2' }
        & Pick<ComponentQuestionTypesCompetency2, 'titleEnglish' | 'titleFrench' | 'titleMandarin'>
        & { questionscompetency2?: Maybe<Array<Maybe<(
          { __typename?: 'ComponentQuestionTypesQuestionscompetency2' }
          & Pick<ComponentQuestionTypesQuestionscompetency2, 'title' | 'question' | 'maxiNumber' | 'miniNumber' | 'simpleQuestion' | 'miniLabel' | 'maxiLabel' | 'midiLabel' | 'textboxQuestion'>
        )>>> }
      ) | { __typename: 'ComponentQuestionTypesFeedForward1' } | { __typename: 'ComponentQuestionTypesFeedForward2' } | { __typename: 'ComponentQuestionTypesGravitasGap' } | { __typename: 'ComponentQuestionTypesGravitasScale' } | { __typename: 'ComponentQuestionTypesGravitasSliders' } | { __typename: 'ComponentQuestionTypesMultipleChoice' } | { __typename: 'ComponentQuestionTypesNestedQuestions' } | { __typename: 'ComponentQuestionTypesParticipant' } | { __typename: 'ComponentQuestionTypesSaboteur' } | { __typename: 'ComponentQuestionTypesSaboteurVideos' } | { __typename: 'ComponentQuestionTypesSimpleQuestion' } | { __typename: 'ComponentQuestionTypesSimpleReadOnly' } | { __typename: 'ComponentQuestionTypesSliderQuestions' } | { __typename: 'ComponentQuestionTypesStakeholderMap' } | { __typename: 'ComponentQuestionTypesUploadQuestion' } | { __typename: 'ComponentQuestionTypesValuesBubble' } | { __typename: 'ComponentQuestionTypesValuesCharacters' } | { __typename: 'ComponentQuestionTypesValuesGaps' } | (
        { __typename: 'ComponentQuestionTypesValuesNested' }
        & Pick<ComponentQuestionTypesValuesNested, 'title' | 'question' | 'description'>
        & { questions?: Maybe<Array<Maybe<(
          { __typename?: 'ComponentQuestionTypesSimpleQuestion' }
          & Pick<ComponentQuestionTypesSimpleQuestion, 'titleEnglish' | 'subTitleEnglish' | 'titleFrench' | 'subTitleFrench' | 'titleGerman' | 'subTitleGerman' | 'titleSpanish' | 'subTitleSpanish' | 'titleMandarin' | 'subTitleMandarin'>
        )>>> }
      ) | { __typename: 'ComponentQuestionTypesValuesSliders' } | { __typename: 'ComponentQuestionTypesXYGraph' } | { __typename: 'Error' }>>>, articles: Array<Maybe<(
        { __typename?: 'Article' }
        & Pick<Article, 'documentId' | 'createdAt' | 'updatedAt' | 'title_english' | 'title_french' | 'title_german' | 'title_spanish' | 'title_mandarin' | 'content_english' | 'content_french' | 'content_german' | 'content_spanish' | 'content_mandarin' | 'date_published' | 'read_time' | 'link'>
        & { image?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'documentId' | 'url'>
        )> }
      )>>, events: Array<Maybe<(
        { __typename?: 'Event' }
        & Pick<Event, 'documentId' | 'name' | 'link' | 'session_id'>
      )>>, sub_modules: Array<Maybe<(
        { __typename?: 'SubModule' }
        & Pick<SubModule, 'documentId' | 'name_english' | 'description_english'>
        & { cover?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'documentId' | 'url'>
        )>, programme_type?: Maybe<(
          { __typename?: 'ProgrammeType' }
          & Pick<ProgrammeType, 'documentId'>
        )> }
      )>> }
    )>, programme_responses?: Maybe<Array<Maybe<(
      { __typename?: 'ComponentSubmissionsProgrammeSubmissions' }
      & { answers?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsAnswer' }
        & Pick<ComponentSubmissionsAnswer, 'id' | 'questionId' | 'answer' | 'isCorrect' | 'feedback' | 'outcome' | 'questionType' | 'questionTitle'>
        & { nestedAnswers?: Maybe<Array<Maybe<(
          { __typename?: 'ComponentSubmissionsRepeatAnswer' }
          & Pick<ComponentSubmissionsRepeatAnswer, 'answer' | 'questionTitle'>
        )>>> }
      )>>>, stakeholderChart?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'documentId' | 'url'>
      )>, stakeholderItems?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentStakeholderMapItemStackholderMapItem' }
        & Pick<ComponentStakeholderMapItemStackholderMapItem, 'id' | 'valueX' | 'valueY' | 'name' | 'color'>
      )>>>, competencyAnswers?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsCompetencyAnswer' }
        & Pick<ComponentSubmissionsCompetencyAnswer, 'question' | 'rating' | 'response' | 'steps' | 'textboxQuestion'>
      )>>>, gravitasScales?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentGravitasScaleItemsGravitasScaleItems' }
        & Pick<ComponentGravitasScaleItemsGravitasScaleItems, 'id' | 'labelOne' | 'labelTwo' | 'labelThree' | 'question' | 'answerOne' | 'answerTwo' | 'answerThree'>
      )>>>, xYGraphChart?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'documentId' | 'url'>
      )>, saboteurImage?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'documentId' | 'url'>
      )>, xYGraphItems?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentXYGraphItemXYGraphItem' }
        & Pick<ComponentXyGraphItemXyGraphItem, 'id' | 'valueX' | 'valueY' | 'color'>
      )>>> }
    )>>>, participants: Array<Maybe<(
      { __typename?: 'Participant' }
      & Pick<Participant, 'documentId' | 'name' | 'email' | 'type'>
    )>>, submission_participants?: Maybe<Array<Maybe<(
      { __typename?: 'ComponentSubmissionsParticipants' }
      & Pick<ComponentSubmissionsParticipants, 'id' | 'name' | 'email'>
    )>>>, my_notes?: Maybe<Array<Maybe<(
      { __typename?: 'ComponentSubmissionsNotes' }
      & Pick<ComponentSubmissionsNotes, 'id' | 'title' | 'description'>
      & { document?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'documentId' | 'url'>
      )> }
    )>>> }
  )> }
);

export type GetProgrammesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProgrammesQuery = (
  { __typename?: 'Query' }
  & { programmes: Array<Maybe<(
    { __typename?: 'Programme' }
    & Pick<Programme, 'documentId' | 'name' | 'description'>
    & { logo?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'documentId' | 'url'>
    )>, programme_types: Array<Maybe<(
      { __typename?: 'ProgrammeType' }
      & Pick<ProgrammeType, 'documentId' | 'title'>
      & { sub_modules: Array<Maybe<(
        { __typename?: 'SubModule' }
        & Pick<SubModule, 'documentId'>
        & { sections: Array<Maybe<(
          { __typename?: 'Section' }
          & Pick<Section, 'documentId' | 'title_english'>
        )>> }
      )>> }
    )>> }
  )>> }
);

export type GetRegionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRegionsQuery = (
  { __typename?: 'Query' }
  & { regions: Array<Maybe<(
    { __typename?: 'Region' }
    & Pick<Region, 'documentId' | 'name_english' | 'name_french' | 'name_german' | 'name_spanish' | 'name_mandarin' | 'createdAt' | 'updatedAt'>
  )>> }
);

export type GetReportsGroupedQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReportsGroupedQuery = (
  { __typename?: 'Query' }
  & { getReportsGrouped?: Maybe<Array<Maybe<(
    { __typename?: 'ReportsGrouped' }
    & Pick<ReportsGrouped, 'companyName'>
    & { programmeType?: Maybe<Array<Maybe<(
      { __typename?: 'ProgrammeTypeReport' }
      & Pick<ProgrammeTypeReport, 'programmeType' | 'programmeName'>
      & { sections?: Maybe<Array<Maybe<(
        { __typename?: 'SectionReport' }
        & Pick<SectionReport, 'programmeName' | 'programmeType' | 'name'>
        & { report?: Maybe<(
          { __typename?: 'ReportDetail' }
          & Pick<ReportDetail, 'id' | 'url'>
        )> }
      )>>> }
    )>>> }
  )>>> }
);

export type GetSectionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSectionQuery = (
  { __typename?: 'Query' }
  & { section?: Maybe<(
    { __typename?: 'Section' }
    & Pick<Section, 'documentId' | 'title_english' | 'sub_title_english' | 'get_started_text' | 'show_session'>
    & { cover?: Maybe<(
      { __typename: 'UploadFile' }
      & Pick<UploadFile, 'name' | 'url'>
    )>, questions?: Maybe<Array<Maybe<{ __typename: 'ComponentQuestionTypesCompetency' } | (
      { __typename: 'ComponentQuestionTypesCompetency2' }
      & Pick<ComponentQuestionTypesCompetency2, 'titleEnglish' | 'titleFrench' | 'titleMandarin'>
      & { questionscompetency2?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentQuestionTypesQuestionscompetency2' }
        & Pick<ComponentQuestionTypesQuestionscompetency2, 'title' | 'question' | 'maxiNumber' | 'miniNumber' | 'simpleQuestion' | 'miniLabel' | 'maxiLabel' | 'midiLabel' | 'textboxQuestion'>
      )>>> }
    ) | (
      { __typename: 'ComponentQuestionTypesFeedForward1' }
      & Pick<ComponentQuestionTypesFeedForward1, 'id' | 'title' | 'question' | 'description'>
    ) | (
      { __typename: 'ComponentQuestionTypesFeedForward2' }
      & Pick<ComponentQuestionTypesFeedForward2, 'id' | 'title' | 'question' | 'description'>
    ) | (
      { __typename: 'ComponentQuestionTypesGravitasGap' }
      & Pick<ComponentQuestionTypesGravitasGap, 'id' | 'title' | 'question' | 'description' | 'color1' | 'color2' | 'color3'>
    ) | (
      { __typename: 'ComponentQuestionTypesGravitasScale' }
      & Pick<ComponentQuestionTypesGravitasScale, 'id' | 'titleEnglish' | 'subTitleEnglish' | 'questionOneEnglish' | 'questionTwoEnglish' | 'questionThreeEnglish' | 'titleOneEnglish' | 'titleTwoEnglish'>
      & { ratingInput?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentRatingInputRatingInput' }
        & Pick<ComponentRatingInputRatingInput, 'id' | 'labelOneEnglish' | 'labelTwoEnglish'>
      )>>> }
    ) | (
      { __typename: 'ComponentQuestionTypesGravitasSliders' }
      & Pick<ComponentQuestionTypesGravitasSliders, 'titleEnglish' | 'titleFrench' | 'titleMandarin' | 'titleSpanish' | 'titleGerman' | 'subTitleEnglish' | 'subTitleFrench' | 'subTitleGerman' | 'positiveHeadingEnglish' | 'positiveHeadingFrench' | 'positiveHeadingSpanish' | 'positiveHeadingMandarin' | 'positiveHeadingGerman' | 'negativeHeadingEnglish' | 'negativeHeadingFrench' | 'negativeHeadingSpanish' | 'negativeHeadingMandarin' | 'negativeHeadingGerman'>
      & { sliderQuestions?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentOptionSliderQuestions' }
        & Pick<ComponentOptionSliderQuestions, 'questionPositiveEnglish' | 'questionPositiveGerman' | 'questionPositiveMandarin' | 'questionPositiveSpanish' | 'questionPositiveFrench' | 'questionNegativeEnglish' | 'questionNegativeGerman' | 'questionNegativeFrench' | 'questionNegativeMandarin' | 'questionNegativeSpanish'>
      )>>>, sliderHeadings?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentOptionSliderHeadings' }
        & Pick<ComponentOptionSliderHeadings, 'headingEnglish' | 'headingSpanish' | 'headingGerman' | 'headingFrench' | 'rating' | 'color'>
      )>>> }
    ) | (
      { __typename: 'ComponentQuestionTypesMultipleChoice' }
      & Pick<ComponentQuestionTypesMultipleChoice, 'id' | 'titleEnglish' | 'titleFrench' | 'titleGerman' | 'titleSpanish' | 'titleMandarin' | 'viewPrevious' | 'numberOfAnswers'>
      & { option?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentOptionOption' }
        & Pick<ComponentOptionOption, 'id' | 'optionEnglish' | 'optionFrench' | 'optionGerman' | 'optionSpanish' | 'optionMandarin' | 'isCorrect'>
      )>>> }
    ) | (
      { __typename: 'ComponentQuestionTypesNestedQuestions' }
      & Pick<ComponentQuestionTypesNestedQuestions, 'id' | 'titleEnglish' | 'titleFrench' | 'titleGerman' | 'titleSpanish' | 'titleMandarin' | 'viewPrevious'>
      & { questions?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentQuestionTypesSimpleQuestion' }
        & Pick<ComponentQuestionTypesSimpleQuestion, 'id' | 'titleEnglish' | 'subTitleEnglish' | 'titleFrench' | 'subTitleFrench' | 'titleGerman' | 'subTitleGerman' | 'titleSpanish' | 'subTitleSpanish' | 'titleMandarin' | 'subTitleMandarin' | 'isNumeric'>
      )>>> }
    ) | { __typename: 'ComponentQuestionTypesParticipant' } | (
      { __typename: 'ComponentQuestionTypesSaboteur' }
      & Pick<ComponentQuestionTypesSaboteur, 'id' | 'titleEnglish' | 'subTitleEnglish' | 'titleFrench' | 'subTitleFrench' | 'titleGerman' | 'subTitleGerman' | 'titleSpanish' | 'subTitleSpanish' | 'titleMandarin' | 'subTitleMandarin' | 'labelEnglish' | 'labelFrench' | 'labelGerman' | 'labelSpanish'>
      & { saboteurQuestions?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentQuestionTypesSaboteurQuestions' }
        & Pick<ComponentQuestionTypesSaboteurQuestions, 'link' | 'skipProof' | 'labelEnglish' | 'labelFrench' | 'labelGerman' | 'labelSpanish' | 'labelMandarin'>
      )>>> }
    ) | (
      { __typename: 'ComponentQuestionTypesSaboteurVideos' }
      & Pick<ComponentQuestionTypesSaboteurVideos, 'id' | 'titleEnglish' | 'titleFrench' | 'titleGerman' | 'titleSpanish' | 'titleMandarin' | 'subTitleEnglish' | 'subTitleFrench' | 'subTitleGerman' | 'subTitleSpanish' | 'subTitleMandarin'>
      & { SaboteurVideo?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSaboteurVideoSaboteurVideo' }
        & Pick<ComponentSaboteurVideoSaboteurVideo, 'id' | 'videoTitleEnglish' | 'videoTitleFrench' | 'videoTitleGerman' | 'videoTitleSpanish' | 'videoTitleMandarin'>
        & { video?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'documentId' | 'url' | 'previewUrl'>
        )> }
      )>>> }
    ) | (
      { __typename: 'ComponentQuestionTypesSimpleQuestion' }
      & Pick<ComponentQuestionTypesSimpleQuestion, 'id' | 'titleEnglish' | 'titleFrench' | 'titleGerman' | 'titleSpanish' | 'titleMandarin' | 'subTitleEnglish' | 'subTitleFrench' | 'subTitleGerman' | 'subTitleSpanish' | 'subTitleMandarin'>
    ) | (
      { __typename: 'ComponentQuestionTypesSimpleReadOnly' }
      & Pick<ComponentQuestionTypesSimpleReadOnly, 'id' | 'titleEnglish' | 'titleFrench' | 'titleGerman' | 'titleMandarin' | 'titleSpanish' | 'subTitleEnglish' | 'subTitleFrench' | 'subTitleGerman' | 'subTitleMandarin' | 'subTitleSpanish' | 'contentEnglish' | 'contentFrench' | 'contentGerman' | 'contentMandarin' | 'contentSpanish'>
    ) | { __typename: 'ComponentQuestionTypesSliderQuestions' } | (
      { __typename: 'ComponentQuestionTypesStakeholderMap' }
      & Pick<ComponentQuestionTypesStakeholderMap, 'id' | 'titleEnglish' | 'subTitleEnglish' | 'titleFrench' | 'subTitleFrench' | 'titleSpanish' | 'subTitleSpanish' | 'titleGerman' | 'subTitleGerman' | 'titleMandarin' | 'subTitleMandarin' | 'questionX' | 'questionY'>
    ) | (
      { __typename: 'ComponentQuestionTypesUploadDocuments' }
      & Pick<ComponentQuestionTypesUploadDocuments, 'id' | 'titleEnglish' | 'titleFrench' | 'titleMandarin' | 'titleSpanish' | 'titleGerman' | 'subTitleEnglish' | 'subTitleFrench' | 'subTitleGerman' | 'subTitleMandarin' | 'subTitleSpanish'>
    ) | { __typename: 'ComponentQuestionTypesUploadQuestion' } | (
      { __typename: 'ComponentQuestionTypesValuesBubble' }
      & Pick<ComponentQuestionTypesValuesBubble, 'id' | 'title' | 'question' | 'description'>
    ) | (
      { __typename: 'ComponentQuestionTypesValuesCharacters' }
      & Pick<ComponentQuestionTypesValuesCharacters, 'id' | 'title' | 'question' | 'description'>
    ) | (
      { __typename: 'ComponentQuestionTypesValuesGaps' }
      & Pick<ComponentQuestionTypesValuesGaps, 'id' | 'title' | 'question' | 'description'>
    ) | (
      { __typename: 'ComponentQuestionTypesValuesNested' }
      & Pick<ComponentQuestionTypesValuesNested, 'id' | 'title' | 'question' | 'description'>
      & { questions?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentQuestionTypesSimpleQuestion' }
        & Pick<ComponentQuestionTypesSimpleQuestion, 'id' | 'titleEnglish' | 'subTitleEnglish' | 'titleFrench' | 'subTitleFrench' | 'titleGerman' | 'subTitleGerman' | 'titleSpanish' | 'subTitleSpanish' | 'titleMandarin' | 'subTitleMandarin'>
      )>>> }
    ) | (
      { __typename: 'ComponentQuestionTypesValuesSliders' }
      & Pick<ComponentQuestionTypesValuesSliders, 'id' | 'title' | 'question' | 'description'>
      & { sliderQuestions?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentQuestionTypesSliderQuestions' }
        & Pick<ComponentQuestionTypesSliderQuestions, 'id' | 'question' | 'color'>
      )>>> }
    ) | (
      { __typename: 'ComponentQuestionTypesXYGraph' }
      & Pick<ComponentQuestionTypesXyGraph, 'id' | 'labelXEnglish' | 'labelYEnglish' | 'titleEnglish' | 'subTitleEnglish' | 'labelXFrench' | 'labelYFrench' | 'titleFrench' | 'subTitleFrench' | 'labelXGerman' | 'labelYGerman' | 'titleGerman' | 'subTitleGerman' | 'labelXSpanish' | 'labelYSpanish' | 'titleSpanish' | 'subTitleSpanish' | 'labelXMandarin' | 'labelYMandarin' | 'titleMandarin' | 'subTitleMandarin'>
    ) | { __typename: 'Error' }>>>, events: Array<Maybe<(
      { __typename?: 'Event' }
      & Pick<Event, 'documentId' | 'name' | 'link' | 'session_id'>
    )>>, sub_module?: Maybe<(
      { __typename?: 'SubModule' }
      & Pick<SubModule, 'documentId'>
      & { programme_type?: Maybe<(
        { __typename?: 'ProgrammeType' }
        & Pick<ProgrammeType, 'documentId' | 'title'>
      )> }
    )> }
  )> }
);

export type GetSectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSectionsQuery = (
  { __typename?: 'Query' }
  & { sections: Array<Maybe<(
    { __typename?: 'Section' }
    & Pick<Section, 'documentId' | 'title_english' | 'sub_title_english' | 'title_french' | 'title_german' | 'title_spanish' | 'title_mandarin' | 'sub_title_french' | 'sub_title_german' | 'sub_title_spanish' | 'sub_title_mandarin' | 'show_session' | 'archive'>
    & { events: Array<Maybe<(
      { __typename?: 'Event' }
      & Pick<Event, 'documentId' | 'name' | 'link' | 'session_id'>
    )>> }
  )>> }
);

export type GetCoachSessionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCoachSessionQuery = (
  { __typename?: 'Query' }
  & { coachSession?: Maybe<(
    { __typename?: 'CoachSession' }
    & Pick<CoachSession, 'documentId' | 'title' | 'status'>
    & { user?: Maybe<(
      { __typename?: 'UsersPermissionsUser' }
      & Pick<UsersPermissionsUser, 'documentId'>
    )>, programme_submission?: Maybe<(
      { __typename?: 'ProgrammeSubmission' }
      & Pick<ProgrammeSubmission, 'documentId'>
    )>, sub_module_submission?: Maybe<(
      { __typename?: 'SubModuleSubmission' }
      & Pick<SubModuleSubmission, 'documentId'>
    )> }
  )> }
);

export type GetCoachSessionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCoachSessionsQuery = (
  { __typename?: 'Query' }
  & { coachSessions: Array<Maybe<(
    { __typename?: 'CoachSession' }
    & Pick<CoachSession, 'documentId' | 'title' | 'status'>
  )>> }
);

export type GetSubModuleQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSubModuleQuery = (
  { __typename?: 'Query' }
  & { subModule?: Maybe<(
    { __typename?: 'SubModule' }
    & Pick<SubModule, 'documentId' | 'name_english' | 'name_french' | 'name_spanish' | 'name_german' | 'name_mandarin' | 'description_english' | 'description_french' | 'description_spanish' | 'description_german' | 'description_mandarin'>
    & { sections: Array<Maybe<(
      { __typename?: 'Section' }
      & Pick<Section, 'documentId' | 'title_french' | 'title_german' | 'title_english' | 'title_spanish' | 'title_mandarin' | 'sub_title_french' | 'sub_title_german' | 'sub_title_english' | 'sub_title_spanish' | 'sub_title_mandarin' | 'position' | 'archive'>
    )>>, programme_type?: Maybe<(
      { __typename?: 'ProgrammeType' }
      & Pick<ProgrammeType, 'documentId' | 'title' | 'description' | 'position' | 'is_coaching' | 'is_sub_module' | 'notes' | 'show_article' | 'show_session' | 'show_participants' | 'competency_survey' | 'feedForward_survey' | 'deadline'>
      & { articles: Array<Maybe<(
        { __typename?: 'Article' }
        & Pick<Article, 'documentId' | 'createdAt' | 'updatedAt' | 'title_english' | 'title_french' | 'title_german' | 'title_spanish' | 'title_mandarin' | 'content_english' | 'content_french' | 'content_german' | 'content_spanish' | 'content_mandarin' | 'date_published' | 'read_time' | 'link'>
        & { image?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'documentId' | 'url'>
        )> }
      )>>, modal?: Maybe<(
        { __typename?: 'Modal' }
        & Pick<Modal, 'documentId' | 'title' | 'subtitle' | 'message'>
        & { image?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'documentId' | 'url' | 'name'>
        )> }
      )>, events: Array<Maybe<(
        { __typename?: 'Event' }
        & Pick<Event, 'documentId' | 'name' | 'link'>
      )>> }
    )> }
  )> }
);

export type GetMySubModuleSubmissionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetMySubModuleSubmissionQuery = (
  { __typename?: 'Query' }
  & { subModuleSubmission?: Maybe<(
    { __typename?: 'SubModuleSubmission' }
    & Pick<SubModuleSubmission, 'documentId' | 'view' | 'progress' | 'status' | 'time_spent'>
    & { participants: Array<Maybe<(
      { __typename?: 'Participant' }
      & Pick<Participant, 'documentId' | 'name' | 'email' | 'type'>
    )>>, submission_participants?: Maybe<Array<Maybe<(
      { __typename?: 'ComponentSubmissionsParticipants' }
      & Pick<ComponentSubmissionsParticipants, 'id' | 'name' | 'email'>
    )>>>, feedfoward_url?: Maybe<(
      { __typename?: 'FeedfowardUrl' }
      & Pick<FeedfowardUrl, 'documentId'>
    )>, language?: Maybe<(
      { __typename?: 'Language' }
      & Pick<Language, 'documentId' | 'name'>
    )>, sub_module?: Maybe<(
      { __typename?: 'SubModule' }
      & Pick<SubModule, 'documentId' | 'name_french' | 'name_german' | 'name_english' | 'name_spanish' | 'name_mandarin' | 'description_french' | 'description_german' | 'description_english' | 'description_spanish' | 'description_mandarin' | 'position'>
      & { cover?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'documentId' | 'url'>
      )>, sections: Array<Maybe<(
        { __typename?: 'Section' }
        & Pick<Section, 'documentId' | 'title_french' | 'title_german' | 'title_english' | 'title_spanish' | 'title_mandarin' | 'sub_title_french' | 'sub_title_german' | 'sub_title_english' | 'sub_title_spanish' | 'sub_title_mandarin' | 'position' | 'archive'>
        & { cover?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'documentId' | 'url'>
        )> }
      )>>, programme_type?: Maybe<(
        { __typename?: 'ProgrammeType' }
        & Pick<ProgrammeType, 'documentId' | 'title' | 'description' | 'position' | 'is_coaching' | 'is_sub_module' | 'notes' | 'show_article' | 'show_session' | 'show_participants' | 'competency_survey' | 'feedForward_survey' | 'deadline' | 'show_statistics'>
        & { cover?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'documentId' | 'url'>
        )>, articles: Array<Maybe<(
          { __typename?: 'Article' }
          & Pick<Article, 'documentId' | 'createdAt' | 'updatedAt' | 'title_english' | 'title_french' | 'title_german' | 'title_spanish' | 'title_mandarin' | 'content_english' | 'content_french' | 'content_german' | 'content_spanish' | 'content_mandarin' | 'date_published' | 'read_time' | 'link'>
          & { image?: Maybe<(
            { __typename?: 'UploadFile' }
            & Pick<UploadFile, 'documentId' | 'url'>
          )> }
        )>>, modal?: Maybe<(
          { __typename?: 'Modal' }
          & Pick<Modal, 'documentId' | 'title' | 'subtitle' | 'message'>
          & { image?: Maybe<(
            { __typename?: 'UploadFile' }
            & Pick<UploadFile, 'documentId' | 'url' | 'name'>
          )> }
        )>, events: Array<Maybe<(
          { __typename?: 'Event' }
          & Pick<Event, 'documentId' | 'name' | 'link'>
        )>> }
      )> }
    )>, section?: Maybe<Array<Maybe<(
      { __typename?: 'ComponentSubmissionsSectionSubmission' }
      & Pick<ComponentSubmissionsSectionSubmission, 'id' | 'progress' | 'sliderAnswers'>
      & { section?: Maybe<(
        { __typename?: 'Section' }
        & Pick<Section, 'documentId'>
      )>, answers?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsAnswer' }
        & Pick<ComponentSubmissionsAnswer, 'id' | 'questionId' | 'answer' | 'isCorrect' | 'feedback' | 'outcome' | 'questionType' | 'questionTitle'>
        & { nestedAnswers?: Maybe<Array<Maybe<(
          { __typename?: 'ComponentSubmissionsRepeatAnswer' }
          & Pick<ComponentSubmissionsRepeatAnswer, 'answer' | 'questionTitle'>
        )>>> }
      )>>>, stakeholderChart?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'documentId' | 'url'>
      )>, stakeholderItems?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentStakeholderMapItemStackholderMapItem' }
        & Pick<ComponentStakeholderMapItemStackholderMapItem, 'id' | 'valueX' | 'valueY' | 'name' | 'color'>
      )>>>, gravitasScales?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentGravitasScaleItemsGravitasScaleItems' }
        & Pick<ComponentGravitasScaleItemsGravitasScaleItems, 'id' | 'labelOne' | 'labelTwo' | 'labelThree' | 'question' | 'answerOne' | 'answerTwo' | 'answerThree'>
      )>>>, gravitasSliderAnswers?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsGravitasSlidersAnswers' }
        & Pick<ComponentSubmissionsGravitasSlidersAnswers, 'negativeQuestion' | 'positiveQuestion'>
        & { colorAndRating?: Maybe<Array<Maybe<(
          { __typename?: 'ComponentOptionColorAndRating' }
          & Pick<ComponentOptionColorAndRating, 'color' | 'rate'>
        )>>> }
      )>>>, gravitasGap?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsGravitasGap' }
        & Pick<ComponentSubmissionsGravitasGap, 'id' | 'gap' | 'commitment'>
      )>>>, xYGraphChart?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'documentId' | 'url'>
      )>, saboteurImage?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'documentId' | 'url'>
      )>, xYGraphItems?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentXYGraphItemXYGraphItem' }
        & Pick<ComponentXyGraphItemXyGraphItem, 'id' | 'valueX' | 'valueY' | 'color'>
      )>>>, characteristics?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsCharacteristics' }
        & Pick<ComponentSubmissionsCharacteristics, 'id' | 'answer' | 'type'>
      )>>>, gapsAnswers?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsValuesGaps' }
        & Pick<ComponentSubmissionsValuesGaps, 'id' | 'gap' | 'commitment'>
      )>>>, competencyAnswers?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsCompetencyAnswer' }
        & Pick<ComponentSubmissionsCompetencyAnswer, 'id' | 'question' | 'rating' | 'steps' | 'response'>
      )>>>, uploadDocuments?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsUploadDocuments' }
        & { saboteurProofValue?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'documentId' | 'url'>
        )> }
      )>>> }
    )>>>, reports: Array<Maybe<(
      { __typename?: 'Report' }
      & Pick<Report, 'documentId' | 'name' | 'type' | 'section_or_module_id'>
      & { report?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'documentId' | 'url'>
      )> }
    )>> }
  )> }
);

export type GetSubModulesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSubModulesQuery = (
  { __typename?: 'Query' }
  & { subModules: Array<Maybe<(
    { __typename?: 'SubModule' }
    & Pick<SubModule, 'documentId' | 'name_english' | 'name_french' | 'name_german' | 'name_spanish' | 'name_mandarin' | 'description_english' | 'description_french' | 'description_german' | 'description_spanish' | 'description_mandarin'>
    & { cover?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'documentId' | 'url'>
    )>, sections: Array<Maybe<(
      { __typename?: 'Section' }
      & Pick<Section, 'documentId' | 'title_english' | 'title_french' | 'title_german' | 'title_spanish' | 'title_mandarin' | 'sub_title_english' | 'sub_title_french' | 'sub_title_german' | 'sub_title_spanish' | 'sub_title_mandarin' | 'archive'>
      & { video_english?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'documentId' | 'url'>
      )>, video_french?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'documentId' | 'url'>
      )>, video_german?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'documentId' | 'url'>
      )>, video_spanish?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'documentId' | 'url'>
      )>, video_mandarin?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'documentId' | 'url'>
      )> }
    )>> }
  )>> }
);

export type GetSectionReportQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSectionReportQuery = (
  { __typename?: 'Query' }
  & { getSectionReport: (
    { __typename?: 'Report' }
    & Pick<Report, 'id' | 'name' | 'type' | 'section_or_module_id'>
    & { report?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'documentId' | 'url'>
    )> }
  ) }
);

export type GetMySubmissionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetMySubmissionQuery = (
  { __typename?: 'Query' }
  & { submission?: Maybe<(
    { __typename?: 'Submission' }
    & Pick<Submission, 'documentId' | 'views' | 'progress' | 'status' | 'time_spent'>
    & { language?: Maybe<(
      { __typename?: 'Language' }
      & Pick<Language, 'documentId' | 'name'>
    )>, module?: Maybe<(
      { __typename?: 'Module' }
      & Pick<Module, 'documentId' | 'name_french' | 'name_german' | 'name_english' | 'name_spanish' | 'name_mandarin' | 'description_french' | 'description_german' | 'description_english' | 'description_spanish' | 'description_mandarin' | 'position'>
      & { cover?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'documentId' | 'url'>
      )>, sections: Array<Maybe<(
        { __typename?: 'Section' }
        & Pick<Section, 'documentId' | 'title_french' | 'title_german' | 'title_english' | 'title_spanish' | 'title_mandarin' | 'sub_title_french' | 'sub_title_german' | 'sub_title_english' | 'sub_title_spanish' | 'sub_title_mandarin'>
        & { cover?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'documentId' | 'url'>
        )> }
      )>> }
    )>, section?: Maybe<Array<Maybe<(
      { __typename?: 'ComponentSubmissionsSectionSubmission' }
      & Pick<ComponentSubmissionsSectionSubmission, 'id' | 'progress'>
      & { section?: Maybe<(
        { __typename?: 'Section' }
        & Pick<Section, 'documentId'>
      )>, answers?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsAnswer' }
        & Pick<ComponentSubmissionsAnswer, 'id' | 'questionId' | 'answer' | 'isCorrect' | 'feedback' | 'outcome' | 'questionType' | 'questionTitle'>
        & { nestedAnswers?: Maybe<Array<Maybe<(
          { __typename?: 'ComponentSubmissionsRepeatAnswer' }
          & Pick<ComponentSubmissionsRepeatAnswer, 'answer' | 'questionTitle'>
        )>>> }
      )>>>, stakeholderChart?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'documentId' | 'url'>
      )>, stakeholderItems?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentStakeholderMapItemStackholderMapItem' }
        & Pick<ComponentStakeholderMapItemStackholderMapItem, 'id' | 'valueX' | 'valueY' | 'name' | 'color'>
      )>>>, gravitasScales?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentGravitasScaleItemsGravitasScaleItems' }
        & Pick<ComponentGravitasScaleItemsGravitasScaleItems, 'id' | 'labelOne' | 'labelTwo' | 'labelThree' | 'question' | 'answerOne' | 'answerTwo' | 'answerThree'>
      )>>>, xYGraphChart?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'documentId' | 'url'>
      )>, saboteurImage?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'documentId' | 'url'>
      )>, xYGraphItems?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentXYGraphItemXYGraphItem' }
        & Pick<ComponentXyGraphItemXyGraphItem, 'id' | 'valueX' | 'valueY' | 'color'>
      )>>> }
    )>>>, reports: Array<Maybe<(
      { __typename?: 'Report' }
      & Pick<Report, 'documentId' | 'name' | 'type' | 'section_or_module_id'>
      & { report?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'documentId' | 'url'>
      )> }
    )>> }
  )> }
);

export type GetSubmissionReportGroupedQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSubmissionReportGroupedQuery = (
  { __typename?: 'Query' }
  & { getSubmissionReportGrouped?: Maybe<Array<Maybe<(
    { __typename?: 'ReportsSubmissionGrouped' }
    & Pick<ReportsSubmissionGrouped, 'id' | 'name' | 'type' | 'createdBy' | 'updatedBy' | 'programmeType' | 'subModuleSubmission' | 'notification'>
    & { report?: Maybe<(
      { __typename?: 'ReportDetail' }
      & Pick<ReportDetail, 'id' | 'url'>
    )> }
  )>>> }
);

export type GetTranslationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTranslationsQuery = (
  { __typename?: 'Query' }
  & { translation?: Maybe<(
    { __typename?: 'Translation' }
    & Pick<Translation, 'documentId'>
    & { menu?: Maybe<(
      { __typename?: 'ComponentTranslationsMenu' }
      & Pick<ComponentTranslationsMenu, 'homeEnglish' | 'myProgrammeEnglish' | 'myWorkEnglish' | 'myLibraryEnglish' | 'myProfileEnglish' | 'helpAndSupportEnglish' | 'signOutEnglish' | 'homeFrench' | 'myProgrammeFrench' | 'myWorkFrench' | 'myLibraryFrench' | 'myProfileFrench' | 'helpAndSupportFrench' | 'signOutFrench' | 'homeGerman' | 'myProgrammeGerman' | 'myWorkGerman' | 'myLibraryGerman' | 'myProfileGerman' | 'helpAndSupportGerman' | 'signOutGerman' | 'homeSpanish' | 'myProgrammeSpanish' | 'myWorkSpanish' | 'myLibrarySpanish' | 'myProfileSpanish' | 'helpAndSupportSpanish' | 'signOutSpanish' | 'homeMandarin' | 'myProgrammeMandarin' | 'myWorkMandarin' | 'myLibraryMandarin' | 'myProfileMandarin' | 'helpAndSupportMandarin' | 'signOutMandarin' | 'aboutUsEnglish' | 'aboutUsGerman' | 'aboutUsFrench' | 'myNotesEnglish' | 'myNotesGerman' | 'myNotesFrench' | 'myNotesSpanish' | 'myNotesMandarin' | 'notificationsEnglish' | 'notificationsGerman' | 'notificationsFrench' | 'notificationsSpanish' | 'notificationsMandarin'>
    )>, language_selection?: Maybe<(
      { __typename?: 'ComponentTranslationsLanguageSelection' }
      & Pick<ComponentTranslationsLanguageSelection, 'titleEnglish' | 'bodyEnglish' | 'nextButtonEnglish' | 'titleFrench' | 'bodyFrench' | 'nextButtonFrench' | 'titleGerman' | 'bodyGerman' | 'nextButtonGerman' | 'titleMandarin' | 'bodyMandarin' | 'nextButtonMandarin' | 'titleSpanish' | 'bodySpanish' | 'nextButtonSpanish'>
    )>, welcome_screen?: Maybe<(
      { __typename?: 'ComponentTranslationsWelcomeScreen' }
      & Pick<ComponentTranslationsWelcomeScreen, 'titleEnglish' | 'bodyEnglish' | 'nextButtonEnglish' | 'titleFrench' | 'bodyFrench' | 'nextButtonFrench' | 'titleGerman' | 'bodyGerman' | 'nextButtonGerman' | 'titleMandarin' | 'bodyMandarin' | 'nextButtonMandarin' | 'titleSpanish' | 'bodySpanish' | 'nextButtonSpanish'>
      & { videoEnglish?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'documentId' | 'url'>
      )>, videoFrench?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'documentId' | 'url'>
      )>, videoGerman?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'documentId' | 'url'>
      )>, videoMandarin?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'documentId' | 'url'>
      )>, videoSpanish?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'documentId' | 'url'>
      )> }
    )>, lets_get_started_screen?: Maybe<(
      { __typename?: 'ComponentTranslationsLetsGetStartedScreen' }
      & Pick<ComponentTranslationsLetsGetStartedScreen, 'titleEnglish' | 'subTitleEnglish' | 'firstNameLabelEnglish' | 'firstNameErrorEnglish' | 'lastNameLabelEnglish' | 'lastNameErrorEnglish' | 'jobTitleLabelEnglish' | 'jobTitleErrorEnglish' | 'divisionLabelEnglish' | 'divisionErrorEnglish' | 'timezoneLabelEnglish' | 'regionLabelEnglish' | 'regionErrorEnglish' | 'nextButtonEnglish' | 'titleFrench' | 'subTitleFrench' | 'firstNameLabelFrench' | 'firstNameErrorFrench' | 'lastNameLabelFrench' | 'lastNameErrorFrench' | 'jobTitleLabelFrench' | 'jobTitleErrorFrench' | 'divisionLabelFrench' | 'divisionErrorFrench' | 'timezoneLabelFrench' | 'regionLabelFrench' | 'regionErrorFrench' | 'nextButtonFrench' | 'titleGerman' | 'subTitleGerman' | 'firstNameLabelGerman' | 'firstNameErrorGerman' | 'lastNameLabelGerman' | 'lastNameErrorGerman' | 'jobTitleLabelGerman' | 'jobTitleErrorGerman' | 'divisionLabelGerman' | 'divisionErrorGerman' | 'timezoneLabelGerman' | 'regionLabelGerman' | 'regionErrorGerman' | 'nextButtonGerman' | 'titleMandarin' | 'subTitleMandarin' | 'firstNameLabelMandarin' | 'firstNameErrorMandarin' | 'lastNameLabelMandarin' | 'lastNameErrorMandarin' | 'jobTitleLabelMandarin' | 'jobTitleErrorMandarin' | 'divisionLabelMandarin' | 'divisionErrorMandarin' | 'timezoneLabelMandarin' | 'regionLabelMandarin' | 'regionErrorMandarin' | 'nextButtonMandarin' | 'titleSpanish' | 'subTitleSpanish' | 'firstNameLabelSpanish' | 'firstNameErrorSpanish' | 'lastNameLabelSpanish' | 'lastNameErrorSpanish' | 'jobTitleLabelSpanish' | 'jobTitleErrorSpanish' | 'divisionLabelSpanish' | 'divisionErrorSpanish' | 'timezoneLabelSpanish' | 'regionLabelSpanish' | 'regionErrorSpanish' | 'nextButtonSpanish' | 'leftTitleEnglish' | 'leftSubtitleEnglish' | 'leftTitleSpanish' | 'leftSubtitleSpanish' | 'leftTitleMandarin' | 'leftSubTitleMandarin' | 'leftTitleFrench' | 'leftSubtitleFrench' | 'leftSubtitleGerman' | 'leftTitleGerman' | 'havingTroubleEnglish' | 'havingTroubleGerman' | 'havingTroubleFrench' | 'havingTroubleMandarin' | 'havingTroubleSpanish' | 'getHelpButtonEnglish' | 'getHelpButtonSpanish' | 'getHelpButtonFrench' | 'getHelpButtonGerman' | 'getHelpButtonMandarin'>
      & { image?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'documentId' | 'url'>
      )> }
    )>, what_to_expect?: Maybe<(
      { __typename?: 'ComponentTranslationsWhatToExpect' }
      & Pick<ComponentTranslationsWhatToExpect, 'titleEnglish' | 'bodyEnglish' | 'getStartedButtonEnglish' | 'titleFrench' | 'bodyFrench' | 'getStartedButtonFrench' | 'titleGerman' | 'bodyGerman' | 'getStartedButtonGerman' | 'titleMandarin' | 'bodyMandarin' | 'getStartedButtonMandarin' | 'titleSpanish' | 'bodySpanish' | 'getStartedButtonSpanish'>
      & { image?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'documentId' | 'url'>
      )> }
    )>, home_screen?: Maybe<(
      { __typename?: 'ComponentTranslationsHomeScreen' }
      & Pick<ComponentTranslationsHomeScreen, 'titleEnglish' | 'myProgrammeEnglish' | 'completedModulesEnglish' | 'noChangesEnglish' | 'changesUpEnglish' | 'changesDownEnglish' | 'viewModulesEnglish' | 'myLibraryEnglish' | 'viewedArticlesEnglish' | 'viewLibraryEnglish' | 'titleFrench' | 'myProgrammeFrench' | 'completedModulesFrench' | 'noChangesFrench' | 'changesUpFrench' | 'changesDownFrench' | 'viewModulesFrench' | 'myLibraryFrench' | 'viewedArticlesFrench' | 'viewLibraryFrench' | 'titleGerman' | 'myProgrammeGerman' | 'completedModulesGerman' | 'noChangesGerman' | 'changesUpGerman' | 'changesDownGerman' | 'viewModulesGerman' | 'myLibraryGerman' | 'viewedArticlesGerman' | 'viewLibraryGerman' | 'titleSpanish' | 'myProgrammeSpanish' | 'completedModulesSpanish' | 'noChangesSpanish' | 'changesUpSpanish' | 'changesDownSpanish' | 'viewModulesSpanish' | 'myLibrarySpanish' | 'viewedArticlesSpanish' | 'viewLibrarySpanish' | 'titleMandarin' | 'myProgrammeMandarin' | 'completedModulesMandarin' | 'noChangesMandarin' | 'changesUpMandarin' | 'changesDownMandarin' | 'viewModulesMandarin' | 'myLibraryMandarin' | 'viewedArticlesMandarin' | 'viewLibraryMandarin' | 'welcomeEnglish' | 'welcomeFrench' | 'welcomeGerman' | 'welcomeSpanish' | 'welcomeMandarin' | 'programmeProgressEnglish' | 'programmeProgressFrench' | 'programmeProgressGerman' | 'programmeProgressSpanish' | 'programmeProgressMandarin' | 'whatsNextEnglish' | 'whatsNextFrench' | 'whatsNextGerman' | 'whatsNextSpanish' | 'whatsNextMandarin' | 'whatToExpectEnglish' | 'whatToExpectFrench' | 'whatToExpectGerman' | 'whatToExpectSpanish' | 'whatToExpectMandarin'>
    )>, my_work_screen?: Maybe<(
      { __typename?: 'ComponentTranslationsMyWorkScreen' }
      & Pick<ComponentTranslationsMyWorkScreen, 'emptyStateTitleEnglish' | 'emptyStateDescEnglish' | 'subtitleEnglish' | 'feedbackEnglish' | 'feedbackNotEligibleEnglish' | 'feedbackNotReceivedEnglish' | 'notStartedEnglish' | 'emptyStateTitleFrench' | 'emptyStateDescFrench' | 'subtitleFrench' | 'feedbackFrench' | 'feedbackNotEligibleFrench' | 'feedbackNotReceivedFrench' | 'notStartedFrench' | 'emptyStateTitleGerman' | 'emptyStateDescGerman' | 'subtitleGerman' | 'feedbackGerman' | 'feedbackNotEligibleGerman' | 'feedbackNotReceivedGerman' | 'notStartedGerman' | 'emptyStateTitleSpanish' | 'emptyStateDescSpanish' | 'subtitleSpanish' | 'feedbackSpanish' | 'feedbackNotEligibleSpanish' | 'feedbackNotReceivedSpanish' | 'notStartedSpanish' | 'emptyStateTitleMandarin' | 'emptyStateDescMandarin' | 'subtitleMandarin' | 'feedbackMandarin' | 'feedbackNotEligibleMandarin' | 'feedbackNotReceivedMandarin' | 'notStartedMandarin' | 'downloadContentTextEnglish' | 'downloadContentTextFrench' | 'downloadContentTextGerman' | 'downloadContentTextSpanish' | 'downloadContentTextMandarin' | 'myNotesEnglish' | 'myNotesSpanish' | 'myNotesFrench' | 'myNotesGerman' | 'myNotesMandarin' | 'moduleReportsEnglish' | 'moduleReportsSpanish' | 'moduleReportsFrench' | 'moduleReportsGerman' | 'moduleReportsMandarin' | 'documentsEnglish' | 'documentsSpanish' | 'documentsMandarin' | 'documentsFrench'>
    )>, my_library_screen?: Maybe<(
      { __typename?: 'ComponentTranslationsMyLibraryScreen' }
      & Pick<ComponentTranslationsMyLibraryScreen, 'id' | 'allArticlesEnglish' | 'myBookmarksEnglish' | 'allArticlesFrench' | 'myBookmarksFrench' | 'allArticlesGerman' | 'myBookmarksGerman' | 'allArticlesSpanish' | 'myBookmarksSpanish' | 'allArticlesMandarin' | 'myBookmarksMandarin' | 'viewArticleEnglish' | 'viewArticleFrench' | 'viewArticleGerman' | 'viewArticleSpanish' | 'viewArticleMandarin'>
    )>, my_profile_screen?: Maybe<(
      { __typename?: 'ComponentTranslationsMyProfileScreen' }
      & Pick<ComponentTranslationsMyProfileScreen, 'id' | 'detailsEnglish' | 'settingsEnglish' | 'logoutEnglish' | 'joinEnglish' | 'detailsFrench' | 'settingsFrench' | 'logoutFrench' | 'joinFrench' | 'detailsGerman' | 'settingsGerman' | 'logoutGerman' | 'joinGerman' | 'detailsSpanish' | 'settingsSpanish' | 'logoutSpanish' | 'joinSpanish' | 'detailsMandarin' | 'settingsMandarin' | 'logoutMandarin'>
    )>, personal_screen?: Maybe<(
      { __typename?: 'ComponentTranslationsPersonalScreen' }
      & Pick<ComponentTranslationsPersonalScreen, 'id' | 'changePhotoEnglish' | 'firstNameLabelEnglish' | 'lastNameLabelEnglish' | 'emailLabelEnglish' | 'jobTitleLabelEnglish' | 'divisionLabelEnglish' | 'editInfoButtonEnglish' | 'changePhotoFrench' | 'firstNameLabelFrench' | 'lastNameLabelFrench' | 'emailLabelFrench' | 'jobTitleLabelFrench' | 'divisionLabelFrench' | 'editInfoButtonFrench' | 'changePhotoGerman' | 'firstNameLabelGerman' | 'lastNameLabelGerman' | 'emailLabelGerman' | 'jobTitleLabelGerman' | 'divisionLabelGerman' | 'editInfoButtonGerman' | 'changePhotoSpanish' | 'firstNameLabelSpanish' | 'lastNameLabelSpanish' | 'emailLabelSpanish' | 'jobTitleLabelSpanish' | 'divisionLabelSpanish' | 'editInfoButtonSpanish' | 'changePhotoMandarin' | 'firstNameLabelMandarin' | 'lastNameLabelMandarin' | 'emailLabelMandarin' | 'jobTitleLabelMandarin' | 'divisionLabelMandarin' | 'editInfoButtonMandarin' | 'resetPasswordEnglish' | 'resetPasswordFrench' | 'resetPasswordGerman' | 'resetPasswordSpanish' | 'resetPasswordMandarin'>
    )>, settings_screen?: Maybe<(
      { __typename?: 'ComponentTranslationsSettingsScreen' }
      & Pick<ComponentTranslationsSettingsScreen, 'id' | 'titleEnglish' | 'saveButtonEnglish' | 'titleFrench' | 'saveButtonFrench' | 'titleGerman' | 'saveButtonGerman' | 'titleSpanish' | 'saveButtonSpanish' | 'titleMandarin' | 'saveButtonMandarin'>
    )>, help_and_support?: Maybe<(
      { __typename?: 'ComponentTranslationsHelpAndSupport' }
      & Pick<ComponentTranslationsHelpAndSupport, 'id' | 'titleEnglish' | 'knowledgeBaseEnglish' | 'liveChatEnglish' | 'myTicketsEnglish' | 'titleFrench' | 'knowledgeBaseFrench' | 'liveChatFrench' | 'myTicketsFrench' | 'titleGerman' | 'knowledgeBaseGerman' | 'liveChatGerman' | 'myTicketsGerman' | 'titleSpanish' | 'knowledgeBaseSpanish' | 'liveChatSpanish' | 'myTicketsSpanish' | 'titleMandarin' | 'knowledgeBaseMandarin' | 'liveChatMandarin' | 'myTicketsMandarin'>
    )>, about_us?: Maybe<(
      { __typename?: 'ComponentTranslationsAboutUs' }
      & Pick<ComponentTranslationsAboutUs, 'textEnglish' | 'textFrench' | 'textGerman' | 'userGuidelinesTextEnglish' | 'userGuidelinesTextGerman' | 'userGuidelinesTextFrench'>
      & { userGuidelinesEnglish: Array<Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'documentId' | 'url'>
      )>>, userGuidelinesGerman: Array<Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'documentId' | 'url'>
      )>>, userGuidelinesFrench: Array<Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'documentId' | 'url'>
      )>> }
    )>, buttons?: Maybe<(
      { __typename?: 'ComponentTranslationsButtons' }
      & Pick<ComponentTranslationsButtons, 'backBtnsEnglish' | 'backBtnsFrench' | 'backBtnsGerman' | 'nextBtnsEnglish' | 'nextBtnsFrench' | 'nextBtnsGerman' | 'addMoreBtnsEnglish' | 'addMoreBtnsFrench' | 'addMoreBtnsGerman'>
    )>, programmes_screen?: Maybe<(
      { __typename?: 'ComponentTranslationsProgrammeScreen' }
      & Pick<ComponentTranslationsProgrammeScreen, 'changeButtonEnglish' | 'changeButtonFrench' | 'changeButtonGerman' | 'changeButtonSpanish' | 'changeButtonMandarin' | 'programmeOverviewEnglish' | 'programmeOverviewFrench' | 'programmeOverviewGerman' | 'programmeOverviewSpanish' | 'programmeOverviewMandarin' | 'programmeTextEnglish' | 'programmeTextFrench' | 'programmeTextGerman' | 'programmeTextSpanish' | 'programmeTextMandarin' | 'informationEnglish' | 'informationFrench' | 'informationGerman' | 'informationSpanish' | 'informationMandarin' | 'selectProgrammesTitleEnglish' | 'selectProgrammesTitleFrench' | 'selectProgrammesTitleGerman' | 'selectProgrammesTitleSpanish' | 'selectProgrammesTitleMandarin' | 'selectProgrammesSubTitleEnglish' | 'selectProgrammesSubTitleFrench' | 'selectProgrammesSubTitleGerman' | 'selectProgrammesSubTitleSpanish' | 'selectProgrammesSubTitleMandarin' | 'selectButtonEnglish' | 'selectButtonFrench' | 'selectButtonGerman' | 'selectButtonSpanish' | 'selectButtonMandarin' | 'changeProgrammeTypeEnglish' | 'changeProgrammeTypeFrench' | 'changeProgrammeTypeGerman' | 'changeProgrammeTypeSpanish' | 'changeProgrammeTypeMandarin'>
    )>, faqs?: Maybe<(
      { __typename?: 'ComponentTranslationsFaqs' }
      & { faqsEnglish?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentTranslationsFaqsQuestionAnswer' }
        & Pick<ComponentTranslationsFaqsQuestionAnswer, 'question' | 'answer'>
      )>>>, faqsFrench?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentTranslationsFaqsFrench' }
        & Pick<ComponentTranslationsFaqsFrench, 'question' | 'answer'>
      )>>>, faqsGerman?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentTranslationsFaqsGerman' }
        & Pick<ComponentTranslationsFaqsGerman, 'question' | 'answer'>
      )>>>, faqsMandarin?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentTranslationsFaqsMandarin' }
        & Pick<ComponentTranslationsFaqsMandarin, 'question' | 'answer'>
      )>>>, faqsSpanish?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentTranslationsFaqsSpanish' }
        & Pick<ComponentTranslationsFaqsSpanish, 'question' | 'answer'>
      )>>> }
    )>, dashboard_screen?: Maybe<(
      { __typename?: 'ComponentTranslationsDashboardScreen' }
      & Pick<ComponentTranslationsDashboardScreen, 'id' | 'myProgrammesEnglish' | 'myProgrammesFrench' | 'myProgrammesGerman' | 'myProgrammesSpanish' | 'myProgrammesMandarin' | 'suggestedTitleEnglish' | 'suggestedTitleFrench' | 'suggestedTitleGerman' | 'suggestedTitleSpanish' | 'suggestedTitleMandarin' | 'uploadTitleEnglish' | 'uploadTitleFrench' | 'uploadTitleGerman' | 'uploadTitleSpanish' | 'uploadTitleMandarin' | 'viewAllEnglish' | 'viewAllFrench' | 'viewAllGerman' | 'viewAllSpanish' | 'viewAllMandarin' | 'logOutDashboardEnglish' | 'logOutDashboardFrench' | 'logOutDashboardGerman' | 'logOutDashboardSpanish' | 'logOutDashboardMandarin' | 'notepadTextEnglish' | 'notepadTextFrench' | 'notepadTextGerman' | 'notepadTextSpanish' | 'notepadTextMandarin'>
    )> }
  )> }
);

export type GetTypeformCompetencyResponsesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTypeformCompetencyResponsesQuery = (
  { __typename?: 'Query' }
  & { getTypeformCompetencyResponses?: Maybe<(
    { __typename?: 'CheckConfirmed' }
    & Pick<CheckConfirmed, 'success'>
  )> }
);

export type GetUserUploadedDocumentQueryVariables = Exact<{
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  filters?: InputMaybe<UserUploadedDocumentFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type GetUserUploadedDocumentQuery = (
  { __typename?: 'Query' }
  & { userUploadedDocuments: Array<Maybe<(
    { __typename?: 'UserUploadedDocument' }
    & Pick<UserUploadedDocument, 'documentId' | 'name'>
    & { documents?: Maybe<Array<Maybe<(
      { __typename?: 'ComponentQuestionTypesDocuments' }
      & Pick<ComponentQuestionTypesDocuments, 'id' | 'name'>
      & { document: Array<Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'documentId' | 'url'>
      )>> }
    )>>> }
  )>> }
);

export type GetUserProgrammeSubmissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserProgrammeSubmissionsQuery = (
  { __typename?: 'Query' }
  & { getMyProgrammeSubmissions?: Maybe<Array<Maybe<(
    { __typename?: 'ProgrammeSubmission' }
    & Pick<ProgrammeSubmission, 'documentId' | 'status' | 'progress'>
    & { programme_type?: Maybe<(
      { __typename?: 'ProgrammeType' }
      & Pick<ProgrammeType, 'title' | 'is_sub_module'>
      & { sub_modules: Array<Maybe<(
        { __typename?: 'SubModule' }
        & Pick<SubModule, 'documentId' | 'name_english'>
        & { sections: Array<Maybe<(
          { __typename?: 'Section' }
          & Pick<Section, 'title_english'>
        )>> }
      )>> }
    )>, programme?: Maybe<(
      { __typename?: 'Programme' }
      & Pick<Programme, 'name' | 'position' | 'start'>
    )> }
  )>>> }
);

export type GetMyProgrammeSubmissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyProgrammeSubmissionsQuery = (
  { __typename?: 'Query' }
  & { getMyProgrammeSubmissions?: Maybe<Array<Maybe<(
    { __typename?: 'ProgrammeSubmission' }
    & Pick<ProgrammeSubmission, 'id' | 'status' | 'progress'>
    & { competency_url?: Maybe<(
      { __typename?: 'CompetencyUrl' }
      & Pick<CompetencyUrl, 'documentId' | 'url'>
    )>, feedfoward_url?: Maybe<(
      { __typename?: 'FeedfowardUrl' }
      & Pick<FeedfowardUrl, 'documentId' | 'url'>
    )>, programme_type?: Maybe<(
      { __typename?: 'ProgrammeType' }
      & Pick<ProgrammeType, 'documentId' | 'programme_type_instructions' | 'title' | 'description' | 'position' | 'is_coaching' | 'is_sub_module' | 'notes' | 'show_article' | 'show_session' | 'show_participants' | 'competency_survey' | 'feedForward_survey' | 'deadline' | 'archive'>
      & { cover?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'documentId' | 'url'>
      )>, programme_questions?: Maybe<Array<Maybe<(
        { __typename: 'ComponentQuestionTypesCompetency' }
        & Pick<ComponentQuestionTypesCompetency, 'title' | 'question' | 'minNumber' | 'maxNumber' | 'miniLabel' | 'maxiLabel' | 'simpleQuestion'>
      ) | (
        { __typename: 'ComponentQuestionTypesCompetency2' }
        & Pick<ComponentQuestionTypesCompetency2, 'titleEnglish' | 'titleFrench' | 'titleMandarin'>
        & { questionscompetency2?: Maybe<Array<Maybe<(
          { __typename?: 'ComponentQuestionTypesQuestionscompetency2' }
          & Pick<ComponentQuestionTypesQuestionscompetency2, 'title' | 'question' | 'maxiNumber' | 'miniNumber' | 'simpleQuestion' | 'miniLabel' | 'maxiLabel' | 'midiLabel' | 'textboxQuestion'>
        )>>> }
      ) | (
        { __typename: 'ComponentQuestionTypesFeedForward1' }
        & Pick<ComponentQuestionTypesFeedForward1, 'title' | 'question' | 'description'>
      ) | (
        { __typename: 'ComponentQuestionTypesFeedForward2' }
        & Pick<ComponentQuestionTypesFeedForward2, 'title' | 'question' | 'description'>
      ) | (
        { __typename: 'ComponentQuestionTypesGravitasGap' }
        & Pick<ComponentQuestionTypesGravitasGap, 'title' | 'question' | 'description' | 'color1' | 'color2' | 'color3'>
      ) | (
        { __typename: 'ComponentQuestionTypesGravitasScale' }
        & Pick<ComponentQuestionTypesGravitasScale, 'titleEnglish' | 'subTitleEnglish' | 'questionOneEnglish' | 'questionTwoEnglish' | 'questionThreeEnglish' | 'titleOneEnglish' | 'titleTwoEnglish'>
        & { ratingInput?: Maybe<Array<Maybe<(
          { __typename?: 'ComponentRatingInputRatingInput' }
          & Pick<ComponentRatingInputRatingInput, 'labelOneEnglish' | 'labelTwoEnglish'>
        )>>> }
      ) | (
        { __typename: 'ComponentQuestionTypesGravitasSliders' }
        & Pick<ComponentQuestionTypesGravitasSliders, 'titleEnglish' | 'titleFrench' | 'titleMandarin' | 'titleSpanish' | 'titleGerman' | 'subTitleEnglish' | 'subTitleFrench' | 'subTitleGerman' | 'positiveHeadingEnglish' | 'positiveHeadingFrench' | 'positiveHeadingSpanish' | 'positiveHeadingMandarin' | 'positiveHeadingGerman' | 'negativeHeadingEnglish' | 'negativeHeadingFrench' | 'negativeHeadingSpanish' | 'negativeHeadingMandarin' | 'negativeHeadingGerman'>
        & { sliderQuestions?: Maybe<Array<Maybe<(
          { __typename?: 'ComponentOptionSliderQuestions' }
          & Pick<ComponentOptionSliderQuestions, 'questionPositiveEnglish' | 'questionPositiveGerman' | 'questionPositiveMandarin' | 'questionPositiveSpanish' | 'questionPositiveFrench' | 'questionNegativeEnglish' | 'questionNegativeGerman' | 'questionNegativeFrench' | 'questionNegativeMandarin' | 'questionNegativeSpanish'>
        )>>>, sliderHeadings?: Maybe<Array<Maybe<(
          { __typename?: 'ComponentOptionSliderHeadings' }
          & Pick<ComponentOptionSliderHeadings, 'headingEnglish' | 'headingSpanish' | 'headingGerman' | 'headingFrench' | 'headingMandarin' | 'color' | 'rating'>
        )>>> }
      ) | (
        { __typename: 'ComponentQuestionTypesMultipleChoice' }
        & Pick<ComponentQuestionTypesMultipleChoice, 'titleEnglish' | 'titleFrench' | 'titleGerman' | 'titleSpanish' | 'titleMandarin' | 'numberOfAnswers'>
        & { option?: Maybe<Array<Maybe<(
          { __typename?: 'ComponentOptionOption' }
          & Pick<ComponentOptionOption, 'optionEnglish' | 'isCorrect'>
        )>>> }
      ) | (
        { __typename: 'ComponentQuestionTypesNestedQuestions' }
        & Pick<ComponentQuestionTypesNestedQuestions, 'titleEnglish' | 'titleFrench' | 'titleGerman' | 'titleSpanish' | 'titleMandarin'>
        & { questions?: Maybe<Array<Maybe<(
          { __typename?: 'ComponentQuestionTypesSimpleQuestion' }
          & Pick<ComponentQuestionTypesSimpleQuestion, 'titleEnglish' | 'subTitleEnglish' | 'titleFrench' | 'subTitleFrench' | 'titleGerman' | 'subTitleGerman' | 'titleSpanish' | 'subTitleSpanish' | 'titleMandarin' | 'subTitleMandarin' | 'isNumeric'>
        )>>> }
      ) | { __typename: 'ComponentQuestionTypesParticipant' } | (
        { __typename: 'ComponentQuestionTypesSaboteur' }
        & Pick<ComponentQuestionTypesSaboteur, 'titleEnglish' | 'subTitleEnglish' | 'titleFrench' | 'subTitleFrench' | 'titleGerman' | 'subTitleGerman' | 'titleSpanish' | 'subTitleSpanish' | 'titleMandarin' | 'subTitleMandarin' | 'labelEnglish' | 'labelFrench' | 'labelGerman' | 'labelSpanish'>
        & { saboteurQuestions?: Maybe<Array<Maybe<(
          { __typename?: 'ComponentQuestionTypesSaboteurQuestions' }
          & Pick<ComponentQuestionTypesSaboteurQuestions, 'link' | 'skipProof' | 'labelEnglish' | 'labelFrench' | 'labelGerman' | 'labelSpanish' | 'labelMandarin'>
        )>>> }
      ) | (
        { __typename: 'ComponentQuestionTypesSaboteurVideos' }
        & Pick<ComponentQuestionTypesSaboteurVideos, 'titleEnglish' | 'subTitleEnglish' | 'titleFrench' | 'subTitleFrench' | 'titleGerman' | 'subTitleGerman' | 'titleSpanish' | 'subTitleSpanish' | 'titleMandarin' | 'subTitleMandarin'>
        & { SaboteurVideo?: Maybe<Array<Maybe<(
          { __typename?: 'ComponentSaboteurVideoSaboteurVideo' }
          & Pick<ComponentSaboteurVideoSaboteurVideo, 'videoTitleEnglish' | 'videoTitleFrench' | 'videoTitleGerman' | 'videoTitleSpanish' | 'videoTitleMandarin'>
          & { video?: Maybe<(
            { __typename?: 'UploadFile' }
            & Pick<UploadFile, 'documentId' | 'url'>
          )> }
        )>>> }
      ) | (
        { __typename: 'ComponentQuestionTypesSimpleQuestion' }
        & Pick<ComponentQuestionTypesSimpleQuestion, 'titleEnglish' | 'titleFrench' | 'titleGerman' | 'titleSpanish' | 'titleMandarin' | 'subTitleEnglish' | 'subTitleFrench' | 'subTitleGerman' | 'subTitleSpanish' | 'subTitleMandarin'>
      ) | (
        { __typename: 'ComponentQuestionTypesSimpleReadOnly' }
        & Pick<ComponentQuestionTypesSimpleReadOnly, 'titleEnglish' | 'subTitleEnglish' | 'titleFrench' | 'subTitleFrench' | 'titleGerman' | 'subTitleGerman' | 'titleSpanish' | 'subTitleSpanish' | 'titleMandarin' | 'subTitleMandarin' | 'contentEnglish' | 'contentFrench' | 'contentGerman' | 'contentMandarin' | 'contentSpanish'>
        & { photo?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'documentId' | 'url'>
        )> }
      ) | { __typename: 'ComponentQuestionTypesSliderQuestions' } | (
        { __typename: 'ComponentQuestionTypesStakeholderMap' }
        & Pick<ComponentQuestionTypesStakeholderMap, 'titleEnglish' | 'subTitleEnglish' | 'titleFrench' | 'subTitleFrench' | 'titleGerman' | 'subTitleGerman' | 'titleSpanish' | 'subTitleSpanish' | 'titleMandarin' | 'subTitleMandarin' | 'questionX' | 'questionY'>
      ) | { __typename: 'ComponentQuestionTypesUploadQuestion' } | (
        { __typename: 'ComponentQuestionTypesValuesBubble' }
        & Pick<ComponentQuestionTypesValuesBubble, 'title' | 'question' | 'description'>
      ) | (
        { __typename: 'ComponentQuestionTypesValuesCharacters' }
        & Pick<ComponentQuestionTypesValuesCharacters, 'title' | 'question' | 'description'>
      ) | (
        { __typename: 'ComponentQuestionTypesValuesGaps' }
        & Pick<ComponentQuestionTypesValuesGaps, 'title' | 'question' | 'description'>
      ) | (
        { __typename: 'ComponentQuestionTypesValuesNested' }
        & Pick<ComponentQuestionTypesValuesNested, 'title' | 'question' | 'description'>
        & { questions?: Maybe<Array<Maybe<(
          { __typename?: 'ComponentQuestionTypesSimpleQuestion' }
          & Pick<ComponentQuestionTypesSimpleQuestion, 'titleEnglish' | 'subTitleEnglish' | 'titleFrench' | 'subTitleFrench' | 'titleGerman' | 'subTitleGerman' | 'titleSpanish' | 'subTitleSpanish' | 'titleMandarin' | 'subTitleMandarin'>
        )>>> }
      ) | (
        { __typename: 'ComponentQuestionTypesValuesSliders' }
        & Pick<ComponentQuestionTypesValuesSliders, 'title' | 'question' | 'description'>
        & { sliderQuestions?: Maybe<Array<Maybe<(
          { __typename?: 'ComponentQuestionTypesSliderQuestions' }
          & Pick<ComponentQuestionTypesSliderQuestions, 'question' | 'color'>
        )>>> }
      ) | (
        { __typename: 'ComponentQuestionTypesXYGraph' }
        & Pick<ComponentQuestionTypesXyGraph, 'labelXEnglish' | 'labelYEnglish' | 'titleEnglish' | 'subTitleEnglish' | 'labelXFrench' | 'labelYFrench' | 'titleFrench' | 'subTitleFrench' | 'labelXGerman' | 'labelYGerman' | 'titleGerman' | 'subTitleGerman' | 'labelXSpanish' | 'labelYSpanish' | 'titleSpanish' | 'subTitleSpanish' | 'labelXMandarin' | 'labelYMandarin' | 'titleMandarin' | 'subTitleMandarin'>
      ) | { __typename: 'Error' }>>>, articles: Array<Maybe<(
        { __typename?: 'Article' }
        & Pick<Article, 'documentId' | 'createdAt' | 'updatedAt' | 'title_english' | 'title_french' | 'title_german' | 'title_spanish' | 'title_mandarin' | 'content_english' | 'content_french' | 'content_german' | 'content_spanish' | 'content_mandarin' | 'date_published' | 'read_time' | 'link'>
        & { image?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'documentId' | 'url'>
        )> }
      )>>, modal?: Maybe<(
        { __typename?: 'Modal' }
        & Pick<Modal, 'documentId' | 'title' | 'subtitle' | 'message'>
        & { image?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'documentId' | 'url' | 'name'>
        )> }
      )>, events: Array<Maybe<(
        { __typename?: 'Event' }
        & Pick<Event, 'documentId' | 'name' | 'link' | 'session_id'>
      )>>, sub_modules: Array<Maybe<(
        { __typename?: 'SubModule' }
        & Pick<SubModule, 'documentId' | 'name_english' | 'description_english'>
        & { cover?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'documentId' | 'url'>
        )>, programme_type?: Maybe<(
          { __typename?: 'ProgrammeType' }
          & Pick<ProgrammeType, 'documentId'>
        )> }
      )>> }
    )> }
  )>>> }
);

export type GetMySubModuleSubmissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMySubModuleSubmissionsQuery = (
  { __typename?: 'Query' }
  & { getMySubModuleSubmissions?: Maybe<Array<Maybe<(
    { __typename?: 'SubModuleSubmission' }
    & Pick<SubModuleSubmission, 'id' | 'view' | 'progress' | 'status' | 'time_spent'>
    & { feedfoward_url?: Maybe<(
      { __typename?: 'FeedfowardUrl' }
      & Pick<FeedfowardUrl, 'documentId'>
    )>, competency_url?: Maybe<(
      { __typename?: 'CompetencyUrl' }
      & Pick<CompetencyUrl, 'documentId'>
    )>, competency_participants?: Maybe<Array<Maybe<(
      { __typename?: 'ComponentSubmissionsCompetencyParticipants' }
      & Pick<ComponentSubmissionsCompetencyParticipants, 'name' | 'email'>
    )>>>, participants: Array<Maybe<(
      { __typename?: 'Participant' }
      & Pick<Participant, 'documentId' | 'name' | 'email' | 'type'>
    )>>, submission_participants?: Maybe<Array<Maybe<(
      { __typename?: 'ComponentSubmissionsParticipants' }
      & Pick<ComponentSubmissionsParticipants, 'id' | 'name' | 'email'>
    )>>>, language?: Maybe<(
      { __typename?: 'Language' }
      & Pick<Language, 'documentId' | 'name'>
    )>, section?: Maybe<Array<Maybe<(
      { __typename?: 'ComponentSubmissionsSectionSubmission' }
      & Pick<ComponentSubmissionsSectionSubmission, 'id' | 'progress' | 'sliderAnswers'>
      & { section?: Maybe<(
        { __typename?: 'Section' }
        & Pick<Section, 'documentId'>
      )>, answers?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsAnswer' }
        & Pick<ComponentSubmissionsAnswer, 'id' | 'questionId' | 'answer' | 'isCorrect' | 'feedback' | 'outcome' | 'questionType' | 'questionTitle'>
        & { nestedAnswers?: Maybe<Array<Maybe<(
          { __typename?: 'ComponentSubmissionsRepeatAnswer' }
          & Pick<ComponentSubmissionsRepeatAnswer, 'answer' | 'questionTitle'>
        )>>> }
      )>>>, stakeholderChart?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'documentId' | 'url'>
      )>, stakeholderItems?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentStakeholderMapItemStackholderMapItem' }
        & Pick<ComponentStakeholderMapItemStackholderMapItem, 'id' | 'valueX' | 'valueY' | 'name' | 'color'>
      )>>>, gravitasScales?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentGravitasScaleItemsGravitasScaleItems' }
        & Pick<ComponentGravitasScaleItemsGravitasScaleItems, 'id' | 'labelOne' | 'labelTwo' | 'labelThree' | 'question' | 'answerOne' | 'answerTwo' | 'answerThree'>
      )>>>, gravitasSliderAnswers?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsGravitasSlidersAnswers' }
        & Pick<ComponentSubmissionsGravitasSlidersAnswers, 'negativeQuestion' | 'positiveQuestion'>
        & { colorAndRating?: Maybe<Array<Maybe<(
          { __typename?: 'ComponentOptionColorAndRating' }
          & Pick<ComponentOptionColorAndRating, 'color' | 'rate'>
        )>>> }
      )>>>, gravitasGap?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsGravitasGap' }
        & Pick<ComponentSubmissionsGravitasGap, 'id' | 'gap' | 'commitment'>
      )>>>, xYGraphChart?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'documentId' | 'url'>
      )>, saboteurImage?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'documentId' | 'url'>
      )>, xYGraphItems?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentXYGraphItemXYGraphItem' }
        & Pick<ComponentXyGraphItemXyGraphItem, 'id' | 'valueX' | 'valueY' | 'color'>
      )>>>, characteristics?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsCharacteristics' }
        & Pick<ComponentSubmissionsCharacteristics, 'id' | 'answer' | 'type'>
      )>>>, gapsAnswers?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsValuesGaps' }
        & Pick<ComponentSubmissionsValuesGaps, 'id' | 'gap' | 'commitment'>
      )>>>, competencyAnswers?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsCompetencyAnswer' }
        & Pick<ComponentSubmissionsCompetencyAnswer, 'id' | 'question' | 'rating' | 'steps' | 'response'>
      )>>>, uploadDocuments?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentSubmissionsUploadDocuments' }
        & { saboteurProofValue?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'documentId'>
        )> }
      )>>> }
    )>>>, sub_module?: Maybe<(
      { __typename?: 'SubModule' }
      & Pick<SubModule, 'documentId' | 'name_french' | 'name_german' | 'name_english' | 'name_spanish' | 'name_mandarin' | 'description_french' | 'description_german' | 'description_english' | 'description_spanish' | 'description_mandarin' | 'position'>
      & { cover?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'documentId' | 'url'>
      )>, sections: Array<Maybe<(
        { __typename?: 'Section' }
        & Pick<Section, 'documentId' | 'title_french' | 'title_german' | 'title_english' | 'title_spanish' | 'title_mandarin' | 'sub_title_french' | 'sub_title_german' | 'sub_title_english' | 'sub_title_spanish' | 'sub_title_mandarin' | 'position' | 'archive'>
        & { cover?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'documentId' | 'url'>
        )> }
      )>>, programme_type?: Maybe<(
        { __typename?: 'ProgrammeType' }
        & Pick<ProgrammeType, 'documentId' | 'title' | 'description' | 'position' | 'is_coaching' | 'is_sub_module' | 'notes' | 'show_article' | 'show_session' | 'show_participants' | 'competency_survey' | 'feedForward_survey' | 'deadline'>
        & { cover?: Maybe<(
          { __typename?: 'UploadFile' }
          & Pick<UploadFile, 'documentId' | 'url'>
        )>, articles: Array<Maybe<(
          { __typename?: 'Article' }
          & Pick<Article, 'documentId' | 'createdAt' | 'updatedAt' | 'title_english' | 'title_french' | 'title_german' | 'title_spanish' | 'title_mandarin' | 'content_english' | 'content_french' | 'content_german' | 'content_spanish' | 'content_mandarin' | 'date_published' | 'read_time' | 'link'>
          & { image?: Maybe<(
            { __typename?: 'UploadFile' }
            & Pick<UploadFile, 'documentId' | 'url'>
          )> }
        )>>, modal?: Maybe<(
          { __typename?: 'Modal' }
          & Pick<Modal, 'documentId' | 'title' | 'subtitle' | 'message'>
          & { image?: Maybe<(
            { __typename?: 'UploadFile' }
            & Pick<UploadFile, 'documentId' | 'url' | 'name'>
          )> }
        )>, events: Array<Maybe<(
          { __typename?: 'Event' }
          & Pick<Event, 'documentId' | 'link' | 'name'>
        )>> }
      )> }
    )> }
  )>>> }
);

export type GetMySubmissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMySubmissionsQuery = (
  { __typename?: 'Query' }
  & { getMySubmissions?: Maybe<Array<Maybe<(
    { __typename?: 'Submission' }
    & Pick<Submission, 'id' | 'views' | 'progress' | 'status' | 'time_spent'>
  )>>> }
);

export type UserQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UserQuery = (
  { __typename?: 'Query' }
  & { usersPermissionsUser?: Maybe<(
    { __typename?: 'UsersPermissionsUser' }
    & Pick<UsersPermissionsUser, 'documentId' | 'username' | 'firstName'>
  )> }
);

export type UsersQueryVariables = Exact<{ [key: string]: never; }>;


export type UsersQuery = (
  { __typename?: 'Query' }
  & { usersPermissionsUsers: Array<Maybe<(
    { __typename?: 'UsersPermissionsUser' }
    & Pick<UsersPermissionsUser, 'id' | 'username' | 'email'>
  )>> }
);

export const ModuleFragmentDoc = gql`
    fragment module on Module {
  name_french
  name_german
  name_english
  name_spanish
  name_mandarin
  description_french
  description_german
  description_english
  description_spanish
  description_mandarin
  cover {
    documentId
    url
  }
}
    `;
export const QuestionsFragmentDoc = gql`
    fragment questions on SectionQuestionsDynamicZone {
  __typename
  ... on ComponentQuestionTypesSimpleQuestion {
    titleEnglish
    subTitleEnglish
    titleFrench
    subTitleFrench
    titleGerman
    subTitleGerman
    titleSpanish
    subTitleSpanish
    titleMandarin
    subTitleMandarin
    viewPrevious
  }
  ... on ComponentQuestionTypesCompetency2 {
    titleEnglish
    titleFrench
    titleMandarin
    questionscompetency2 {
      title
      question
      maxiNumber
      miniNumber
      simpleQuestion
      miniLabel
      maxiLabel
    }
  }
  ... on ComponentQuestionTypesXYGraph {
    labelXEnglish
    labelYEnglish
    titleEnglish
    subTitleEnglish
    labelXFrench
    labelYFrench
    titleFrench
    subTitleFrench
    labelXGerman
    labelYGerman
    titleGerman
    subTitleGerman
    labelXSpanish
    labelYSpanish
    titleSpanish
    subTitleSpanish
    labelXMandarin
    labelYMandarin
    titleMandarin
    subTitleMandarin
  }
  ... on ComponentQuestionTypesMultipleChoice {
    titleEnglish
    titleFrench
    titleGerman
    titleSpanish
    titleMandarin
    viewPrevious
    option {
      optionEnglish
      optionFrench
      optionGerman
      optionSpanish
      optionMandarin
      isCorrect
    }
    numberOfAnswers
  }
  ... on ComponentQuestionTypesFeedForward1 {
    title
    question
    description
  }
  ... on ComponentQuestionTypesFeedForward2 {
    title
    question
    description
  }
  ... on ComponentQuestionTypesSaboteur {
    titleEnglish
    subTitleEnglish
    titleFrench
    subTitleFrench
    titleGerman
    subTitleGerman
    titleSpanish
    subTitleSpanish
    titleMandarin
    subTitleMandarin
    saboteurQuestions {
      link
      skipProof
      labelEnglish
      labelFrench
      labelGerman
      labelSpanish
      labelMandarin
      labelFrench
      labelGerman
      labelSpanish
      labelMandarin
    }
  }
  ... on ComponentQuestionTypesNestedQuestions {
    titleEnglish
    titleFrench
    titleGerman
    titleSpanish
    titleMandarin
    viewPrevious
    questions {
      titleEnglish
      subTitleEnglish
      titleFrench
      subTitleFrench
      titleGerman
      subTitleGerman
      titleSpanish
      subTitleSpanish
      titleMandarin
      subTitleMandarin
      isNumeric
    }
  }
  ... on ComponentQuestionTypesGravitasScale {
    titleEnglish
    subTitleEnglish
    questionOneEnglish
    questionTwoEnglish
    questionThreeEnglish
    titleOneEnglish
    titleTwoEnglish
    ratingInput {
      labelOneEnglish
      labelTwoEnglish
    }
  }
  ... on ComponentQuestionTypesStakeholderMap {
    titleEnglish
    subTitleEnglish
    titleFrench
    subTitleFrench
    titleSpanish
    subTitleSpanish
    titleGerman
    subTitleGerman
    titleMandarin
    subTitleMandarin
    questionX
    questionY
  }
  ... on ComponentQuestionTypesSaboteurVideos {
    titleEnglish
    titleFrench
    titleGerman
    titleSpanish
    titleMandarin
    subTitleEnglish
    subTitleFrench
    subTitleGerman
    subTitleSpanish
    subTitleMandarin
    SaboteurVideo {
      videoTitleEnglish
      videoTitleFrench
      videoTitleGerman
      videoTitleSpanish
      videoTitleMandarin
      videoDescriptionEnglish
      videoDescriptionFrench
      videoDescriptionGerman
      videoDescriptionSpanish
      videoDescriptionMandarin
    }
  }
}
    `;
export const SectionFragmentDoc = gql`
    fragment section on Section {
  title_french
  title_german
  title_english
  title_spanish
  title_mandarin
  sub_title_french
  sub_title_german
  sub_title_english
  sub_title_spanish
  sub_title_mandarin
  cover {
    documentId
    url
  }
}
    `;
export const SubmissionFragmentDoc = gql`
    fragment submission on Submission {
  documentId
  views
  progress
  status
  time_spent
  language {
    documentId
    name
  }
}
    `;
export const UploadFileFragmentDoc = gql`
    fragment uploadFile on UploadFile {
  documentId
  name
  alternativeText
  caption
  width
  height
  formats
  hash
  ext
  mime
  size
  url
  previewUrl
  provider
  createdAt
  updatedAt
}
    `;
export const AddDocumentDocument = gql`
    mutation addDocument($input: editUserUploadedDocumentInput!) {
  addDocument(input: $input) {
    name
  }
}
    `;
export type AddDocumentMutationFn = Apollo.MutationFunction<AddDocumentMutation, AddDocumentMutationVariables>;

/**
 * __useAddDocumentMutation__
 *
 * To run a mutation, you first call `useAddDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDocumentMutation, { data, loading, error }] = useAddDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddDocumentMutation(baseOptions?: Apollo.MutationHookOptions<AddDocumentMutation, AddDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddDocumentMutation, AddDocumentMutationVariables>(AddDocumentDocument, options);
      }
export type AddDocumentMutationHookResult = ReturnType<typeof useAddDocumentMutation>;
export type AddDocumentMutationResult = Apollo.MutationResult<AddDocumentMutation>;
export type AddDocumentMutationOptions = Apollo.BaseMutationOptions<AddDocumentMutation, AddDocumentMutationVariables>;
export const AddNoteDocument = gql`
    mutation addNote($input: editNoteInput!) {
  addNote(input: $input) {
    note
  }
}
    `;
export type AddNoteMutationFn = Apollo.MutationFunction<AddNoteMutation, AddNoteMutationVariables>;

/**
 * __useAddNoteMutation__
 *
 * To run a mutation, you first call `useAddNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNoteMutation, { data, loading, error }] = useAddNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddNoteMutation(baseOptions?: Apollo.MutationHookOptions<AddNoteMutation, AddNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddNoteMutation, AddNoteMutationVariables>(AddNoteDocument, options);
      }
export type AddNoteMutationHookResult = ReturnType<typeof useAddNoteMutation>;
export type AddNoteMutationResult = Apollo.MutationResult<AddNoteMutation>;
export type AddNoteMutationOptions = Apollo.BaseMutationOptions<AddNoteMutation, AddNoteMutationVariables>;
export const ConfirmMyAppointmentsDocument = gql`
    mutation confirmMyAppointments($appointmentScheduleId: ID!, $programmeSubmissionId: ID!, $subModule: Boolean!) {
  confirmMyAppointments(
    appointmentScheduleId: $appointmentScheduleId
    programmeSubmissionId: $programmeSubmissionId
    subModule: $subModule
  ) {
    success
    message
  }
}
    `;
export type ConfirmMyAppointmentsMutationFn = Apollo.MutationFunction<ConfirmMyAppointmentsMutation, ConfirmMyAppointmentsMutationVariables>;

/**
 * __useConfirmMyAppointmentsMutation__
 *
 * To run a mutation, you first call `useConfirmMyAppointmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmMyAppointmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmMyAppointmentsMutation, { data, loading, error }] = useConfirmMyAppointmentsMutation({
 *   variables: {
 *      appointmentScheduleId: // value for 'appointmentScheduleId'
 *      programmeSubmissionId: // value for 'programmeSubmissionId'
 *      subModule: // value for 'subModule'
 *   },
 * });
 */
export function useConfirmMyAppointmentsMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmMyAppointmentsMutation, ConfirmMyAppointmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmMyAppointmentsMutation, ConfirmMyAppointmentsMutationVariables>(ConfirmMyAppointmentsDocument, options);
      }
export type ConfirmMyAppointmentsMutationHookResult = ReturnType<typeof useConfirmMyAppointmentsMutation>;
export type ConfirmMyAppointmentsMutationResult = Apollo.MutationResult<ConfirmMyAppointmentsMutation>;
export type ConfirmMyAppointmentsMutationOptions = Apollo.BaseMutationOptions<ConfirmMyAppointmentsMutation, ConfirmMyAppointmentsMutationVariables>;
export const CreateAccountChangeDocument = gql`
    mutation createAccountChange($data: AccountChangeInput!) {
  createAccountChange(data: $data) {
    documentId
  }
}
    `;
export type CreateAccountChangeMutationFn = Apollo.MutationFunction<CreateAccountChangeMutation, CreateAccountChangeMutationVariables>;

/**
 * __useCreateAccountChangeMutation__
 *
 * To run a mutation, you first call `useCreateAccountChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountChangeMutation, { data, loading, error }] = useCreateAccountChangeMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateAccountChangeMutation(baseOptions?: Apollo.MutationHookOptions<CreateAccountChangeMutation, CreateAccountChangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAccountChangeMutation, CreateAccountChangeMutationVariables>(CreateAccountChangeDocument, options);
      }
export type CreateAccountChangeMutationHookResult = ReturnType<typeof useCreateAccountChangeMutation>;
export type CreateAccountChangeMutationResult = Apollo.MutationResult<CreateAccountChangeMutation>;
export type CreateAccountChangeMutationOptions = Apollo.BaseMutationOptions<CreateAccountChangeMutation, CreateAccountChangeMutationVariables>;
export const CreateBookingDocument = gql`
    mutation createBooking($data: BookingInput!) {
  createBooking(data: $data) {
    documentId
    title
  }
}
    `;
export type CreateBookingMutationFn = Apollo.MutationFunction<CreateBookingMutation, CreateBookingMutationVariables>;

/**
 * __useCreateBookingMutation__
 *
 * To run a mutation, you first call `useCreateBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBookingMutation, { data, loading, error }] = useCreateBookingMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateBookingMutation(baseOptions?: Apollo.MutationHookOptions<CreateBookingMutation, CreateBookingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBookingMutation, CreateBookingMutationVariables>(CreateBookingDocument, options);
      }
export type CreateBookingMutationHookResult = ReturnType<typeof useCreateBookingMutation>;
export type CreateBookingMutationResult = Apollo.MutationResult<CreateBookingMutation>;
export type CreateBookingMutationOptions = Apollo.BaseMutationOptions<CreateBookingMutation, CreateBookingMutationVariables>;
export const CreateProgrammeSubmissionDocument = gql`
    mutation createProgrammeSubmission($data: ProgrammeSubmissionInput!) {
  createProgrammeSubmission(data: $data) {
    documentId
    status
    progress
  }
}
    `;
export type CreateProgrammeSubmissionMutationFn = Apollo.MutationFunction<CreateProgrammeSubmissionMutation, CreateProgrammeSubmissionMutationVariables>;

/**
 * __useCreateProgrammeSubmissionMutation__
 *
 * To run a mutation, you first call `useCreateProgrammeSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProgrammeSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProgrammeSubmissionMutation, { data, loading, error }] = useCreateProgrammeSubmissionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateProgrammeSubmissionMutation(baseOptions?: Apollo.MutationHookOptions<CreateProgrammeSubmissionMutation, CreateProgrammeSubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProgrammeSubmissionMutation, CreateProgrammeSubmissionMutationVariables>(CreateProgrammeSubmissionDocument, options);
      }
export type CreateProgrammeSubmissionMutationHookResult = ReturnType<typeof useCreateProgrammeSubmissionMutation>;
export type CreateProgrammeSubmissionMutationResult = Apollo.MutationResult<CreateProgrammeSubmissionMutation>;
export type CreateProgrammeSubmissionMutationOptions = Apollo.BaseMutationOptions<CreateProgrammeSubmissionMutation, CreateProgrammeSubmissionMutationVariables>;
export const CreateSessionDocument = gql`
    mutation createSession($data: CoachSessionInput!) {
  createCoachSession(data: $data) {
    documentId
    title
    createdAt
    updatedAt
  }
}
    `;
export type CreateSessionMutationFn = Apollo.MutationFunction<CreateSessionMutation, CreateSessionMutationVariables>;

/**
 * __useCreateSessionMutation__
 *
 * To run a mutation, you first call `useCreateSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSessionMutation, { data, loading, error }] = useCreateSessionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateSessionMutation(baseOptions?: Apollo.MutationHookOptions<CreateSessionMutation, CreateSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSessionMutation, CreateSessionMutationVariables>(CreateSessionDocument, options);
      }
export type CreateSessionMutationHookResult = ReturnType<typeof useCreateSessionMutation>;
export type CreateSessionMutationResult = Apollo.MutationResult<CreateSessionMutation>;
export type CreateSessionMutationOptions = Apollo.BaseMutationOptions<CreateSessionMutation, CreateSessionMutationVariables>;
export const DeletedNoteDocument = gql`
    mutation deletedNote($id: ID!) {
  deletedNote(id: $id) {
    note
  }
}
    `;
export type DeletedNoteMutationFn = Apollo.MutationFunction<DeletedNoteMutation, DeletedNoteMutationVariables>;

/**
 * __useDeletedNoteMutation__
 *
 * To run a mutation, you first call `useDeletedNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletedNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletedNoteMutation, { data, loading, error }] = useDeletedNoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletedNoteMutation(baseOptions?: Apollo.MutationHookOptions<DeletedNoteMutation, DeletedNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletedNoteMutation, DeletedNoteMutationVariables>(DeletedNoteDocument, options);
      }
export type DeletedNoteMutationHookResult = ReturnType<typeof useDeletedNoteMutation>;
export type DeletedNoteMutationResult = Apollo.MutationResult<DeletedNoteMutation>;
export type DeletedNoteMutationOptions = Apollo.BaseMutationOptions<DeletedNoteMutation, DeletedNoteMutationVariables>;
export const GenerateCompetencyResponsesDocument = gql`
    mutation generateCompetencyResponses($id: ID!) {
  generateCompetencyResponses(id: $id) {
    success
  }
}
    `;
export type GenerateCompetencyResponsesMutationFn = Apollo.MutationFunction<GenerateCompetencyResponsesMutation, GenerateCompetencyResponsesMutationVariables>;

/**
 * __useGenerateCompetencyResponsesMutation__
 *
 * To run a mutation, you first call `useGenerateCompetencyResponsesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateCompetencyResponsesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateCompetencyResponsesMutation, { data, loading, error }] = useGenerateCompetencyResponsesMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGenerateCompetencyResponsesMutation(baseOptions?: Apollo.MutationHookOptions<GenerateCompetencyResponsesMutation, GenerateCompetencyResponsesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateCompetencyResponsesMutation, GenerateCompetencyResponsesMutationVariables>(GenerateCompetencyResponsesDocument, options);
      }
export type GenerateCompetencyResponsesMutationHookResult = ReturnType<typeof useGenerateCompetencyResponsesMutation>;
export type GenerateCompetencyResponsesMutationResult = Apollo.MutationResult<GenerateCompetencyResponsesMutation>;
export type GenerateCompetencyResponsesMutationOptions = Apollo.BaseMutationOptions<GenerateCompetencyResponsesMutation, GenerateCompetencyResponsesMutationVariables>;
export const GenerateMyMiniSectionSubmissionResponseDocument = gql`
    mutation generateMyMiniSectionSubmissionResponse($id: ID!, $sectionId: Int, $secId: Int) {
  generateMyMiniSectionSubmissionResponse(
    id: $id
    sectionId: $sectionId
    secId: $secId
  ) {
    success
  }
}
    `;
export type GenerateMyMiniSectionSubmissionResponseMutationFn = Apollo.MutationFunction<GenerateMyMiniSectionSubmissionResponseMutation, GenerateMyMiniSectionSubmissionResponseMutationVariables>;

/**
 * __useGenerateMyMiniSectionSubmissionResponseMutation__
 *
 * To run a mutation, you first call `useGenerateMyMiniSectionSubmissionResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateMyMiniSectionSubmissionResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateMyMiniSectionSubmissionResponseMutation, { data, loading, error }] = useGenerateMyMiniSectionSubmissionResponseMutation({
 *   variables: {
 *      id: // value for 'id'
 *      sectionId: // value for 'sectionId'
 *      secId: // value for 'secId'
 *   },
 * });
 */
export function useGenerateMyMiniSectionSubmissionResponseMutation(baseOptions?: Apollo.MutationHookOptions<GenerateMyMiniSectionSubmissionResponseMutation, GenerateMyMiniSectionSubmissionResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateMyMiniSectionSubmissionResponseMutation, GenerateMyMiniSectionSubmissionResponseMutationVariables>(GenerateMyMiniSectionSubmissionResponseDocument, options);
      }
export type GenerateMyMiniSectionSubmissionResponseMutationHookResult = ReturnType<typeof useGenerateMyMiniSectionSubmissionResponseMutation>;
export type GenerateMyMiniSectionSubmissionResponseMutationResult = Apollo.MutationResult<GenerateMyMiniSectionSubmissionResponseMutation>;
export type GenerateMyMiniSectionSubmissionResponseMutationOptions = Apollo.BaseMutationOptions<GenerateMyMiniSectionSubmissionResponseMutation, GenerateMyMiniSectionSubmissionResponseMutationVariables>;
export const GenerateMyProgrammeSubmissionResponsesDocument = gql`
    mutation generateMyProgrammeSubmissionResponses($id: ID!) {
  generateMyProgrammeSubmissionResponses(id: $id) {
    success
  }
}
    `;
export type GenerateMyProgrammeSubmissionResponsesMutationFn = Apollo.MutationFunction<GenerateMyProgrammeSubmissionResponsesMutation, GenerateMyProgrammeSubmissionResponsesMutationVariables>;

/**
 * __useGenerateMyProgrammeSubmissionResponsesMutation__
 *
 * To run a mutation, you first call `useGenerateMyProgrammeSubmissionResponsesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateMyProgrammeSubmissionResponsesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateMyProgrammeSubmissionResponsesMutation, { data, loading, error }] = useGenerateMyProgrammeSubmissionResponsesMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGenerateMyProgrammeSubmissionResponsesMutation(baseOptions?: Apollo.MutationHookOptions<GenerateMyProgrammeSubmissionResponsesMutation, GenerateMyProgrammeSubmissionResponsesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateMyProgrammeSubmissionResponsesMutation, GenerateMyProgrammeSubmissionResponsesMutationVariables>(GenerateMyProgrammeSubmissionResponsesDocument, options);
      }
export type GenerateMyProgrammeSubmissionResponsesMutationHookResult = ReturnType<typeof useGenerateMyProgrammeSubmissionResponsesMutation>;
export type GenerateMyProgrammeSubmissionResponsesMutationResult = Apollo.MutationResult<GenerateMyProgrammeSubmissionResponsesMutation>;
export type GenerateMyProgrammeSubmissionResponsesMutationOptions = Apollo.BaseMutationOptions<GenerateMyProgrammeSubmissionResponsesMutation, GenerateMyProgrammeSubmissionResponsesMutationVariables>;
export const GenerateMySubModuleSubmissionComptencyResponsesDocument = gql`
    mutation generateMySubModuleSubmissionComptencyResponses($id: ID!, $sectionId: Int) {
  generateMySubModuleSubmissionComptencyResponses(id: $id, sectionId: $sectionId) {
    success
  }
}
    `;
export type GenerateMySubModuleSubmissionComptencyResponsesMutationFn = Apollo.MutationFunction<GenerateMySubModuleSubmissionComptencyResponsesMutation, GenerateMySubModuleSubmissionComptencyResponsesMutationVariables>;

/**
 * __useGenerateMySubModuleSubmissionComptencyResponsesMutation__
 *
 * To run a mutation, you first call `useGenerateMySubModuleSubmissionComptencyResponsesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateMySubModuleSubmissionComptencyResponsesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateMySubModuleSubmissionComptencyResponsesMutation, { data, loading, error }] = useGenerateMySubModuleSubmissionComptencyResponsesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      sectionId: // value for 'sectionId'
 *   },
 * });
 */
export function useGenerateMySubModuleSubmissionComptencyResponsesMutation(baseOptions?: Apollo.MutationHookOptions<GenerateMySubModuleSubmissionComptencyResponsesMutation, GenerateMySubModuleSubmissionComptencyResponsesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateMySubModuleSubmissionComptencyResponsesMutation, GenerateMySubModuleSubmissionComptencyResponsesMutationVariables>(GenerateMySubModuleSubmissionComptencyResponsesDocument, options);
      }
export type GenerateMySubModuleSubmissionComptencyResponsesMutationHookResult = ReturnType<typeof useGenerateMySubModuleSubmissionComptencyResponsesMutation>;
export type GenerateMySubModuleSubmissionComptencyResponsesMutationResult = Apollo.MutationResult<GenerateMySubModuleSubmissionComptencyResponsesMutation>;
export type GenerateMySubModuleSubmissionComptencyResponsesMutationOptions = Apollo.BaseMutationOptions<GenerateMySubModuleSubmissionComptencyResponsesMutation, GenerateMySubModuleSubmissionComptencyResponsesMutationVariables>;
export const GenerateMySubModuleSubmissionResponsesDocument = gql`
    mutation generateMySubModuleSubmissionResponses($id: ID!, $sectionId: Int) {
  generateMySubModuleSubmissionResponses(id: $id, sectionId: $sectionId) {
    success
  }
}
    `;
export type GenerateMySubModuleSubmissionResponsesMutationFn = Apollo.MutationFunction<GenerateMySubModuleSubmissionResponsesMutation, GenerateMySubModuleSubmissionResponsesMutationVariables>;

/**
 * __useGenerateMySubModuleSubmissionResponsesMutation__
 *
 * To run a mutation, you first call `useGenerateMySubModuleSubmissionResponsesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateMySubModuleSubmissionResponsesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateMySubModuleSubmissionResponsesMutation, { data, loading, error }] = useGenerateMySubModuleSubmissionResponsesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      sectionId: // value for 'sectionId'
 *   },
 * });
 */
export function useGenerateMySubModuleSubmissionResponsesMutation(baseOptions?: Apollo.MutationHookOptions<GenerateMySubModuleSubmissionResponsesMutation, GenerateMySubModuleSubmissionResponsesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateMySubModuleSubmissionResponsesMutation, GenerateMySubModuleSubmissionResponsesMutationVariables>(GenerateMySubModuleSubmissionResponsesDocument, options);
      }
export type GenerateMySubModuleSubmissionResponsesMutationHookResult = ReturnType<typeof useGenerateMySubModuleSubmissionResponsesMutation>;
export type GenerateMySubModuleSubmissionResponsesMutationResult = Apollo.MutationResult<GenerateMySubModuleSubmissionResponsesMutation>;
export type GenerateMySubModuleSubmissionResponsesMutationOptions = Apollo.BaseMutationOptions<GenerateMySubModuleSubmissionResponsesMutation, GenerateMySubModuleSubmissionResponsesMutationVariables>;
export const ResendMailDocument = gql`
    mutation resendMail($id: ID!, $name: String, $email: String) {
  resendMail(id: $id, name: $name, email: $email) {
    success
  }
}
    `;
export type ResendMailMutationFn = Apollo.MutationFunction<ResendMailMutation, ResendMailMutationVariables>;

/**
 * __useResendMailMutation__
 *
 * To run a mutation, you first call `useResendMailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendMailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendMailMutation, { data, loading, error }] = useResendMailMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useResendMailMutation(baseOptions?: Apollo.MutationHookOptions<ResendMailMutation, ResendMailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendMailMutation, ResendMailMutationVariables>(ResendMailDocument, options);
      }
export type ResendMailMutationHookResult = ReturnType<typeof useResendMailMutation>;
export type ResendMailMutationResult = Apollo.MutationResult<ResendMailMutation>;
export type ResendMailMutationOptions = Apollo.BaseMutationOptions<ResendMailMutation, ResendMailMutationVariables>;
export const ResendProgrammeMailDocument = gql`
    mutation resendProgrammeMail($id: ID!, $name: String, $email: String) {
  resendProgrammeMail(id: $id, name: $name, email: $email) {
    successed
  }
}
    `;
export type ResendProgrammeMailMutationFn = Apollo.MutationFunction<ResendProgrammeMailMutation, ResendProgrammeMailMutationVariables>;

/**
 * __useResendProgrammeMailMutation__
 *
 * To run a mutation, you first call `useResendProgrammeMailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendProgrammeMailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendProgrammeMailMutation, { data, loading, error }] = useResendProgrammeMailMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useResendProgrammeMailMutation(baseOptions?: Apollo.MutationHookOptions<ResendProgrammeMailMutation, ResendProgrammeMailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendProgrammeMailMutation, ResendProgrammeMailMutationVariables>(ResendProgrammeMailDocument, options);
      }
export type ResendProgrammeMailMutationHookResult = ReturnType<typeof useResendProgrammeMailMutation>;
export type ResendProgrammeMailMutationResult = Apollo.MutationResult<ResendProgrammeMailMutation>;
export type ResendProgrammeMailMutationOptions = Apollo.BaseMutationOptions<ResendProgrammeMailMutation, ResendProgrammeMailMutationVariables>;
export const UpdateMySubModuleSubmissionDocument = gql`
    mutation updateMySubModuleSubmission($id: ID!, $currentSection: Int, $isPdf: Boolean, $name: String, $programmeSubmissionId: ID, $input: editSubModuleSubmissionInput!) {
  updateMySubModuleSubmission(
    id: $id
    isPdf: $isPdf
    name: $name
    currentSection: $currentSection
    programmeSubmissionId: $programmeSubmissionId
    input: $input
  ) {
    id
    view
    progress
    status
    time_spent
    language {
      documentId
      name
    }
    participants {
      documentId
      name
      email
      type
    }
    submission_participants {
      id
      name
    }
    sub_module {
      documentId
      name_french
      name_german
      name_english
      name_spanish
      name_mandarin
      description_french
      description_german
      description_english
      description_spanish
      cover {
        documentId
        url
      }
      programme_type {
        documentId
      }
    }
    section {
      id
      progress
      section {
        documentId
      }
      answers {
        id
        questionId
        answer
        nestedAnswers {
          answer
          questionTitle
        }
        isCorrect
        feedback
        outcome
      }
    }
  }
}
    `;
export type UpdateMySubModuleSubmissionMutationFn = Apollo.MutationFunction<UpdateMySubModuleSubmissionMutation, UpdateMySubModuleSubmissionMutationVariables>;

/**
 * __useUpdateMySubModuleSubmissionMutation__
 *
 * To run a mutation, you first call `useUpdateMySubModuleSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMySubModuleSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMySubModuleSubmissionMutation, { data, loading, error }] = useUpdateMySubModuleSubmissionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      currentSection: // value for 'currentSection'
 *      isPdf: // value for 'isPdf'
 *      name: // value for 'name'
 *      programmeSubmissionId: // value for 'programmeSubmissionId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMySubModuleSubmissionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMySubModuleSubmissionMutation, UpdateMySubModuleSubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMySubModuleSubmissionMutation, UpdateMySubModuleSubmissionMutationVariables>(UpdateMySubModuleSubmissionDocument, options);
      }
export type UpdateMySubModuleSubmissionMutationHookResult = ReturnType<typeof useUpdateMySubModuleSubmissionMutation>;
export type UpdateMySubModuleSubmissionMutationResult = Apollo.MutationResult<UpdateMySubModuleSubmissionMutation>;
export type UpdateMySubModuleSubmissionMutationOptions = Apollo.BaseMutationOptions<UpdateMySubModuleSubmissionMutation, UpdateMySubModuleSubmissionMutationVariables>;
export const UpdateNotificationDocument = gql`
    mutation updateNotification($id: ID!, $data: NotificationInput!) {
  updateNotification(documentId: $id, data: $data) {
    documentId
    title
    time_stamp
    path
    read
  }
}
    `;
export type UpdateNotificationMutationFn = Apollo.MutationFunction<UpdateNotificationMutation, UpdateNotificationMutationVariables>;

/**
 * __useUpdateNotificationMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationMutation, { data, loading, error }] = useUpdateNotificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateNotificationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotificationMutation, UpdateNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNotificationMutation, UpdateNotificationMutationVariables>(UpdateNotificationDocument, options);
      }
export type UpdateNotificationMutationHookResult = ReturnType<typeof useUpdateNotificationMutation>;
export type UpdateNotificationMutationResult = Apollo.MutationResult<UpdateNotificationMutation>;
export type UpdateNotificationMutationOptions = Apollo.BaseMutationOptions<UpdateNotificationMutation, UpdateNotificationMutationVariables>;
export const UpdateMyProgrammeSubmissionDocument = gql`
    mutation updateMyProgrammeSubmission($id: ID!, $input: editProgrammeSubmissionInput!, $isPdf: Boolean, $name: String) {
  updateMyProgrammeSubmissions(id: $id, isPdf: $isPdf, name: $name, input: $input) {
    id
    status
    progress
    programme_type {
      documentId
      title
      description
      cover {
        documentId
        url
      }
      is_coaching
      notes
      deadline
      programme_questions {
        __typename
        ... on ComponentQuestionTypesValuesNested {
          id
          title
          question
          questions {
            id
            titleEnglish
            subTitleEnglish
            titleFrench
            subTitleFrench
            titleGerman
            subTitleGerman
            titleSpanish
            subTitleSpanish
            titleMandarin
            subTitleMandarin
          }
        }
      }
      articles {
        documentId
        createdAt
        updatedAt
        title_english
        title_french
        title_german
        title_spanish
        title_mandarin
        content_english
        content_french
        content_german
        content_spanish
        content_mandarin
        image {
          documentId
          url
        }
        date_published
        read_time
        link
      }
      sub_modules {
        documentId
        name_english
        description_english
        cover {
          documentId
          url
        }
        programme_type {
          documentId
        }
      }
      archive
    }
  }
}
    `;
export type UpdateMyProgrammeSubmissionMutationFn = Apollo.MutationFunction<UpdateMyProgrammeSubmissionMutation, UpdateMyProgrammeSubmissionMutationVariables>;

/**
 * __useUpdateMyProgrammeSubmissionMutation__
 *
 * To run a mutation, you first call `useUpdateMyProgrammeSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMyProgrammeSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMyProgrammeSubmissionMutation, { data, loading, error }] = useUpdateMyProgrammeSubmissionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      isPdf: // value for 'isPdf'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateMyProgrammeSubmissionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMyProgrammeSubmissionMutation, UpdateMyProgrammeSubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMyProgrammeSubmissionMutation, UpdateMyProgrammeSubmissionMutationVariables>(UpdateMyProgrammeSubmissionDocument, options);
      }
export type UpdateMyProgrammeSubmissionMutationHookResult = ReturnType<typeof useUpdateMyProgrammeSubmissionMutation>;
export type UpdateMyProgrammeSubmissionMutationResult = Apollo.MutationResult<UpdateMyProgrammeSubmissionMutation>;
export type UpdateMyProgrammeSubmissionMutationOptions = Apollo.BaseMutationOptions<UpdateMyProgrammeSubmissionMutation, UpdateMyProgrammeSubmissionMutationVariables>;
export const UpdateSessionDocument = gql`
    mutation updateSession($id: ID!, $data: CoachSessionInput!) {
  updateCoachSession(documentId: $id, data: $data) {
    documentId
    title
    status
    user {
      documentId
    }
  }
}
    `;
export type UpdateSessionMutationFn = Apollo.MutationFunction<UpdateSessionMutation, UpdateSessionMutationVariables>;

/**
 * __useUpdateSessionMutation__
 *
 * To run a mutation, you first call `useUpdateSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSessionMutation, { data, loading, error }] = useUpdateSessionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateSessionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSessionMutation, UpdateSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSessionMutation, UpdateSessionMutationVariables>(UpdateSessionDocument, options);
      }
export type UpdateSessionMutationHookResult = ReturnType<typeof useUpdateSessionMutation>;
export type UpdateSessionMutationResult = Apollo.MutationResult<UpdateSessionMutation>;
export type UpdateSessionMutationOptions = Apollo.BaseMutationOptions<UpdateSessionMutation, UpdateSessionMutationVariables>;
export const UpdateMySubmissionDocument = gql`
    mutation updateMySubmission($id: ID!, $currentSection: Int, $programmeSubmissionId: ID, $input: editSubmissionInput!) {
  updateMySubmission(
    id: $id
    currentSection: $currentSection
    programmeSubmissionId: $programmeSubmissionId
    input: $input
  ) {
    id
    views
    progress
    status
    time_spent
    language {
      documentId
      name
    }
    module {
      documentId
      name_french
      name_german
      name_english
      name_spanish
      name_mandarin
      description_french
      description_german
      description_english
      description_spanish
      description_mandarin
      cover {
        documentId
        url
      }
    }
    section {
      id
      progress
      section {
        documentId
      }
      answers {
        id
        questionId
        answer
        nestedAnswers {
          answer
          questionTitle
        }
        isCorrect
        feedback
        outcome
      }
    }
  }
}
    `;
export type UpdateMySubmissionMutationFn = Apollo.MutationFunction<UpdateMySubmissionMutation, UpdateMySubmissionMutationVariables>;

/**
 * __useUpdateMySubmissionMutation__
 *
 * To run a mutation, you first call `useUpdateMySubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMySubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMySubmissionMutation, { data, loading, error }] = useUpdateMySubmissionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      currentSection: // value for 'currentSection'
 *      programmeSubmissionId: // value for 'programmeSubmissionId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMySubmissionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMySubmissionMutation, UpdateMySubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMySubmissionMutation, UpdateMySubmissionMutationVariables>(UpdateMySubmissionDocument, options);
      }
export type UpdateMySubmissionMutationHookResult = ReturnType<typeof useUpdateMySubmissionMutation>;
export type UpdateMySubmissionMutationResult = Apollo.MutationResult<UpdateMySubmissionMutation>;
export type UpdateMySubmissionMutationOptions = Apollo.BaseMutationOptions<UpdateMySubmissionMutation, UpdateMySubmissionMutationVariables>;
export const UpdateSelfDocument = gql`
    mutation updateSelf($user: editUserInput!) {
  updateSelf(user: $user) {
    documentId
    createdAt
    updatedAt
    email
    confirmed
    blocked
    phoneNumber
    onboarding
    profilePicture {
      documentId
      url
    }
    language {
      documentId
      name
    }
    firstName
    lastName
    jobTitle
    division {
      documentId
      title_french
      title_german
      title_english
      title_mandarin
      title_spanish
    }
    modulesRead
    homePromptsRead
    programmePromptsRead
    modulePromptsRead
    bookmarks
    articlesViewed
    report {
      documentId
      url
    }
    company {
      documentId
      name
      logo {
        documentId
        url
      }
      language_selection {
        id
        titleEnglish
        bodyEnglish
        nextButtonEnglish
        titleFrench
        bodyFrench
        nextButtonFrench
        titleGerman
        bodyGerman
        nextButtonGerman
        titleMandarin
        bodyMandarin
        nextButtonMandarin
        titleSpanish
        bodySpanish
        nextButtonSpanish
      }
      welcome_screen {
        id
        titleEnglish
        bodyEnglish
        videoEnglish {
          url
        }
        nextButtonEnglish
        titleFrench
        bodyFrench
        videoFrench {
          url
        }
        nextButtonFrench
        titleGerman
        bodyGerman
        videoGerman {
          url
        }
        nextButtonGerman
        titleMandarin
        bodyMandarin
        videoMandarin {
          url
        }
        nextButtonMandarin
        titleSpanish
        bodySpanish
        videoSpanish {
          url
        }
        nextButtonSpanish
      }
      lets_get_started_screen {
        id
        titleEnglish
        subTitleEnglish
        firstNameLabelEnglish
        firstNameErrorEnglish
        lastNameLabelEnglish
        lastNameErrorEnglish
        jobTitleLabelEnglish
        jobTitleErrorEnglish
        divisionLabelEnglish
        divisionErrorEnglish
        timezoneLabelEnglish
        regionLabelEnglish
        regionErrorEnglish
        image {
          url
        }
        nextButtonEnglish
        titleFrench
        subTitleFrench
        firstNameLabelFrench
        firstNameErrorFrench
        lastNameLabelFrench
        lastNameErrorFrench
        jobTitleLabelFrench
        jobTitleErrorFrench
        divisionLabelFrench
        divisionErrorFrench
        timezoneLabelFrench
        regionLabelFrench
        regionErrorFrench
        nextButtonFrench
        titleGerman
        subTitleGerman
        firstNameLabelGerman
        firstNameErrorGerman
        lastNameLabelGerman
        lastNameErrorGerman
        jobTitleLabelGerman
        jobTitleErrorGerman
        divisionLabelGerman
        divisionErrorGerman
        timezoneLabelGerman
        regionLabelGerman
        regionErrorGerman
        nextButtonGerman
        titleMandarin
        subTitleMandarin
        firstNameLabelMandarin
        firstNameErrorMandarin
        lastNameLabelMandarin
        lastNameErrorMandarin
        jobTitleLabelMandarin
        jobTitleErrorMandarin
        divisionLabelMandarin
        divisionErrorMandarin
        timezoneLabelMandarin
        regionLabelMandarin
        regionErrorMandarin
        nextButtonMandarin
        titleSpanish
        subTitleSpanish
        firstNameLabelSpanish
        firstNameErrorSpanish
        lastNameLabelSpanish
        lastNameErrorSpanish
        jobTitleLabelSpanish
        jobTitleErrorSpanish
        divisionLabelSpanish
        divisionErrorSpanish
        timezoneLabelSpanish
        regionLabelSpanish
        regionErrorSpanish
        nextButtonSpanish
        leftTitleEnglish
        leftSubtitleEnglish
        leftTitleSpanish
        leftSubtitleSpanish
        leftTitleMandarin
        leftSubTitleMandarin
        leftTitleFrench
        leftSubtitleFrench
        leftSubtitleGerman
        leftTitleGerman
      }
      what_to_expect {
        id
        titleEnglish
        bodyEnglish
        image {
          url
        }
        getStartedButtonEnglish
        titleFrench
        bodyFrench
        getStartedButtonFrench
        titleGerman
        bodyGerman
        getStartedButtonGerman
        titleMandarin
        bodyMandarin
        getStartedButtonMandarin
        titleSpanish
        bodySpanish
        getStartedButtonSpanish
      }
      about_us {
        id
        textEnglish
        textFrench
        textGerman
        userGuidelinesTextEnglish
        userGuidelinesTextGerman
        userGuidelinesTextFrench
        userGuidelinesEnglish {
          url
        }
        userGuidelinesGerman {
          url
        }
        userGuidelinesFrench {
          url
        }
      }
      programmes_title
      programmes_subTitle
      users_confirm_details
    }
    submissions {
      documentId
    }
    programmes {
      documentId
      name
      description
      start
      is_custom_journey
      position
      logo {
        documentId
        url
      }
    }
  }
}
    `;
export type UpdateSelfMutationFn = Apollo.MutationFunction<UpdateSelfMutation, UpdateSelfMutationVariables>;

/**
 * __useUpdateSelfMutation__
 *
 * To run a mutation, you first call `useUpdateSelfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSelfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSelfMutation, { data, loading, error }] = useUpdateSelfMutation({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useUpdateSelfMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSelfMutation, UpdateSelfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSelfMutation, UpdateSelfMutationVariables>(UpdateSelfDocument, options);
      }
export type UpdateSelfMutationHookResult = ReturnType<typeof useUpdateSelfMutation>;
export type UpdateSelfMutationResult = Apollo.MutationResult<UpdateSelfMutation>;
export type UpdateSelfMutationOptions = Apollo.BaseMutationOptions<UpdateSelfMutation, UpdateSelfMutationVariables>;
export const CheckResponsesFromTypeFormDocument = gql`
    query checkResponsesFromTypeForm($id: ID!, $sectionid: Int) {
  checkResponsesFromTypeForm(id: $id, sectionid: $sectionid) {
    emails
  }
}
    `;

/**
 * __useCheckResponsesFromTypeFormQuery__
 *
 * To run a query within a React component, call `useCheckResponsesFromTypeFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckResponsesFromTypeFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckResponsesFromTypeFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *      sectionid: // value for 'sectionid'
 *   },
 * });
 */
export function useCheckResponsesFromTypeFormQuery(baseOptions: Apollo.QueryHookOptions<CheckResponsesFromTypeFormQuery, CheckResponsesFromTypeFormQueryVariables> & ({ variables: CheckResponsesFromTypeFormQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckResponsesFromTypeFormQuery, CheckResponsesFromTypeFormQueryVariables>(CheckResponsesFromTypeFormDocument, options);
      }
export function useCheckResponsesFromTypeFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckResponsesFromTypeFormQuery, CheckResponsesFromTypeFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckResponsesFromTypeFormQuery, CheckResponsesFromTypeFormQueryVariables>(CheckResponsesFromTypeFormDocument, options);
        }
// @ts-ignore
export function useCheckResponsesFromTypeFormSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckResponsesFromTypeFormQuery, CheckResponsesFromTypeFormQueryVariables>): Apollo.UseSuspenseQueryResult<CheckResponsesFromTypeFormQuery, CheckResponsesFromTypeFormQueryVariables>;
export function useCheckResponsesFromTypeFormSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckResponsesFromTypeFormQuery, CheckResponsesFromTypeFormQueryVariables>): Apollo.UseSuspenseQueryResult<CheckResponsesFromTypeFormQuery | undefined, CheckResponsesFromTypeFormQueryVariables>;
export function useCheckResponsesFromTypeFormSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckResponsesFromTypeFormQuery, CheckResponsesFromTypeFormQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckResponsesFromTypeFormQuery, CheckResponsesFromTypeFormQueryVariables>(CheckResponsesFromTypeFormDocument, options);
        }
export type CheckResponsesFromTypeFormQueryHookResult = ReturnType<typeof useCheckResponsesFromTypeFormQuery>;
export type CheckResponsesFromTypeFormLazyQueryHookResult = ReturnType<typeof useCheckResponsesFromTypeFormLazyQuery>;
export type CheckResponsesFromTypeFormSuspenseQueryHookResult = ReturnType<typeof useCheckResponsesFromTypeFormSuspenseQuery>;
export type CheckResponsesFromTypeFormQueryResult = Apollo.QueryResult<CheckResponsesFromTypeFormQuery, CheckResponsesFromTypeFormQueryVariables>;
export const CheckResponsesFromTypeFormProgrammeDocument = gql`
    query checkResponsesFromTypeFormProgramme($id: ID!, $sectionid: Int) {
  checkResponsesFromTypeFormProgramme(id: $id, sectionid: $sectionid) {
    emails
  }
}
    `;

/**
 * __useCheckResponsesFromTypeFormProgrammeQuery__
 *
 * To run a query within a React component, call `useCheckResponsesFromTypeFormProgrammeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckResponsesFromTypeFormProgrammeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckResponsesFromTypeFormProgrammeQuery({
 *   variables: {
 *      id: // value for 'id'
 *      sectionid: // value for 'sectionid'
 *   },
 * });
 */
export function useCheckResponsesFromTypeFormProgrammeQuery(baseOptions: Apollo.QueryHookOptions<CheckResponsesFromTypeFormProgrammeQuery, CheckResponsesFromTypeFormProgrammeQueryVariables> & ({ variables: CheckResponsesFromTypeFormProgrammeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckResponsesFromTypeFormProgrammeQuery, CheckResponsesFromTypeFormProgrammeQueryVariables>(CheckResponsesFromTypeFormProgrammeDocument, options);
      }
export function useCheckResponsesFromTypeFormProgrammeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckResponsesFromTypeFormProgrammeQuery, CheckResponsesFromTypeFormProgrammeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckResponsesFromTypeFormProgrammeQuery, CheckResponsesFromTypeFormProgrammeQueryVariables>(CheckResponsesFromTypeFormProgrammeDocument, options);
        }
// @ts-ignore
export function useCheckResponsesFromTypeFormProgrammeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckResponsesFromTypeFormProgrammeQuery, CheckResponsesFromTypeFormProgrammeQueryVariables>): Apollo.UseSuspenseQueryResult<CheckResponsesFromTypeFormProgrammeQuery, CheckResponsesFromTypeFormProgrammeQueryVariables>;
export function useCheckResponsesFromTypeFormProgrammeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckResponsesFromTypeFormProgrammeQuery, CheckResponsesFromTypeFormProgrammeQueryVariables>): Apollo.UseSuspenseQueryResult<CheckResponsesFromTypeFormProgrammeQuery | undefined, CheckResponsesFromTypeFormProgrammeQueryVariables>;
export function useCheckResponsesFromTypeFormProgrammeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckResponsesFromTypeFormProgrammeQuery, CheckResponsesFromTypeFormProgrammeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckResponsesFromTypeFormProgrammeQuery, CheckResponsesFromTypeFormProgrammeQueryVariables>(CheckResponsesFromTypeFormProgrammeDocument, options);
        }
export type CheckResponsesFromTypeFormProgrammeQueryHookResult = ReturnType<typeof useCheckResponsesFromTypeFormProgrammeQuery>;
export type CheckResponsesFromTypeFormProgrammeLazyQueryHookResult = ReturnType<typeof useCheckResponsesFromTypeFormProgrammeLazyQuery>;
export type CheckResponsesFromTypeFormProgrammeSuspenseQueryHookResult = ReturnType<typeof useCheckResponsesFromTypeFormProgrammeSuspenseQuery>;
export type CheckResponsesFromTypeFormProgrammeQueryResult = Apollo.QueryResult<CheckResponsesFromTypeFormProgrammeQuery, CheckResponsesFromTypeFormProgrammeQueryVariables>;
export const GetAllsectionReportDocument = gql`
    query getAllsectionReport($id: ID!) {
  getAllsectionReport(id: $id) {
    id
    name
    type
    report {
      documentId
      url
    }
    section_or_module_id
  }
}
    `;

/**
 * __useGetAllsectionReportQuery__
 *
 * To run a query within a React component, call `useGetAllsectionReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllsectionReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllsectionReportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAllsectionReportQuery(baseOptions: Apollo.QueryHookOptions<GetAllsectionReportQuery, GetAllsectionReportQueryVariables> & ({ variables: GetAllsectionReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllsectionReportQuery, GetAllsectionReportQueryVariables>(GetAllsectionReportDocument, options);
      }
export function useGetAllsectionReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllsectionReportQuery, GetAllsectionReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllsectionReportQuery, GetAllsectionReportQueryVariables>(GetAllsectionReportDocument, options);
        }
// @ts-ignore
export function useGetAllsectionReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllsectionReportQuery, GetAllsectionReportQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllsectionReportQuery, GetAllsectionReportQueryVariables>;
export function useGetAllsectionReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllsectionReportQuery, GetAllsectionReportQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllsectionReportQuery | undefined, GetAllsectionReportQueryVariables>;
export function useGetAllsectionReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllsectionReportQuery, GetAllsectionReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllsectionReportQuery, GetAllsectionReportQueryVariables>(GetAllsectionReportDocument, options);
        }
export type GetAllsectionReportQueryHookResult = ReturnType<typeof useGetAllsectionReportQuery>;
export type GetAllsectionReportLazyQueryHookResult = ReturnType<typeof useGetAllsectionReportLazyQuery>;
export type GetAllsectionReportSuspenseQueryHookResult = ReturnType<typeof useGetAllsectionReportSuspenseQuery>;
export type GetAllsectionReportQueryResult = Apollo.QueryResult<GetAllsectionReportQuery, GetAllsectionReportQueryVariables>;
export const GetArticlesDocument = gql`
    query getArticles($filters: ArticleFiltersInput, $pagination: PaginationArg, $sort: [String]) {
  articles(filters: $filters, pagination: $pagination, sort: $sort) {
    documentId
    createdAt
    updatedAt
    title_english
    title_french
    title_german
    title_spanish
    title_mandarin
    content_english
    content_french
    content_german
    content_spanish
    content_mandarin
    position
    companies {
      documentId
      name
    }
    image {
      documentId
      url
    }
    date_published
    read_time
    link
  }
}
    `;

/**
 * __useGetArticlesQuery__
 *
 * To run a query within a React component, call `useGetArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArticlesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetArticlesQuery(baseOptions?: Apollo.QueryHookOptions<GetArticlesQuery, GetArticlesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetArticlesQuery, GetArticlesQueryVariables>(GetArticlesDocument, options);
      }
export function useGetArticlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetArticlesQuery, GetArticlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetArticlesQuery, GetArticlesQueryVariables>(GetArticlesDocument, options);
        }
// @ts-ignore
export function useGetArticlesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetArticlesQuery, GetArticlesQueryVariables>): Apollo.UseSuspenseQueryResult<GetArticlesQuery, GetArticlesQueryVariables>;
export function useGetArticlesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetArticlesQuery, GetArticlesQueryVariables>): Apollo.UseSuspenseQueryResult<GetArticlesQuery | undefined, GetArticlesQueryVariables>;
export function useGetArticlesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetArticlesQuery, GetArticlesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetArticlesQuery, GetArticlesQueryVariables>(GetArticlesDocument, options);
        }
export type GetArticlesQueryHookResult = ReturnType<typeof useGetArticlesQuery>;
export type GetArticlesLazyQueryHookResult = ReturnType<typeof useGetArticlesLazyQuery>;
export type GetArticlesSuspenseQueryHookResult = ReturnType<typeof useGetArticlesSuspenseQuery>;
export type GetArticlesQueryResult = Apollo.QueryResult<GetArticlesQuery, GetArticlesQueryVariables>;
export const GetCoachSubmittedReportsDocument = gql`
    query getCoachSubmittedReports($sort: [String]) {
  coachSubmittedReports(sort: $sort) {
    documentId
    name
    notes_id {
      name
      saboteurProofValue {
        documentId
        url
      }
    }
  }
}
    `;

/**
 * __useGetCoachSubmittedReportsQuery__
 *
 * To run a query within a React component, call `useGetCoachSubmittedReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoachSubmittedReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoachSubmittedReportsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetCoachSubmittedReportsQuery(baseOptions?: Apollo.QueryHookOptions<GetCoachSubmittedReportsQuery, GetCoachSubmittedReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoachSubmittedReportsQuery, GetCoachSubmittedReportsQueryVariables>(GetCoachSubmittedReportsDocument, options);
      }
export function useGetCoachSubmittedReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoachSubmittedReportsQuery, GetCoachSubmittedReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoachSubmittedReportsQuery, GetCoachSubmittedReportsQueryVariables>(GetCoachSubmittedReportsDocument, options);
        }
// @ts-ignore
export function useGetCoachSubmittedReportsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCoachSubmittedReportsQuery, GetCoachSubmittedReportsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCoachSubmittedReportsQuery, GetCoachSubmittedReportsQueryVariables>;
export function useGetCoachSubmittedReportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCoachSubmittedReportsQuery, GetCoachSubmittedReportsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCoachSubmittedReportsQuery | undefined, GetCoachSubmittedReportsQueryVariables>;
export function useGetCoachSubmittedReportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCoachSubmittedReportsQuery, GetCoachSubmittedReportsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCoachSubmittedReportsQuery, GetCoachSubmittedReportsQueryVariables>(GetCoachSubmittedReportsDocument, options);
        }
export type GetCoachSubmittedReportsQueryHookResult = ReturnType<typeof useGetCoachSubmittedReportsQuery>;
export type GetCoachSubmittedReportsLazyQueryHookResult = ReturnType<typeof useGetCoachSubmittedReportsLazyQuery>;
export type GetCoachSubmittedReportsSuspenseQueryHookResult = ReturnType<typeof useGetCoachSubmittedReportsSuspenseQuery>;
export type GetCoachSubmittedReportsQueryResult = Apollo.QueryResult<GetCoachSubmittedReportsQuery, GetCoachSubmittedReportsQueryVariables>;
export const GetCompanyDocument = gql`
    query getCompany($id: ID!) {
  company(documentId: $id) {
    programmes {
      documentId
      name
      description
      start
      programme_types {
        documentId
        programme_submissions {
          documentId
          user {
            documentId
          }
          programme {
            documentId
            is_custom_journey
            show_timeline
            logo {
              documentId
              url
            }
          }
        }
      }
      is_custom_journey
      show_timeline
      position
    }
  }
}
    `;

/**
 * __useGetCompanyQuery__
 *
 * To run a query within a React component, call `useGetCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCompanyQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyQuery, GetCompanyQueryVariables> & ({ variables: GetCompanyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyQuery, GetCompanyQueryVariables>(GetCompanyDocument, options);
      }
export function useGetCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyQuery, GetCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyQuery, GetCompanyQueryVariables>(GetCompanyDocument, options);
        }
// @ts-ignore
export function useGetCompanySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCompanyQuery, GetCompanyQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyQuery, GetCompanyQueryVariables>;
export function useGetCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyQuery, GetCompanyQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyQuery | undefined, GetCompanyQueryVariables>;
export function useGetCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyQuery, GetCompanyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyQuery, GetCompanyQueryVariables>(GetCompanyDocument, options);
        }
export type GetCompanyQueryHookResult = ReturnType<typeof useGetCompanyQuery>;
export type GetCompanyLazyQueryHookResult = ReturnType<typeof useGetCompanyLazyQuery>;
export type GetCompanySuspenseQueryHookResult = ReturnType<typeof useGetCompanySuspenseQuery>;
export type GetCompanyQueryResult = Apollo.QueryResult<GetCompanyQuery, GetCompanyQueryVariables>;
export const GetCompanyDivisionsDocument = gql`
    query getCompanyDivisions($filters: DivisionFiltersInput, $sort: [String], $pagination: PaginationArg) {
  divisions(filters: $filters, sort: $sort, pagination: $pagination) {
    documentId
    title_english
    title_french
    title_german
    title_spanish
    title_mandarin
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetCompanyDivisionsQuery__
 *
 * To run a query within a React component, call `useGetCompanyDivisionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyDivisionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyDivisionsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetCompanyDivisionsQuery(baseOptions?: Apollo.QueryHookOptions<GetCompanyDivisionsQuery, GetCompanyDivisionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyDivisionsQuery, GetCompanyDivisionsQueryVariables>(GetCompanyDivisionsDocument, options);
      }
export function useGetCompanyDivisionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyDivisionsQuery, GetCompanyDivisionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyDivisionsQuery, GetCompanyDivisionsQueryVariables>(GetCompanyDivisionsDocument, options);
        }
// @ts-ignore
export function useGetCompanyDivisionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCompanyDivisionsQuery, GetCompanyDivisionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyDivisionsQuery, GetCompanyDivisionsQueryVariables>;
export function useGetCompanyDivisionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyDivisionsQuery, GetCompanyDivisionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyDivisionsQuery | undefined, GetCompanyDivisionsQueryVariables>;
export function useGetCompanyDivisionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyDivisionsQuery, GetCompanyDivisionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyDivisionsQuery, GetCompanyDivisionsQueryVariables>(GetCompanyDivisionsDocument, options);
        }
export type GetCompanyDivisionsQueryHookResult = ReturnType<typeof useGetCompanyDivisionsQuery>;
export type GetCompanyDivisionsLazyQueryHookResult = ReturnType<typeof useGetCompanyDivisionsLazyQuery>;
export type GetCompanyDivisionsSuspenseQueryHookResult = ReturnType<typeof useGetCompanyDivisionsSuspenseQuery>;
export type GetCompanyDivisionsQueryResult = Apollo.QueryResult<GetCompanyDivisionsQuery, GetCompanyDivisionsQueryVariables>;
export const GetCompanyRegionsDocument = gql`
    query getCompanyRegions($filters: RegionFiltersInput, $sort: [String], $pagination: PaginationArg) {
  regions(filters: $filters, sort: $sort, pagination: $pagination) {
    documentId
    name_english
    name_french
    name_german
    name_spanish
    name_mandarin
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetCompanyRegionsQuery__
 *
 * To run a query within a React component, call `useGetCompanyRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyRegionsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetCompanyRegionsQuery(baseOptions?: Apollo.QueryHookOptions<GetCompanyRegionsQuery, GetCompanyRegionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyRegionsQuery, GetCompanyRegionsQueryVariables>(GetCompanyRegionsDocument, options);
      }
export function useGetCompanyRegionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyRegionsQuery, GetCompanyRegionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyRegionsQuery, GetCompanyRegionsQueryVariables>(GetCompanyRegionsDocument, options);
        }
// @ts-ignore
export function useGetCompanyRegionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCompanyRegionsQuery, GetCompanyRegionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyRegionsQuery, GetCompanyRegionsQueryVariables>;
export function useGetCompanyRegionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyRegionsQuery, GetCompanyRegionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyRegionsQuery | undefined, GetCompanyRegionsQueryVariables>;
export function useGetCompanyRegionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyRegionsQuery, GetCompanyRegionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyRegionsQuery, GetCompanyRegionsQueryVariables>(GetCompanyRegionsDocument, options);
        }
export type GetCompanyRegionsQueryHookResult = ReturnType<typeof useGetCompanyRegionsQuery>;
export type GetCompanyRegionsLazyQueryHookResult = ReturnType<typeof useGetCompanyRegionsLazyQuery>;
export type GetCompanyRegionsSuspenseQueryHookResult = ReturnType<typeof useGetCompanyRegionsSuspenseQuery>;
export type GetCompanyRegionsQueryResult = Apollo.QueryResult<GetCompanyRegionsQuery, GetCompanyRegionsQueryVariables>;
export const GetDivisionsDocument = gql`
    query getDivisions($filters: DivisionFiltersInput, $sort: [String], $pagination: PaginationArg) {
  divisions(filters: $filters, sort: $sort, pagination: $pagination) {
    documentId
    title_english
    title_french
    title_german
    title_spanish
    title_mandarin
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetDivisionsQuery__
 *
 * To run a query within a React component, call `useGetDivisionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDivisionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDivisionsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetDivisionsQuery(baseOptions?: Apollo.QueryHookOptions<GetDivisionsQuery, GetDivisionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDivisionsQuery, GetDivisionsQueryVariables>(GetDivisionsDocument, options);
      }
export function useGetDivisionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDivisionsQuery, GetDivisionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDivisionsQuery, GetDivisionsQueryVariables>(GetDivisionsDocument, options);
        }
// @ts-ignore
export function useGetDivisionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDivisionsQuery, GetDivisionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDivisionsQuery, GetDivisionsQueryVariables>;
export function useGetDivisionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDivisionsQuery, GetDivisionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDivisionsQuery | undefined, GetDivisionsQueryVariables>;
export function useGetDivisionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDivisionsQuery, GetDivisionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDivisionsQuery, GetDivisionsQueryVariables>(GetDivisionsDocument, options);
        }
export type GetDivisionsQueryHookResult = ReturnType<typeof useGetDivisionsQuery>;
export type GetDivisionsLazyQueryHookResult = ReturnType<typeof useGetDivisionsLazyQuery>;
export type GetDivisionsSuspenseQueryHookResult = ReturnType<typeof useGetDivisionsSuspenseQuery>;
export type GetDivisionsQueryResult = Apollo.QueryResult<GetDivisionsQuery, GetDivisionsQueryVariables>;
export const GetFirstFourNotesDocument = gql`
    query getFirstFourNotes {
  getFirstFourNotes {
    id
    name
    note
    document {
      id
      url
    }
    programme {
      name
    }
    notesId {
      saboteurProofValue {
        documentId
        url
        name
      }
    }
    subModuleSubmission {
      sub_module {
        documentId
        name_english
      }
    }
    sectionOrSubmissionId
    createdAt
  }
}
    `;

/**
 * __useGetFirstFourNotesQuery__
 *
 * To run a query within a React component, call `useGetFirstFourNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFirstFourNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFirstFourNotesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFirstFourNotesQuery(baseOptions?: Apollo.QueryHookOptions<GetFirstFourNotesQuery, GetFirstFourNotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFirstFourNotesQuery, GetFirstFourNotesQueryVariables>(GetFirstFourNotesDocument, options);
      }
export function useGetFirstFourNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFirstFourNotesQuery, GetFirstFourNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFirstFourNotesQuery, GetFirstFourNotesQueryVariables>(GetFirstFourNotesDocument, options);
        }
// @ts-ignore
export function useGetFirstFourNotesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFirstFourNotesQuery, GetFirstFourNotesQueryVariables>): Apollo.UseSuspenseQueryResult<GetFirstFourNotesQuery, GetFirstFourNotesQueryVariables>;
export function useGetFirstFourNotesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFirstFourNotesQuery, GetFirstFourNotesQueryVariables>): Apollo.UseSuspenseQueryResult<GetFirstFourNotesQuery | undefined, GetFirstFourNotesQueryVariables>;
export function useGetFirstFourNotesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFirstFourNotesQuery, GetFirstFourNotesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFirstFourNotesQuery, GetFirstFourNotesQueryVariables>(GetFirstFourNotesDocument, options);
        }
export type GetFirstFourNotesQueryHookResult = ReturnType<typeof useGetFirstFourNotesQuery>;
export type GetFirstFourNotesLazyQueryHookResult = ReturnType<typeof useGetFirstFourNotesLazyQuery>;
export type GetFirstFourNotesSuspenseQueryHookResult = ReturnType<typeof useGetFirstFourNotesSuspenseQuery>;
export type GetFirstFourNotesQueryResult = Apollo.QueryResult<GetFirstFourNotesQuery, GetFirstFourNotesQueryVariables>;
export const GetFirstTwelveArticlesDocument = gql`
    query getFirstTwelveArticles {
  articles(pagination: {limit: 12}, sort: "position:asc") {
    documentId
    createdAt
    updatedAt
    title_english
    title_french
    title_german
    title_spanish
    title_mandarin
    content_english
    content_french
    content_german
    content_spanish
    content_mandarin
    position
    companies {
      documentId
    }
    image {
      url
    }
    date_published
    read_time
    link
  }
}
    `;

/**
 * __useGetFirstTwelveArticlesQuery__
 *
 * To run a query within a React component, call `useGetFirstTwelveArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFirstTwelveArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFirstTwelveArticlesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFirstTwelveArticlesQuery(baseOptions?: Apollo.QueryHookOptions<GetFirstTwelveArticlesQuery, GetFirstTwelveArticlesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFirstTwelveArticlesQuery, GetFirstTwelveArticlesQueryVariables>(GetFirstTwelveArticlesDocument, options);
      }
export function useGetFirstTwelveArticlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFirstTwelveArticlesQuery, GetFirstTwelveArticlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFirstTwelveArticlesQuery, GetFirstTwelveArticlesQueryVariables>(GetFirstTwelveArticlesDocument, options);
        }
// @ts-ignore
export function useGetFirstTwelveArticlesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFirstTwelveArticlesQuery, GetFirstTwelveArticlesQueryVariables>): Apollo.UseSuspenseQueryResult<GetFirstTwelveArticlesQuery, GetFirstTwelveArticlesQueryVariables>;
export function useGetFirstTwelveArticlesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFirstTwelveArticlesQuery, GetFirstTwelveArticlesQueryVariables>): Apollo.UseSuspenseQueryResult<GetFirstTwelveArticlesQuery | undefined, GetFirstTwelveArticlesQueryVariables>;
export function useGetFirstTwelveArticlesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFirstTwelveArticlesQuery, GetFirstTwelveArticlesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFirstTwelveArticlesQuery, GetFirstTwelveArticlesQueryVariables>(GetFirstTwelveArticlesDocument, options);
        }
export type GetFirstTwelveArticlesQueryHookResult = ReturnType<typeof useGetFirstTwelveArticlesQuery>;
export type GetFirstTwelveArticlesLazyQueryHookResult = ReturnType<typeof useGetFirstTwelveArticlesLazyQuery>;
export type GetFirstTwelveArticlesSuspenseQueryHookResult = ReturnType<typeof useGetFirstTwelveArticlesSuspenseQuery>;
export type GetFirstTwelveArticlesQueryResult = Apollo.QueryResult<GetFirstTwelveArticlesQuery, GetFirstTwelveArticlesQueryVariables>;
export const GetInviteDocument = gql`
    query getInvite($filters: InviteFiltersInput, $sort: [String], $pagination: PaginationArg) {
  invites(filters: $filters, sort: $sort, pagination: $pagination) {
    documentId
    email
    company {
      documentId
      name
    }
  }
}
    `;

/**
 * __useGetInviteQuery__
 *
 * To run a query within a React component, call `useGetInviteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInviteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInviteQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetInviteQuery(baseOptions?: Apollo.QueryHookOptions<GetInviteQuery, GetInviteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInviteQuery, GetInviteQueryVariables>(GetInviteDocument, options);
      }
export function useGetInviteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInviteQuery, GetInviteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInviteQuery, GetInviteQueryVariables>(GetInviteDocument, options);
        }
// @ts-ignore
export function useGetInviteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInviteQuery, GetInviteQueryVariables>): Apollo.UseSuspenseQueryResult<GetInviteQuery, GetInviteQueryVariables>;
export function useGetInviteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInviteQuery, GetInviteQueryVariables>): Apollo.UseSuspenseQueryResult<GetInviteQuery | undefined, GetInviteQueryVariables>;
export function useGetInviteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInviteQuery, GetInviteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInviteQuery, GetInviteQueryVariables>(GetInviteDocument, options);
        }
export type GetInviteQueryHookResult = ReturnType<typeof useGetInviteQuery>;
export type GetInviteLazyQueryHookResult = ReturnType<typeof useGetInviteLazyQuery>;
export type GetInviteSuspenseQueryHookResult = ReturnType<typeof useGetInviteSuspenseQuery>;
export type GetInviteQueryResult = Apollo.QueryResult<GetInviteQuery, GetInviteQueryVariables>;
export const GetLanguagesDocument = gql`
    query getLanguages($filters: LanguageFiltersInput, $sort: [String], $pagination: PaginationArg) {
  languages(filters: $filters, sort: $sort, pagination: $pagination) {
    documentId
    name
    image {
      documentId
      url
    }
    companies {
      documentId
      name
    }
  }
}
    `;

/**
 * __useGetLanguagesQuery__
 *
 * To run a query within a React component, call `useGetLanguagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLanguagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLanguagesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetLanguagesQuery(baseOptions?: Apollo.QueryHookOptions<GetLanguagesQuery, GetLanguagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLanguagesQuery, GetLanguagesQueryVariables>(GetLanguagesDocument, options);
      }
export function useGetLanguagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLanguagesQuery, GetLanguagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLanguagesQuery, GetLanguagesQueryVariables>(GetLanguagesDocument, options);
        }
// @ts-ignore
export function useGetLanguagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLanguagesQuery, GetLanguagesQueryVariables>): Apollo.UseSuspenseQueryResult<GetLanguagesQuery, GetLanguagesQueryVariables>;
export function useGetLanguagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLanguagesQuery, GetLanguagesQueryVariables>): Apollo.UseSuspenseQueryResult<GetLanguagesQuery | undefined, GetLanguagesQueryVariables>;
export function useGetLanguagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLanguagesQuery, GetLanguagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLanguagesQuery, GetLanguagesQueryVariables>(GetLanguagesDocument, options);
        }
export type GetLanguagesQueryHookResult = ReturnType<typeof useGetLanguagesQuery>;
export type GetLanguagesLazyQueryHookResult = ReturnType<typeof useGetLanguagesLazyQuery>;
export type GetLanguagesSuspenseQueryHookResult = ReturnType<typeof useGetLanguagesSuspenseQuery>;
export type GetLanguagesQueryResult = Apollo.QueryResult<GetLanguagesQuery, GetLanguagesQueryVariables>;
export const GetModuleDocument = gql`
    query getModule($id: ID!) {
  module(documentId: $id) {
    documentId
    name_english
    name_french
    name_spanish
    name_german
    name_mandarin
    description_english
    description_french
    description_german
    description_mandarin
    description_spanish
    sections {
      documentId
      title_french
      title_german
      title_english
      title_spanish
      title_mandarin
      sub_title_french
      sub_title_german
      sub_title_english
      sub_title_spanish
      sub_title_mandarin
      position
      archive
    }
  }
}
    `;

/**
 * __useGetModuleQuery__
 *
 * To run a query within a React component, call `useGetModuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModuleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetModuleQuery(baseOptions: Apollo.QueryHookOptions<GetModuleQuery, GetModuleQueryVariables> & ({ variables: GetModuleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetModuleQuery, GetModuleQueryVariables>(GetModuleDocument, options);
      }
export function useGetModuleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetModuleQuery, GetModuleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetModuleQuery, GetModuleQueryVariables>(GetModuleDocument, options);
        }
// @ts-ignore
export function useGetModuleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetModuleQuery, GetModuleQueryVariables>): Apollo.UseSuspenseQueryResult<GetModuleQuery, GetModuleQueryVariables>;
export function useGetModuleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetModuleQuery, GetModuleQueryVariables>): Apollo.UseSuspenseQueryResult<GetModuleQuery | undefined, GetModuleQueryVariables>;
export function useGetModuleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetModuleQuery, GetModuleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetModuleQuery, GetModuleQueryVariables>(GetModuleDocument, options);
        }
export type GetModuleQueryHookResult = ReturnType<typeof useGetModuleQuery>;
export type GetModuleLazyQueryHookResult = ReturnType<typeof useGetModuleLazyQuery>;
export type GetModuleSuspenseQueryHookResult = ReturnType<typeof useGetModuleSuspenseQuery>;
export type GetModuleQueryResult = Apollo.QueryResult<GetModuleQuery, GetModuleQueryVariables>;
export const GetModulesDocument = gql`
    query getModules {
  modules {
    documentId
    name_english
    name_french
    name_spanish
    name_german
    name_mandarin
    description_english
    description_french
    description_spanish
    description_german
    description_mandarin
    sections {
      documentId
      title_french
      title_german
      title_english
      title_spanish
      title_mandarin
      sub_title_french
      sub_title_german
      sub_title_english
      sub_title_spanish
      sub_title_mandarin
      archive
    }
  }
}
    `;

/**
 * __useGetModulesQuery__
 *
 * To run a query within a React component, call `useGetModulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModulesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetModulesQuery(baseOptions?: Apollo.QueryHookOptions<GetModulesQuery, GetModulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetModulesQuery, GetModulesQueryVariables>(GetModulesDocument, options);
      }
export function useGetModulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetModulesQuery, GetModulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetModulesQuery, GetModulesQueryVariables>(GetModulesDocument, options);
        }
// @ts-ignore
export function useGetModulesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetModulesQuery, GetModulesQueryVariables>): Apollo.UseSuspenseQueryResult<GetModulesQuery, GetModulesQueryVariables>;
export function useGetModulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetModulesQuery, GetModulesQueryVariables>): Apollo.UseSuspenseQueryResult<GetModulesQuery | undefined, GetModulesQueryVariables>;
export function useGetModulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetModulesQuery, GetModulesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetModulesQuery, GetModulesQueryVariables>(GetModulesDocument, options);
        }
export type GetModulesQueryHookResult = ReturnType<typeof useGetModulesQuery>;
export type GetModulesLazyQueryHookResult = ReturnType<typeof useGetModulesLazyQuery>;
export type GetModulesSuspenseQueryHookResult = ReturnType<typeof useGetModulesSuspenseQuery>;
export type GetModulesQueryResult = Apollo.QueryResult<GetModulesQuery, GetModulesQueryVariables>;
export const GetMyBookingsDocument = gql`
    query getMyBookings($filters: BookingFiltersInput, $sort: [String], $pagination: PaginationArg) {
  bookings(filters: $filters, sort: $sort, pagination: $pagination) {
    documentId
    title
    description
    duration
    date
    confirmed
    event_id
    cancelled
    organiser
    location
    is_updated
    end
  }
}
    `;

/**
 * __useGetMyBookingsQuery__
 *
 * To run a query within a React component, call `useGetMyBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyBookingsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetMyBookingsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyBookingsQuery, GetMyBookingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyBookingsQuery, GetMyBookingsQueryVariables>(GetMyBookingsDocument, options);
      }
export function useGetMyBookingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyBookingsQuery, GetMyBookingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyBookingsQuery, GetMyBookingsQueryVariables>(GetMyBookingsDocument, options);
        }
// @ts-ignore
export function useGetMyBookingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyBookingsQuery, GetMyBookingsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyBookingsQuery, GetMyBookingsQueryVariables>;
export function useGetMyBookingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyBookingsQuery, GetMyBookingsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyBookingsQuery | undefined, GetMyBookingsQueryVariables>;
export function useGetMyBookingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyBookingsQuery, GetMyBookingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyBookingsQuery, GetMyBookingsQueryVariables>(GetMyBookingsDocument, options);
        }
export type GetMyBookingsQueryHookResult = ReturnType<typeof useGetMyBookingsQuery>;
export type GetMyBookingsLazyQueryHookResult = ReturnType<typeof useGetMyBookingsLazyQuery>;
export type GetMyBookingsSuspenseQueryHookResult = ReturnType<typeof useGetMyBookingsSuspenseQuery>;
export type GetMyBookingsQueryResult = Apollo.QueryResult<GetMyBookingsQuery, GetMyBookingsQueryVariables>;
export const GetMyCoachSessionsDocument = gql`
    query getMyCoachSessions($filters: CoachSessionFiltersInput, $sort: [String], $pagination: PaginationArg) {
  coachSessions(filters: $filters, sort: $sort, pagination: $pagination) {
    documentId
    title
    status
    user {
      documentId
    }
    programme_submission {
      documentId
    }
    sub_module_submission {
      documentId
    }
    appointment {
      documentId
      appointment_url
      appointment_start_date
      appointment_end_date
      status
    }
  }
}
    `;

/**
 * __useGetMyCoachSessionsQuery__
 *
 * To run a query within a React component, call `useGetMyCoachSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyCoachSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyCoachSessionsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetMyCoachSessionsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyCoachSessionsQuery, GetMyCoachSessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyCoachSessionsQuery, GetMyCoachSessionsQueryVariables>(GetMyCoachSessionsDocument, options);
      }
export function useGetMyCoachSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyCoachSessionsQuery, GetMyCoachSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyCoachSessionsQuery, GetMyCoachSessionsQueryVariables>(GetMyCoachSessionsDocument, options);
        }
// @ts-ignore
export function useGetMyCoachSessionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyCoachSessionsQuery, GetMyCoachSessionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyCoachSessionsQuery, GetMyCoachSessionsQueryVariables>;
export function useGetMyCoachSessionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyCoachSessionsQuery, GetMyCoachSessionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyCoachSessionsQuery | undefined, GetMyCoachSessionsQueryVariables>;
export function useGetMyCoachSessionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyCoachSessionsQuery, GetMyCoachSessionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyCoachSessionsQuery, GetMyCoachSessionsQueryVariables>(GetMyCoachSessionsDocument, options);
        }
export type GetMyCoachSessionsQueryHookResult = ReturnType<typeof useGetMyCoachSessionsQuery>;
export type GetMyCoachSessionsLazyQueryHookResult = ReturnType<typeof useGetMyCoachSessionsLazyQuery>;
export type GetMyCoachSessionsSuspenseQueryHookResult = ReturnType<typeof useGetMyCoachSessionsSuspenseQuery>;
export type GetMyCoachSessionsQueryResult = Apollo.QueryResult<GetMyCoachSessionsQuery, GetMyCoachSessionsQueryVariables>;
export const GetMyNotificationsDocument = gql`
    query getMyNotifications($filters: NotificationFiltersInput, $sort: [String], $pagination: PaginationArg) {
  notifications(filters: $filters, sort: $sort, pagination: $pagination) {
    documentId
    createdAt
    updatedAt
    title
    time_stamp
    path
    read
    users {
      documentId
    }
  }
}
    `;

/**
 * __useGetMyNotificationsQuery__
 *
 * To run a query within a React component, call `useGetMyNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyNotificationsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetMyNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyNotificationsQuery, GetMyNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyNotificationsQuery, GetMyNotificationsQueryVariables>(GetMyNotificationsDocument, options);
      }
export function useGetMyNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyNotificationsQuery, GetMyNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyNotificationsQuery, GetMyNotificationsQueryVariables>(GetMyNotificationsDocument, options);
        }
// @ts-ignore
export function useGetMyNotificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyNotificationsQuery, GetMyNotificationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyNotificationsQuery, GetMyNotificationsQueryVariables>;
export function useGetMyNotificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyNotificationsQuery, GetMyNotificationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyNotificationsQuery | undefined, GetMyNotificationsQueryVariables>;
export function useGetMyNotificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyNotificationsQuery, GetMyNotificationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyNotificationsQuery, GetMyNotificationsQueryVariables>(GetMyNotificationsDocument, options);
        }
export type GetMyNotificationsQueryHookResult = ReturnType<typeof useGetMyNotificationsQuery>;
export type GetMyNotificationsLazyQueryHookResult = ReturnType<typeof useGetMyNotificationsLazyQuery>;
export type GetMyNotificationsSuspenseQueryHookResult = ReturnType<typeof useGetMyNotificationsSuspenseQuery>;
export type GetMyNotificationsQueryResult = Apollo.QueryResult<GetMyNotificationsQuery, GetMyNotificationsQueryVariables>;
export const GetMySubModuleReportDocument = gql`
    query getMySubModuleReport($sort: [String]) {
  reports(sort: $sort) {
    documentId
    name
    type
    report {
      documentId
      url
    }
    section_or_module_id
    sub_module_submission {
      documentId
      section {
        progress
        section {
          documentId
          title_english
        }
      }
      sub_module {
        documentId
        programme_type {
          documentId
          title
          programmes {
            documentId
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetMySubModuleReportQuery__
 *
 * To run a query within a React component, call `useGetMySubModuleReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMySubModuleReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMySubModuleReportQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetMySubModuleReportQuery(baseOptions?: Apollo.QueryHookOptions<GetMySubModuleReportQuery, GetMySubModuleReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMySubModuleReportQuery, GetMySubModuleReportQueryVariables>(GetMySubModuleReportDocument, options);
      }
export function useGetMySubModuleReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMySubModuleReportQuery, GetMySubModuleReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMySubModuleReportQuery, GetMySubModuleReportQueryVariables>(GetMySubModuleReportDocument, options);
        }
// @ts-ignore
export function useGetMySubModuleReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMySubModuleReportQuery, GetMySubModuleReportQueryVariables>): Apollo.UseSuspenseQueryResult<GetMySubModuleReportQuery, GetMySubModuleReportQueryVariables>;
export function useGetMySubModuleReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMySubModuleReportQuery, GetMySubModuleReportQueryVariables>): Apollo.UseSuspenseQueryResult<GetMySubModuleReportQuery | undefined, GetMySubModuleReportQueryVariables>;
export function useGetMySubModuleReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMySubModuleReportQuery, GetMySubModuleReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMySubModuleReportQuery, GetMySubModuleReportQueryVariables>(GetMySubModuleReportDocument, options);
        }
export type GetMySubModuleReportQueryHookResult = ReturnType<typeof useGetMySubModuleReportQuery>;
export type GetMySubModuleReportLazyQueryHookResult = ReturnType<typeof useGetMySubModuleReportLazyQuery>;
export type GetMySubModuleReportSuspenseQueryHookResult = ReturnType<typeof useGetMySubModuleReportSuspenseQuery>;
export type GetMySubModuleReportQueryResult = Apollo.QueryResult<GetMySubModuleReportQuery, GetMySubModuleReportQueryVariables>;
export const GetMySubModuleSubmissionsReportsDocument = gql`
    query getMySubModuleSubmissionsReports {
  getMySubModuleSubmissionsReports {
    id
    subModule {
      id
      name_french
      name_german
      name_english
      name_spanish
      name_mandarin
      description_french
      description_german
      description_english
      description_spanish
      description_mandarin
      cover {
        documentId
        url
      }
      sections {
        documentId
        title_french
        title_german
        title_english
        title_spanish
        title_mandarin
        sub_title_french
        sub_title_german
        sub_title_english
        sub_title_spanish
        sub_title_mandarin
        cover {
          documentId
          url
        }
        position
      }
      position
      programme_type {
        documentId
        title
        description
        position
        cover {
          documentId
          url
        }
        is_coaching
        is_sub_module
        notes
        show_article
        show_session
        show_participants
        competency_survey
        feedForward_survey
        deadline
        articles {
          documentId
          createdAt
          updatedAt
          title_english
          title_french
          title_german
          title_spanish
          title_mandarin
          content_english
          content_french
          content_german
          content_spanish
          content_mandarin
          image {
            documentId
            url
          }
          date_published
          read_time
          link
        }
        modal {
          documentId
          title
          subtitle
          message
          image {
            documentId
            url
            name
          }
        }
        events {
          documentId
          name
          link
        }
      }
    }
    reports {
      id
      name
      type
      report {
        documentId
        url
      }
      section_or_module_id
    }
  }
}
    `;

/**
 * __useGetMySubModuleSubmissionsReportsQuery__
 *
 * To run a query within a React component, call `useGetMySubModuleSubmissionsReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMySubModuleSubmissionsReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMySubModuleSubmissionsReportsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMySubModuleSubmissionsReportsQuery(baseOptions?: Apollo.QueryHookOptions<GetMySubModuleSubmissionsReportsQuery, GetMySubModuleSubmissionsReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMySubModuleSubmissionsReportsQuery, GetMySubModuleSubmissionsReportsQueryVariables>(GetMySubModuleSubmissionsReportsDocument, options);
      }
export function useGetMySubModuleSubmissionsReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMySubModuleSubmissionsReportsQuery, GetMySubModuleSubmissionsReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMySubModuleSubmissionsReportsQuery, GetMySubModuleSubmissionsReportsQueryVariables>(GetMySubModuleSubmissionsReportsDocument, options);
        }
// @ts-ignore
export function useGetMySubModuleSubmissionsReportsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMySubModuleSubmissionsReportsQuery, GetMySubModuleSubmissionsReportsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMySubModuleSubmissionsReportsQuery, GetMySubModuleSubmissionsReportsQueryVariables>;
export function useGetMySubModuleSubmissionsReportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMySubModuleSubmissionsReportsQuery, GetMySubModuleSubmissionsReportsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMySubModuleSubmissionsReportsQuery | undefined, GetMySubModuleSubmissionsReportsQueryVariables>;
export function useGetMySubModuleSubmissionsReportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMySubModuleSubmissionsReportsQuery, GetMySubModuleSubmissionsReportsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMySubModuleSubmissionsReportsQuery, GetMySubModuleSubmissionsReportsQueryVariables>(GetMySubModuleSubmissionsReportsDocument, options);
        }
export type GetMySubModuleSubmissionsReportsQueryHookResult = ReturnType<typeof useGetMySubModuleSubmissionsReportsQuery>;
export type GetMySubModuleSubmissionsReportsLazyQueryHookResult = ReturnType<typeof useGetMySubModuleSubmissionsReportsLazyQuery>;
export type GetMySubModuleSubmissionsReportsSuspenseQueryHookResult = ReturnType<typeof useGetMySubModuleSubmissionsReportsSuspenseQuery>;
export type GetMySubModuleSubmissionsReportsQueryResult = Apollo.QueryResult<GetMySubModuleSubmissionsReportsQuery, GetMySubModuleSubmissionsReportsQueryVariables>;
export const GetMySubModuleNotesDocument = gql`
    query getMySubModuleNotes($sort: [String], $filters: NoteFiltersInput) {
  notes(sort: $sort, filters: $filters) {
    documentId
    name
    note
    document {
      documentId
      url
    }
    programme {
      documentId
      name
    }
    notes_id {
      saboteurProofValue {
        documentId
        url
        name
      }
    }
    sub_module_submission {
      documentId
      sub_module {
        documentId
        name_english
      }
    }
    section_or_submission_id
    createdAt
  }
}
    `;

/**
 * __useGetMySubModuleNotesQuery__
 *
 * To run a query within a React component, call `useGetMySubModuleNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMySubModuleNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMySubModuleNotesQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetMySubModuleNotesQuery(baseOptions?: Apollo.QueryHookOptions<GetMySubModuleNotesQuery, GetMySubModuleNotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMySubModuleNotesQuery, GetMySubModuleNotesQueryVariables>(GetMySubModuleNotesDocument, options);
      }
export function useGetMySubModuleNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMySubModuleNotesQuery, GetMySubModuleNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMySubModuleNotesQuery, GetMySubModuleNotesQueryVariables>(GetMySubModuleNotesDocument, options);
        }
// @ts-ignore
export function useGetMySubModuleNotesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMySubModuleNotesQuery, GetMySubModuleNotesQueryVariables>): Apollo.UseSuspenseQueryResult<GetMySubModuleNotesQuery, GetMySubModuleNotesQueryVariables>;
export function useGetMySubModuleNotesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMySubModuleNotesQuery, GetMySubModuleNotesQueryVariables>): Apollo.UseSuspenseQueryResult<GetMySubModuleNotesQuery | undefined, GetMySubModuleNotesQueryVariables>;
export function useGetMySubModuleNotesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMySubModuleNotesQuery, GetMySubModuleNotesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMySubModuleNotesQuery, GetMySubModuleNotesQueryVariables>(GetMySubModuleNotesDocument, options);
        }
export type GetMySubModuleNotesQueryHookResult = ReturnType<typeof useGetMySubModuleNotesQuery>;
export type GetMySubModuleNotesLazyQueryHookResult = ReturnType<typeof useGetMySubModuleNotesLazyQuery>;
export type GetMySubModuleNotesSuspenseQueryHookResult = ReturnType<typeof useGetMySubModuleNotesSuspenseQuery>;
export type GetMySubModuleNotesQueryResult = Apollo.QueryResult<GetMySubModuleNotesQuery, GetMySubModuleNotesQueryVariables>;
export const GetMyUploadedReportDocument = gql`
    query getMyUploadedReport($sort: [String]) {
  uploadedReports(sort: $sort) {
    documentId
    name
    type
    report {
      documentId
      url
      createdAt
    }
    section_or_module_id
  }
}
    `;

/**
 * __useGetMyUploadedReportQuery__
 *
 * To run a query within a React component, call `useGetMyUploadedReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyUploadedReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyUploadedReportQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetMyUploadedReportQuery(baseOptions?: Apollo.QueryHookOptions<GetMyUploadedReportQuery, GetMyUploadedReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyUploadedReportQuery, GetMyUploadedReportQueryVariables>(GetMyUploadedReportDocument, options);
      }
export function useGetMyUploadedReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyUploadedReportQuery, GetMyUploadedReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyUploadedReportQuery, GetMyUploadedReportQueryVariables>(GetMyUploadedReportDocument, options);
        }
// @ts-ignore
export function useGetMyUploadedReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyUploadedReportQuery, GetMyUploadedReportQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyUploadedReportQuery, GetMyUploadedReportQueryVariables>;
export function useGetMyUploadedReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyUploadedReportQuery, GetMyUploadedReportQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyUploadedReportQuery | undefined, GetMyUploadedReportQueryVariables>;
export function useGetMyUploadedReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyUploadedReportQuery, GetMyUploadedReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyUploadedReportQuery, GetMyUploadedReportQueryVariables>(GetMyUploadedReportDocument, options);
        }
export type GetMyUploadedReportQueryHookResult = ReturnType<typeof useGetMyUploadedReportQuery>;
export type GetMyUploadedReportLazyQueryHookResult = ReturnType<typeof useGetMyUploadedReportLazyQuery>;
export type GetMyUploadedReportSuspenseQueryHookResult = ReturnType<typeof useGetMyUploadedReportSuspenseQuery>;
export type GetMyUploadedReportQueryResult = Apollo.QueryResult<GetMyUploadedReportQuery, GetMyUploadedReportQueryVariables>;
export const GetMyWorkDocument = gql`
    query getMyWork {
  getMySubmissions {
    id
    views
    progress
    status
    time_spent
    language {
      documentId
      name
    }
    module {
      documentId
      name_french
      name_german
      name_english
      name_spanish
      name_mandarin
      description_french
      description_german
      description_english
      description_spanish
      description_mandarin
      sections {
        documentId
        title_english
        title_french
        title_german
        title_spanish
        title_mandarin
        sub_title_english
        sub_title_french
        sub_title_german
        sub_title_spanish
        sub_title_mandarin
      }
    }
    section {
      id
      answers {
        id
        questionId
        answer
        nestedAnswers {
          answer
          questionTitle
        }
        isCorrect
        feedback
        outcome
      }
      section {
        documentId
        createdAt
        updatedAt
        title_english
        title_french
        title_german
        title_spanish
        title_mandarin
        sub_title_english
        sub_title_french
        sub_title_german
        sub_title_spanish
        sub_title_mandarin
      }
    }
  }
}
    `;

/**
 * __useGetMyWorkQuery__
 *
 * To run a query within a React component, call `useGetMyWorkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyWorkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyWorkQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyWorkQuery(baseOptions?: Apollo.QueryHookOptions<GetMyWorkQuery, GetMyWorkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyWorkQuery, GetMyWorkQueryVariables>(GetMyWorkDocument, options);
      }
export function useGetMyWorkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyWorkQuery, GetMyWorkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyWorkQuery, GetMyWorkQueryVariables>(GetMyWorkDocument, options);
        }
// @ts-ignore
export function useGetMyWorkSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyWorkQuery, GetMyWorkQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyWorkQuery, GetMyWorkQueryVariables>;
export function useGetMyWorkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyWorkQuery, GetMyWorkQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyWorkQuery | undefined, GetMyWorkQueryVariables>;
export function useGetMyWorkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyWorkQuery, GetMyWorkQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyWorkQuery, GetMyWorkQueryVariables>(GetMyWorkDocument, options);
        }
export type GetMyWorkQueryHookResult = ReturnType<typeof useGetMyWorkQuery>;
export type GetMyWorkLazyQueryHookResult = ReturnType<typeof useGetMyWorkLazyQuery>;
export type GetMyWorkSuspenseQueryHookResult = ReturnType<typeof useGetMyWorkSuspenseQuery>;
export type GetMyWorkQueryResult = Apollo.QueryResult<GetMyWorkQuery, GetMyWorkQueryVariables>;
export const GetSubModuleSubmissionDocument = gql`
    query getSubModuleSubmission($id: ID!) {
  subModuleSubmission(documentId: $id) {
    documentId
    view
    progress
    status
    time_spent
    feedfoward_url {
      documentId
    }
    competency_url {
      documentId
    }
    competency_participants {
      name
      email
    }
    participants {
      documentId
      name
      email
      type
    }
    submission_participants {
      id
      name
      email
    }
    language {
      documentId
      name
    }
    section {
      id
      progress
      section {
        documentId
      }
      answers {
        id
        questionId
        answer
        nestedAnswers {
          answer
          questionTitle
        }
        isCorrect
        feedback
        outcome
        questionType
        questionTitle
      }
      stakeholderChart {
        documentId
        url
      }
      stakeholderItems {
        id
        valueX
        valueY
        name
        color
      }
      gravitasScales {
        id
        labelOne
        labelTwo
        labelThree
        question
        answerOne
        answerTwo
        answerThree
      }
      gravitasSliderAnswers {
        negativeQuestion
        positiveQuestion
        colorAndRating {
          color
          rate
        }
      }
      gravitasGap {
        id
        gap
        commitment
      }
      xYGraphChart {
        documentId
        url
      }
      saboteurImage {
        documentId
        url
      }
      xYGraphItems {
        id
        valueX
        valueY
        color
      }
      characteristics {
        id
        answer
        type
      }
      sliderAnswers
      gapsAnswers {
        id
        gap
        commitment
      }
      competencyAnswers {
        id
        question
        rating
        steps
        response
      }
      uploadDocuments {
        saboteurProofValue {
          documentId
        }
      }
    }
    sub_module {
      documentId
      name_french
      name_german
      name_english
      name_spanish
      name_mandarin
      description_french
      description_german
      description_english
      description_spanish
      description_mandarin
      cover {
        documentId
        url
      }
      sections {
        documentId
        title_french
        title_german
        title_english
        title_spanish
        title_mandarin
        sub_title_french
        sub_title_german
        sub_title_english
        sub_title_spanish
        sub_title_mandarin
        cover {
          documentId
          url
        }
        position
        archive
      }
      position
      programme_type {
        documentId
        title
        description
        position
        cover {
          documentId
          url
        }
        is_coaching
        is_sub_module
        notes
        show_article
        show_session
        show_participants
        competency_survey
        feedForward_survey
        deadline
        articles {
          documentId
          createdAt
          updatedAt
          title_english
          title_french
          title_german
          title_spanish
          title_mandarin
          content_english
          content_french
          content_german
          content_spanish
          content_mandarin
          image {
            documentId
            url
          }
          date_published
          read_time
          link
        }
        modal {
          documentId
          title
          subtitle
          message
          image {
            documentId
            url
            name
          }
        }
        events {
          documentId
          name
          link
        }
      }
    }
    reports {
      documentId
      name
      type
      report {
        documentId
        url
      }
      section_or_module_id
    }
  }
}
    `;

/**
 * __useGetSubModuleSubmissionQuery__
 *
 * To run a query within a React component, call `useGetSubModuleSubmissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubModuleSubmissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubModuleSubmissionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSubModuleSubmissionQuery(baseOptions: Apollo.QueryHookOptions<GetSubModuleSubmissionQuery, GetSubModuleSubmissionQueryVariables> & ({ variables: GetSubModuleSubmissionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubModuleSubmissionQuery, GetSubModuleSubmissionQueryVariables>(GetSubModuleSubmissionDocument, options);
      }
export function useGetSubModuleSubmissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubModuleSubmissionQuery, GetSubModuleSubmissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubModuleSubmissionQuery, GetSubModuleSubmissionQueryVariables>(GetSubModuleSubmissionDocument, options);
        }
// @ts-ignore
export function useGetSubModuleSubmissionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSubModuleSubmissionQuery, GetSubModuleSubmissionQueryVariables>): Apollo.UseSuspenseQueryResult<GetSubModuleSubmissionQuery, GetSubModuleSubmissionQueryVariables>;
export function useGetSubModuleSubmissionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubModuleSubmissionQuery, GetSubModuleSubmissionQueryVariables>): Apollo.UseSuspenseQueryResult<GetSubModuleSubmissionQuery | undefined, GetSubModuleSubmissionQueryVariables>;
export function useGetSubModuleSubmissionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubModuleSubmissionQuery, GetSubModuleSubmissionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSubModuleSubmissionQuery, GetSubModuleSubmissionQueryVariables>(GetSubModuleSubmissionDocument, options);
        }
export type GetSubModuleSubmissionQueryHookResult = ReturnType<typeof useGetSubModuleSubmissionQuery>;
export type GetSubModuleSubmissionLazyQueryHookResult = ReturnType<typeof useGetSubModuleSubmissionLazyQuery>;
export type GetSubModuleSubmissionSuspenseQueryHookResult = ReturnType<typeof useGetSubModuleSubmissionSuspenseQuery>;
export type GetSubModuleSubmissionQueryResult = Apollo.QueryResult<GetSubModuleSubmissionQuery, GetSubModuleSubmissionQueryVariables>;
export const GetNewTypeformFeedResponsesDocument = gql`
    query getNewTypeformFeedResponses {
  getNewTypeformFeedResponses {
    success
  }
}
    `;

/**
 * __useGetNewTypeformFeedResponsesQuery__
 *
 * To run a query within a React component, call `useGetNewTypeformFeedResponsesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewTypeformFeedResponsesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewTypeformFeedResponsesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNewTypeformFeedResponsesQuery(baseOptions?: Apollo.QueryHookOptions<GetNewTypeformFeedResponsesQuery, GetNewTypeformFeedResponsesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNewTypeformFeedResponsesQuery, GetNewTypeformFeedResponsesQueryVariables>(GetNewTypeformFeedResponsesDocument, options);
      }
export function useGetNewTypeformFeedResponsesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNewTypeformFeedResponsesQuery, GetNewTypeformFeedResponsesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNewTypeformFeedResponsesQuery, GetNewTypeformFeedResponsesQueryVariables>(GetNewTypeformFeedResponsesDocument, options);
        }
// @ts-ignore
export function useGetNewTypeformFeedResponsesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNewTypeformFeedResponsesQuery, GetNewTypeformFeedResponsesQueryVariables>): Apollo.UseSuspenseQueryResult<GetNewTypeformFeedResponsesQuery, GetNewTypeformFeedResponsesQueryVariables>;
export function useGetNewTypeformFeedResponsesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNewTypeformFeedResponsesQuery, GetNewTypeformFeedResponsesQueryVariables>): Apollo.UseSuspenseQueryResult<GetNewTypeformFeedResponsesQuery | undefined, GetNewTypeformFeedResponsesQueryVariables>;
export function useGetNewTypeformFeedResponsesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNewTypeformFeedResponsesQuery, GetNewTypeformFeedResponsesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNewTypeformFeedResponsesQuery, GetNewTypeformFeedResponsesQueryVariables>(GetNewTypeformFeedResponsesDocument, options);
        }
export type GetNewTypeformFeedResponsesQueryHookResult = ReturnType<typeof useGetNewTypeformFeedResponsesQuery>;
export type GetNewTypeformFeedResponsesLazyQueryHookResult = ReturnType<typeof useGetNewTypeformFeedResponsesLazyQuery>;
export type GetNewTypeformFeedResponsesSuspenseQueryHookResult = ReturnType<typeof useGetNewTypeformFeedResponsesSuspenseQuery>;
export type GetNewTypeformFeedResponsesQueryResult = Apollo.QueryResult<GetNewTypeformFeedResponsesQuery, GetNewTypeformFeedResponsesQueryVariables>;
export const GetNotificationsDocument = gql`
    query getNotifications {
  notifications {
    documentId
    createdAt
    updatedAt
    title
    time_stamp
    path
    read
    users {
      documentId
    }
  }
}
    `;

/**
 * __useGetNotificationsQuery__
 *
 * To run a query within a React component, call `useGetNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
      }
export function useGetNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
        }
// @ts-ignore
export function useGetNotificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetNotificationsQuery, GetNotificationsQueryVariables>;
export function useGetNotificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetNotificationsQuery | undefined, GetNotificationsQueryVariables>;
export function useGetNotificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
        }
export type GetNotificationsQueryHookResult = ReturnType<typeof useGetNotificationsQuery>;
export type GetNotificationsLazyQueryHookResult = ReturnType<typeof useGetNotificationsLazyQuery>;
export type GetNotificationsSuspenseQueryHookResult = ReturnType<typeof useGetNotificationsSuspenseQuery>;
export type GetNotificationsQueryResult = Apollo.QueryResult<GetNotificationsQuery, GetNotificationsQueryVariables>;
export const GetOrderedSubmissionsDocument = gql`
    query getOrderedSubmissions($programme: ID!) {
  getOrderedSubmissions(programme: $programme) {
    programmeSubmission {
      id
      progress
      programme {
        documentId
        name
        description
        logo {
          documentId
          url
        }
      }
      programme_type {
        documentId
        title
        is_sub_module
        sub_modules {
          documentId
          name_english
          name_french
          name_spanish
          name_mandarin
          name_german
          sections {
            documentId
            title_english
            title_french
            title_german
            title_spanish
            title_mandarin
            position
          }
          position
        }
        archive
        position
      }
    }
    subModuleSubmissions {
      id
      view
      progress
      sub_module {
        documentId
        name_french
        name_german
        name_english
        name_spanish
        name_mandarin
        sections {
          documentId
          title_french
          title_german
          title_english
          title_spanish
          title_mandarin
          position
        }
        position
      }
      section {
        id
        progress
        section {
          documentId
        }
      }
    }
  }
}
    `;

/**
 * __useGetOrderedSubmissionsQuery__
 *
 * To run a query within a React component, call `useGetOrderedSubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderedSubmissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderedSubmissionsQuery({
 *   variables: {
 *      programme: // value for 'programme'
 *   },
 * });
 */
export function useGetOrderedSubmissionsQuery(baseOptions: Apollo.QueryHookOptions<GetOrderedSubmissionsQuery, GetOrderedSubmissionsQueryVariables> & ({ variables: GetOrderedSubmissionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrderedSubmissionsQuery, GetOrderedSubmissionsQueryVariables>(GetOrderedSubmissionsDocument, options);
      }
export function useGetOrderedSubmissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderedSubmissionsQuery, GetOrderedSubmissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrderedSubmissionsQuery, GetOrderedSubmissionsQueryVariables>(GetOrderedSubmissionsDocument, options);
        }
// @ts-ignore
export function useGetOrderedSubmissionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrderedSubmissionsQuery, GetOrderedSubmissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrderedSubmissionsQuery, GetOrderedSubmissionsQueryVariables>;
export function useGetOrderedSubmissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrderedSubmissionsQuery, GetOrderedSubmissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrderedSubmissionsQuery | undefined, GetOrderedSubmissionsQueryVariables>;
export function useGetOrderedSubmissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrderedSubmissionsQuery, GetOrderedSubmissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrderedSubmissionsQuery, GetOrderedSubmissionsQueryVariables>(GetOrderedSubmissionsDocument, options);
        }
export type GetOrderedSubmissionsQueryHookResult = ReturnType<typeof useGetOrderedSubmissionsQuery>;
export type GetOrderedSubmissionsLazyQueryHookResult = ReturnType<typeof useGetOrderedSubmissionsLazyQuery>;
export type GetOrderedSubmissionsSuspenseQueryHookResult = ReturnType<typeof useGetOrderedSubmissionsSuspenseQuery>;
export type GetOrderedSubmissionsQueryResult = Apollo.QueryResult<GetOrderedSubmissionsQuery, GetOrderedSubmissionsQueryVariables>;
export const GetProgammeReportsGroupedDocument = gql`
    query getProgammeReportsGrouped {
  getProgammeReportsGrouped {
    companyName
    programmeType {
      programmeType
      programmeName
      sections {
        programmeName
        programmeType
        name
        report {
          id
          url
        }
      }
    }
  }
}
    `;

/**
 * __useGetProgammeReportsGroupedQuery__
 *
 * To run a query within a React component, call `useGetProgammeReportsGroupedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgammeReportsGroupedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgammeReportsGroupedQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProgammeReportsGroupedQuery(baseOptions?: Apollo.QueryHookOptions<GetProgammeReportsGroupedQuery, GetProgammeReportsGroupedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProgammeReportsGroupedQuery, GetProgammeReportsGroupedQueryVariables>(GetProgammeReportsGroupedDocument, options);
      }
export function useGetProgammeReportsGroupedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProgammeReportsGroupedQuery, GetProgammeReportsGroupedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProgammeReportsGroupedQuery, GetProgammeReportsGroupedQueryVariables>(GetProgammeReportsGroupedDocument, options);
        }
// @ts-ignore
export function useGetProgammeReportsGroupedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProgammeReportsGroupedQuery, GetProgammeReportsGroupedQueryVariables>): Apollo.UseSuspenseQueryResult<GetProgammeReportsGroupedQuery, GetProgammeReportsGroupedQueryVariables>;
export function useGetProgammeReportsGroupedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProgammeReportsGroupedQuery, GetProgammeReportsGroupedQueryVariables>): Apollo.UseSuspenseQueryResult<GetProgammeReportsGroupedQuery | undefined, GetProgammeReportsGroupedQueryVariables>;
export function useGetProgammeReportsGroupedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProgammeReportsGroupedQuery, GetProgammeReportsGroupedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProgammeReportsGroupedQuery, GetProgammeReportsGroupedQueryVariables>(GetProgammeReportsGroupedDocument, options);
        }
export type GetProgammeReportsGroupedQueryHookResult = ReturnType<typeof useGetProgammeReportsGroupedQuery>;
export type GetProgammeReportsGroupedLazyQueryHookResult = ReturnType<typeof useGetProgammeReportsGroupedLazyQuery>;
export type GetProgammeReportsGroupedSuspenseQueryHookResult = ReturnType<typeof useGetProgammeReportsGroupedSuspenseQuery>;
export type GetProgammeReportsGroupedQueryResult = Apollo.QueryResult<GetProgammeReportsGroupedQuery, GetProgammeReportsGroupedQueryVariables>;
export const GetProgrammeDocument = gql`
    query getProgramme($id: ID!) {
  programme(documentId: $id) {
    documentId
    name
    description
    logo {
      documentId
      url
    }
    what_to_expect
    completion
  }
}
    `;

/**
 * __useGetProgrammeQuery__
 *
 * To run a query within a React component, call `useGetProgrammeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgrammeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgrammeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProgrammeQuery(baseOptions: Apollo.QueryHookOptions<GetProgrammeQuery, GetProgrammeQueryVariables> & ({ variables: GetProgrammeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProgrammeQuery, GetProgrammeQueryVariables>(GetProgrammeDocument, options);
      }
export function useGetProgrammeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProgrammeQuery, GetProgrammeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProgrammeQuery, GetProgrammeQueryVariables>(GetProgrammeDocument, options);
        }
// @ts-ignore
export function useGetProgrammeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProgrammeQuery, GetProgrammeQueryVariables>): Apollo.UseSuspenseQueryResult<GetProgrammeQuery, GetProgrammeQueryVariables>;
export function useGetProgrammeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProgrammeQuery, GetProgrammeQueryVariables>): Apollo.UseSuspenseQueryResult<GetProgrammeQuery | undefined, GetProgrammeQueryVariables>;
export function useGetProgrammeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProgrammeQuery, GetProgrammeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProgrammeQuery, GetProgrammeQueryVariables>(GetProgrammeDocument, options);
        }
export type GetProgrammeQueryHookResult = ReturnType<typeof useGetProgrammeQuery>;
export type GetProgrammeLazyQueryHookResult = ReturnType<typeof useGetProgrammeLazyQuery>;
export type GetProgrammeSuspenseQueryHookResult = ReturnType<typeof useGetProgrammeSuspenseQuery>;
export type GetProgrammeQueryResult = Apollo.QueryResult<GetProgrammeQuery, GetProgrammeQueryVariables>;
export const GetProgrammeProgrammeSubmissionsDocument = gql`
    query getProgrammeProgrammeSubmissions {
  programmeSubmissions {
    documentId
    progress
    programme {
      documentId
      name
      description
      logo {
        documentId
        url
      }
    }
    programme_type {
      documentId
      title
      is_sub_module
      sub_modules {
        documentId
        name_english
        name_french
        name_spanish
        name_mandarin
        name_german
        sections {
          documentId
          title_english
          title_french
          title_german
          title_spanish
          title_mandarin
        }
        position
      }
      archive
      position
    }
  }
}
    `;

/**
 * __useGetProgrammeProgrammeSubmissionsQuery__
 *
 * To run a query within a React component, call `useGetProgrammeProgrammeSubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgrammeProgrammeSubmissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgrammeProgrammeSubmissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProgrammeProgrammeSubmissionsQuery(baseOptions?: Apollo.QueryHookOptions<GetProgrammeProgrammeSubmissionsQuery, GetProgrammeProgrammeSubmissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProgrammeProgrammeSubmissionsQuery, GetProgrammeProgrammeSubmissionsQueryVariables>(GetProgrammeProgrammeSubmissionsDocument, options);
      }
export function useGetProgrammeProgrammeSubmissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProgrammeProgrammeSubmissionsQuery, GetProgrammeProgrammeSubmissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProgrammeProgrammeSubmissionsQuery, GetProgrammeProgrammeSubmissionsQueryVariables>(GetProgrammeProgrammeSubmissionsDocument, options);
        }
// @ts-ignore
export function useGetProgrammeProgrammeSubmissionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProgrammeProgrammeSubmissionsQuery, GetProgrammeProgrammeSubmissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProgrammeProgrammeSubmissionsQuery, GetProgrammeProgrammeSubmissionsQueryVariables>;
export function useGetProgrammeProgrammeSubmissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProgrammeProgrammeSubmissionsQuery, GetProgrammeProgrammeSubmissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProgrammeProgrammeSubmissionsQuery | undefined, GetProgrammeProgrammeSubmissionsQueryVariables>;
export function useGetProgrammeProgrammeSubmissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProgrammeProgrammeSubmissionsQuery, GetProgrammeProgrammeSubmissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProgrammeProgrammeSubmissionsQuery, GetProgrammeProgrammeSubmissionsQueryVariables>(GetProgrammeProgrammeSubmissionsDocument, options);
        }
export type GetProgrammeProgrammeSubmissionsQueryHookResult = ReturnType<typeof useGetProgrammeProgrammeSubmissionsQuery>;
export type GetProgrammeProgrammeSubmissionsLazyQueryHookResult = ReturnType<typeof useGetProgrammeProgrammeSubmissionsLazyQuery>;
export type GetProgrammeProgrammeSubmissionsSuspenseQueryHookResult = ReturnType<typeof useGetProgrammeProgrammeSubmissionsSuspenseQuery>;
export type GetProgrammeProgrammeSubmissionsQueryResult = Apollo.QueryResult<GetProgrammeProgrammeSubmissionsQuery, GetProgrammeProgrammeSubmissionsQueryVariables>;
export const GetMyProgrammeSubmissionDocument = gql`
    query getMyProgrammeSubmission($id: ID!) {
  programmeSubmission(documentId: $id) {
    documentId
    status
    progress
    competency_url {
      documentId
      url
    }
    feedfoward_url {
      documentId
      url
    }
    programme_type {
      documentId
      title
      description
      show_participants
      cover {
        documentId
        url
      }
      is_coaching
      is_sub_module
      notes
      deadline
      programme_questions {
        __typename
        ... on ComponentQuestionTypesValuesNested {
          title
          question
          description
          questions {
            titleEnglish
            subTitleEnglish
            titleFrench
            subTitleFrench
            titleGerman
            subTitleGerman
            titleSpanish
            subTitleSpanish
            titleMandarin
            subTitleMandarin
          }
        }
        ... on ComponentQuestionTypesCompetency2 {
          titleEnglish
          titleFrench
          titleMandarin
          questionscompetency2 {
            title
            question
            maxiNumber
            miniNumber
            simpleQuestion
            miniLabel
            maxiLabel
            midiLabel
            textboxQuestion
          }
        }
      }
      articles {
        documentId
        createdAt
        updatedAt
        title_english
        title_french
        title_german
        title_spanish
        title_mandarin
        content_english
        content_french
        content_german
        content_spanish
        content_mandarin
        image {
          documentId
          url
        }
        date_published
        read_time
        link
      }
      events {
        documentId
        name
        link
        session_id
      }
      sub_modules {
        documentId
        name_english
        description_english
        cover {
          documentId
          url
        }
        programme_type {
          documentId
        }
      }
    }
    programme_responses {
      answers {
        id
        questionId
        answer
        nestedAnswers {
          answer
          questionTitle
        }
        isCorrect
        feedback
        outcome
        questionType
        questionTitle
      }
      stakeholderChart {
        documentId
        url
      }
      stakeholderItems {
        id
        valueX
        valueY
        name
        color
      }
      competencyAnswers {
        question
        rating
        response
        steps
        textboxQuestion
      }
      gravitasScales {
        id
        labelOne
        labelTwo
        labelThree
        question
        answerOne
        answerTwo
        answerThree
      }
      xYGraphChart {
        documentId
        url
      }
      saboteurImage {
        documentId
        url
      }
      xYGraphItems {
        id
        valueX
        valueY
        color
      }
    }
    participants {
      documentId
      name
      email
      type
    }
    submission_participants {
      id
      name
      email
    }
    my_notes {
      id
      title
      description
      document {
        documentId
        url
      }
    }
    selected
  }
}
    `;

/**
 * __useGetMyProgrammeSubmissionQuery__
 *
 * To run a query within a React component, call `useGetMyProgrammeSubmissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyProgrammeSubmissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyProgrammeSubmissionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMyProgrammeSubmissionQuery(baseOptions: Apollo.QueryHookOptions<GetMyProgrammeSubmissionQuery, GetMyProgrammeSubmissionQueryVariables> & ({ variables: GetMyProgrammeSubmissionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyProgrammeSubmissionQuery, GetMyProgrammeSubmissionQueryVariables>(GetMyProgrammeSubmissionDocument, options);
      }
export function useGetMyProgrammeSubmissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyProgrammeSubmissionQuery, GetMyProgrammeSubmissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyProgrammeSubmissionQuery, GetMyProgrammeSubmissionQueryVariables>(GetMyProgrammeSubmissionDocument, options);
        }
// @ts-ignore
export function useGetMyProgrammeSubmissionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyProgrammeSubmissionQuery, GetMyProgrammeSubmissionQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyProgrammeSubmissionQuery, GetMyProgrammeSubmissionQueryVariables>;
export function useGetMyProgrammeSubmissionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyProgrammeSubmissionQuery, GetMyProgrammeSubmissionQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyProgrammeSubmissionQuery | undefined, GetMyProgrammeSubmissionQueryVariables>;
export function useGetMyProgrammeSubmissionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyProgrammeSubmissionQuery, GetMyProgrammeSubmissionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyProgrammeSubmissionQuery, GetMyProgrammeSubmissionQueryVariables>(GetMyProgrammeSubmissionDocument, options);
        }
export type GetMyProgrammeSubmissionQueryHookResult = ReturnType<typeof useGetMyProgrammeSubmissionQuery>;
export type GetMyProgrammeSubmissionLazyQueryHookResult = ReturnType<typeof useGetMyProgrammeSubmissionLazyQuery>;
export type GetMyProgrammeSubmissionSuspenseQueryHookResult = ReturnType<typeof useGetMyProgrammeSubmissionSuspenseQuery>;
export type GetMyProgrammeSubmissionQueryResult = Apollo.QueryResult<GetMyProgrammeSubmissionQuery, GetMyProgrammeSubmissionQueryVariables>;
export const GetProgrammesDocument = gql`
    query getProgrammes {
  programmes {
    documentId
    name
    description
    logo {
      documentId
      url
    }
    programme_types {
      documentId
      title
      sub_modules {
        documentId
        sections {
          documentId
          title_english
        }
      }
    }
  }
}
    `;

/**
 * __useGetProgrammesQuery__
 *
 * To run a query within a React component, call `useGetProgrammesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgrammesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgrammesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProgrammesQuery(baseOptions?: Apollo.QueryHookOptions<GetProgrammesQuery, GetProgrammesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProgrammesQuery, GetProgrammesQueryVariables>(GetProgrammesDocument, options);
      }
export function useGetProgrammesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProgrammesQuery, GetProgrammesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProgrammesQuery, GetProgrammesQueryVariables>(GetProgrammesDocument, options);
        }
// @ts-ignore
export function useGetProgrammesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProgrammesQuery, GetProgrammesQueryVariables>): Apollo.UseSuspenseQueryResult<GetProgrammesQuery, GetProgrammesQueryVariables>;
export function useGetProgrammesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProgrammesQuery, GetProgrammesQueryVariables>): Apollo.UseSuspenseQueryResult<GetProgrammesQuery | undefined, GetProgrammesQueryVariables>;
export function useGetProgrammesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProgrammesQuery, GetProgrammesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProgrammesQuery, GetProgrammesQueryVariables>(GetProgrammesDocument, options);
        }
export type GetProgrammesQueryHookResult = ReturnType<typeof useGetProgrammesQuery>;
export type GetProgrammesLazyQueryHookResult = ReturnType<typeof useGetProgrammesLazyQuery>;
export type GetProgrammesSuspenseQueryHookResult = ReturnType<typeof useGetProgrammesSuspenseQuery>;
export type GetProgrammesQueryResult = Apollo.QueryResult<GetProgrammesQuery, GetProgrammesQueryVariables>;
export const GetRegionsDocument = gql`
    query getRegions {
  regions {
    documentId
    name_english
    name_french
    name_german
    name_spanish
    name_mandarin
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetRegionsQuery__
 *
 * To run a query within a React component, call `useGetRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRegionsQuery(baseOptions?: Apollo.QueryHookOptions<GetRegionsQuery, GetRegionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRegionsQuery, GetRegionsQueryVariables>(GetRegionsDocument, options);
      }
export function useGetRegionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegionsQuery, GetRegionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRegionsQuery, GetRegionsQueryVariables>(GetRegionsDocument, options);
        }
// @ts-ignore
export function useGetRegionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRegionsQuery, GetRegionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetRegionsQuery, GetRegionsQueryVariables>;
export function useGetRegionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRegionsQuery, GetRegionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetRegionsQuery | undefined, GetRegionsQueryVariables>;
export function useGetRegionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRegionsQuery, GetRegionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRegionsQuery, GetRegionsQueryVariables>(GetRegionsDocument, options);
        }
export type GetRegionsQueryHookResult = ReturnType<typeof useGetRegionsQuery>;
export type GetRegionsLazyQueryHookResult = ReturnType<typeof useGetRegionsLazyQuery>;
export type GetRegionsSuspenseQueryHookResult = ReturnType<typeof useGetRegionsSuspenseQuery>;
export type GetRegionsQueryResult = Apollo.QueryResult<GetRegionsQuery, GetRegionsQueryVariables>;
export const GetReportsGroupedDocument = gql`
    query getReportsGrouped {
  getReportsGrouped {
    companyName
    programmeType {
      programmeType
      programmeName
      sections {
        programmeName
        programmeType
        name
        report {
          id
          url
        }
      }
    }
  }
}
    `;

/**
 * __useGetReportsGroupedQuery__
 *
 * To run a query within a React component, call `useGetReportsGroupedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportsGroupedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportsGroupedQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetReportsGroupedQuery(baseOptions?: Apollo.QueryHookOptions<GetReportsGroupedQuery, GetReportsGroupedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportsGroupedQuery, GetReportsGroupedQueryVariables>(GetReportsGroupedDocument, options);
      }
export function useGetReportsGroupedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReportsGroupedQuery, GetReportsGroupedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportsGroupedQuery, GetReportsGroupedQueryVariables>(GetReportsGroupedDocument, options);
        }
// @ts-ignore
export function useGetReportsGroupedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetReportsGroupedQuery, GetReportsGroupedQueryVariables>): Apollo.UseSuspenseQueryResult<GetReportsGroupedQuery, GetReportsGroupedQueryVariables>;
export function useGetReportsGroupedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReportsGroupedQuery, GetReportsGroupedQueryVariables>): Apollo.UseSuspenseQueryResult<GetReportsGroupedQuery | undefined, GetReportsGroupedQueryVariables>;
export function useGetReportsGroupedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReportsGroupedQuery, GetReportsGroupedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReportsGroupedQuery, GetReportsGroupedQueryVariables>(GetReportsGroupedDocument, options);
        }
export type GetReportsGroupedQueryHookResult = ReturnType<typeof useGetReportsGroupedQuery>;
export type GetReportsGroupedLazyQueryHookResult = ReturnType<typeof useGetReportsGroupedLazyQuery>;
export type GetReportsGroupedSuspenseQueryHookResult = ReturnType<typeof useGetReportsGroupedSuspenseQuery>;
export type GetReportsGroupedQueryResult = Apollo.QueryResult<GetReportsGroupedQuery, GetReportsGroupedQueryVariables>;
export const GetSectionDocument = gql`
    query getSection($id: ID!) {
  section(documentId: $id) {
    documentId
    title_english
    sub_title_english
    get_started_text
    cover {
      __typename
      name
      url
    }
    questions {
      __typename
      ... on ComponentQuestionTypesValuesNested {
        id
        title
        question
        description
        questions {
          id
          titleEnglish
          subTitleEnglish
          titleFrench
          subTitleFrench
          titleGerman
          subTitleGerman
          titleSpanish
          subTitleSpanish
          titleMandarin
          subTitleMandarin
        }
      }
      ... on ComponentQuestionTypesValuesCharacters {
        id
        title
        question
        description
      }
      ... on ComponentQuestionTypesValuesBubble {
        id
        title
        question
        description
      }
      ... on ComponentQuestionTypesValuesSliders {
        id
        title
        question
        description
        sliderQuestions {
          id
          question
          color
        }
      }
      ... on ComponentQuestionTypesValuesGaps {
        id
        title
        question
        description
      }
      ... on ComponentQuestionTypesSimpleQuestion {
        id
        titleEnglish
        titleFrench
        titleGerman
        titleSpanish
        titleMandarin
        subTitleEnglish
        subTitleFrench
        subTitleGerman
        subTitleSpanish
        subTitleMandarin
      }
      ... on ComponentQuestionTypesXYGraph {
        id
        labelXEnglish
        labelYEnglish
        titleEnglish
        subTitleEnglish
        labelXFrench
        labelYFrench
        titleFrench
        subTitleFrench
        labelXGerman
        labelYGerman
        titleGerman
        subTitleGerman
        labelXSpanish
        labelYSpanish
        titleSpanish
        subTitleSpanish
        labelXMandarin
        labelYMandarin
        titleMandarin
        subTitleMandarin
      }
      ... on ComponentQuestionTypesMultipleChoice {
        id
        titleEnglish
        titleFrench
        titleGerman
        titleSpanish
        titleMandarin
        viewPrevious
        option {
          id
          optionEnglish
          optionFrench
          optionGerman
          optionSpanish
          optionMandarin
          isCorrect
        }
        numberOfAnswers
      }
      ... on ComponentQuestionTypesSaboteur {
        id
        titleEnglish
        subTitleEnglish
        titleFrench
        subTitleFrench
        titleGerman
        subTitleGerman
        titleSpanish
        subTitleSpanish
        titleMandarin
        subTitleMandarin
        saboteurQuestions {
          link
          skipProof
          labelEnglish
          labelFrench
          labelGerman
          labelSpanish
          labelMandarin
        }
        labelEnglish
        labelFrench
        labelGerman
        labelSpanish
      }
      ... on ComponentQuestionTypesNestedQuestions {
        id
        titleEnglish
        titleFrench
        titleGerman
        titleSpanish
        titleMandarin
        viewPrevious
        questions {
          id
          titleEnglish
          subTitleEnglish
          titleFrench
          subTitleFrench
          titleGerman
          subTitleGerman
          titleSpanish
          subTitleSpanish
          titleMandarin
          subTitleMandarin
          isNumeric
        }
      }
      ... on ComponentQuestionTypesGravitasScale {
        id
        titleEnglish
        subTitleEnglish
        questionOneEnglish
        questionTwoEnglish
        questionThreeEnglish
        titleOneEnglish
        titleTwoEnglish
        ratingInput {
          id
          labelOneEnglish
          labelTwoEnglish
        }
      }
      ... on ComponentQuestionTypesStakeholderMap {
        id
        titleEnglish
        subTitleEnglish
        titleFrench
        subTitleFrench
        titleSpanish
        subTitleSpanish
        titleGerman
        subTitleGerman
        titleMandarin
        subTitleMandarin
        questionX
        questionY
      }
      ... on ComponentQuestionTypesSaboteurVideos {
        id
        titleEnglish
        titleFrench
        titleGerman
        titleSpanish
        titleMandarin
        subTitleEnglish
        subTitleFrench
        subTitleGerman
        subTitleSpanish
        subTitleMandarin
        SaboteurVideo {
          id
          videoTitleEnglish
          videoTitleFrench
          videoTitleGerman
          videoTitleSpanish
          videoTitleMandarin
          video {
            documentId
            url
            previewUrl
          }
        }
      }
      ... on ComponentQuestionTypesFeedForward1 {
        id
        title
        question
        description
      }
      ... on ComponentQuestionTypesFeedForward2 {
        id
        title
        question
        description
      }
      ... on ComponentQuestionTypesSimpleReadOnly {
        id
        titleEnglish
        titleFrench
        titleGerman
        titleMandarin
        titleSpanish
        subTitleEnglish
        subTitleFrench
        subTitleGerman
        subTitleMandarin
        subTitleSpanish
        contentEnglish
        contentFrench
        contentGerman
        contentMandarin
        contentSpanish
      }
      ... on ComponentQuestionTypesCompetency2 {
        titleEnglish
        titleFrench
        titleMandarin
        questionscompetency2 {
          title
          question
          maxiNumber
          miniNumber
          simpleQuestion
          miniLabel
          maxiLabel
          midiLabel
          textboxQuestion
        }
      }
      ... on ComponentQuestionTypesUploadDocuments {
        id
        titleEnglish
        titleFrench
        titleMandarin
        titleSpanish
        titleGerman
        subTitleEnglish
        subTitleFrench
        subTitleGerman
        subTitleMandarin
        subTitleSpanish
      }
      ... on ComponentQuestionTypesGravitasGap {
        id
        title
        question
        description
        color1
        color2
        color3
      }
      ... on ComponentQuestionTypesGravitasSliders {
        titleEnglish
        titleFrench
        titleMandarin
        titleSpanish
        titleGerman
        subTitleEnglish
        subTitleFrench
        subTitleGerman
        positiveHeadingEnglish
        positiveHeadingFrench
        positiveHeadingSpanish
        positiveHeadingMandarin
        positiveHeadingGerman
        negativeHeadingEnglish
        negativeHeadingFrench
        negativeHeadingSpanish
        negativeHeadingMandarin
        negativeHeadingGerman
        sliderQuestions {
          questionPositiveEnglish
          questionPositiveGerman
          questionPositiveMandarin
          questionPositiveSpanish
          questionPositiveFrench
          questionNegativeEnglish
          questionNegativeGerman
          questionNegativeFrench
          questionNegativeMandarin
          questionNegativeSpanish
        }
        sliderHeadings {
          headingEnglish
          headingSpanish
          headingGerman
          headingFrench
          rating
          color
        }
      }
    }
    events {
      documentId
      name
      link
      session_id
    }
    show_session
    sub_module {
      documentId
      programme_type {
        documentId
        title
      }
    }
  }
}
    `;

/**
 * __useGetSectionQuery__
 *
 * To run a query within a React component, call `useGetSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSectionQuery(baseOptions: Apollo.QueryHookOptions<GetSectionQuery, GetSectionQueryVariables> & ({ variables: GetSectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSectionQuery, GetSectionQueryVariables>(GetSectionDocument, options);
      }
export function useGetSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSectionQuery, GetSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSectionQuery, GetSectionQueryVariables>(GetSectionDocument, options);
        }
// @ts-ignore
export function useGetSectionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSectionQuery, GetSectionQueryVariables>): Apollo.UseSuspenseQueryResult<GetSectionQuery, GetSectionQueryVariables>;
export function useGetSectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSectionQuery, GetSectionQueryVariables>): Apollo.UseSuspenseQueryResult<GetSectionQuery | undefined, GetSectionQueryVariables>;
export function useGetSectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSectionQuery, GetSectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSectionQuery, GetSectionQueryVariables>(GetSectionDocument, options);
        }
export type GetSectionQueryHookResult = ReturnType<typeof useGetSectionQuery>;
export type GetSectionLazyQueryHookResult = ReturnType<typeof useGetSectionLazyQuery>;
export type GetSectionSuspenseQueryHookResult = ReturnType<typeof useGetSectionSuspenseQuery>;
export type GetSectionQueryResult = Apollo.QueryResult<GetSectionQuery, GetSectionQueryVariables>;
export const GetSectionsDocument = gql`
    query getSections {
  sections {
    documentId
    title_english
    sub_title_english
    title_french
    title_german
    title_spanish
    title_mandarin
    sub_title_french
    sub_title_german
    sub_title_spanish
    sub_title_mandarin
    events {
      documentId
      name
      link
      session_id
    }
    show_session
    archive
  }
}
    `;

/**
 * __useGetSectionsQuery__
 *
 * To run a query within a React component, call `useGetSectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSectionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSectionsQuery(baseOptions?: Apollo.QueryHookOptions<GetSectionsQuery, GetSectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSectionsQuery, GetSectionsQueryVariables>(GetSectionsDocument, options);
      }
export function useGetSectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSectionsQuery, GetSectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSectionsQuery, GetSectionsQueryVariables>(GetSectionsDocument, options);
        }
// @ts-ignore
export function useGetSectionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSectionsQuery, GetSectionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSectionsQuery, GetSectionsQueryVariables>;
export function useGetSectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSectionsQuery, GetSectionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSectionsQuery | undefined, GetSectionsQueryVariables>;
export function useGetSectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSectionsQuery, GetSectionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSectionsQuery, GetSectionsQueryVariables>(GetSectionsDocument, options);
        }
export type GetSectionsQueryHookResult = ReturnType<typeof useGetSectionsQuery>;
export type GetSectionsLazyQueryHookResult = ReturnType<typeof useGetSectionsLazyQuery>;
export type GetSectionsSuspenseQueryHookResult = ReturnType<typeof useGetSectionsSuspenseQuery>;
export type GetSectionsQueryResult = Apollo.QueryResult<GetSectionsQuery, GetSectionsQueryVariables>;
export const GetCoachSessionDocument = gql`
    query getCoachSession($id: ID!) {
  coachSession(documentId: $id) {
    documentId
    title
    status
    user {
      documentId
    }
    programme_submission {
      documentId
    }
    sub_module_submission {
      documentId
    }
  }
}
    `;

/**
 * __useGetCoachSessionQuery__
 *
 * To run a query within a React component, call `useGetCoachSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoachSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoachSessionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCoachSessionQuery(baseOptions: Apollo.QueryHookOptions<GetCoachSessionQuery, GetCoachSessionQueryVariables> & ({ variables: GetCoachSessionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoachSessionQuery, GetCoachSessionQueryVariables>(GetCoachSessionDocument, options);
      }
export function useGetCoachSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoachSessionQuery, GetCoachSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoachSessionQuery, GetCoachSessionQueryVariables>(GetCoachSessionDocument, options);
        }
// @ts-ignore
export function useGetCoachSessionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCoachSessionQuery, GetCoachSessionQueryVariables>): Apollo.UseSuspenseQueryResult<GetCoachSessionQuery, GetCoachSessionQueryVariables>;
export function useGetCoachSessionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCoachSessionQuery, GetCoachSessionQueryVariables>): Apollo.UseSuspenseQueryResult<GetCoachSessionQuery | undefined, GetCoachSessionQueryVariables>;
export function useGetCoachSessionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCoachSessionQuery, GetCoachSessionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCoachSessionQuery, GetCoachSessionQueryVariables>(GetCoachSessionDocument, options);
        }
export type GetCoachSessionQueryHookResult = ReturnType<typeof useGetCoachSessionQuery>;
export type GetCoachSessionLazyQueryHookResult = ReturnType<typeof useGetCoachSessionLazyQuery>;
export type GetCoachSessionSuspenseQueryHookResult = ReturnType<typeof useGetCoachSessionSuspenseQuery>;
export type GetCoachSessionQueryResult = Apollo.QueryResult<GetCoachSessionQuery, GetCoachSessionQueryVariables>;
export const GetCoachSessionsDocument = gql`
    query getCoachSessions {
  coachSessions {
    documentId
    title
    status
  }
}
    `;

/**
 * __useGetCoachSessionsQuery__
 *
 * To run a query within a React component, call `useGetCoachSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoachSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoachSessionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCoachSessionsQuery(baseOptions?: Apollo.QueryHookOptions<GetCoachSessionsQuery, GetCoachSessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoachSessionsQuery, GetCoachSessionsQueryVariables>(GetCoachSessionsDocument, options);
      }
export function useGetCoachSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoachSessionsQuery, GetCoachSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoachSessionsQuery, GetCoachSessionsQueryVariables>(GetCoachSessionsDocument, options);
        }
// @ts-ignore
export function useGetCoachSessionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCoachSessionsQuery, GetCoachSessionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCoachSessionsQuery, GetCoachSessionsQueryVariables>;
export function useGetCoachSessionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCoachSessionsQuery, GetCoachSessionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCoachSessionsQuery | undefined, GetCoachSessionsQueryVariables>;
export function useGetCoachSessionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCoachSessionsQuery, GetCoachSessionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCoachSessionsQuery, GetCoachSessionsQueryVariables>(GetCoachSessionsDocument, options);
        }
export type GetCoachSessionsQueryHookResult = ReturnType<typeof useGetCoachSessionsQuery>;
export type GetCoachSessionsLazyQueryHookResult = ReturnType<typeof useGetCoachSessionsLazyQuery>;
export type GetCoachSessionsSuspenseQueryHookResult = ReturnType<typeof useGetCoachSessionsSuspenseQuery>;
export type GetCoachSessionsQueryResult = Apollo.QueryResult<GetCoachSessionsQuery, GetCoachSessionsQueryVariables>;
export const GetSubModuleDocument = gql`
    query getSubModule($id: ID!) {
  subModule(documentId: $id) {
    documentId
    name_english
    name_french
    name_spanish
    name_german
    name_mandarin
    description_english
    description_french
    description_spanish
    description_german
    description_mandarin
    sections {
      documentId
      title_french
      title_german
      title_english
      title_spanish
      title_mandarin
      sub_title_french
      sub_title_german
      sub_title_english
      sub_title_spanish
      sub_title_mandarin
      position
      archive
    }
    programme_type {
      documentId
      title
      description
      position
      is_coaching
      is_sub_module
      notes
      show_article
      show_session
      show_participants
      competency_survey
      feedForward_survey
      deadline
      articles {
        documentId
        createdAt
        updatedAt
        title_english
        title_french
        title_german
        title_spanish
        title_mandarin
        content_english
        content_french
        content_german
        content_spanish
        content_mandarin
        image {
          documentId
          url
        }
        date_published
        read_time
        link
      }
      modal {
        documentId
        title
        subtitle
        message
        image {
          documentId
          url
          name
        }
      }
      events {
        documentId
        name
        link
      }
    }
  }
}
    `;

/**
 * __useGetSubModuleQuery__
 *
 * To run a query within a React component, call `useGetSubModuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubModuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubModuleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSubModuleQuery(baseOptions: Apollo.QueryHookOptions<GetSubModuleQuery, GetSubModuleQueryVariables> & ({ variables: GetSubModuleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubModuleQuery, GetSubModuleQueryVariables>(GetSubModuleDocument, options);
      }
export function useGetSubModuleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubModuleQuery, GetSubModuleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubModuleQuery, GetSubModuleQueryVariables>(GetSubModuleDocument, options);
        }
// @ts-ignore
export function useGetSubModuleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSubModuleQuery, GetSubModuleQueryVariables>): Apollo.UseSuspenseQueryResult<GetSubModuleQuery, GetSubModuleQueryVariables>;
export function useGetSubModuleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubModuleQuery, GetSubModuleQueryVariables>): Apollo.UseSuspenseQueryResult<GetSubModuleQuery | undefined, GetSubModuleQueryVariables>;
export function useGetSubModuleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubModuleQuery, GetSubModuleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSubModuleQuery, GetSubModuleQueryVariables>(GetSubModuleDocument, options);
        }
export type GetSubModuleQueryHookResult = ReturnType<typeof useGetSubModuleQuery>;
export type GetSubModuleLazyQueryHookResult = ReturnType<typeof useGetSubModuleLazyQuery>;
export type GetSubModuleSuspenseQueryHookResult = ReturnType<typeof useGetSubModuleSuspenseQuery>;
export type GetSubModuleQueryResult = Apollo.QueryResult<GetSubModuleQuery, GetSubModuleQueryVariables>;
export const GetMySubModuleSubmissionDocument = gql`
    query getMySubModuleSubmission($id: ID!) {
  subModuleSubmission(documentId: $id) {
    documentId
    view
    progress
    status
    time_spent
    participants {
      documentId
      name
      email
      type
    }
    submission_participants {
      id
      name
      email
    }
    feedfoward_url {
      documentId
    }
    language {
      documentId
      name
    }
    sub_module {
      documentId
      name_french
      name_german
      name_english
      name_spanish
      name_mandarin
      description_french
      description_german
      description_english
      description_spanish
      description_mandarin
      cover {
        documentId
        url
      }
      sections {
        documentId
        title_french
        title_german
        title_english
        title_spanish
        title_mandarin
        sub_title_french
        sub_title_german
        sub_title_english
        sub_title_spanish
        sub_title_mandarin
        cover {
          documentId
          url
        }
        position
        archive
      }
      position
      programme_type {
        documentId
        title
        description
        position
        cover {
          documentId
          url
        }
        is_coaching
        is_sub_module
        notes
        show_article
        show_session
        show_participants
        competency_survey
        feedForward_survey
        deadline
        articles {
          documentId
          createdAt
          updatedAt
          title_english
          title_french
          title_german
          title_spanish
          title_mandarin
          content_english
          content_french
          content_german
          content_spanish
          content_mandarin
          image {
            documentId
            url
          }
          date_published
          read_time
          link
        }
        modal {
          documentId
          title
          subtitle
          message
          image {
            documentId
            url
            name
          }
        }
        events {
          documentId
          name
          link
        }
        show_statistics
      }
    }
    section {
      id
      progress
      section {
        documentId
      }
      answers {
        id
        questionId
        answer
        nestedAnswers {
          answer
          questionTitle
        }
        isCorrect
        feedback
        outcome
        questionType
        questionTitle
      }
      stakeholderChart {
        documentId
        url
      }
      stakeholderItems {
        id
        valueX
        valueY
        name
        color
      }
      gravitasScales {
        id
        labelOne
        labelTwo
        labelThree
        question
        answerOne
        answerTwo
        answerThree
      }
      gravitasSliderAnswers {
        negativeQuestion
        positiveQuestion
        colorAndRating {
          color
          rate
        }
      }
      gravitasGap {
        id
        gap
        commitment
      }
      xYGraphChart {
        documentId
        url
      }
      saboteurImage {
        documentId
        url
      }
      xYGraphItems {
        id
        valueX
        valueY
        color
      }
      characteristics {
        id
        answer
        type
      }
      sliderAnswers
      gapsAnswers {
        id
        gap
        commitment
      }
      competencyAnswers {
        id
        question
        rating
        steps
        response
      }
      uploadDocuments {
        saboteurProofValue {
          documentId
          url
        }
      }
    }
    reports {
      documentId
      name
      type
      report {
        documentId
        url
      }
      section_or_module_id
    }
  }
}
    `;

/**
 * __useGetMySubModuleSubmissionQuery__
 *
 * To run a query within a React component, call `useGetMySubModuleSubmissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMySubModuleSubmissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMySubModuleSubmissionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMySubModuleSubmissionQuery(baseOptions: Apollo.QueryHookOptions<GetMySubModuleSubmissionQuery, GetMySubModuleSubmissionQueryVariables> & ({ variables: GetMySubModuleSubmissionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMySubModuleSubmissionQuery, GetMySubModuleSubmissionQueryVariables>(GetMySubModuleSubmissionDocument, options);
      }
export function useGetMySubModuleSubmissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMySubModuleSubmissionQuery, GetMySubModuleSubmissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMySubModuleSubmissionQuery, GetMySubModuleSubmissionQueryVariables>(GetMySubModuleSubmissionDocument, options);
        }
// @ts-ignore
export function useGetMySubModuleSubmissionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMySubModuleSubmissionQuery, GetMySubModuleSubmissionQueryVariables>): Apollo.UseSuspenseQueryResult<GetMySubModuleSubmissionQuery, GetMySubModuleSubmissionQueryVariables>;
export function useGetMySubModuleSubmissionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMySubModuleSubmissionQuery, GetMySubModuleSubmissionQueryVariables>): Apollo.UseSuspenseQueryResult<GetMySubModuleSubmissionQuery | undefined, GetMySubModuleSubmissionQueryVariables>;
export function useGetMySubModuleSubmissionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMySubModuleSubmissionQuery, GetMySubModuleSubmissionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMySubModuleSubmissionQuery, GetMySubModuleSubmissionQueryVariables>(GetMySubModuleSubmissionDocument, options);
        }
export type GetMySubModuleSubmissionQueryHookResult = ReturnType<typeof useGetMySubModuleSubmissionQuery>;
export type GetMySubModuleSubmissionLazyQueryHookResult = ReturnType<typeof useGetMySubModuleSubmissionLazyQuery>;
export type GetMySubModuleSubmissionSuspenseQueryHookResult = ReturnType<typeof useGetMySubModuleSubmissionSuspenseQuery>;
export type GetMySubModuleSubmissionQueryResult = Apollo.QueryResult<GetMySubModuleSubmissionQuery, GetMySubModuleSubmissionQueryVariables>;
export const GetSubModulesDocument = gql`
    query getSubModules {
  subModules {
    documentId
    name_english
    name_french
    name_german
    name_spanish
    name_mandarin
    description_english
    description_french
    description_german
    description_spanish
    description_mandarin
    cover {
      documentId
      url
    }
    sections {
      documentId
      title_english
      title_french
      title_german
      title_spanish
      title_mandarin
      sub_title_english
      sub_title_french
      sub_title_german
      sub_title_spanish
      sub_title_mandarin
      video_english {
        documentId
        url
      }
      video_french {
        documentId
        url
      }
      video_german {
        documentId
        url
      }
      video_spanish {
        documentId
        url
      }
      video_mandarin {
        documentId
        url
      }
      archive
    }
  }
}
    `;

/**
 * __useGetSubModulesQuery__
 *
 * To run a query within a React component, call `useGetSubModulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubModulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubModulesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSubModulesQuery(baseOptions?: Apollo.QueryHookOptions<GetSubModulesQuery, GetSubModulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubModulesQuery, GetSubModulesQueryVariables>(GetSubModulesDocument, options);
      }
export function useGetSubModulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubModulesQuery, GetSubModulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubModulesQuery, GetSubModulesQueryVariables>(GetSubModulesDocument, options);
        }
// @ts-ignore
export function useGetSubModulesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSubModulesQuery, GetSubModulesQueryVariables>): Apollo.UseSuspenseQueryResult<GetSubModulesQuery, GetSubModulesQueryVariables>;
export function useGetSubModulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubModulesQuery, GetSubModulesQueryVariables>): Apollo.UseSuspenseQueryResult<GetSubModulesQuery | undefined, GetSubModulesQueryVariables>;
export function useGetSubModulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubModulesQuery, GetSubModulesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSubModulesQuery, GetSubModulesQueryVariables>(GetSubModulesDocument, options);
        }
export type GetSubModulesQueryHookResult = ReturnType<typeof useGetSubModulesQuery>;
export type GetSubModulesLazyQueryHookResult = ReturnType<typeof useGetSubModulesLazyQuery>;
export type GetSubModulesSuspenseQueryHookResult = ReturnType<typeof useGetSubModulesSuspenseQuery>;
export type GetSubModulesQueryResult = Apollo.QueryResult<GetSubModulesQuery, GetSubModulesQueryVariables>;
export const GetSectionReportDocument = gql`
    query getSectionReport($id: ID!) {
  getSectionReport(id: $id) {
    id
    name
    type
    report {
      documentId
      url
    }
    section_or_module_id
  }
}
    `;

/**
 * __useGetSectionReportQuery__
 *
 * To run a query within a React component, call `useGetSectionReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSectionReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSectionReportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSectionReportQuery(baseOptions: Apollo.QueryHookOptions<GetSectionReportQuery, GetSectionReportQueryVariables> & ({ variables: GetSectionReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSectionReportQuery, GetSectionReportQueryVariables>(GetSectionReportDocument, options);
      }
export function useGetSectionReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSectionReportQuery, GetSectionReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSectionReportQuery, GetSectionReportQueryVariables>(GetSectionReportDocument, options);
        }
// @ts-ignore
export function useGetSectionReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSectionReportQuery, GetSectionReportQueryVariables>): Apollo.UseSuspenseQueryResult<GetSectionReportQuery, GetSectionReportQueryVariables>;
export function useGetSectionReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSectionReportQuery, GetSectionReportQueryVariables>): Apollo.UseSuspenseQueryResult<GetSectionReportQuery | undefined, GetSectionReportQueryVariables>;
export function useGetSectionReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSectionReportQuery, GetSectionReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSectionReportQuery, GetSectionReportQueryVariables>(GetSectionReportDocument, options);
        }
export type GetSectionReportQueryHookResult = ReturnType<typeof useGetSectionReportQuery>;
export type GetSectionReportLazyQueryHookResult = ReturnType<typeof useGetSectionReportLazyQuery>;
export type GetSectionReportSuspenseQueryHookResult = ReturnType<typeof useGetSectionReportSuspenseQuery>;
export type GetSectionReportQueryResult = Apollo.QueryResult<GetSectionReportQuery, GetSectionReportQueryVariables>;
export const GetMySubmissionDocument = gql`
    query getMySubmission($id: ID!) {
  submission(documentId: $id) {
    documentId
    views
    progress
    status
    time_spent
    language {
      documentId
      name
    }
    module {
      documentId
      name_french
      name_german
      name_english
      name_spanish
      name_mandarin
      description_french
      description_german
      description_english
      description_spanish
      description_mandarin
      cover {
        documentId
        url
      }
      sections {
        documentId
        title_french
        title_german
        title_english
        title_spanish
        title_mandarin
        sub_title_french
        sub_title_german
        sub_title_english
        sub_title_spanish
        sub_title_mandarin
        cover {
          documentId
          url
        }
      }
      position
    }
    section {
      id
      progress
      section {
        documentId
      }
      answers {
        id
        questionId
        answer
        nestedAnswers {
          answer
          questionTitle
        }
        isCorrect
        feedback
        outcome
        questionType
        questionTitle
      }
      stakeholderChart {
        documentId
        url
      }
      stakeholderItems {
        id
        valueX
        valueY
        name
        color
      }
      gravitasScales {
        id
        labelOne
        labelTwo
        labelThree
        question
        answerOne
        answerTwo
        answerThree
      }
      xYGraphChart {
        documentId
        url
      }
      saboteurImage {
        documentId
        url
      }
      xYGraphItems {
        id
        valueX
        valueY
        color
      }
    }
    reports {
      documentId
      name
      type
      report {
        documentId
        url
      }
      section_or_module_id
    }
  }
}
    `;

/**
 * __useGetMySubmissionQuery__
 *
 * To run a query within a React component, call `useGetMySubmissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMySubmissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMySubmissionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMySubmissionQuery(baseOptions: Apollo.QueryHookOptions<GetMySubmissionQuery, GetMySubmissionQueryVariables> & ({ variables: GetMySubmissionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMySubmissionQuery, GetMySubmissionQueryVariables>(GetMySubmissionDocument, options);
      }
export function useGetMySubmissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMySubmissionQuery, GetMySubmissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMySubmissionQuery, GetMySubmissionQueryVariables>(GetMySubmissionDocument, options);
        }
// @ts-ignore
export function useGetMySubmissionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMySubmissionQuery, GetMySubmissionQueryVariables>): Apollo.UseSuspenseQueryResult<GetMySubmissionQuery, GetMySubmissionQueryVariables>;
export function useGetMySubmissionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMySubmissionQuery, GetMySubmissionQueryVariables>): Apollo.UseSuspenseQueryResult<GetMySubmissionQuery | undefined, GetMySubmissionQueryVariables>;
export function useGetMySubmissionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMySubmissionQuery, GetMySubmissionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMySubmissionQuery, GetMySubmissionQueryVariables>(GetMySubmissionDocument, options);
        }
export type GetMySubmissionQueryHookResult = ReturnType<typeof useGetMySubmissionQuery>;
export type GetMySubmissionLazyQueryHookResult = ReturnType<typeof useGetMySubmissionLazyQuery>;
export type GetMySubmissionSuspenseQueryHookResult = ReturnType<typeof useGetMySubmissionSuspenseQuery>;
export type GetMySubmissionQueryResult = Apollo.QueryResult<GetMySubmissionQuery, GetMySubmissionQueryVariables>;
export const GetSubmissionReportGroupedDocument = gql`
    query getSubmissionReportGrouped {
  getSubmissionReportGrouped {
    id
    name
    type
    createdBy
    updatedBy
    programmeType
    subModuleSubmission
    notification
    report {
      id
      url
    }
  }
}
    `;

/**
 * __useGetSubmissionReportGroupedQuery__
 *
 * To run a query within a React component, call `useGetSubmissionReportGroupedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubmissionReportGroupedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubmissionReportGroupedQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSubmissionReportGroupedQuery(baseOptions?: Apollo.QueryHookOptions<GetSubmissionReportGroupedQuery, GetSubmissionReportGroupedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubmissionReportGroupedQuery, GetSubmissionReportGroupedQueryVariables>(GetSubmissionReportGroupedDocument, options);
      }
export function useGetSubmissionReportGroupedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubmissionReportGroupedQuery, GetSubmissionReportGroupedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubmissionReportGroupedQuery, GetSubmissionReportGroupedQueryVariables>(GetSubmissionReportGroupedDocument, options);
        }
// @ts-ignore
export function useGetSubmissionReportGroupedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSubmissionReportGroupedQuery, GetSubmissionReportGroupedQueryVariables>): Apollo.UseSuspenseQueryResult<GetSubmissionReportGroupedQuery, GetSubmissionReportGroupedQueryVariables>;
export function useGetSubmissionReportGroupedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubmissionReportGroupedQuery, GetSubmissionReportGroupedQueryVariables>): Apollo.UseSuspenseQueryResult<GetSubmissionReportGroupedQuery | undefined, GetSubmissionReportGroupedQueryVariables>;
export function useGetSubmissionReportGroupedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubmissionReportGroupedQuery, GetSubmissionReportGroupedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSubmissionReportGroupedQuery, GetSubmissionReportGroupedQueryVariables>(GetSubmissionReportGroupedDocument, options);
        }
export type GetSubmissionReportGroupedQueryHookResult = ReturnType<typeof useGetSubmissionReportGroupedQuery>;
export type GetSubmissionReportGroupedLazyQueryHookResult = ReturnType<typeof useGetSubmissionReportGroupedLazyQuery>;
export type GetSubmissionReportGroupedSuspenseQueryHookResult = ReturnType<typeof useGetSubmissionReportGroupedSuspenseQuery>;
export type GetSubmissionReportGroupedQueryResult = Apollo.QueryResult<GetSubmissionReportGroupedQuery, GetSubmissionReportGroupedQueryVariables>;
export const GetTranslationsDocument = gql`
    query getTranslations {
  translation {
    documentId
    menu {
      homeEnglish
      myProgrammeEnglish
      myWorkEnglish
      myLibraryEnglish
      myProfileEnglish
      helpAndSupportEnglish
      signOutEnglish
      homeFrench
      myProgrammeFrench
      myWorkFrench
      myLibraryFrench
      myProfileFrench
      helpAndSupportFrench
      signOutFrench
      homeGerman
      myProgrammeGerman
      myWorkGerman
      myLibraryGerman
      myProfileGerman
      helpAndSupportGerman
      signOutGerman
      homeSpanish
      myProgrammeSpanish
      myWorkSpanish
      myLibrarySpanish
      myProfileSpanish
      helpAndSupportSpanish
      signOutSpanish
      homeMandarin
      myProgrammeMandarin
      myWorkMandarin
      myLibraryMandarin
      myProfileMandarin
      helpAndSupportMandarin
      signOutMandarin
      aboutUsEnglish
      aboutUsGerman
      aboutUsFrench
      myNotesEnglish
      myNotesGerman
      myNotesFrench
      myNotesSpanish
      myNotesMandarin
      notificationsEnglish
      notificationsGerman
      notificationsFrench
      notificationsSpanish
      notificationsMandarin
    }
    language_selection {
      titleEnglish
      bodyEnglish
      nextButtonEnglish
      titleFrench
      bodyFrench
      nextButtonFrench
      titleGerman
      bodyGerman
      nextButtonGerman
      titleMandarin
      bodyMandarin
      nextButtonMandarin
      titleSpanish
      bodySpanish
      nextButtonSpanish
    }
    welcome_screen {
      titleEnglish
      bodyEnglish
      videoEnglish {
        documentId
        url
      }
      nextButtonEnglish
      titleFrench
      bodyFrench
      videoFrench {
        documentId
        url
      }
      nextButtonFrench
      titleGerman
      bodyGerman
      videoGerman {
        documentId
        url
      }
      nextButtonGerman
      titleMandarin
      bodyMandarin
      videoMandarin {
        documentId
        url
      }
      nextButtonMandarin
      titleSpanish
      bodySpanish
      videoSpanish {
        documentId
        url
      }
      nextButtonSpanish
    }
    lets_get_started_screen {
      titleEnglish
      subTitleEnglish
      firstNameLabelEnglish
      firstNameErrorEnglish
      lastNameLabelEnglish
      lastNameErrorEnglish
      jobTitleLabelEnglish
      jobTitleErrorEnglish
      divisionLabelEnglish
      divisionErrorEnglish
      timezoneLabelEnglish
      regionLabelEnglish
      regionErrorEnglish
      image {
        documentId
        url
      }
      nextButtonEnglish
      titleFrench
      subTitleFrench
      firstNameLabelFrench
      firstNameErrorFrench
      lastNameLabelFrench
      lastNameErrorFrench
      jobTitleLabelFrench
      jobTitleErrorFrench
      divisionLabelFrench
      divisionErrorFrench
      timezoneLabelFrench
      regionLabelFrench
      regionErrorFrench
      nextButtonFrench
      titleGerman
      subTitleGerman
      firstNameLabelGerman
      firstNameErrorGerman
      lastNameLabelGerman
      lastNameErrorGerman
      jobTitleLabelGerman
      jobTitleErrorGerman
      divisionLabelGerman
      divisionErrorGerman
      timezoneLabelGerman
      regionLabelGerman
      regionErrorGerman
      nextButtonGerman
      titleMandarin
      subTitleMandarin
      firstNameLabelMandarin
      firstNameErrorMandarin
      lastNameLabelMandarin
      lastNameErrorMandarin
      jobTitleLabelMandarin
      jobTitleErrorMandarin
      divisionLabelMandarin
      divisionErrorMandarin
      timezoneLabelMandarin
      regionLabelMandarin
      regionErrorMandarin
      nextButtonMandarin
      titleSpanish
      subTitleSpanish
      firstNameLabelSpanish
      firstNameErrorSpanish
      lastNameLabelSpanish
      lastNameErrorSpanish
      jobTitleLabelSpanish
      jobTitleErrorSpanish
      divisionLabelSpanish
      divisionErrorSpanish
      timezoneLabelSpanish
      regionLabelSpanish
      regionErrorSpanish
      nextButtonSpanish
      leftTitleEnglish
      leftSubtitleEnglish
      leftTitleSpanish
      leftSubtitleSpanish
      leftTitleMandarin
      leftSubTitleMandarin
      leftTitleFrench
      leftSubtitleFrench
      leftSubtitleGerman
      leftTitleGerman
      havingTroubleEnglish
      havingTroubleGerman
      havingTroubleFrench
      havingTroubleMandarin
      havingTroubleSpanish
      getHelpButtonEnglish
      getHelpButtonSpanish
      getHelpButtonFrench
      getHelpButtonGerman
      getHelpButtonMandarin
    }
    what_to_expect {
      titleEnglish
      bodyEnglish
      image {
        documentId
        url
      }
      getStartedButtonEnglish
      titleFrench
      bodyFrench
      getStartedButtonFrench
      titleGerman
      bodyGerman
      getStartedButtonGerman
      titleMandarin
      bodyMandarin
      getStartedButtonMandarin
      titleSpanish
      bodySpanish
      getStartedButtonSpanish
    }
    home_screen {
      titleEnglish
      myProgrammeEnglish
      completedModulesEnglish
      noChangesEnglish
      changesUpEnglish
      changesDownEnglish
      viewModulesEnglish
      myLibraryEnglish
      viewedArticlesEnglish
      viewLibraryEnglish
      titleFrench
      myProgrammeFrench
      completedModulesFrench
      noChangesFrench
      changesUpFrench
      changesDownFrench
      viewModulesFrench
      myLibraryFrench
      viewedArticlesFrench
      viewLibraryFrench
      titleGerman
      myProgrammeGerman
      completedModulesGerman
      noChangesGerman
      changesUpGerman
      changesDownGerman
      viewModulesGerman
      myLibraryGerman
      viewedArticlesGerman
      viewLibraryGerman
      titleSpanish
      myProgrammeSpanish
      completedModulesSpanish
      noChangesSpanish
      changesUpSpanish
      changesDownSpanish
      viewModulesSpanish
      myLibrarySpanish
      viewedArticlesSpanish
      viewLibrarySpanish
      titleMandarin
      myProgrammeMandarin
      completedModulesMandarin
      noChangesMandarin
      changesUpMandarin
      changesDownMandarin
      viewModulesMandarin
      myLibraryMandarin
      viewedArticlesMandarin
      viewLibraryMandarin
      welcomeEnglish
      welcomeFrench
      welcomeGerman
      welcomeSpanish
      welcomeMandarin
      programmeProgressEnglish
      programmeProgressFrench
      programmeProgressGerman
      programmeProgressSpanish
      programmeProgressMandarin
      whatsNextEnglish
      whatsNextFrench
      whatsNextGerman
      whatsNextSpanish
      whatsNextMandarin
      whatToExpectEnglish
      whatToExpectFrench
      whatToExpectGerman
      whatToExpectSpanish
      whatToExpectMandarin
    }
    my_work_screen {
      emptyStateTitleEnglish
      emptyStateDescEnglish
      subtitleEnglish
      feedbackEnglish
      feedbackNotEligibleEnglish
      feedbackNotReceivedEnglish
      notStartedEnglish
      emptyStateTitleFrench
      emptyStateDescFrench
      subtitleFrench
      feedbackFrench
      feedbackNotEligibleFrench
      feedbackNotReceivedFrench
      notStartedFrench
      emptyStateTitleGerman
      emptyStateDescGerman
      subtitleGerman
      feedbackGerman
      feedbackNotEligibleGerman
      feedbackNotReceivedGerman
      notStartedGerman
      emptyStateTitleSpanish
      emptyStateDescSpanish
      subtitleSpanish
      feedbackSpanish
      feedbackNotEligibleSpanish
      feedbackNotReceivedSpanish
      notStartedSpanish
      emptyStateTitleMandarin
      emptyStateDescMandarin
      subtitleMandarin
      feedbackMandarin
      feedbackNotEligibleMandarin
      feedbackNotReceivedMandarin
      notStartedMandarin
      downloadContentTextEnglish
      downloadContentTextFrench
      downloadContentTextGerman
      downloadContentTextSpanish
      downloadContentTextMandarin
      myNotesEnglish
      myNotesSpanish
      myNotesFrench
      myNotesGerman
      myNotesMandarin
      moduleReportsEnglish
      moduleReportsSpanish
      moduleReportsFrench
      moduleReportsGerman
      moduleReportsMandarin
      documentsEnglish
      documentsSpanish
      documentsMandarin
      documentsSpanish
      documentsFrench
    }
    my_library_screen {
      id
      allArticlesEnglish
      myBookmarksEnglish
      allArticlesFrench
      myBookmarksFrench
      allArticlesGerman
      myBookmarksGerman
      allArticlesSpanish
      myBookmarksSpanish
      allArticlesMandarin
      myBookmarksMandarin
      viewArticleEnglish
      viewArticleFrench
      viewArticleGerman
      viewArticleSpanish
      viewArticleMandarin
    }
    my_profile_screen {
      id
      detailsEnglish
      settingsEnglish
      logoutEnglish
      joinEnglish
      detailsFrench
      settingsFrench
      logoutFrench
      joinFrench
      detailsGerman
      settingsGerman
      logoutGerman
      joinGerman
      detailsSpanish
      settingsSpanish
      logoutSpanish
      joinSpanish
      detailsMandarin
      settingsMandarin
      logoutMandarin
    }
    personal_screen {
      id
      changePhotoEnglish
      firstNameLabelEnglish
      lastNameLabelEnglish
      emailLabelEnglish
      jobTitleLabelEnglish
      divisionLabelEnglish
      editInfoButtonEnglish
      changePhotoFrench
      firstNameLabelFrench
      lastNameLabelFrench
      emailLabelFrench
      jobTitleLabelFrench
      divisionLabelFrench
      editInfoButtonFrench
      changePhotoGerman
      firstNameLabelGerman
      lastNameLabelGerman
      emailLabelGerman
      jobTitleLabelGerman
      divisionLabelGerman
      editInfoButtonGerman
      changePhotoSpanish
      firstNameLabelSpanish
      lastNameLabelSpanish
      emailLabelSpanish
      jobTitleLabelSpanish
      divisionLabelSpanish
      editInfoButtonSpanish
      changePhotoMandarin
      firstNameLabelMandarin
      lastNameLabelMandarin
      emailLabelMandarin
      jobTitleLabelMandarin
      divisionLabelMandarin
      editInfoButtonMandarin
      resetPasswordEnglish
      resetPasswordFrench
      resetPasswordGerman
      resetPasswordSpanish
      resetPasswordMandarin
    }
    settings_screen {
      id
      titleEnglish
      saveButtonEnglish
      titleFrench
      saveButtonFrench
      titleGerman
      saveButtonGerman
      titleSpanish
      saveButtonSpanish
      titleMandarin
      saveButtonMandarin
    }
    help_and_support {
      id
      titleEnglish
      knowledgeBaseEnglish
      liveChatEnglish
      myTicketsEnglish
      titleFrench
      knowledgeBaseFrench
      liveChatFrench
      myTicketsFrench
      titleGerman
      knowledgeBaseGerman
      liveChatGerman
      myTicketsGerman
      titleSpanish
      knowledgeBaseSpanish
      liveChatSpanish
      myTicketsSpanish
      titleMandarin
      knowledgeBaseMandarin
      liveChatMandarin
      myTicketsMandarin
    }
    about_us {
      textEnglish
      textFrench
      textGerman
      userGuidelinesTextEnglish
      userGuidelinesTextGerman
      userGuidelinesTextFrench
      userGuidelinesEnglish {
        documentId
        url
      }
      userGuidelinesGerman {
        documentId
        url
      }
      userGuidelinesFrench {
        documentId
        url
      }
    }
    buttons {
      backBtnsEnglish
      backBtnsFrench
      backBtnsGerman
      nextBtnsEnglish
      nextBtnsFrench
      nextBtnsGerman
      addMoreBtnsEnglish
      addMoreBtnsFrench
      addMoreBtnsGerman
    }
    programmes_screen {
      changeButtonEnglish
      changeButtonFrench
      changeButtonGerman
      changeButtonSpanish
      changeButtonMandarin
      programmeOverviewEnglish
      programmeOverviewFrench
      programmeOverviewGerman
      programmeOverviewSpanish
      programmeOverviewMandarin
      programmeTextEnglish
      programmeTextFrench
      programmeTextGerman
      programmeTextSpanish
      programmeTextMandarin
      informationEnglish
      informationFrench
      informationGerman
      informationSpanish
      informationMandarin
      selectProgrammesTitleEnglish
      selectProgrammesTitleFrench
      selectProgrammesTitleGerman
      selectProgrammesTitleSpanish
      selectProgrammesTitleMandarin
      selectProgrammesSubTitleEnglish
      selectProgrammesSubTitleFrench
      selectProgrammesSubTitleGerman
      selectProgrammesSubTitleSpanish
      selectProgrammesSubTitleMandarin
      selectButtonEnglish
      selectButtonFrench
      selectButtonGerman
      selectButtonSpanish
      selectButtonMandarin
      changeProgrammeTypeEnglish
      changeProgrammeTypeFrench
      changeProgrammeTypeGerman
      changeProgrammeTypeSpanish
      changeProgrammeTypeMandarin
    }
    faqs {
      faqsEnglish {
        question
        answer
      }
      faqsFrench {
        question
        answer
      }
      faqsGerman {
        question
        answer
      }
      faqsMandarin {
        question
        answer
      }
      faqsSpanish {
        question
        answer
      }
    }
    dashboard_screen {
      id
      myProgrammesEnglish
      myProgrammesFrench
      myProgrammesGerman
      myProgrammesSpanish
      myProgrammesMandarin
      suggestedTitleEnglish
      suggestedTitleFrench
      suggestedTitleGerman
      suggestedTitleSpanish
      suggestedTitleMandarin
      uploadTitleEnglish
      uploadTitleFrench
      uploadTitleGerman
      uploadTitleSpanish
      uploadTitleMandarin
      viewAllEnglish
      viewAllFrench
      viewAllGerman
      viewAllSpanish
      viewAllMandarin
      logOutDashboardEnglish
      logOutDashboardFrench
      logOutDashboardGerman
      logOutDashboardSpanish
      logOutDashboardMandarin
      notepadTextEnglish
      notepadTextFrench
      notepadTextGerman
      notepadTextSpanish
      notepadTextMandarin
    }
  }
}
    `;

/**
 * __useGetTranslationsQuery__
 *
 * To run a query within a React component, call `useGetTranslationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTranslationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTranslationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTranslationsQuery(baseOptions?: Apollo.QueryHookOptions<GetTranslationsQuery, GetTranslationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTranslationsQuery, GetTranslationsQueryVariables>(GetTranslationsDocument, options);
      }
export function useGetTranslationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTranslationsQuery, GetTranslationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTranslationsQuery, GetTranslationsQueryVariables>(GetTranslationsDocument, options);
        }
// @ts-ignore
export function useGetTranslationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTranslationsQuery, GetTranslationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTranslationsQuery, GetTranslationsQueryVariables>;
export function useGetTranslationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTranslationsQuery, GetTranslationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTranslationsQuery | undefined, GetTranslationsQueryVariables>;
export function useGetTranslationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTranslationsQuery, GetTranslationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTranslationsQuery, GetTranslationsQueryVariables>(GetTranslationsDocument, options);
        }
export type GetTranslationsQueryHookResult = ReturnType<typeof useGetTranslationsQuery>;
export type GetTranslationsLazyQueryHookResult = ReturnType<typeof useGetTranslationsLazyQuery>;
export type GetTranslationsSuspenseQueryHookResult = ReturnType<typeof useGetTranslationsSuspenseQuery>;
export type GetTranslationsQueryResult = Apollo.QueryResult<GetTranslationsQuery, GetTranslationsQueryVariables>;
export const GetTypeformCompetencyResponsesDocument = gql`
    query getTypeformCompetencyResponses {
  getTypeformCompetencyResponses {
    success
  }
}
    `;

/**
 * __useGetTypeformCompetencyResponsesQuery__
 *
 * To run a query within a React component, call `useGetTypeformCompetencyResponsesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTypeformCompetencyResponsesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTypeformCompetencyResponsesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTypeformCompetencyResponsesQuery(baseOptions?: Apollo.QueryHookOptions<GetTypeformCompetencyResponsesQuery, GetTypeformCompetencyResponsesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTypeformCompetencyResponsesQuery, GetTypeformCompetencyResponsesQueryVariables>(GetTypeformCompetencyResponsesDocument, options);
      }
export function useGetTypeformCompetencyResponsesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTypeformCompetencyResponsesQuery, GetTypeformCompetencyResponsesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTypeformCompetencyResponsesQuery, GetTypeformCompetencyResponsesQueryVariables>(GetTypeformCompetencyResponsesDocument, options);
        }
// @ts-ignore
export function useGetTypeformCompetencyResponsesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTypeformCompetencyResponsesQuery, GetTypeformCompetencyResponsesQueryVariables>): Apollo.UseSuspenseQueryResult<GetTypeformCompetencyResponsesQuery, GetTypeformCompetencyResponsesQueryVariables>;
export function useGetTypeformCompetencyResponsesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTypeformCompetencyResponsesQuery, GetTypeformCompetencyResponsesQueryVariables>): Apollo.UseSuspenseQueryResult<GetTypeformCompetencyResponsesQuery | undefined, GetTypeformCompetencyResponsesQueryVariables>;
export function useGetTypeformCompetencyResponsesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTypeformCompetencyResponsesQuery, GetTypeformCompetencyResponsesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTypeformCompetencyResponsesQuery, GetTypeformCompetencyResponsesQueryVariables>(GetTypeformCompetencyResponsesDocument, options);
        }
export type GetTypeformCompetencyResponsesQueryHookResult = ReturnType<typeof useGetTypeformCompetencyResponsesQuery>;
export type GetTypeformCompetencyResponsesLazyQueryHookResult = ReturnType<typeof useGetTypeformCompetencyResponsesLazyQuery>;
export type GetTypeformCompetencyResponsesSuspenseQueryHookResult = ReturnType<typeof useGetTypeformCompetencyResponsesSuspenseQuery>;
export type GetTypeformCompetencyResponsesQueryResult = Apollo.QueryResult<GetTypeformCompetencyResponsesQuery, GetTypeformCompetencyResponsesQueryVariables>;
export const GetUserUploadedDocumentDocument = gql`
    query getUserUploadedDocument($sort: [String], $filters: UserUploadedDocumentFiltersInput, $pagination: PaginationArg) {
  userUploadedDocuments(sort: $sort, filters: $filters, pagination: $pagination) {
    documentId
    name
    documents {
      id
      name
      document {
        documentId
        url
      }
    }
  }
}
    `;

/**
 * __useGetUserUploadedDocumentQuery__
 *
 * To run a query within a React component, call `useGetUserUploadedDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserUploadedDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserUploadedDocumentQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetUserUploadedDocumentQuery(baseOptions?: Apollo.QueryHookOptions<GetUserUploadedDocumentQuery, GetUserUploadedDocumentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserUploadedDocumentQuery, GetUserUploadedDocumentQueryVariables>(GetUserUploadedDocumentDocument, options);
      }
export function useGetUserUploadedDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserUploadedDocumentQuery, GetUserUploadedDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserUploadedDocumentQuery, GetUserUploadedDocumentQueryVariables>(GetUserUploadedDocumentDocument, options);
        }
// @ts-ignore
export function useGetUserUploadedDocumentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserUploadedDocumentQuery, GetUserUploadedDocumentQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserUploadedDocumentQuery, GetUserUploadedDocumentQueryVariables>;
export function useGetUserUploadedDocumentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserUploadedDocumentQuery, GetUserUploadedDocumentQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserUploadedDocumentQuery | undefined, GetUserUploadedDocumentQueryVariables>;
export function useGetUserUploadedDocumentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserUploadedDocumentQuery, GetUserUploadedDocumentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserUploadedDocumentQuery, GetUserUploadedDocumentQueryVariables>(GetUserUploadedDocumentDocument, options);
        }
export type GetUserUploadedDocumentQueryHookResult = ReturnType<typeof useGetUserUploadedDocumentQuery>;
export type GetUserUploadedDocumentLazyQueryHookResult = ReturnType<typeof useGetUserUploadedDocumentLazyQuery>;
export type GetUserUploadedDocumentSuspenseQueryHookResult = ReturnType<typeof useGetUserUploadedDocumentSuspenseQuery>;
export type GetUserUploadedDocumentQueryResult = Apollo.QueryResult<GetUserUploadedDocumentQuery, GetUserUploadedDocumentQueryVariables>;
export const GetUserProgrammeSubmissionsDocument = gql`
    query getUserProgrammeSubmissions {
  getMyProgrammeSubmissions {
    documentId
    status
    progress
    programme_type {
      title
      is_sub_module
      sub_modules {
        documentId
        name_english
        sections {
          title_english
        }
      }
    }
    programme {
      name
      position
      start
    }
  }
}
    `;

/**
 * __useGetUserProgrammeSubmissionsQuery__
 *
 * To run a query within a React component, call `useGetUserProgrammeSubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserProgrammeSubmissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserProgrammeSubmissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserProgrammeSubmissionsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserProgrammeSubmissionsQuery, GetUserProgrammeSubmissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserProgrammeSubmissionsQuery, GetUserProgrammeSubmissionsQueryVariables>(GetUserProgrammeSubmissionsDocument, options);
      }
export function useGetUserProgrammeSubmissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserProgrammeSubmissionsQuery, GetUserProgrammeSubmissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserProgrammeSubmissionsQuery, GetUserProgrammeSubmissionsQueryVariables>(GetUserProgrammeSubmissionsDocument, options);
        }
// @ts-ignore
export function useGetUserProgrammeSubmissionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserProgrammeSubmissionsQuery, GetUserProgrammeSubmissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserProgrammeSubmissionsQuery, GetUserProgrammeSubmissionsQueryVariables>;
export function useGetUserProgrammeSubmissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserProgrammeSubmissionsQuery, GetUserProgrammeSubmissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserProgrammeSubmissionsQuery | undefined, GetUserProgrammeSubmissionsQueryVariables>;
export function useGetUserProgrammeSubmissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserProgrammeSubmissionsQuery, GetUserProgrammeSubmissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserProgrammeSubmissionsQuery, GetUserProgrammeSubmissionsQueryVariables>(GetUserProgrammeSubmissionsDocument, options);
        }
export type GetUserProgrammeSubmissionsQueryHookResult = ReturnType<typeof useGetUserProgrammeSubmissionsQuery>;
export type GetUserProgrammeSubmissionsLazyQueryHookResult = ReturnType<typeof useGetUserProgrammeSubmissionsLazyQuery>;
export type GetUserProgrammeSubmissionsSuspenseQueryHookResult = ReturnType<typeof useGetUserProgrammeSubmissionsSuspenseQuery>;
export type GetUserProgrammeSubmissionsQueryResult = Apollo.QueryResult<GetUserProgrammeSubmissionsQuery, GetUserProgrammeSubmissionsQueryVariables>;
export const GetMyProgrammeSubmissionsDocument = gql`
    query getMyProgrammeSubmissions {
  getMyProgrammeSubmissions {
    id
    status
    progress
    competency_url {
      documentId
      url
    }
    feedfoward_url {
      documentId
      url
    }
    programme_type {
      documentId
      programme_type_instructions
      title
      description
      position
      cover {
        documentId
        url
      }
      is_coaching
      is_sub_module
      notes
      show_article
      show_session
      show_participants
      competency_survey
      feedForward_survey
      deadline
      programme_questions {
        __typename
        ... on ComponentQuestionTypesValuesNested {
          title
          question
          description
          questions {
            titleEnglish
            subTitleEnglish
            titleFrench
            subTitleFrench
            titleGerman
            subTitleGerman
            titleSpanish
            subTitleSpanish
            titleMandarin
            subTitleMandarin
          }
        }
        ... on ComponentQuestionTypesValuesCharacters {
          title
          question
          description
        }
        ... on ComponentQuestionTypesValuesBubble {
          title
          question
          description
        }
        ... on ComponentQuestionTypesValuesSliders {
          title
          question
          description
          sliderQuestions {
            question
            color
          }
        }
        ... on ComponentQuestionTypesValuesGaps {
          title
          question
          description
        }
        ... on ComponentQuestionTypesSimpleQuestion {
          titleEnglish
          titleFrench
          titleGerman
          titleSpanish
          titleMandarin
          subTitleEnglish
          subTitleFrench
          subTitleGerman
          subTitleSpanish
          subTitleMandarin
        }
        ... on ComponentQuestionTypesXYGraph {
          labelXEnglish
          labelYEnglish
          titleEnglish
          subTitleEnglish
          labelXFrench
          labelYFrench
          titleFrench
          subTitleFrench
          labelXGerman
          labelYGerman
          titleGerman
          subTitleGerman
          labelXSpanish
          labelYSpanish
          titleSpanish
          subTitleSpanish
          labelXMandarin
          labelYMandarin
          titleMandarin
          subTitleMandarin
        }
        ... on ComponentQuestionTypesMultipleChoice {
          titleEnglish
          titleFrench
          titleGerman
          titleSpanish
          titleMandarin
          option {
            optionEnglish
            isCorrect
          }
          numberOfAnswers
        }
        ... on ComponentQuestionTypesSaboteur {
          titleEnglish
          subTitleEnglish
          titleFrench
          subTitleFrench
          titleGerman
          subTitleGerman
          titleSpanish
          subTitleSpanish
          titleMandarin
          subTitleMandarin
          saboteurQuestions {
            link
            skipProof
            labelEnglish
            labelFrench
            labelGerman
            labelSpanish
            labelMandarin
          }
          labelEnglish
          labelFrench
          labelGerman
          labelSpanish
        }
        ... on ComponentQuestionTypesNestedQuestions {
          titleEnglish
          titleFrench
          titleGerman
          titleSpanish
          titleMandarin
          questions {
            titleEnglish
            subTitleEnglish
            titleFrench
            subTitleFrench
            titleGerman
            subTitleGerman
            titleSpanish
            subTitleSpanish
            titleMandarin
            subTitleMandarin
            isNumeric
          }
        }
        ... on ComponentQuestionTypesGravitasScale {
          titleEnglish
          subTitleEnglish
          questionOneEnglish
          questionTwoEnglish
          questionThreeEnglish
          titleOneEnglish
          titleTwoEnglish
          ratingInput {
            labelOneEnglish
            labelTwoEnglish
          }
        }
        ... on ComponentQuestionTypesStakeholderMap {
          titleEnglish
          subTitleEnglish
          titleFrench
          subTitleFrench
          titleGerman
          subTitleGerman
          titleSpanish
          subTitleSpanish
          titleMandarin
          subTitleMandarin
          questionX
          questionY
        }
        ... on ComponentQuestionTypesSaboteurVideos {
          titleEnglish
          subTitleEnglish
          titleFrench
          subTitleFrench
          titleGerman
          subTitleGerman
          titleSpanish
          subTitleSpanish
          titleMandarin
          subTitleMandarin
          SaboteurVideo {
            videoTitleEnglish
            videoTitleFrench
            videoTitleGerman
            videoTitleSpanish
            videoTitleMandarin
            video {
              documentId
              url
            }
          }
        }
        ... on ComponentQuestionTypesFeedForward1 {
          title
          question
          description
        }
        ... on ComponentQuestionTypesFeedForward2 {
          title
          question
          description
        }
        ... on ComponentQuestionTypesSimpleReadOnly {
          titleEnglish
          subTitleEnglish
          titleFrench
          subTitleFrench
          titleGerman
          subTitleGerman
          titleSpanish
          subTitleSpanish
          titleMandarin
          subTitleMandarin
          contentEnglish
          contentFrench
          contentGerman
          contentMandarin
          contentSpanish
          photo {
            documentId
            url
          }
        }
        ... on ComponentQuestionTypesCompetency {
          title
          question
          minNumber
          maxNumber
          miniLabel
          maxiLabel
          simpleQuestion
        }
        ... on ComponentQuestionTypesCompetency2 {
          titleEnglish
          titleFrench
          titleMandarin
          questionscompetency2 {
            title
            question
            maxiNumber
            miniNumber
            simpleQuestion
            miniLabel
            maxiLabel
            midiLabel
            textboxQuestion
          }
        }
        ... on ComponentQuestionTypesGravitasGap {
          title
          question
          description
          color1
          color2
          color3
        }
        ... on ComponentQuestionTypesGravitasSliders {
          titleEnglish
          titleFrench
          titleMandarin
          titleSpanish
          titleGerman
          subTitleEnglish
          subTitleFrench
          subTitleGerman
          positiveHeadingEnglish
          positiveHeadingFrench
          positiveHeadingSpanish
          positiveHeadingMandarin
          positiveHeadingGerman
          negativeHeadingEnglish
          negativeHeadingFrench
          negativeHeadingSpanish
          negativeHeadingMandarin
          negativeHeadingGerman
          sliderQuestions {
            questionPositiveEnglish
            questionPositiveGerman
            questionPositiveMandarin
            questionPositiveSpanish
            questionPositiveFrench
            questionNegativeEnglish
            questionNegativeGerman
            questionNegativeFrench
            questionNegativeMandarin
            questionNegativeSpanish
          }
          sliderHeadings {
            headingEnglish
            headingSpanish
            headingGerman
            headingFrench
            headingMandarin
            color
            rating
          }
        }
      }
      articles {
        documentId
        createdAt
        updatedAt
        title_english
        title_french
        title_german
        title_spanish
        title_mandarin
        content_english
        content_french
        content_german
        content_spanish
        content_mandarin
        image {
          documentId
          url
        }
        date_published
        read_time
        link
      }
      modal {
        documentId
        title
        subtitle
        message
        image {
          documentId
          url
          name
        }
      }
      events {
        documentId
        name
        link
        session_id
      }
      sub_modules {
        documentId
        name_english
        description_english
        cover {
          documentId
          url
        }
        programme_type {
          documentId
        }
      }
      archive
    }
  }
}
    `;

/**
 * __useGetMyProgrammeSubmissionsQuery__
 *
 * To run a query within a React component, call `useGetMyProgrammeSubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyProgrammeSubmissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyProgrammeSubmissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyProgrammeSubmissionsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyProgrammeSubmissionsQuery, GetMyProgrammeSubmissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyProgrammeSubmissionsQuery, GetMyProgrammeSubmissionsQueryVariables>(GetMyProgrammeSubmissionsDocument, options);
      }
export function useGetMyProgrammeSubmissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyProgrammeSubmissionsQuery, GetMyProgrammeSubmissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyProgrammeSubmissionsQuery, GetMyProgrammeSubmissionsQueryVariables>(GetMyProgrammeSubmissionsDocument, options);
        }
// @ts-ignore
export function useGetMyProgrammeSubmissionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyProgrammeSubmissionsQuery, GetMyProgrammeSubmissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyProgrammeSubmissionsQuery, GetMyProgrammeSubmissionsQueryVariables>;
export function useGetMyProgrammeSubmissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyProgrammeSubmissionsQuery, GetMyProgrammeSubmissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyProgrammeSubmissionsQuery | undefined, GetMyProgrammeSubmissionsQueryVariables>;
export function useGetMyProgrammeSubmissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyProgrammeSubmissionsQuery, GetMyProgrammeSubmissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyProgrammeSubmissionsQuery, GetMyProgrammeSubmissionsQueryVariables>(GetMyProgrammeSubmissionsDocument, options);
        }
export type GetMyProgrammeSubmissionsQueryHookResult = ReturnType<typeof useGetMyProgrammeSubmissionsQuery>;
export type GetMyProgrammeSubmissionsLazyQueryHookResult = ReturnType<typeof useGetMyProgrammeSubmissionsLazyQuery>;
export type GetMyProgrammeSubmissionsSuspenseQueryHookResult = ReturnType<typeof useGetMyProgrammeSubmissionsSuspenseQuery>;
export type GetMyProgrammeSubmissionsQueryResult = Apollo.QueryResult<GetMyProgrammeSubmissionsQuery, GetMyProgrammeSubmissionsQueryVariables>;
export const GetMySubModuleSubmissionsDocument = gql`
    query getMySubModuleSubmissions {
  getMySubModuleSubmissions {
    id
    view
    progress
    status
    time_spent
    feedfoward_url {
      documentId
    }
    competency_url {
      documentId
    }
    competency_participants {
      name
      email
    }
    participants {
      documentId
      name
      email
      type
    }
    submission_participants {
      id
      name
      email
    }
    language {
      documentId
      name
    }
    section {
      id
      progress
      section {
        documentId
      }
      answers {
        id
        questionId
        answer
        nestedAnswers {
          answer
          questionTitle
        }
        isCorrect
        feedback
        outcome
        questionType
        questionTitle
      }
      stakeholderChart {
        documentId
        url
      }
      stakeholderItems {
        id
        valueX
        valueY
        name
        color
      }
      gravitasScales {
        id
        labelOne
        labelTwo
        labelThree
        question
        answerOne
        answerTwo
        answerThree
      }
      gravitasSliderAnswers {
        negativeQuestion
        positiveQuestion
        colorAndRating {
          color
          rate
        }
      }
      gravitasGap {
        id
        gap
        commitment
      }
      xYGraphChart {
        documentId
        url
      }
      saboteurImage {
        documentId
        url
      }
      xYGraphItems {
        id
        valueX
        valueY
        color
      }
      characteristics {
        id
        answer
        type
      }
      sliderAnswers
      gapsAnswers {
        id
        gap
        commitment
      }
      competencyAnswers {
        id
        question
        rating
        steps
        response
      }
      uploadDocuments {
        saboteurProofValue {
          documentId
        }
      }
    }
    sub_module {
      documentId
      name_french
      name_german
      name_english
      name_spanish
      name_mandarin
      description_french
      description_german
      description_english
      description_spanish
      description_mandarin
      cover {
        documentId
        url
      }
      sections {
        documentId
        title_french
        title_german
        title_english
        title_spanish
        title_mandarin
        sub_title_french
        sub_title_german
        sub_title_english
        sub_title_spanish
        sub_title_mandarin
        cover {
          documentId
          url
        }
        position
        archive
      }
      position
      programme_type {
        documentId
        title
        description
        position
        cover {
          documentId
          url
        }
        is_coaching
        is_sub_module
        notes
        show_article
        show_session
        show_participants
        competency_survey
        feedForward_survey
        deadline
        articles {
          documentId
          createdAt
          updatedAt
          title_english
          title_french
          title_german
          title_spanish
          title_mandarin
          content_english
          content_french
          content_german
          content_spanish
          content_mandarin
          image {
            documentId
            url
          }
          date_published
          read_time
          link
        }
        modal {
          documentId
          title
          subtitle
          message
          image {
            documentId
            url
            name
          }
        }
        events {
          documentId
          link
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetMySubModuleSubmissionsQuery__
 *
 * To run a query within a React component, call `useGetMySubModuleSubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMySubModuleSubmissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMySubModuleSubmissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMySubModuleSubmissionsQuery(baseOptions?: Apollo.QueryHookOptions<GetMySubModuleSubmissionsQuery, GetMySubModuleSubmissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMySubModuleSubmissionsQuery, GetMySubModuleSubmissionsQueryVariables>(GetMySubModuleSubmissionsDocument, options);
      }
export function useGetMySubModuleSubmissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMySubModuleSubmissionsQuery, GetMySubModuleSubmissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMySubModuleSubmissionsQuery, GetMySubModuleSubmissionsQueryVariables>(GetMySubModuleSubmissionsDocument, options);
        }
// @ts-ignore
export function useGetMySubModuleSubmissionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMySubModuleSubmissionsQuery, GetMySubModuleSubmissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMySubModuleSubmissionsQuery, GetMySubModuleSubmissionsQueryVariables>;
export function useGetMySubModuleSubmissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMySubModuleSubmissionsQuery, GetMySubModuleSubmissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMySubModuleSubmissionsQuery | undefined, GetMySubModuleSubmissionsQueryVariables>;
export function useGetMySubModuleSubmissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMySubModuleSubmissionsQuery, GetMySubModuleSubmissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMySubModuleSubmissionsQuery, GetMySubModuleSubmissionsQueryVariables>(GetMySubModuleSubmissionsDocument, options);
        }
export type GetMySubModuleSubmissionsQueryHookResult = ReturnType<typeof useGetMySubModuleSubmissionsQuery>;
export type GetMySubModuleSubmissionsLazyQueryHookResult = ReturnType<typeof useGetMySubModuleSubmissionsLazyQuery>;
export type GetMySubModuleSubmissionsSuspenseQueryHookResult = ReturnType<typeof useGetMySubModuleSubmissionsSuspenseQuery>;
export type GetMySubModuleSubmissionsQueryResult = Apollo.QueryResult<GetMySubModuleSubmissionsQuery, GetMySubModuleSubmissionsQueryVariables>;
export const GetMySubmissionsDocument = gql`
    query getMySubmissions {
  getMySubmissions {
    id
    views
    progress
    status
    time_spent
  }
}
    `;

/**
 * __useGetMySubmissionsQuery__
 *
 * To run a query within a React component, call `useGetMySubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMySubmissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMySubmissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMySubmissionsQuery(baseOptions?: Apollo.QueryHookOptions<GetMySubmissionsQuery, GetMySubmissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMySubmissionsQuery, GetMySubmissionsQueryVariables>(GetMySubmissionsDocument, options);
      }
export function useGetMySubmissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMySubmissionsQuery, GetMySubmissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMySubmissionsQuery, GetMySubmissionsQueryVariables>(GetMySubmissionsDocument, options);
        }
// @ts-ignore
export function useGetMySubmissionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMySubmissionsQuery, GetMySubmissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMySubmissionsQuery, GetMySubmissionsQueryVariables>;
export function useGetMySubmissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMySubmissionsQuery, GetMySubmissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMySubmissionsQuery | undefined, GetMySubmissionsQueryVariables>;
export function useGetMySubmissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMySubmissionsQuery, GetMySubmissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMySubmissionsQuery, GetMySubmissionsQueryVariables>(GetMySubmissionsDocument, options);
        }
export type GetMySubmissionsQueryHookResult = ReturnType<typeof useGetMySubmissionsQuery>;
export type GetMySubmissionsLazyQueryHookResult = ReturnType<typeof useGetMySubmissionsLazyQuery>;
export type GetMySubmissionsSuspenseQueryHookResult = ReturnType<typeof useGetMySubmissionsSuspenseQuery>;
export type GetMySubmissionsQueryResult = Apollo.QueryResult<GetMySubmissionsQuery, GetMySubmissionsQueryVariables>;
export const UserDocument = gql`
    query user($id: ID!) {
  usersPermissionsUser(documentId: $id) {
    documentId
    username
    firstName
  }
}
    `;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserQuery(baseOptions: Apollo.QueryHookOptions<UserQuery, UserQueryVariables> & ({ variables: UserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
// @ts-ignore
export function useUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>): Apollo.UseSuspenseQueryResult<UserQuery, UserQueryVariables>;
export function useUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>): Apollo.UseSuspenseQueryResult<UserQuery | undefined, UserQueryVariables>;
export function useUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserSuspenseQueryHookResult = ReturnType<typeof useUserSuspenseQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export const UsersDocument = gql`
    query Users {
  usersPermissionsUsers {
    id
    username
    email
  }
}
    `;

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useUsersQuery(baseOptions?: Apollo.QueryHookOptions<UsersQuery, UsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
      }
export function useUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
// @ts-ignore
export function useUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UsersQuery, UsersQueryVariables>): Apollo.UseSuspenseQueryResult<UsersQuery, UsersQueryVariables>;
export function useUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UsersQuery, UsersQueryVariables>): Apollo.UseSuspenseQueryResult<UsersQuery | undefined, UsersQueryVariables>;
export function useUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>;
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>;
export type UsersSuspenseQueryHookResult = ReturnType<typeof useUsersSuspenseQuery>;
export type UsersQueryResult = Apollo.QueryResult<UsersQuery, UsersQueryVariables>;